import React from 'react';

const Decor1: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-1 prefix__map-decor"
      transform="translate(23 190)"
    >
      <defs>
        <linearGradient
          id="b70d4c96-e3ee-46e4-bf17-84bcd87f7aca"
          data-name="grad-190"
          x1="1077.44"
          y1="151.26"
          x2="1077.43"
          y2="153.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#35323c" />
          <stop offset="0.43" stopColor="#7a7a42" />
          <stop offset="0.63" stopColor="#b1b347" />
          <stop offset="0.79" stopColor="#d9dc4a" />
          <stop offset="0.92" stopColor="#f1f64c" />
          <stop offset="1" stopColor="#faff4d" />
        </linearGradient>
        <linearGradient
          id="baa8ba92-349d-479f-9c89-c74c37a14a76"
          data-name="grad-198"
          x1="1077.43"
          y1="151.78"
          x2="1077.44"
          y2="154.64"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.27" stopColor="#4b4945" />
          <stop offset="0.47" stopColor="#8d8d51" />
          <stop offset="0.63" stopColor="#bdbf5a" />
          <stop offset="0.75" stopColor="#dadd60" />
          <stop offset="0.82" stopColor="#e5e962" />
          <stop offset="1" stopColor="#faff64" />
        </linearGradient>
        <linearGradient
          id="b1bd32d4-64f6-42da-bc4e-37dad12fbd00"
          data-name="grad-197"
          x1="1077.4"
          y1="152.33"
          x2="1077.46"
          y2="155.56"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.17" stopColor="#272341" />
          <stop offset="0.41" stopColor="#7a7959" />
          <stop offset="0.61" stopColor="#b7b86a" />
          <stop offset="0.75" stopColor="#dddf75" />
          <stop offset="0.82" stopColor="#ebee79" />
          <stop offset="1" stopColor="#fbff7b" />
        </linearGradient>
        <linearGradient
          id="aec1955d-c62d-45b9-8654-20a44522097c"
          data-name="grad-196"
          x1="1077.36"
          y1="152.88"
          x2="1077.47"
          y2="156.38"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.31" stopColor="#565456" />
          <stop offset="0.56" stopColor="#a8a975" />
          <stop offset="0.74" stopColor="#dcdf89" />
          <stop offset="0.82" stopColor="#f0f491" />
          <stop offset="1" stopColor="#fbff91" />
        </linearGradient>
        <linearGradient
          id="bd93b759-d104-4f8e-b9e8-64894ff60a26"
          data-name="grad-195"
          x1="1077.32"
          y1="153.43"
          x2="1077.48"
          y2="157.11"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.44" stopColor="#818070" />
          <stop offset="0.7" stopColor="#d5d798" />
          <stop offset="0.82" stopColor="#f6f9a8" />
          <stop offset="1" stopColor="#fcffa8" />
        </linearGradient>
        <linearGradient
          id="bc816acd-3215-499d-8ed3-054cc242e444"
          data-name="grad-47"
          x1="1077.27"
          y1="153.99"
          x2="1077.48"
          y2="157.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#a3a38d" />
          <stop offset="0.82" stopColor="#fcffbf" />
        </linearGradient>
        <linearGradient
          id="ee25e030-00d8-40e4-9c70-fb42e8f66404"
          data-name="grad-194"
          x1="1077.32"
          y1="155.52"
          x2="1077.48"
          y2="159.35"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.2" stopColor="#332f4b" />
          <stop offset="0.43" stopColor="#888773" />
          <stop offset="0.62" stopColor="#c6c891" />
          <stop offset="0.75" stopColor="#ecf0a3" />
          <stop offset="0.82" stopColor="#fbffaa" />
        </linearGradient>
        <linearGradient
          id="a3af6921-49f2-43ca-beed-286fd9624229"
          data-name="grad-193"
          x1="1077.36"
          y1="157.05"
          x2="1077.47"
          y2="160.89"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.25" stopColor="#4d4b53" />
          <stop offset="0.4" stopColor="#8a8a6a" />
          <stop offset="0.54" stopColor="#babd7d" />
          <stop offset="0.66" stopColor="#dde18b" />
          <stop offset="0.76" stopColor="#f2f793" />
          <stop offset="0.82" stopColor="#faff96" />
        </linearGradient>
        <linearGradient
          id="bbbd27e8-fabf-45ab-890b-1f47ae997295"
          data-name="grad-192"
          x1="1077.39"
          y1="158.58"
          x2="1077.46"
          y2="162.37"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#4a484c" />
          <stop offset="0.34" stopColor="#7f805c" />
          <stop offset="0.45" stopColor="#abad69" />
          <stop offset="0.56" stopColor="#cdd174" />
          <stop offset="0.66" stopColor="#e5ea7b" />
          <stop offset="0.75" stopColor="#f4fa7f" />
          <stop offset="0.82" stopColor="#f9ff81" />
        </linearGradient>
        <linearGradient
          id="b8aff133-41f9-4cd0-b1db-d235b9a038c8"
          data-name="grad-19"
          x1="1077.42"
          y1="160.11"
          x2="1077.45"
          y2="163.78"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.18" stopColor="#403d44" />
          <stop offset="0.27" stopColor="#70704f" />
          <stop offset="0.36" stopColor="#9a9c58" />
          <stop offset="0.45" stopColor="#bcc060" />
          <stop offset="0.54" stopColor="#d6db66" />
          <stop offset="0.64" stopColor="#e9ef6a" />
          <stop offset="0.73" stopColor="#f4fb6c" />
          <stop offset="0.82" stopColor="#f8ff6d" />
        </linearGradient>
        <linearGradient
          id="bd6f1f03-b3c6-47ba-9abd-22992687dbac"
          data-name="grad-126"
          x1="1077.45"
          y1="161.64"
          x2="1077.43"
          y2="165.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.14" stopColor="#302d3e" />
          <stop offset="0.21" stopColor="#5e5e44" />
          <stop offset="0.28" stopColor="#878949" />
          <stop offset="0.35" stopColor="#aaae4e" />
          <stop offset="0.43" stopColor="#c6cb52" />
          <stop offset="0.51" stopColor="#dce254" />
          <stop offset="0.6" stopColor="#ebf256" />
          <stop offset="0.69" stopColor="#f4fc58" />
          <stop offset="0.82" stopColor="#f7ff58" />
        </linearGradient>
        <radialGradient
          id="a20379ec-735b-41cd-bf8c-e1ef2c15d0ef"
          data-name="grad-210"
          cx="1077.31"
          cy="157.67"
          r="12.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.27" stopColor="#f2ff7d" stopOpacity="0.39" />
          <stop offset="0.58" stopColor="#f9ffbc" stopOpacity="0.18" />
          <stop offset="0.81" stopColor="#fdffe2" stopOpacity="0.05" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="fd01894c-1a7a-469e-a37f-d78f31ad88b4"
          x1="912.44"
          y1="99.26"
          x2="912.43"
          y2="101.63"
          xlinkHref="#b70d4c96-e3ee-46e4-bf17-84bcd87f7aca"
        />
        <linearGradient
          id="bea81d03-5b8d-4314-8980-26242fc6b07a"
          x1="912.43"
          y1="99.78"
          x2="912.44"
          y2="102.64"
          xlinkHref="#baa8ba92-349d-479f-9c89-c74c37a14a76"
        />
        <linearGradient
          id="aa6f4fa5-77d1-4546-8dc0-9e508ab5ee5e"
          x1="912.4"
          y1="100.33"
          x2="912.46"
          y2="103.56"
          xlinkHref="#b1bd32d4-64f6-42da-bc4e-37dad12fbd00"
        />
        <linearGradient
          id="aacbb724-ebc8-451e-8d94-b07620e17ccf"
          x1="912.36"
          y1="100.88"
          x2="912.47"
          y2="104.38"
          xlinkHref="#aec1955d-c62d-45b9-8654-20a44522097c"
        />
        <linearGradient
          id="e06fdf2a-57cd-4993-bce3-e77507512e88"
          x1="912.32"
          y1="101.43"
          x2="912.48"
          y2="105.11"
          xlinkHref="#bd93b759-d104-4f8e-b9e8-64894ff60a26"
        />
        <linearGradient
          id="f3d33721-24a5-45ff-b7d6-ef105eeef6da"
          x1="912.27"
          y1="101.99"
          x2="912.48"
          y2="105.73"
          xlinkHref="#bc816acd-3215-499d-8ed3-054cc242e444"
        />
        <linearGradient
          id="abf74358-5153-4b53-8fad-a282de3d4dd2"
          x1="912.32"
          y1="103.52"
          x2="912.48"
          y2="107.35"
          xlinkHref="#ee25e030-00d8-40e4-9c70-fb42e8f66404"
        />
        <linearGradient
          id="fb36786d-39b2-469d-9216-bf61b15fa08a"
          x1="912.36"
          y1="105.05"
          x2="912.47"
          y2="108.89"
          xlinkHref="#a3af6921-49f2-43ca-beed-286fd9624229"
        />
        <linearGradient
          id="f2ff9e68-bbc0-4e62-b0d8-8bc7b38b96bc"
          x1="912.39"
          y1="106.58"
          x2="912.46"
          y2="110.37"
          xlinkHref="#bbbd27e8-fabf-45ab-890b-1f47ae997295"
        />
        <linearGradient
          id="afbef28f-de05-48a5-8ff4-0536e76a5a1f"
          x1="912.42"
          y1="108.11"
          x2="912.45"
          y2="111.78"
          xlinkHref="#b8aff133-41f9-4cd0-b1db-d235b9a038c8"
        />
        <linearGradient
          id="a55b1972-0d25-4e6f-b38d-52e051fbc718"
          x1="912.45"
          y1="109.64"
          x2="912.43"
          y2="113.13"
          xlinkHref="#bd6f1f03-b3c6-47ba-9abd-22992687dbac"
        />
        <radialGradient
          id="b3fcad5d-80e1-4961-b68c-ba4f96e61cd9"
          cx="912.31"
          cy="105.67"
          r="12.67"
          xlinkHref="#a20379ec-735b-41cd-bf8c-e1ef2c15d0ef"
        />
        <linearGradient
          id="bc32a4a3-eb62-48aa-bbcb-ffccebbbfaf9"
          x1="1464.81"
          y1="112.43"
          x2="1464.8"
          y2="115.42"
          xlinkHref="#b70d4c96-e3ee-46e4-bf17-84bcd87f7aca"
        />
        <linearGradient
          id="feaef4d5-e5a1-4919-a858-6c5e1f679664"
          x1="1464.79"
          y1="113.1"
          x2="1464.81"
          y2="116.7"
          xlinkHref="#baa8ba92-349d-479f-9c89-c74c37a14a76"
        />
        <linearGradient
          id="ebe75484-1277-4cbc-8305-9f1b1e079075"
          x1="1464.76"
          y1="113.78"
          x2="1464.83"
          y2="117.86"
          xlinkHref="#b1bd32d4-64f6-42da-bc4e-37dad12fbd00"
        />
        <linearGradient
          id="a786257d-9b68-4bc5-ac09-05bed0187e90"
          data-name="grad-28"
          x1="1464.71"
          y1="114.47"
          x2="1464.85"
          y2="118.9"
          xlinkHref="#aec1955d-c62d-45b9-8654-20a44522097c"
        />
        <linearGradient
          id="b9021642-348b-4180-b04e-5809e0f82051"
          data-name="grad-26"
          x1="1464.66"
          y1="115.18"
          x2="1464.86"
          y2="119.82"
          xlinkHref="#bd93b759-d104-4f8e-b9e8-64894ff60a26"
        />
        <linearGradient
          id="a3b01322-ad28-4ad8-9efc-64464e07c912"
          x1="1464.6"
          y1="115.88"
          x2="1464.85"
          y2="120.6"
          xlinkHref="#bc816acd-3215-499d-8ed3-054cc242e444"
        />
        <linearGradient
          id="ffb3f597-b16d-43fe-a4cd-d75916827581"
          x1="1464.65"
          y1="117.82"
          x2="1464.86"
          y2="122.65"
          xlinkHref="#ee25e030-00d8-40e4-9c70-fb42e8f66404"
        />
        <linearGradient
          id="eb058aef-9914-4891-8ea4-15d60f2e2c10"
          x1="1464.7"
          y1="119.75"
          x2="1464.85"
          y2="124.6"
          xlinkHref="#a3af6921-49f2-43ca-beed-286fd9624229"
        />
        <linearGradient
          id="b4b80d86-5440-40e4-8930-039528db9f7c"
          x1="1464.75"
          y1="121.68"
          x2="1464.84"
          y2="126.47"
          xlinkHref="#bbbd27e8-fabf-45ab-890b-1f47ae997295"
        />
        <linearGradient
          id="accf7f03-c6bd-456e-9103-34b51593f26b"
          x1="1464.79"
          y1="123.61"
          x2="1464.82"
          y2="128.25"
          xlinkHref="#b8aff133-41f9-4cd0-b1db-d235b9a038c8"
        />
        <linearGradient
          id="bc714e6a-a0ad-4663-b01b-6219ad250c84"
          x1="1464.82"
          y1="125.55"
          x2="1464.79"
          y2="129.96"
          xlinkHref="#bd6f1f03-b3c6-47ba-9abd-22992687dbac"
        />
        <radialGradient
          id="a7016031-ea24-4a19-9484-3ffde6eaf8ce"
          cx="1464.64"
          cy="120.53"
          r="16"
          xlinkHref="#a20379ec-735b-41cd-bf8c-e1ef2c15d0ef"
        />
        <linearGradient
          id="bec60323-d769-4410-bedb-9d1a5b624f6f"
          x1="1035.59"
          y1="480.94"
          x2="1035.54"
          y2="489.63"
          xlinkHref="#b70d4c96-e3ee-46e4-bf17-84bcd87f7aca"
        />
        <linearGradient
          id="fb8b0a93-b921-434f-b061-2a367a402405"
          x1="1035.52"
          y1="482.87"
          x2="1035.59"
          y2="493.34"
          xlinkHref="#baa8ba92-349d-479f-9c89-c74c37a14a76"
        />
        <linearGradient
          id="b40f72c9-63dd-4bcb-90e1-3e30a03826dd"
          x1="1035.42"
          y1="484.86"
          x2="1035.64"
          y2="496.7"
          xlinkHref="#b1bd32d4-64f6-42da-bc4e-37dad12fbd00"
        />
        <linearGradient
          id="e3080e83-f213-4f0d-9816-985f085ec523"
          data-name="grad-28"
          x1="1035.3"
          y1="486.88"
          x2="1035.69"
          y2="499.72"
          xlinkHref="#aec1955d-c62d-45b9-8654-20a44522097c"
        />
        <linearGradient
          id="a3c1f275-d642-4ef0-91f3-ff84c2d9e04d"
          data-name="grad-26"
          x1="1035.14"
          y1="488.92"
          x2="1035.71"
          y2="502.39"
          xlinkHref="#bd93b759-d104-4f8e-b9e8-64894ff60a26"
        />
        <linearGradient
          id="ac44ac44-3c06-4de0-9c3d-3d20e91062f7"
          x1="1034.96"
          y1="490.96"
          x2="1035.7"
          y2="504.67"
          xlinkHref="#bc816acd-3215-499d-8ed3-054cc242e444"
        />
        <linearGradient
          id="e8c6cf2f-138b-4b10-a48f-c6d3c0184ba7"
          x1="1035.12"
          y1="496.57"
          x2="1035.72"
          y2="510.61"
          xlinkHref="#ee25e030-00d8-40e4-9c70-fb42e8f66404"
        />
        <linearGradient
          id="b6f3cbe5-0c50-4434-9b13-4f3f7646fdb8"
          x1="1035.27"
          y1="502.18"
          x2="1035.7"
          y2="516.28"
          xlinkHref="#a3af6921-49f2-43ca-beed-286fd9624229"
        />
        <linearGradient
          id="b1d68aae-4486-4203-a28f-b3ddd010a55b"
          x1="1035.4"
          y1="507.78"
          x2="1035.66"
          y2="521.69"
          xlinkHref="#bbbd27e8-fabf-45ab-890b-1f47ae997295"
        />
        <linearGradient
          id="a3d21b57-3fc2-4f3a-93ec-bbb3a6155f6c"
          x1="1035.51"
          y1="513.39"
          x2="1035.6"
          y2="526.87"
          xlinkHref="#b8aff133-41f9-4cd0-b1db-d235b9a038c8"
        />
        <linearGradient
          id="bd488495-a153-4c60-a47a-5c024b8d925a"
          x1="1035.6"
          y1="519.02"
          x2="1035.53"
          y2="531.82"
          xlinkHref="#bd6f1f03-b3c6-47ba-9abd-22992687dbac"
        />
        <radialGradient
          id="f22240dc-7c67-4e00-9cf2-b6d4a37f8922"
          cx="1035.08"
          cy="504.44"
          r="46.44"
          xlinkHref="#a20379ec-735b-41cd-bf8c-e1ef2c15d0ef"
        />
        <linearGradient
          id="ab05e789-6ed6-4718-ab45-8666636c4cae"
          x1="1331.96"
          y1="177.86"
          x2="1331.93"
          y2="182.73"
          xlinkHref="#b70d4c96-e3ee-46e4-bf17-84bcd87f7aca"
        />
        <linearGradient
          id="b6d6f108-2007-49a6-9238-4eea08fa6b42"
          x1="1331.92"
          y1="178.94"
          x2="1331.96"
          y2="184.81"
          xlinkHref="#baa8ba92-349d-479f-9c89-c74c37a14a76"
        />
        <linearGradient
          id="b18781dd-4d4e-4ea4-822f-67677271ac47"
          x1="1331.87"
          y1="180.06"
          x2="1331.99"
          y2="186.7"
          xlinkHref="#b1bd32d4-64f6-42da-bc4e-37dad12fbd00"
        />
        <linearGradient
          id="e99a5672-5ef3-4397-907a-f753df0c00f9"
          data-name="grad-28"
          x1="1331.8"
          y1="181.19"
          x2="1332.02"
          y2="188.39"
          xlinkHref="#aec1955d-c62d-45b9-8654-20a44522097c"
        />
        <linearGradient
          id="b43a387e-a075-4149-9e20-5112de49a97d"
          data-name="grad-26"
          x1="1331.71"
          y1="182.33"
          x2="1332.03"
          y2="189.88"
          xlinkHref="#bd93b759-d104-4f8e-b9e8-64894ff60a26"
        />
        <linearGradient
          id="a3bd8bb4-90d5-4bb4-86b0-b3e1101b5937"
          x1="1331.6"
          y1="183.48"
          x2="1332.02"
          y2="191.16"
          xlinkHref="#bc816acd-3215-499d-8ed3-054cc242e444"
        />
        <linearGradient
          id="fba0e165-14ff-4f0c-b535-4d235da3e284"
          x1="1331.7"
          y1="186.63"
          x2="1332.03"
          y2="194.49"
          xlinkHref="#ee25e030-00d8-40e4-9c70-fb42e8f66404"
        />
        <linearGradient
          id="f5337567-7b22-4ea7-95fe-a34f983c61a7"
          x1="1331.78"
          y1="189.77"
          x2="1332.02"
          y2="197.67"
          xlinkHref="#a3af6921-49f2-43ca-beed-286fd9624229"
        />
        <linearGradient
          id="fa73ba13-0756-4275-b841-480d9338bd09"
          x1="1331.85"
          y1="192.91"
          x2="1332"
          y2="200.71"
          xlinkHref="#bbbd27e8-fabf-45ab-890b-1f47ae997295"
        />
        <linearGradient
          id="abda2944-774a-40da-9b16-2cd4d0dda7d6"
          x1="1331.92"
          y1="196.05"
          x2="1331.96"
          y2="203.61"
          xlinkHref="#b8aff133-41f9-4cd0-b1db-d235b9a038c8"
        />
        <linearGradient
          id="a888f4bd-2cda-4b84-8d69-d043f7c26678"
          x1="1331.97"
          y1="199.21"
          x2="1331.93"
          y2="206.38"
          xlinkHref="#bd6f1f03-b3c6-47ba-9abd-22992687dbac"
        />
        <radialGradient
          id="bd5efdb5-d77a-427d-bd62-c17d14d8d748"
          cx="1331.68"
          cy="191.04"
          r="26.04"
          xlinkHref="#a20379ec-735b-41cd-bf8c-e1ef2c15d0ef"
        />
        <linearGradient
          id="e560be48-7cb1-4f74-a7a8-dcec9f99f3a8"
          x1="366.85"
          y1="418.38"
          x2="366.83"
          y2="421.94"
          xlinkHref="#b70d4c96-e3ee-46e4-bf17-84bcd87f7aca"
        />
        <linearGradient
          id="b0ad335c-ae5a-4ad8-8856-006e91eaa192"
          x1="366.82"
          y1="419.18"
          x2="366.85"
          y2="423.46"
          xlinkHref="#baa8ba92-349d-479f-9c89-c74c37a14a76"
        />
        <linearGradient
          id="b2532a7c-b025-4629-a1ba-879ad9a784ea"
          x1="366.78"
          y1="419.99"
          x2="366.87"
          y2="424.83"
          xlinkHref="#b1bd32d4-64f6-42da-bc4e-37dad12fbd00"
        />
        <linearGradient
          id="ac7fb9b1-8f34-4162-ae8a-aa7bde386270"
          x1="366.73"
          y1="420.81"
          x2="366.89"
          y2="426.07"
          xlinkHref="#aec1955d-c62d-45b9-8654-20a44522097c"
        />
        <linearGradient
          id="f67fb4c4-79b3-45b3-bf2b-b191552aa565"
          x1="366.66"
          y1="421.65"
          x2="366.9"
          y2="427.16"
          xlinkHref="#bd93b759-d104-4f8e-b9e8-64894ff60a26"
        />
        <linearGradient
          id="a339ba60-5c48-46a8-9a06-61d9669c4262"
          x1="366.59"
          y1="422.48"
          x2="366.89"
          y2="428.09"
          xlinkHref="#bc816acd-3215-499d-8ed3-054cc242e444"
        />
        <linearGradient
          id="e83cef85-fd5b-476d-bf09-12e81c1f22fb"
          x1="366.66"
          y1="424.78"
          x2="366.9"
          y2="430.52"
          xlinkHref="#ee25e030-00d8-40e4-9c70-fb42e8f66404"
        />
        <linearGradient
          id="e553b056-e908-4785-8200-8045662cf26c"
          x1="366.72"
          y1="427.07"
          x2="366.89"
          y2="432.84"
          xlinkHref="#a3af6921-49f2-43ca-beed-286fd9624229"
        />
        <linearGradient
          id="ac1d384a-3614-4216-a566-1371bbfa2521"
          x1="366.77"
          y1="429.36"
          x2="366.87"
          y2="435.06"
          xlinkHref="#bbbd27e8-fabf-45ab-890b-1f47ae997295"
        />
        <linearGradient
          id="b98359e4-e056-4c70-af5d-a24d0c5e842a"
          x1="366.81"
          y1="431.66"
          x2="366.85"
          y2="437.17"
          xlinkHref="#b8aff133-41f9-4cd0-b1db-d235b9a038c8"
        />
        <linearGradient
          id="bc4ae6c0-8b48-4b46-90c4-2e4e03306f1b"
          x1="366.85"
          y1="433.96"
          x2="366.82"
          y2="439.2"
          xlinkHref="#bd6f1f03-b3c6-47ba-9abd-22992687dbac"
        />
        <radialGradient
          id="f1df4704-fc35-40a7-a4a2-9caee2738a43"
          cx="366.64"
          cy="428"
          r="19"
          xlinkHref="#a20379ec-735b-41cd-bf8c-e1ef2c15d0ef"
        />
        <radialGradient
          id="bf20c103-0d05-4e7a-8182-294a2430c0c3"
          data-name="grad-7"
          cx="366.52"
          cy="463.07"
          r="10.73"
          gradientTransform="translate(0 -76.74) scale(1 1.17)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.05" stopColor="#eeff5c" stopOpacity="0.51" />
          <stop offset="0.12" stopColor="#f3ff84" stopOpacity="0.37" />
          <stop offset="0.19" stopColor="#f6ffa6" stopOpacity="0.26" />
          <stop offset="0.28" stopColor="#faffc2" stopOpacity="0.16" />
          <stop offset="0.37" stopColor="#fcffd7" stopOpacity="0.09" />
          <stop offset="0.49" stopColor="#feffe6" stopOpacity="0.04" />
          <stop offset="0.63" stopColor="#ffe" stopOpacity="0.01" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="e4dcb444-f9c9-4f6f-8cd7-92fd96adb20b"
          x1="361.85"
          y1="312.38"
          x2="361.83"
          y2="315.94"
          xlinkHref="#b70d4c96-e3ee-46e4-bf17-84bcd87f7aca"
        />
        <linearGradient
          id="b91ad7b7-39c0-4c4e-bf6d-654a03b33b57"
          x1="361.82"
          y1="313.18"
          x2="361.85"
          y2="317.46"
          xlinkHref="#baa8ba92-349d-479f-9c89-c74c37a14a76"
        />
        <linearGradient
          id="af442fd8-1490-485e-b4d0-637c8b94ca56"
          x1="361.78"
          y1="313.99"
          x2="361.87"
          y2="318.83"
          xlinkHref="#b1bd32d4-64f6-42da-bc4e-37dad12fbd00"
        />
        <linearGradient
          id="fdef9908-9612-4c09-89a0-96bc1f634221"
          x1="361.73"
          y1="314.81"
          x2="361.89"
          y2="320.07"
          xlinkHref="#aec1955d-c62d-45b9-8654-20a44522097c"
        />
        <linearGradient
          id="f46d8305-7d1f-4d0b-a54f-486f4d6680cc"
          x1="361.66"
          y1="315.65"
          x2="361.9"
          y2="321.16"
          xlinkHref="#bd93b759-d104-4f8e-b9e8-64894ff60a26"
        />
        <linearGradient
          id="fece5287-b9aa-4d6d-ac27-b0ce06521360"
          x1="361.59"
          y1="316.48"
          x2="361.89"
          y2="322.09"
          xlinkHref="#bc816acd-3215-499d-8ed3-054cc242e444"
        />
        <linearGradient
          id="b1aeb61a-f9b8-4367-9093-4405bd5e099d"
          x1="361.66"
          y1="318.78"
          x2="361.9"
          y2="324.52"
          xlinkHref="#ee25e030-00d8-40e4-9c70-fb42e8f66404"
        />
        <linearGradient
          id="e314ec30-29e7-4d5a-9496-36c76f206df4"
          x1="361.72"
          y1="321.07"
          x2="361.89"
          y2="326.84"
          xlinkHref="#a3af6921-49f2-43ca-beed-286fd9624229"
        />
        <linearGradient
          id="e87301aa-0f2c-47a9-b9b1-498014ab04c8"
          x1="361.77"
          y1="323.36"
          x2="361.87"
          y2="329.06"
          xlinkHref="#bbbd27e8-fabf-45ab-890b-1f47ae997295"
        />
        <linearGradient
          id="bbb109ad-1a54-436e-93f8-dd5e52aa0049"
          x1="361.81"
          y1="325.66"
          x2="361.85"
          y2="331.17"
          xlinkHref="#b8aff133-41f9-4cd0-b1db-d235b9a038c8"
        />
        <linearGradient
          id="ae929960-be27-4ea6-88c7-50df15c2cf4f"
          x1="361.85"
          y1="327.96"
          x2="361.82"
          y2="333.2"
          xlinkHref="#bd6f1f03-b3c6-47ba-9abd-22992687dbac"
        />
        <radialGradient
          id="a88c4ca5-9797-4cbf-9c1e-9afdc769d89d"
          cx="361.64"
          cy="322"
          r="19"
          xlinkHref="#a20379ec-735b-41cd-bf8c-e1ef2c15d0ef"
        />
        <radialGradient
          id="ff77f898-2dee-46ae-8714-8378394d09a2"
          cx="362.52"
          cy="373.07"
          r="10.73"
          xlinkHref="#bf20c103-0d05-4e7a-8182-294a2430c0c3"
        />
        <linearGradient
          id="b14b543c-6321-495a-af1c-10106bd7b6dc"
          data-name="grad-21"
          x1="1404.52"
          y1="346.61"
          x2="926.67"
          y2="347.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.3" stopColor="#0d2b6c" />
          <stop offset="0.34" stopColor="#303472" />
          <stop offset="0.4" stopColor="#68427c" />
          <stop offset="0.45" stopColor="#8b4b83" />
          <stop offset="0.48" stopColor="#984e85" />
          <stop offset="0.82" stopColor="#ff9683" />
        </linearGradient>
      </defs>
      <g id="f23e745c-509e-47c8-951a-2b8a02cfd020" data-name="decor_1">
        <g>
          <rect x="180.64" y="557.71" width="33" height="1.74" fill="#845460" />
          <g>
            <ellipse
              cx="197.14"
              cy="559.62"
              rx="16.5"
              ry="2.78"
              fill="#845460"
            />
            <ellipse
              cx="197.13"
              cy="557.47"
              rx="16.5"
              ry="2.78"
              fill="#ead3cb"
            />
          </g>
        </g>
        <g transform="translate(-15 0)">
          <rect
            x="0.03"
            y="296.69"
            width="134.24"
            height="11.32"
            fill="#845460"
          />
          <g>
            <ellipse
              cx="67.17"
              cy="309.11"
              rx="67.11"
              ry="18.1"
              fill="#845460"
            />
            <ellipse
              cx="67.11"
              cy="295.1"
              rx="67.11"
              ry="18.1"
              fill="#ead3cb"
            />
          </g>
        </g>
        <g transform="translate(-15 0)">
          <rect
            x="75.09"
            y="261.63"
            width="86.12"
            height="7.26"
            fill="#845460"
          />
          <g>
            <ellipse
              cx="118.15"
              cy="269.6"
              rx="43.05"
              ry="11.61"
              fill="#845460"
            />
            <ellipse
              cx="118.12"
              cy="260.61"
              rx="43.05"
              ry="11.61"
              fill="#ead3cb"
            />
          </g>
        </g>
        <g transform="translate(0 -20)">
          <g>
            <rect
              x="1076.8"
              y="158.53"
              width="1.27"
              height="22.47"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1077.44"
                cy="152.57"
                rx="2.61"
                ry="0.51"
                fill="url(#b70d4c96-e3ee-46e4-bf17-84bcd87f7aca)"
              />
              <ellipse
                cx="1077.44"
                cy="153.46"
                rx="3.6"
                ry="0.67"
                fill="url(#baa8ba92-349d-479f-9c89-c74c37a14a76)"
              />
              <ellipse
                cx="1077.44"
                cy="154.35"
                rx="4.59"
                ry="0.83"
                fill="url(#b1bd32d4-64f6-42da-bc4e-37dad12fbd00)"
              />
              <ellipse
                cx="1077.44"
                cy="155.24"
                rx="5.57"
                ry="0.99"
                fill="url(#aec1955d-c62d-45b9-8654-20a44522097c)"
              />
              <ellipse
                cx="1077.44"
                cy="156.13"
                rx="6.56"
                ry="1.15"
                fill="url(#bd93b759-d104-4f8e-b9e8-64894ff60a26)"
              />
              <ellipse
                cx="1077.44"
                cy="157.03"
                rx="7.55"
                ry="1.31"
                fill="url(#bc816acd-3215-499d-8ed3-054cc242e444)"
              />
              <ellipse
                cx="1077.44"
                cy="158.34"
                rx="6.81"
                ry="1.2"
                fill="url(#ee25e030-00d8-40e4-9c70-fb42e8f66404)"
              />
              <ellipse
                cx="1077.44"
                cy="159.65"
                rx="6.07"
                ry="1.09"
                fill="url(#a3af6921-49f2-43ca-beed-286fd9624229)"
              />
              <ellipse
                cx="1077.44"
                cy="160.96"
                rx="5.32"
                ry="0.98"
                fill="url(#bbbd27e8-fabf-45ab-890b-1f47ae997295)"
              />
              <ellipse
                cx="1077.44"
                cy="162.27"
                rx="4.58"
                ry="0.86"
                fill="url(#b8aff133-41f9-4cd0-b1db-d235b9a038c8)"
              />
              <ellipse
                cx="1077.44"
                cy="163.58"
                rx="3.84"
                ry="0.75"
                fill="url(#bd6f1f03-b3c6-47ba-9abd-22992687dbac)"
              />
            </g>
          </g>
          <circle
            cx="1077.31"
            cy="157.67"
            r="12.67"
            fill="url(#a20379ec-735b-41cd-bf8c-e1ef2c15d0ef)"
          />
        </g>
        <g>
          <g>
            <rect
              x="911.8"
              y="106.53"
              width="1.27"
              height="22.47"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="912.44"
                cy="100.57"
                rx="2.61"
                ry="0.51"
                fill="url(#fd01894c-1a7a-469e-a37f-d78f31ad88b4)"
              />
              <ellipse
                cx="912.44"
                cy="101.46"
                rx="3.6"
                ry="0.67"
                fill="url(#bea81d03-5b8d-4314-8980-26242fc6b07a)"
              />
              <ellipse
                cx="912.44"
                cy="102.35"
                rx="4.59"
                ry="0.83"
                fill="url(#aa6f4fa5-77d1-4546-8dc0-9e508ab5ee5e)"
              />
              <ellipse
                cx="912.44"
                cy="103.24"
                rx="5.57"
                ry="0.99"
                fill="url(#aacbb724-ebc8-451e-8d94-b07620e17ccf)"
              />
              <ellipse
                cx="912.44"
                cy="104.13"
                rx="6.56"
                ry="1.15"
                fill="url(#e06fdf2a-57cd-4993-bce3-e77507512e88)"
              />
              <ellipse
                cx="912.44"
                cy="105.03"
                rx="7.55"
                ry="1.31"
                fill="url(#f3d33721-24a5-45ff-b7d6-ef105eeef6da)"
              />
              <ellipse
                cx="912.44"
                cy="106.34"
                rx="6.81"
                ry="1.2"
                fill="url(#abf74358-5153-4b53-8fad-a282de3d4dd2)"
              />
              <ellipse
                cx="912.44"
                cy="107.65"
                rx="6.07"
                ry="1.09"
                fill="url(#fb36786d-39b2-469d-9216-bf61b15fa08a)"
              />
              <ellipse
                cx="912.44"
                cy="108.96"
                rx="5.32"
                ry="0.98"
                fill="url(#f2ff9e68-bbc0-4e62-b0d8-8bc7b38b96bc)"
              />
              <ellipse
                cx="912.44"
                cy="110.27"
                rx="4.58"
                ry="0.86"
                fill="url(#afbef28f-de05-48a5-8ff4-0536e76a5a1f)"
              />
              <ellipse
                cx="912.44"
                cy="111.58"
                rx="3.84"
                ry="0.75"
                fill="url(#a55b1972-0d25-4e6f-b38d-52e051fbc718)"
              />
            </g>
          </g>
          <circle
            cx="912.31"
            cy="105.67"
            r="12.67"
            fill="url(#b3fcad5d-80e1-4961-b68c-ba4f96e61cd9)"
          />
        </g>
        <g>
          <g>
            <rect
              x="1464"
              y="121.61"
              width="1.61"
              height="28.39"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1464.8"
                cy="114.09"
                rx="3.29"
                ry="0.65"
                fill="url(#bc32a4a3-eb62-48aa-bbcb-ffccebbbfaf9)"
              />
              <ellipse
                cx="1464.8"
                cy="115.22"
                rx="4.54"
                ry="0.85"
                fill="url(#feaef4d5-e5a1-4919-a858-6c5e1f679664)"
              />
              <ellipse
                cx="1464.8"
                cy="116.34"
                rx="5.79"
                ry="1.05"
                fill="url(#ebe75484-1277-4cbc-8305-9f1b1e079075)"
              />
              <ellipse
                cx="1464.8"
                cy="117.47"
                rx="7.04"
                ry="1.25"
                fill="url(#a786257d-9b68-4bc5-ac09-05bed0187e90)"
              />
              <ellipse
                cx="1464.8"
                cy="118.59"
                rx="8.29"
                ry="1.45"
                fill="url(#b9021642-348b-4180-b04e-5809e0f82051)"
              />
              <ellipse
                cx="1464.8"
                cy="119.72"
                rx="9.54"
                ry="1.65"
                fill="url(#a3b01322-ad28-4ad8-9efc-64464e07c912)"
              />
              <ellipse
                cx="1464.8"
                cy="121.37"
                rx="8.6"
                ry="1.51"
                fill="url(#ffb3f597-b16d-43fe-a4cd-d75916827581)"
              />
              <ellipse
                cx="1464.8"
                cy="123.03"
                rx="7.66"
                ry="1.37"
                fill="url(#eb058aef-9914-4891-8ea4-15d60f2e2c10)"
              />
              <ellipse
                cx="1464.8"
                cy="124.68"
                rx="6.72"
                ry="1.23"
                fill="url(#b4b80d86-5440-40e4-8930-039528db9f7c)"
              />
              <ellipse
                cx="1464.8"
                cy="126.34"
                rx="5.79"
                ry="1.09"
                fill="url(#accf7f03-c6bd-456e-9103-34b51593f26b)"
              />
              <ellipse
                cx="1464.8"
                cy="128"
                rx="4.85"
                ry="0.95"
                fill="url(#bc714e6a-a0ad-4663-b01b-6219ad250c84)"
              />
            </g>
          </g>
          <circle
            cx="1464.64"
            cy="120.53"
            r="16"
            fill="url(#a7016031-ea24-4a19-9484-3ffde6eaf8ce)"
          />
        </g>
        <g>
          <path
            d="M880.85,286.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M884.05,287.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S884,281.76,884.05,287.51Z"
            fill="#43771c"
          />
          <path
            d="M880.85,287.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S880.86,281.76,880.85,287.51Z"
            fill="#43771c"
          />
          <path
            d="M885.11,290.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C874.11,285.41,884.69,288,885.11,290.2Z"
            fill="#529022"
          />
          <path
            d="M882,289.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C892.39,286.11,882.19,287.65,882,289.91Z"
            fill="#529022"
          />
          <path
            d="M885.49,289s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C876.46,289.82,884.84,287.07,885.49,289Z"
            fill="#426642"
          />
          <path
            d="M880.85,289.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C891.44,290.18,881.65,287.25,880.85,289.44Z"
            fill="#426642"
          />
          <path
            d="M883.63,289.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M883.09,289.9c-.54-6.79,6.62-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M882.23,292.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S882.23,289.26,882.23,292.58Z"
            fill="#659965"
          />
          <path
            d="M883.74,291.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1.05,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S883.74,288,883.74,291.3Z"
            fill="#659965"
          />
          <path
            d="M892.17,319.63c-1-2.59-1.21-17.95-7-29.05.78,3.06,5.95,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S893.29,322.52,892.17,319.63Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <g>
            <rect
              x="1033.23"
              y="507.59"
              width="4.66"
              height="82.41"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1035.56"
                cy="485.77"
                rx="9.56"
                ry="1.88"
                fill="url(#bec60323-d769-4410-bedb-9d1a5b624f6f)"
              />
              <ellipse
                cx="1035.56"
                cy="489.03"
                rx="13.19"
                ry="2.46"
                fill="url(#fb8b0a93-b921-434f-b061-2a367a402405)"
              />
              <ellipse
                cx="1035.56"
                cy="492.3"
                rx="16.81"
                ry="3.05"
                fill="url(#b40f72c9-63dd-4bcb-90e1-3e30a03826dd)"
              />
              <ellipse
                cx="1035.56"
                cy="495.56"
                rx="20.44"
                ry="3.63"
                fill="url(#e3080e83-f213-4f0d-9816-985f085ec523)"
              />
              <ellipse
                cx="1035.56"
                cy="498.83"
                rx="24.06"
                ry="4.21"
                fill="url(#a3c1f275-d642-4ef0-91f3-ff84c2d9e04d)"
              />
              <ellipse
                cx="1035.56"
                cy="502.09"
                rx="27.69"
                ry="4.8"
                fill="url(#ac44ac44-3c06-4de0-9c3d-3d20e91062f7)"
              />
              <ellipse
                cx="1035.56"
                cy="506.9"
                rx="24.96"
                ry="4.39"
                fill="url(#e8c6cf2f-138b-4b10-a48f-c6d3c0184ba7)"
              />
              <ellipse
                cx="1035.56"
                cy="511.71"
                rx="22.24"
                ry="3.98"
                fill="url(#b6f3cbe5-0c50-4434-9b13-4f3f7646fdb8)"
              />
              <ellipse
                cx="1035.56"
                cy="516.52"
                rx="19.52"
                ry="3.58"
                fill="url(#b1d68aae-4486-4203-a28f-b3ddd010a55b)"
              />
              <ellipse
                cx="1035.56"
                cy="521.32"
                rx="16.8"
                ry="3.17"
                fill="url(#a3d21b57-3fc2-4f3a-93ec-bbb3a6155f6c)"
              />
              <ellipse
                cx="1035.56"
                cy="526.13"
                rx="14.08"
                ry="2.76"
                fill="url(#bd488495-a153-4c60-a47a-5c024b8d925a)"
              />
            </g>
          </g>
          <circle
            cx="1035.08"
            cy="504.44"
            r="46.44"
            fill="url(#f22240dc-7c67-4e00-9cf2-b6d4a37f8922)"
          />
        </g>
        <g>
          <g>
            <rect
              x="1330.64"
              y="192.8"
              width="2.61"
              height="46.2"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1331.94"
                cy="180.57"
                rx="5.36"
                ry="1.05"
                fill="url(#ab05e789-6ed6-4718-ab45-8666636c4cae)"
              />
              <ellipse
                cx="1331.94"
                cy="182.4"
                rx="7.39"
                ry="1.38"
                fill="url(#b6d6f108-2007-49a6-9238-4eea08fa6b42)"
              />
              <ellipse
                cx="1331.94"
                cy="184.23"
                rx="9.42"
                ry="1.71"
                fill="url(#b18781dd-4d4e-4ea4-822f-67677271ac47)"
              />
              <ellipse
                cx="1331.94"
                cy="186.06"
                rx="11.46"
                ry="2.04"
                fill="url(#e99a5672-5ef3-4397-907a-f753df0c00f9)"
              />
              <ellipse
                cx="1331.94"
                cy="187.89"
                rx="13.49"
                ry="2.36"
                fill="url(#b43a387e-a075-4149-9e20-5112de49a97d)"
              />
              <ellipse
                cx="1331.94"
                cy="189.72"
                rx="15.52"
                ry="2.69"
                fill="url(#a3bd8bb4-90d5-4bb4-86b0-b3e1101b5937)"
              />
              <ellipse
                cx="1331.94"
                cy="192.41"
                rx="14"
                ry="2.46"
                fill="url(#fba0e165-14ff-4f0c-b535-4d235da3e284)"
              />
              <ellipse
                cx="1331.94"
                cy="195.11"
                rx="12.47"
                ry="2.23"
                fill="url(#f5337567-7b22-4ea7-95fe-a34f983c61a7)"
              />
              <ellipse
                cx="1331.94"
                cy="197.8"
                rx="10.94"
                ry="2.01"
                fill="url(#fa73ba13-0756-4275-b841-480d9338bd09)"
              />
              <ellipse
                cx="1331.94"
                cy="200.5"
                rx="9.42"
                ry="1.78"
                fill="url(#abda2944-774a-40da-9b16-2cd4d0dda7d6)"
              />
              <ellipse
                cx="1331.94"
                cy="203.19"
                rx="7.89"
                ry="1.55"
                fill="url(#a888f4bd-2cda-4b84-8d69-d043f7c26678)"
              />
            </g>
          </g>
          <circle
            cx="1331.68"
            cy="191.04"
            r="26.04"
            fill="url(#bd5efdb5-d77a-427d-bd62-c17d14d8d748)"
          />
        </g>
        <g>
          <path
            d="M1140.83,493.83s-28.09,58.3,7.43,90.17h-55.12s20.19-9.91,22.67-16.29,2.75-47.56,20.08-72Z"
            fill="#6d3b2f"
          />
          <path
            d="M1133.77,496.69s-3-33.67-22.21-38c0,0,8,6.83,4,12.39,0,0-7.31-16.52-29.62-12.39,0,0,25.71,3.15,29.62,18.69a17.94,17.94,0,0,0-19.7,6S1133.79,484,1133.77,496.69Z"
            fill="#43771c"
          />
          <path
            d="M1140.83,496.69s3-33.67,22.21-38c0,0-8,6.83-4,12.39,0,0,7.3-16.52,29.61-12.39,0,0-25.71,3.15-29.61,18.69a17.94,17.94,0,0,1,19.7,6S1140.81,484,1140.83,496.69Z"
            fill="#43771c"
          />
          <path
            d="M1131.41,502.64s37.2-48.46,78.7-29.82c0,0-23.47-.88-25.44,1.88,0,0,7.68-1.2,7.3,6.37,0,0-16-7.65-20.45-3.87,0,0,8.86,1.77,8.33,5.51,0,0-14.23-3.39-17.89-.09,0,0,9.18,2.15,5.52,6.56,0,0-12.58-5.45-18.61,2.71,0,0,5.25-1.79,6.88.14C1155.75,492,1132.35,497.67,1131.41,502.64Z"
            fill="#529022"
          />
          <path
            d="M1138.29,502s-31.85-45.83-74.77-22.54c0,0,23.29-3.28,25-.66,0,0-7.48-.45-7.87,7.26,0,0,16.56-9.44,20.61-6,0,0-8.93,2.71-8.79,6.49,0,0,14.41-4.92,17.7-1.91,0,0-9.3,3.13-6.12,7.27,0,0,13-6.85,18.11.88,0,0-5-1.29-6.81.85C1115.31,493.59,1137.87,497,1138.29,502Z"
            fill="#529022"
          />
          <path
            d="M1130.57,500s35.3-28.11,64,10.11c0,0-17.63-12.36-19.53-10.69a8.54,8.54,0,0,1,4.59,9.68s-10.95-15.15-14.91-13.74c0,0,6.44,6,5.49,9.36,0,0-10.27-10.23-13.53-8.87,0,0,6.63,6.57,3.21,9,0,0-8.71-11.38-14.48-6.54,0,0,4.24.87,5.18,3.51C1150.55,501.8,1132,495.71,1130.57,500Z"
            fill="#426642"
          />
          <path
            d="M1140.84,501s-42-32.34-74.9,10.09c0,0,20.46-13.56,22.72-11.64a9.19,9.19,0,0,0-5.19,10.8s12.55-16.83,17.23-15.16c0,0-7.45,6.67-6.26,10.42,0,0,11.85-11.31,15.71-9.71,0,0-7.66,7.26-3.59,10,0,0,10-12.63,16.87-7.07,0,0-5,.89-6,3.85C1117.41,502.58,1139.06,496.1,1140.84,501Z"
            fill="#426642"
          />
          <path
            d="M1134.69,502c1.53-19.47-19-42.13-33.76-40.72,0,0,29.16-5.66,33.88,11.8,0,0-5.9-23.13-14.52-23.13,0,0,19-5.19,22.43,10.86,0,0,10.26-20.07,0-22.78,0,0,23.48,6.26,13.45,21.84,0,0,10.74-9,23.49,2.83,0,0-25,.47-29.27,10.38,0,0,11-7.08,17.47,0,0,0-22.08-3.65-27.62,12.63Z"
            fill="#529022"
          />
          <path
            d="M1135.89,502c1.18-15-14.66-32.49-26-31.4,0,0,22.48-4.37,26.12,9.1,0,0-4.55-17.84-11.2-17.84,0,0,14.66-4,17.3,8.37,0,0,7.92-15.47,0-17.56,0,0,18.11,4.82,10.38,16.84,0,0,8.28-6.92,18.11,2.18,0,0-19.3.36-22.57,8,0,0,8.46-5.46,13.47,0,0,0-17-2.82-21.3,9.74Z"
            fill="#396039"
          />
          <path
            d="M1137.78,507.9s-1.72-19.46-12.84-22c0,0,4.63,3.95,2.32,7.16,0,0-4.23-9.55-17.12-7.16,0,0,14.86,1.81,17.12,10.8a10.37,10.37,0,0,0-11.39,3.46S1137.79,500.55,1137.78,507.9Z"
            fill="#659965"
          />
          <path
            d="M1134.45,505.07s1.72-19.46,12.84-22c0,0-4.62,3.94-2.31,7.15,0,0,4.22-9.54,17.11-7.15,0,0-14.85,1.81-17.11,10.79a10.37,10.37,0,0,1,11.38,3.46S1134.44,497.72,1134.45,505.07Z"
            fill="#659965"
          />
          <path
            d="M1115.81,567.71c2.23-5.74,2.67-39.7,15.39-64.24-1.72,6.76-13.15,53-7.25,66.25,2.36,5.28-5.29,10.19-15.87,14.28h-14.94S1113.33,574.09,1115.81,567.71Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <path d="M1340.13,290.3v0h0Z" fill="#ef6291" />
          <path
            d="M1367.25,284.78v0c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77Z"
            fill="#ef6291"
          />
          <path
            d="M1361.82,301.8h0a.22.22,0,0,1,0,.08c0,.9-3.51,1.63-7.85,1.63s-7.84-.73-7.84-1.63a.22.22,0,0,1,0-.08H1346l-5.9-11.58h27.12Z"
            fill="#c1567f"
          />
          <path
            d="M1367.25,284.8c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77,6-2.77,13.33-2.77,13.73,1.25,13.79,2.77Z"
            fill="#c16f86"
          />
          <path
            d="M1365.72,284.8c0,1.35-5.69,2.44-12.23,2.44s-11.83-1.1-11.83-2.46,5.29-2.46,11.83-2.46S1365.72,283.44,1365.72,284.8Z"
            fill="#513126"
          />
          <path
            d="M1361.63,302.22c-9.42.46-9.11-11.1-9.11-11.1l-12.15-.43L1346,301.8h.08a.22.22,0,0,0,0,.08c0,.9,3.51,1.63,7.84,1.63C1357.73,303.51,1360.88,303,1361.63,302.22Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <path
            d="M1367.25,284.8v5.52c0,1.52-6.21,2.77-13.54,2.77s-13.53-1.25-13.58-2.77v-5.54c0,1.53,6,2.77,13.33,2.77S1367.25,286.33,1367.25,284.8Z"
            fill="#ef6291"
          />
          <path
            d="M1347.31,287.24h0c-4.27-.46-7.18-1.38-7.18-2.45v5.54c0,1.3,4.58,2.4,10.5,2.69C1346.23,292,1347.31,287.24,1347.31,287.24Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <g>
            <path
              d="M1344.27,282.18c-2.16.42-4.16-4.58-5.59-6.84,0,0,3.77.23,5.63,1.43S1347.19,281.6,1344.27,282.18Z"
              fill="#1c7f19"
            />
            <path
              d="M1338.68,275.34a35.75,35.75,0,0,1,3.88,2.69,17.55,17.55,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.16,2.16,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,19.9,19.9,0,0,0-1.76-1.55C1341.25,277.15,1340,276.26,1338.68,275.34Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1357.06,280c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.64,1.43S1360,279.39,1357.06,280Z"
              fill="#1c7f19"
            />
            <path
              d="M1351.47,273.13a35.35,35.35,0,0,1,3.89,2.68,20.35,20.35,0,0,1,1.74,1.61,3.49,3.49,0,0,1,1.13,2,2,2,0,0,0-.46-1.06,7.07,7.07,0,0,0-.75-.89,20,20,0,0,0-1.77-1.55C1354.05,274.93,1352.75,274,1351.47,273.13Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1351.83,286.77c-2.16.42-4.16-4.57-5.59-6.83,0,0,3.78.23,5.63,1.43S1354.75,286.2,1351.83,286.77Z"
              fill="#1b6817"
            />
            <path
              d="M1346.24,279.94a36.79,36.79,0,0,1,3.89,2.68,18.84,18.84,0,0,1,1.73,1.61,3.48,3.48,0,0,1,1.14,2,2,2,0,0,0-.46-1.05,5.86,5.86,0,0,0-.76-.89,17.36,17.36,0,0,0-1.76-1.56C1348.82,281.74,1347.52,280.85,1346.24,279.94Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1346.18,286.77c-1.55.3-3-3.29-4-4.91a10.7,10.7,0,0,1,4,1C1347.55,283.74,1348.28,286.36,1346.18,286.77Z"
              fill="#1b6817"
            />
            <path
              d="M1342.16,281.86a26.67,26.67,0,0,1,2.8,1.92,13.61,13.61,0,0,1,1.24,1.16,2.51,2.51,0,0,1,.82,1.45,2.73,2.73,0,0,0-.87-1.4,13.45,13.45,0,0,0-1.27-1.11C1344,283.15,1343.08,282.51,1342.16,281.86Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1345.94,276.5c-1.57.31-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C1347.32,273.44,1348.06,276.08,1345.94,276.5Z"
              fill="#1c7f19"
            />
            <path
              d="M1341.88,271.53a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.55,2.55,0,0,1,.83,1.47,2.85,2.85,0,0,0-.88-1.41,12.57,12.57,0,0,0-1.29-1.13C1343.75,272.85,1342.81,272.2,1341.88,271.53Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1347.71,284.06c2.16.43,4.17-4.57,5.6-6.83,0,0-3.78.23-5.64,1.43S1344.8,283.49,1347.71,284.06Z"
              fill="#1c7f19"
            />
            <path
              d="M1353.31,277.23c-1.28.91-2.58,1.81-3.78,2.81a17.48,17.48,0,0,0-1.77,1.56,5.8,5.8,0,0,0-.75.89,2,2,0,0,0-.47,1.06,3.53,3.53,0,0,1,1.14-2,20.35,20.35,0,0,1,1.74-1.61A36.79,36.79,0,0,1,1353.31,277.23Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1358.9,277.42c2.16.42,4.16-4.58,5.59-6.84,0,0-3.77.23-5.63,1.43S1356,276.84,1358.9,277.42Z"
              fill="#1c7f19"
            />
            <path
              d="M1364.49,270.58c-1.28.92-2.57,1.81-3.78,2.82A19.9,19.9,0,0,0,1359,275a7.15,7.15,0,0,0-.76.89,2.16,2.16,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,17.55,17.55,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1364.49,270.58Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1347.73,278.39c1.57.3,3-3.33,4.07-5a10.92,10.92,0,0,0-4.1,1C1346.35,275.33,1345.61,278,1347.73,278.39Z"
              fill="#1b6817"
            />
            <path
              d="M1351.8,273.42c-.94.67-1.88,1.31-2.75,2.05a11.49,11.49,0,0,0-1.28,1.13,2.8,2.8,0,0,0-.89,1.41,2.57,2.57,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A27.33,27.33,0,0,1,1351.8,273.42Z"
              fill="#30562e"
            />
          </g>
          <path
            d="M1347.57,286.15a9,9,0,0,1-1.64-3,5.23,5.23,0,0,1-.24-1.77,4.13,4.13,0,0,1,.16-.92l.3-.81a13.39,13.39,0,0,0,.54-3.26c.06-1.13.09-2.26.08-3.41a16.34,16.34,0,0,1,.43,3.42,10.35,10.35,0,0,1-.44,3.47,4.58,4.58,0,0,0-.45,1.55,5.19,5.19,0,0,0,.11,1.61A13.8,13.8,0,0,0,1347.57,286.15Z"
            fill="#30562e"
          />
          <path
            d="M1353.69,276.14c-.1.41-.35.84-.46,1.19a3.88,3.88,0,0,0,.37,1.11,9.39,9.39,0,0,1,.72,2.54,11.59,11.59,0,0,1-.63,5.17c0-.86.08-1.72.1-2.57a21,21,0,0,0-.11-2.52,13.82,13.82,0,0,0-.56-2.46c0-.21-.12-.41-.17-.63a1.3,1.3,0,0,1,0-.74C1353.19,276.8,1353.44,276.52,1353.69,276.14Z"
            fill="#30562e"
          />
          <path
            d="M1359,271.63a6.61,6.61,0,0,1-1,1.49c-.38.45-.74.92-.59,1.4a3.64,3.64,0,0,0,.86,1.39,5.4,5.4,0,0,1,.93,1.65,9.92,9.92,0,0,1,.44,3.65,13.84,13.84,0,0,1-.61,3.57,32.91,32.91,0,0,0,.11-3.57,12.13,12.13,0,0,0-.55-3.43,4.8,4.8,0,0,0-.79-1.48,3.75,3.75,0,0,1-.89-1.7,1.38,1.38,0,0,1,.23-1,3.85,3.85,0,0,1,.64-.69A9.38,9.38,0,0,0,1359,271.63Z"
            fill="#30562e"
          />
          <g>
            <path
              d="M1360.11,283.64c1.57.31,3-3.33,4.06-5a10.89,10.89,0,0,0-4.09,1C1358.73,280.58,1358,283.23,1360.11,283.64Z"
              fill="#1b6817"
            />
            <path
              d="M1358.66,286c1.57.31,3-3.33,4.06-5a10.8,10.8,0,0,0-4.09,1C1357.28,283,1356.54,285.61,1358.66,286Z"
              fill="#1b6817"
            />
            <path
              d="M1364.17,278.67c-.93.67-1.87,1.32-2.74,2.05a12.57,12.57,0,0,0-1.29,1.13,2.85,2.85,0,0,0-.88,1.41,2.55,2.55,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A26.17,26.17,0,0,1,1364.17,278.67Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1355.2,285.7c2.16.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.63,1.43S1352.28,285.13,1355.2,285.7Z"
              fill="#1c7f19"
            />
            <path
              d="M1360.79,278.87c-1.28.92-2.58,1.81-3.78,2.82a17.27,17.27,0,0,0-1.76,1.55,5.86,5.86,0,0,0-.76.89,2.07,2.07,0,0,0-.46,1.06,3.47,3.47,0,0,1,1.14-2,16.5,16.5,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1360.79,278.87Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1352.38,279c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C1353.76,276,1354.5,278.63,1352.38,279Z"
              fill="#1c7f19"
            />
            <path
              d="M1348.32,274.08a28.31,28.31,0,0,1,2.82,1.95,12.65,12.65,0,0,1,1.26,1.17,2.49,2.49,0,0,1,.83,1.47,2.78,2.78,0,0,0-.89-1.42,12.6,12.6,0,0,0-1.28-1.13C1350.19,275.39,1349.25,274.74,1348.32,274.08Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1359.09,274c-1.72-.65-.26-3.4-.46-4.55s1.52-1.9,2.89-1.23.57,1.85,1.69,2.55S1360.48,274.54,1359.09,274Z"
              fill="#bc784a"
            />
            <path
              d="M1358.34,274.16c-1.82-.2-1.08-3.23-1.55-4.29s1-2.23,2.49-1.92,1,1.64,2.26,2S1359.81,274.31,1358.34,274.16Z"
              fill="#ed863a"
            />
            <path
              d="M1358.26,274.4c-1.83-.2-.24-2.73-.71-3.79s.08-2,1.57-1.73.94.87,2.19,1.27S1359.73,274.55,1358.26,274.4Z"
              fill="#bc784a"
            />
            <path
              d="M1358.5,274.91c-1.62-.48-.44-2.81-.69-3.76s1.29-1.62,2.58-1.1.64,1.51,1.71,2.05S1359.81,275.3,1358.5,274.91Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M1353.33,274.93c-1.8-.33-.83-3.3-1.22-4.4s1.17-2.13,2.63-1.71.88,1.71,2.1,2.21S1354.79,275.21,1353.33,274.93Z"
              fill="#bc784a"
            />
            <path
              d="M1352.61,275.2c-1.82.13-1.61-3-2.25-3.95s.61-2.37,2.13-2.33,1.27,1.44,2.57,1.61S1354.09,275.1,1352.61,275.2Z"
              fill="#ed863a"
            />
            <path
              d="M1352.57,275.45c-1.82.13-.69-2.64-1.34-3.6s-.26-2,1.26-2,1.07.69,2.37.86S1354.06,275.35,1352.57,275.45Z"
              fill="#bc784a"
            />
            <path
              d="M1352.9,275.92c-1.68-.19-.91-2.7-1.31-3.58s1-1.83,2.35-1.55.88,1.38,2,1.73S1354.26,276.07,1352.9,275.92Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M1347.85,273.21c1.8-.34.82-3.31,1.21-4.4s-1.17-2.14-2.63-1.71-.88,1.71-2.09,2.21S1346.38,273.48,1347.85,273.21Z"
              fill="#bc784a"
            />
            <path
              d="M1348.56,273.48c1.83.13,1.61-3,2.25-4s-.61-2.37-2.13-2.33-1.26,1.44-2.57,1.61S1347.08,273.37,1348.56,273.48Z"
              fill="#ed863a"
            />
            <path
              d="M1348.6,273.73c1.83.13.7-2.64,1.34-3.6s.26-2-1.26-2-1.07.7-2.37.87S1347.12,273.62,1348.6,273.73Z"
              fill="#bc784a"
            />
            <path
              d="M1348.28,274.19c1.67-.19.9-2.69,1.31-3.58s-1-1.82-2.36-1.54-.88,1.37-2,1.72S1346.92,274.35,1348.28,274.19Z"
              fill="#ed863a"
            />
          </g>
          <ellipse
            cx="1360.97"
            cy="282.3"
            rx="1.15"
            ry="0.35"
            transform="translate(271.09 1144.92) rotate(-50.08)"
            fill="#b2eff9"
            opacity="0.25"
          />
        </g>
        <g>
          <path d="M1299.13,292.3v0h0Z" fill="#ef6291" />
          <path
            d="M1326.25,286.78v0c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77Z"
            fill="#ef6291"
          />
          <path
            d="M1320.82,303.8h0a.22.22,0,0,1,0,.08c0,.9-3.51,1.63-7.85,1.63s-7.84-.73-7.84-1.63a.22.22,0,0,1,0-.08H1305l-5.9-11.58h27.12Z"
            fill="#c1567f"
          />
          <path
            d="M1326.25,286.8c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77,6-2.77,13.33-2.77,13.73,1.25,13.79,2.77Z"
            fill="#c16f86"
          />
          <path
            d="M1324.72,286.8c0,1.35-5.69,2.44-12.23,2.44s-11.83-1.1-11.83-2.46,5.29-2.46,11.83-2.46S1324.72,285.44,1324.72,286.8Z"
            fill="#513126"
          />
          <path
            d="M1320.63,304.22c-9.42.46-9.11-11.1-9.11-11.1l-12.15-.43L1305,303.8h.08a.22.22,0,0,0,0,.08c0,.9,3.51,1.63,7.84,1.63C1316.73,305.51,1319.88,305,1320.63,304.22Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <path
            d="M1326.25,286.8v5.52c0,1.52-6.21,2.77-13.54,2.77s-13.53-1.25-13.58-2.77v-5.54c0,1.53,6,2.77,13.33,2.77S1326.25,288.33,1326.25,286.8Z"
            fill="#ef6291"
          />
          <path
            d="M1306.31,289.24h0c-4.27-.46-7.18-1.38-7.18-2.45v5.54c0,1.3,4.58,2.4,10.5,2.69C1305.23,294,1306.31,289.24,1306.31,289.24Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <g>
            <path
              d="M1303.27,284.18c-2.16.42-4.16-4.58-5.59-6.84,0,0,3.77.23,5.63,1.43S1306.19,283.6,1303.27,284.18Z"
              fill="#1c7f19"
            />
            <path
              d="M1297.68,277.34a35.75,35.75,0,0,1,3.88,2.69,17.55,17.55,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.16,2.16,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,19.9,19.9,0,0,0-1.76-1.55C1300.25,279.15,1299,278.26,1297.68,277.34Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1316.06,282c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.64,1.43S1319,281.39,1316.06,282Z"
              fill="#1c7f19"
            />
            <path
              d="M1310.47,275.13a35.35,35.35,0,0,1,3.89,2.68,20.35,20.35,0,0,1,1.74,1.61,3.49,3.49,0,0,1,1.13,2,2,2,0,0,0-.46-1.06,7.07,7.07,0,0,0-.75-.89,20,20,0,0,0-1.77-1.55C1313.05,276.93,1311.75,276,1310.47,275.13Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1310.83,288.77c-2.16.42-4.16-4.57-5.59-6.83,0,0,3.78.23,5.63,1.43S1313.75,288.2,1310.83,288.77Z"
              fill="#1b6817"
            />
            <path
              d="M1305.24,281.94a36.79,36.79,0,0,1,3.89,2.68,18.84,18.84,0,0,1,1.73,1.61,3.48,3.48,0,0,1,1.14,2,2,2,0,0,0-.46-1.05,5.86,5.86,0,0,0-.76-.89,17.36,17.36,0,0,0-1.76-1.56C1307.82,283.74,1306.52,282.85,1305.24,281.94Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1305.18,288.77c-1.55.3-3-3.29-4-4.91a10.7,10.7,0,0,1,4,1C1306.55,285.74,1307.28,288.36,1305.18,288.77Z"
              fill="#1b6817"
            />
            <path
              d="M1301.16,283.86a26.67,26.67,0,0,1,2.8,1.92,13.61,13.61,0,0,1,1.24,1.16,2.51,2.51,0,0,1,.82,1.45,2.73,2.73,0,0,0-.87-1.4,13.45,13.45,0,0,0-1.27-1.11C1303,285.15,1302.08,284.51,1301.16,283.86Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1304.94,278.5c-1.57.31-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C1306.32,275.44,1307.06,278.08,1304.94,278.5Z"
              fill="#1c7f19"
            />
            <path
              d="M1300.88,273.53a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.55,2.55,0,0,1,.83,1.47,2.85,2.85,0,0,0-.88-1.41,12.57,12.57,0,0,0-1.29-1.13C1302.75,274.85,1301.81,274.2,1300.88,273.53Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1306.71,286.06c2.16.43,4.17-4.57,5.6-6.83,0,0-3.78.23-5.64,1.43S1303.8,285.49,1306.71,286.06Z"
              fill="#1c7f19"
            />
            <path
              d="M1312.31,279.23c-1.28.91-2.58,1.81-3.78,2.81a17.48,17.48,0,0,0-1.77,1.56,5.8,5.8,0,0,0-.75.89,2,2,0,0,0-.47,1.06,3.53,3.53,0,0,1,1.14-2,20.35,20.35,0,0,1,1.74-1.61A36.79,36.79,0,0,1,1312.31,279.23Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1317.9,279.42c2.16.42,4.16-4.58,5.59-6.84,0,0-3.77.23-5.63,1.43S1315,278.84,1317.9,279.42Z"
              fill="#1c7f19"
            />
            <path
              d="M1323.49,272.58c-1.28.92-2.57,1.81-3.78,2.82A19.9,19.9,0,0,0,1318,277a7.15,7.15,0,0,0-.76.89,2.16,2.16,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,17.55,17.55,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1323.49,272.58Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1306.73,280.39c1.57.3,3-3.33,4.07-5a10.92,10.92,0,0,0-4.1,1C1305.35,277.33,1304.61,280,1306.73,280.39Z"
              fill="#1b6817"
            />
            <path
              d="M1310.8,275.42c-.94.67-1.88,1.31-2.75,2.05a11.49,11.49,0,0,0-1.28,1.13,2.8,2.8,0,0,0-.89,1.41,2.57,2.57,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A27.33,27.33,0,0,1,1310.8,275.42Z"
              fill="#30562e"
            />
          </g>
          <path
            d="M1306.57,288.15a9,9,0,0,1-1.64-3,5.23,5.23,0,0,1-.24-1.77,4.13,4.13,0,0,1,.16-.92l.3-.81a13.39,13.39,0,0,0,.54-3.26c.06-1.13.09-2.26.08-3.41a16.34,16.34,0,0,1,.43,3.42,10.35,10.35,0,0,1-.44,3.47,4.58,4.58,0,0,0-.45,1.55,5.19,5.19,0,0,0,.11,1.61A13.8,13.8,0,0,0,1306.57,288.15Z"
            fill="#30562e"
          />
          <path
            d="M1312.69,278.14c-.1.41-.35.84-.46,1.19a3.88,3.88,0,0,0,.37,1.11,9.39,9.39,0,0,1,.72,2.54,11.59,11.59,0,0,1-.63,5.17c0-.86.08-1.72.1-2.57a21,21,0,0,0-.11-2.52,13.82,13.82,0,0,0-.56-2.46c0-.21-.12-.41-.17-.63a1.3,1.3,0,0,1,0-.74C1312.19,278.8,1312.44,278.52,1312.69,278.14Z"
            fill="#30562e"
          />
          <path
            d="M1318,273.63a6.61,6.61,0,0,1-1,1.49c-.38.45-.74.92-.59,1.4a3.64,3.64,0,0,0,.86,1.39,5.4,5.4,0,0,1,.93,1.65,9.92,9.92,0,0,1,.44,3.65,13.84,13.84,0,0,1-.61,3.57,32.91,32.91,0,0,0,.11-3.57,12.13,12.13,0,0,0-.55-3.43,4.8,4.8,0,0,0-.79-1.48,3.75,3.75,0,0,1-.89-1.7,1.38,1.38,0,0,1,.23-1,3.85,3.85,0,0,1,.64-.69A9.38,9.38,0,0,0,1318,273.63Z"
            fill="#30562e"
          />
          <g>
            <path
              d="M1319.11,285.64c1.57.31,3-3.33,4.06-5a10.89,10.89,0,0,0-4.09,1C1317.73,282.58,1317,285.23,1319.11,285.64Z"
              fill="#1b6817"
            />
            <path
              d="M1317.66,288c1.57.31,3-3.33,4.06-5a10.8,10.8,0,0,0-4.09,1C1316.28,285,1315.54,287.61,1317.66,288Z"
              fill="#1b6817"
            />
            <path
              d="M1323.17,280.67c-.93.67-1.87,1.32-2.74,2.05a12.57,12.57,0,0,0-1.29,1.13,2.85,2.85,0,0,0-.88,1.41,2.55,2.55,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A26.17,26.17,0,0,1,1323.17,280.67Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1314.2,287.7c2.16.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.63,1.43S1311.28,287.13,1314.2,287.7Z"
              fill="#1c7f19"
            />
            <path
              d="M1319.79,280.87c-1.28.92-2.58,1.81-3.78,2.82a17.27,17.27,0,0,0-1.76,1.55,5.86,5.86,0,0,0-.76.89,2.07,2.07,0,0,0-.46,1.06,3.47,3.47,0,0,1,1.14-2,16.5,16.5,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1319.79,280.87Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1311.38,281c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C1312.76,278,1313.5,280.63,1311.38,281Z"
              fill="#1c7f19"
            />
            <path
              d="M1307.32,276.08a28.31,28.31,0,0,1,2.82,1.95,12.65,12.65,0,0,1,1.26,1.17,2.49,2.49,0,0,1,.83,1.47,2.78,2.78,0,0,0-.89-1.42,12.6,12.6,0,0,0-1.28-1.13C1309.19,277.39,1308.25,276.74,1307.32,276.08Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1318.09,276c-1.72-.65-.26-3.4-.46-4.55s1.52-1.9,2.89-1.23.57,1.85,1.69,2.55S1319.48,276.54,1318.09,276Z"
              fill="#414182"
            />
            <path
              d="M1317.34,276.16c-1.82-.2-1.08-3.23-1.55-4.29s1-2.23,2.49-1.92,1,1.64,2.26,2S1318.81,276.31,1317.34,276.16Z"
              fill="#4d4d9e"
            />
            <path
              d="M1317.26,276.4c-1.83-.2-.24-2.73-.71-3.79s.08-2,1.57-1.73.94.87,2.19,1.27S1318.73,276.55,1317.26,276.4Z"
              fill="#414182"
            />
            <path
              d="M1317.5,276.91c-1.62-.48-.44-2.81-.69-3.76s1.29-1.62,2.58-1.1.64,1.51,1.71,2.05S1318.81,277.3,1317.5,276.91Z"
              fill="#4d4d9e"
            />
          </g>
          <g>
            <path
              d="M1312.33,276.93c-1.8-.33-.83-3.3-1.22-4.4s1.17-2.13,2.63-1.71.88,1.71,2.1,2.21S1313.79,277.21,1312.33,276.93Z"
              fill="#414182"
            />
            <path
              d="M1311.61,277.2c-1.82.13-1.61-3-2.25-3.95s.61-2.37,2.13-2.33,1.27,1.44,2.57,1.61S1313.09,277.1,1311.61,277.2Z"
              fill="#4d4d9e"
            />
            <path
              d="M1311.57,277.45c-1.82.13-.69-2.64-1.34-3.6s-.26-2,1.26-2,1.07.69,2.37.86S1313.06,277.35,1311.57,277.45Z"
              fill="#414182"
            />
            <path
              d="M1311.9,277.92c-1.68-.19-.91-2.7-1.31-3.58s1-1.83,2.35-1.55.88,1.38,2,1.73S1313.26,278.07,1311.9,277.92Z"
              fill="#4d4d9e"
            />
          </g>
          <g>
            <path
              d="M1306.85,275.21c1.8-.34.82-3.31,1.21-4.4s-1.17-2.14-2.63-1.71-.88,1.71-2.09,2.21S1305.38,275.48,1306.85,275.21Z"
              fill="#414182"
            />
            <path
              d="M1307.56,275.48c1.83.13,1.61-3,2.25-4s-.61-2.37-2.13-2.33-1.26,1.44-2.57,1.61S1306.08,275.37,1307.56,275.48Z"
              fill="#4d4d9e"
            />
            <path
              d="M1307.6,275.73c1.83.13.7-2.64,1.34-3.6s.26-2-1.26-2-1.07.7-2.37.87S1306.12,275.62,1307.6,275.73Z"
              fill="#414182"
            />
            <path
              d="M1307.28,276.19c1.67-.19.9-2.69,1.31-3.58s-1-1.82-2.36-1.54-.88,1.37-2,1.72S1305.92,276.35,1307.28,276.19Z"
              fill="#4d4d9e"
            />
          </g>
          <ellipse
            cx="1319.97"
            cy="284.3"
            rx="1.15"
            ry="0.35"
            transform="translate(254.87 1114.19) rotate(-50.08)"
            fill="#b2eff9"
            opacity="0.25"
          />
        </g>
        <g>
          <path d="M1260.13,297.3v0h0Z" fill="#ef6291" />
          <path
            d="M1287.25,291.78v0c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77Z"
            fill="#ef6291"
          />
          <path
            d="M1281.82,308.8h0a.22.22,0,0,1,0,.08c0,.9-3.51,1.63-7.85,1.63s-7.84-.73-7.84-1.63a.22.22,0,0,1,0-.08H1266l-5.9-11.58h27.12Z"
            fill="#c1567f"
          />
          <path
            d="M1287.25,291.8c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77,6-2.77,13.33-2.77,13.73,1.25,13.79,2.77Z"
            fill="#c16f86"
          />
          <path
            d="M1285.72,291.8c0,1.35-5.69,2.44-12.23,2.44s-11.83-1.1-11.83-2.46,5.29-2.46,11.83-2.46S1285.72,290.44,1285.72,291.8Z"
            fill="#513126"
          />
          <path
            d="M1281.63,309.22c-9.42.46-9.11-11.1-9.11-11.1l-12.15-.43L1266,308.8h.08a.22.22,0,0,0,0,.08c0,.9,3.51,1.63,7.84,1.63C1277.73,310.51,1280.88,310,1281.63,309.22Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <path
            d="M1287.25,291.8v5.52c0,1.52-6.21,2.77-13.54,2.77s-13.53-1.25-13.58-2.77v-5.54c0,1.53,6,2.77,13.33,2.77S1287.25,293.33,1287.25,291.8Z"
            fill="#ef6291"
          />
          <path
            d="M1267.31,294.24h0c-4.27-.46-7.18-1.38-7.18-2.45v5.54c0,1.3,4.58,2.4,10.5,2.69C1266.23,299,1267.31,294.24,1267.31,294.24Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <g>
            <path
              d="M1264.27,289.18c-2.16.42-4.16-4.58-5.59-6.84,0,0,3.77.23,5.63,1.43S1267.19,288.6,1264.27,289.18Z"
              fill="#1c7f19"
            />
            <path
              d="M1258.68,282.34a35.75,35.75,0,0,1,3.88,2.69,17.55,17.55,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.16,2.16,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,19.9,19.9,0,0,0-1.76-1.55C1261.25,284.15,1260,283.26,1258.68,282.34Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1277.06,287c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.64,1.43S1280,286.39,1277.06,287Z"
              fill="#1c7f19"
            />
            <path
              d="M1271.47,280.13a35.35,35.35,0,0,1,3.89,2.68,20.35,20.35,0,0,1,1.74,1.61,3.49,3.49,0,0,1,1.13,2,2,2,0,0,0-.46-1.06,7.07,7.07,0,0,0-.75-.89,20,20,0,0,0-1.77-1.55C1274.05,281.93,1272.75,281,1271.47,280.13Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1271.83,293.77c-2.16.42-4.16-4.57-5.59-6.83,0,0,3.78.23,5.63,1.43S1274.75,293.2,1271.83,293.77Z"
              fill="#1b6817"
            />
            <path
              d="M1266.24,286.94a36.79,36.79,0,0,1,3.89,2.68,18.84,18.84,0,0,1,1.73,1.61,3.48,3.48,0,0,1,1.14,2,2,2,0,0,0-.46-1.05,5.86,5.86,0,0,0-.76-.89,17.36,17.36,0,0,0-1.76-1.56C1268.82,288.74,1267.52,287.85,1266.24,286.94Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1266.18,293.77c-1.55.3-3-3.29-4-4.91a10.7,10.7,0,0,1,4,1C1267.55,290.74,1268.28,293.36,1266.18,293.77Z"
              fill="#1b6817"
            />
            <path
              d="M1262.16,288.86a26.67,26.67,0,0,1,2.8,1.92,13.61,13.61,0,0,1,1.24,1.16,2.51,2.51,0,0,1,.82,1.45,2.73,2.73,0,0,0-.87-1.4,13.45,13.45,0,0,0-1.27-1.11C1264,290.15,1263.08,289.51,1262.16,288.86Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1265.94,283.5c-1.57.31-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C1267.32,280.44,1268.06,283.08,1265.94,283.5Z"
              fill="#1c7f19"
            />
            <path
              d="M1261.88,278.53a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.55,2.55,0,0,1,.83,1.47,2.85,2.85,0,0,0-.88-1.41,12.57,12.57,0,0,0-1.29-1.13C1263.75,279.85,1262.81,279.2,1261.88,278.53Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1267.71,291.06c2.16.43,4.17-4.57,5.6-6.83,0,0-3.78.23-5.64,1.43S1264.8,290.49,1267.71,291.06Z"
              fill="#1c7f19"
            />
            <path
              d="M1273.31,284.23c-1.28.91-2.58,1.81-3.78,2.81a17.48,17.48,0,0,0-1.77,1.56,5.8,5.8,0,0,0-.75.89,2,2,0,0,0-.47,1.06,3.53,3.53,0,0,1,1.14-2,20.35,20.35,0,0,1,1.74-1.61A36.79,36.79,0,0,1,1273.31,284.23Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1278.9,284.42c2.16.42,4.16-4.58,5.59-6.84,0,0-3.77.23-5.63,1.43S1276,283.84,1278.9,284.42Z"
              fill="#1c7f19"
            />
            <path
              d="M1284.49,277.58c-1.28.92-2.57,1.81-3.78,2.82A19.9,19.9,0,0,0,1279,282a7.15,7.15,0,0,0-.76.89,2.16,2.16,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,17.55,17.55,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1284.49,277.58Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1267.73,285.39c1.57.3,3-3.33,4.07-5a10.92,10.92,0,0,0-4.1,1C1266.35,282.33,1265.61,285,1267.73,285.39Z"
              fill="#1b6817"
            />
            <path
              d="M1271.8,280.42c-.94.67-1.88,1.31-2.75,2.05a11.49,11.49,0,0,0-1.28,1.13,2.8,2.8,0,0,0-.89,1.41,2.57,2.57,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A27.33,27.33,0,0,1,1271.8,280.42Z"
              fill="#30562e"
            />
          </g>
          <path
            d="M1267.57,293.15a9,9,0,0,1-1.64-3,5.23,5.23,0,0,1-.24-1.77,4.13,4.13,0,0,1,.16-.92l.3-.81a13.39,13.39,0,0,0,.54-3.26c.06-1.13.09-2.26.08-3.41a16.34,16.34,0,0,1,.43,3.42,10.35,10.35,0,0,1-.44,3.47,4.58,4.58,0,0,0-.45,1.55,5.19,5.19,0,0,0,.11,1.61A13.8,13.8,0,0,0,1267.57,293.15Z"
            fill="#30562e"
          />
          <path
            d="M1273.69,283.14c-.1.41-.35.84-.46,1.19a3.88,3.88,0,0,0,.37,1.11,9.39,9.39,0,0,1,.72,2.54,11.59,11.59,0,0,1-.63,5.17c0-.86.08-1.72.1-2.57a21,21,0,0,0-.11-2.52,13.82,13.82,0,0,0-.56-2.46c0-.21-.12-.41-.17-.63a1.3,1.3,0,0,1,0-.74C1273.19,283.8,1273.44,283.52,1273.69,283.14Z"
            fill="#30562e"
          />
          <path
            d="M1279,278.63a6.61,6.61,0,0,1-1,1.49c-.38.45-.74.92-.59,1.4a3.64,3.64,0,0,0,.86,1.39,5.4,5.4,0,0,1,.93,1.65,9.92,9.92,0,0,1,.44,3.65,13.84,13.84,0,0,1-.61,3.57,32.91,32.91,0,0,0,.11-3.57,12.13,12.13,0,0,0-.55-3.43,4.8,4.8,0,0,0-.79-1.48,3.75,3.75,0,0,1-.89-1.7,1.38,1.38,0,0,1,.23-1,3.85,3.85,0,0,1,.64-.69A9.38,9.38,0,0,0,1279,278.63Z"
            fill="#30562e"
          />
          <g>
            <path
              d="M1280.11,290.64c1.57.31,3-3.33,4.06-5a10.89,10.89,0,0,0-4.09,1C1278.73,287.58,1278,290.23,1280.11,290.64Z"
              fill="#1b6817"
            />
            <path
              d="M1278.66,293c1.57.31,3-3.33,4.06-5a10.8,10.8,0,0,0-4.09,1C1277.28,290,1276.54,292.61,1278.66,293Z"
              fill="#1b6817"
            />
            <path
              d="M1284.17,285.67c-.93.67-1.87,1.32-2.74,2.05a12.57,12.57,0,0,0-1.29,1.13,2.85,2.85,0,0,0-.88,1.41,2.55,2.55,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A26.17,26.17,0,0,1,1284.17,285.67Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1275.2,292.7c2.16.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.63,1.43S1272.28,292.13,1275.2,292.7Z"
              fill="#1c7f19"
            />
            <path
              d="M1280.79,285.87c-1.28.92-2.58,1.81-3.78,2.82a17.27,17.27,0,0,0-1.76,1.55,5.86,5.86,0,0,0-.76.89,2.07,2.07,0,0,0-.46,1.06,3.47,3.47,0,0,1,1.14-2,16.5,16.5,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1280.79,285.87Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1272.38,286c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C1273.76,283,1274.5,285.63,1272.38,286Z"
              fill="#1c7f19"
            />
            <path
              d="M1268.32,281.08a28.31,28.31,0,0,1,2.82,1.95,12.65,12.65,0,0,1,1.26,1.17,2.49,2.49,0,0,1,.83,1.47,2.78,2.78,0,0,0-.89-1.42,12.6,12.6,0,0,0-1.28-1.13C1270.19,282.39,1269.25,281.74,1268.32,281.08Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1279.09,281c-1.72-.65-.26-3.4-.46-4.55s1.52-1.9,2.89-1.23.57,1.85,1.69,2.55S1280.48,281.54,1279.09,281Z"
              fill="#bc784a"
            />
            <path
              d="M1278.34,281.16c-1.82-.2-1.08-3.23-1.55-4.29s1-2.23,2.49-1.92,1,1.64,2.26,2S1279.81,281.31,1278.34,281.16Z"
              fill="#ed863a"
            />
            <path
              d="M1278.26,281.4c-1.83-.2-.24-2.73-.71-3.79s.08-2,1.57-1.73.94.87,2.19,1.27S1279.73,281.55,1278.26,281.4Z"
              fill="#bc784a"
            />
            <path
              d="M1278.5,281.91c-1.62-.48-.44-2.81-.69-3.76s1.29-1.62,2.58-1.1.64,1.51,1.71,2.05S1279.81,282.3,1278.5,281.91Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M1273.33,281.93c-1.8-.33-.83-3.3-1.22-4.4s1.17-2.13,2.63-1.71.88,1.71,2.1,2.21S1274.79,282.21,1273.33,281.93Z"
              fill="#bc784a"
            />
            <path
              d="M1272.61,282.2c-1.82.13-1.61-3-2.25-3.95s.61-2.37,2.13-2.33,1.27,1.44,2.57,1.61S1274.09,282.1,1272.61,282.2Z"
              fill="#ed863a"
            />
            <path
              d="M1272.57,282.45c-1.82.13-.69-2.64-1.34-3.6s-.26-2,1.26-2,1.07.69,2.37.86S1274.06,282.35,1272.57,282.45Z"
              fill="#bc784a"
            />
            <path
              d="M1272.9,282.92c-1.68-.19-.91-2.7-1.31-3.58s1-1.83,2.35-1.55.88,1.38,2,1.73S1274.26,283.07,1272.9,282.92Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M1267.85,280.21c1.8-.34.82-3.31,1.21-4.4s-1.17-2.14-2.63-1.71-.88,1.71-2.09,2.21S1266.38,280.48,1267.85,280.21Z"
              fill="#bc784a"
            />
            <path
              d="M1268.56,280.48c1.83.13,1.61-3,2.25-4s-.61-2.37-2.13-2.33-1.26,1.44-2.57,1.61S1267.08,280.37,1268.56,280.48Z"
              fill="#ed863a"
            />
            <path
              d="M1268.6,280.73c1.83.13.7-2.64,1.34-3.6s.26-2-1.26-2-1.07.7-2.37.87S1267.12,280.62,1268.6,280.73Z"
              fill="#bc784a"
            />
            <path
              d="M1268.28,281.19c1.67-.19.9-2.69,1.31-3.58s-1-1.82-2.36-1.54-.88,1.37-2,1.72S1266.92,281.35,1268.28,281.19Z"
              fill="#ed863a"
            />
          </g>
          <ellipse
            cx="1280.97"
            cy="289.3"
            rx="1.15"
            ry="0.35"
            transform="translate(237.06 1086.07) rotate(-50.08)"
            fill="#b2eff9"
            opacity="0.25"
          />
        </g>
        <g>
          <path d="M1219.13,303.3v0h0Z" fill="#ef6291" />
          <path
            d="M1246.25,297.78v0c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77Z"
            fill="#ef6291"
          />
          <path
            d="M1240.82,314.8h0a.22.22,0,0,1,0,.08c0,.9-3.51,1.63-7.85,1.63s-7.84-.73-7.84-1.63a.22.22,0,0,1,0-.08H1225l-5.9-11.58h27.12Z"
            fill="#c1567f"
          />
          <path
            d="M1246.25,297.8c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77,6-2.77,13.33-2.77,13.73,1.25,13.79,2.77Z"
            fill="#c16f86"
          />
          <path
            d="M1244.72,297.8c0,1.35-5.69,2.44-12.23,2.44s-11.83-1.1-11.83-2.46,5.29-2.46,11.83-2.46S1244.72,296.44,1244.72,297.8Z"
            fill="#513126"
          />
          <path
            d="M1240.63,315.22c-9.42.46-9.11-11.1-9.11-11.1l-12.15-.43L1225,314.8h.08a.22.22,0,0,0,0,.08c0,.9,3.51,1.63,7.84,1.63C1236.73,316.51,1239.88,316,1240.63,315.22Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <path
            d="M1246.25,297.8v5.52c0,1.52-6.21,2.77-13.54,2.77s-13.53-1.25-13.58-2.77v-5.54c0,1.53,6,2.77,13.33,2.77S1246.25,299.33,1246.25,297.8Z"
            fill="#ef6291"
          />
          <path
            d="M1226.31,300.24h0c-4.27-.46-7.18-1.38-7.18-2.45v5.54c0,1.3,4.58,2.4,10.5,2.69C1225.23,305,1226.31,300.24,1226.31,300.24Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <g>
            <path
              d="M1223.27,295.18c-2.16.42-4.16-4.58-5.59-6.84,0,0,3.77.23,5.63,1.43S1226.19,294.6,1223.27,295.18Z"
              fill="#1c7f19"
            />
            <path
              d="M1217.68,288.34a35.75,35.75,0,0,1,3.88,2.69,17.55,17.55,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.16,2.16,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,19.9,19.9,0,0,0-1.76-1.55C1220.25,290.15,1219,289.26,1217.68,288.34Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1236.06,293c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.64,1.43S1239,292.39,1236.06,293Z"
              fill="#1c7f19"
            />
            <path
              d="M1230.47,286.13a35.35,35.35,0,0,1,3.89,2.68,20.35,20.35,0,0,1,1.74,1.61,3.49,3.49,0,0,1,1.13,2,2,2,0,0,0-.46-1.06,7.07,7.07,0,0,0-.75-.89,20,20,0,0,0-1.77-1.55C1233.05,287.93,1231.75,287,1230.47,286.13Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1230.83,299.77c-2.16.42-4.16-4.57-5.59-6.83,0,0,3.78.23,5.63,1.43S1233.75,299.2,1230.83,299.77Z"
              fill="#1b6817"
            />
            <path
              d="M1225.24,292.94a36.79,36.79,0,0,1,3.89,2.68,18.84,18.84,0,0,1,1.73,1.61,3.48,3.48,0,0,1,1.14,2,2,2,0,0,0-.46-1.05,5.86,5.86,0,0,0-.76-.89,17.36,17.36,0,0,0-1.76-1.56C1227.82,294.74,1226.52,293.85,1225.24,292.94Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1225.18,299.77c-1.55.3-3-3.29-4-4.91a10.7,10.7,0,0,1,4,1C1226.55,296.74,1227.28,299.36,1225.18,299.77Z"
              fill="#1b6817"
            />
            <path
              d="M1221.16,294.86a26.67,26.67,0,0,1,2.8,1.92,13.61,13.61,0,0,1,1.24,1.16,2.51,2.51,0,0,1,.82,1.45,2.73,2.73,0,0,0-.87-1.4,13.45,13.45,0,0,0-1.27-1.11C1223,296.15,1222.08,295.51,1221.16,294.86Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1224.94,289.5c-1.57.31-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C1226.32,286.44,1227.06,289.08,1224.94,289.5Z"
              fill="#1c7f19"
            />
            <path
              d="M1220.88,284.53a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.55,2.55,0,0,1,.83,1.47,2.85,2.85,0,0,0-.88-1.41,12.57,12.57,0,0,0-1.29-1.13C1222.75,285.85,1221.81,285.2,1220.88,284.53Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1226.71,297.06c2.16.43,4.17-4.57,5.6-6.83,0,0-3.78.23-5.64,1.43S1223.8,296.49,1226.71,297.06Z"
              fill="#1c7f19"
            />
            <path
              d="M1232.31,290.23c-1.28.91-2.58,1.81-3.78,2.81a17.48,17.48,0,0,0-1.77,1.56,5.8,5.8,0,0,0-.75.89,2,2,0,0,0-.47,1.06,3.53,3.53,0,0,1,1.14-2,20.35,20.35,0,0,1,1.74-1.61A36.79,36.79,0,0,1,1232.31,290.23Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1237.9,290.42c2.16.42,4.16-4.58,5.59-6.84,0,0-3.77.23-5.63,1.43S1235,289.84,1237.9,290.42Z"
              fill="#1c7f19"
            />
            <path
              d="M1243.49,283.58c-1.28.92-2.57,1.81-3.78,2.82A19.9,19.9,0,0,0,1238,288a7.15,7.15,0,0,0-.76.89,2.16,2.16,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,17.55,17.55,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1243.49,283.58Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1226.73,291.39c1.57.3,3-3.33,4.07-5a10.92,10.92,0,0,0-4.1,1C1225.35,288.33,1224.61,291,1226.73,291.39Z"
              fill="#1b6817"
            />
            <path
              d="M1230.8,286.42c-.94.67-1.88,1.31-2.75,2.05a11.49,11.49,0,0,0-1.28,1.13,2.8,2.8,0,0,0-.89,1.41,2.57,2.57,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A27.33,27.33,0,0,1,1230.8,286.42Z"
              fill="#30562e"
            />
          </g>
          <path
            d="M1226.57,299.15a9,9,0,0,1-1.64-3,5.23,5.23,0,0,1-.24-1.77,4.13,4.13,0,0,1,.16-.92l.3-.81a13.39,13.39,0,0,0,.54-3.26c.06-1.13.09-2.26.08-3.41a16.34,16.34,0,0,1,.43,3.42,10.35,10.35,0,0,1-.44,3.47,4.58,4.58,0,0,0-.45,1.55,5.19,5.19,0,0,0,.11,1.61A13.8,13.8,0,0,0,1226.57,299.15Z"
            fill="#30562e"
          />
          <path
            d="M1232.69,289.14c-.1.41-.35.84-.46,1.19a3.88,3.88,0,0,0,.37,1.11,9.39,9.39,0,0,1,.72,2.54,11.59,11.59,0,0,1-.63,5.17c0-.86.08-1.72.1-2.57a21,21,0,0,0-.11-2.52,13.82,13.82,0,0,0-.56-2.46c0-.21-.12-.41-.17-.63a1.3,1.3,0,0,1,0-.74C1232.19,289.8,1232.44,289.52,1232.69,289.14Z"
            fill="#30562e"
          />
          <path
            d="M1238,284.63a6.61,6.61,0,0,1-1,1.49c-.38.45-.74.92-.59,1.4a3.64,3.64,0,0,0,.86,1.39,5.4,5.4,0,0,1,.93,1.65,9.92,9.92,0,0,1,.44,3.65,13.84,13.84,0,0,1-.61,3.57,32.91,32.91,0,0,0,.11-3.57,12.13,12.13,0,0,0-.55-3.43,4.8,4.8,0,0,0-.79-1.48,3.75,3.75,0,0,1-.89-1.7,1.38,1.38,0,0,1,.23-1,3.85,3.85,0,0,1,.64-.69A9.38,9.38,0,0,0,1238,284.63Z"
            fill="#30562e"
          />
          <g>
            <path
              d="M1239.11,296.64c1.57.31,3-3.33,4.06-5a10.89,10.89,0,0,0-4.09,1C1237.73,293.58,1237,296.23,1239.11,296.64Z"
              fill="#1b6817"
            />
            <path
              d="M1237.66,299c1.57.31,3-3.33,4.06-5a10.8,10.8,0,0,0-4.09,1C1236.28,296,1235.54,298.61,1237.66,299Z"
              fill="#1b6817"
            />
            <path
              d="M1243.17,291.67c-.93.67-1.87,1.32-2.74,2.05a12.57,12.57,0,0,0-1.29,1.13,2.85,2.85,0,0,0-.88,1.41,2.55,2.55,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A26.17,26.17,0,0,1,1243.17,291.67Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1234.2,298.7c2.16.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.63,1.43S1231.28,298.13,1234.2,298.7Z"
              fill="#1c7f19"
            />
            <path
              d="M1239.79,291.87c-1.28.92-2.58,1.81-3.78,2.82a17.27,17.27,0,0,0-1.76,1.55,5.86,5.86,0,0,0-.76.89,2.07,2.07,0,0,0-.46,1.06,3.47,3.47,0,0,1,1.14-2,16.5,16.5,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1239.79,291.87Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1231.38,292c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C1232.76,289,1233.5,291.63,1231.38,292Z"
              fill="#1c7f19"
            />
            <path
              d="M1227.32,287.08a28.31,28.31,0,0,1,2.82,1.95,12.65,12.65,0,0,1,1.26,1.17,2.49,2.49,0,0,1,.83,1.47,2.78,2.78,0,0,0-.89-1.42,12.6,12.6,0,0,0-1.28-1.13C1229.19,288.39,1228.25,287.74,1227.32,287.08Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1238.09,287c-1.72-.65-.26-3.4-.46-4.55s1.52-1.9,2.89-1.23.57,1.85,1.69,2.55S1239.48,287.54,1238.09,287Z"
              fill="#89457f"
            />
            <path
              d="M1237.34,287.16c-1.82-.2-1.08-3.23-1.55-4.29s1-2.23,2.49-1.92,1,1.64,2.26,2S1238.81,287.31,1237.34,287.16Z"
              fill="#a04d90"
            />
            <path
              d="M1237.26,287.4c-1.83-.2-.24-2.73-.71-3.79s.08-2,1.57-1.73.94.87,2.19,1.27S1238.73,287.55,1237.26,287.4Z"
              fill="#89457f"
            />
            <path
              d="M1237.5,287.91c-1.62-.48-.44-2.81-.69-3.76s1.29-1.62,2.58-1.1.64,1.51,1.71,2.05S1238.81,288.3,1237.5,287.91Z"
              fill="#a04d90"
            />
          </g>
          <g>
            <path
              d="M1232.33,287.93c-1.8-.33-.83-3.3-1.22-4.4s1.17-2.13,2.63-1.71.88,1.71,2.1,2.21S1233.79,288.21,1232.33,287.93Z"
              fill="#89457f"
            />
            <path
              d="M1231.61,288.2c-1.82.13-1.61-3-2.25-3.95s.61-2.37,2.13-2.33,1.27,1.44,2.57,1.61S1233.09,288.1,1231.61,288.2Z"
              fill="#a04d90"
            />
            <path
              d="M1231.57,288.45c-1.82.13-.69-2.64-1.34-3.6s-.26-2,1.26-2,1.07.69,2.37.86S1233.06,288.35,1231.57,288.45Z"
              fill="#89457f"
            />
            <path
              d="M1231.9,288.92c-1.68-.19-.91-2.7-1.31-3.58s1-1.83,2.35-1.55.88,1.38,2,1.73S1233.26,289.07,1231.9,288.92Z"
              fill="#a04d90"
            />
          </g>
          <g>
            <path
              d="M1226.85,286.21c1.8-.34.82-3.31,1.21-4.4s-1.17-2.14-2.63-1.71-.88,1.71-2.09,2.21S1225.38,286.48,1226.85,286.21Z"
              fill="#89457f"
            />
            <path
              d="M1227.56,286.48c1.83.13,1.61-3,2.25-4s-.61-2.37-2.13-2.33-1.26,1.44-2.57,1.61S1226.08,286.37,1227.56,286.48Z"
              fill="#a04d90"
            />
            <path
              d="M1227.6,286.73c1.83.13.7-2.64,1.34-3.6s.26-2-1.26-2-1.07.7-2.37.87S1226.12,286.62,1227.6,286.73Z"
              fill="#89457f"
            />
            <path
              d="M1227.28,287.19c1.67-.19.9-2.69,1.31-3.58s-1-1.82-2.36-1.54-.88,1.37-2,1.72S1225.92,287.35,1227.28,287.19Z"
              fill="#a04d90"
            />
          </g>
          <ellipse
            cx="1239.97"
            cy="295.3"
            rx="1.15"
            ry="0.35"
            transform="translate(217.77 1056.78) rotate(-50.08)"
            fill="#b2eff9"
            opacity="0.25"
          />
        </g>
        <g>
          <g>
            <path
              d="M1393.94,485.51c-.12-.82-.18-1.67-.22-2.49a18.55,18.55,0,0,1,.11-3.65c.15-1.08.47-2.13.71-3.19a10.52,10.52,0,0,0,.32-2.85c0-1.05-.34-2.06-.42-3.1a7,7,0,0,1,.21-2.37c.2-.54.42-1.06.65-1.56a12.73,12.73,0,0,1,.92-1.38.22.22,0,0,0,0-.3,11.13,11.13,0,0,1,12.37-5.32,3.47,3.47,0,0,0,.84.87,7.52,7.52,0,0,0,2.56.94,4.89,4.89,0,0,1,2.65,1.37,25.55,25.55,0,0,1,1.79,2.87,5.28,5.28,0,0,0,1.19,1.26,5.13,5.13,0,0,0,1.46.68,4,4,0,0,1,1.53.95,14.46,14.46,0,0,1,1.05,1.39,11.43,11.43,0,0,0,1.23,1.28,10.83,10.83,0,0,1,.89,1c1.31,1.73,1.42,4,1.9,6.08a8.58,8.58,0,0,0,1.43,3.36,15.39,15.39,0,0,0,2.13,2.14,7.22,7.22,0,0,1,1.62,1.86,8.08,8.08,0,0,1,.72,3.4c.14,2.78-.1,5.58.23,8.36a17.25,17.25,0,0,0,.35,2c.15.64.38,1.25.5,1.9a4.25,4.25,0,0,1-.19,2.47,19.21,19.21,0,0,1-1.15,2.08,6.33,6.33,0,0,0-1,3.33,5,5,0,0,1,0,1.85,3.9,3.9,0,0,1-.8,1.32,17,17,0,0,0-2,2.36.22.22,0,0,0,0,.13,10.68,10.68,0,0,1-2.86,1.72,11,11,0,0,1-4.8.75,16.74,16.74,0,0,0-3.22-1.69,40.2,40.2,0,0,1-3.82-1.63,11.13,11.13,0,0,1-1.69-1.1c-.52-.42-1-.92-1.52-1.32-1-.76-2.21-1.32-3.19-2.16a5.58,5.58,0,0,1-1.35-1.67c-.33-.62-.56-1.29-.84-1.93a6.21,6.21,0,0,0-1-1.72,17,17,0,0,0-1.48-1.46c-.67-.6-1.37-1.18-2-1.78a49.93,49.93,0,0,1-2.5-5.14,10.39,10.39,0,0,1,.9-2.11c.54-1,1.18-2,1.73-3a.26.26,0,0,0-.13-.39c-.92-.19-1.86-.35-2.77-.62a4,4,0,0,1-1.77-1,3.49,3.49,0,0,1-.68-1.22C1394.16,486.58,1394,486.05,1393.94,485.51Z"
              fill="#396039"
            />
            <path
              d="M1402.59,461.86a139.89,139.89,0,0,1,6.83,13.36c1.06,2.26,2,4.59,3,6.88l2.79,7c3.61,9.34,6.74,18.85,9.63,28.44l2.07,7.21,1.92,7.26,1,3.63.88,3.65,1.75,7.3c1.12,4.87,2.12,9.78,3.19,14.66l2.75,14.76-3-14.7c-1.1-4.88-2.13-9.78-3.28-14.64l-1.79-7.29-.9-3.64-1-3.62-2-7.24-2.11-7.2c-2.83-9.59-5.9-19.11-9.45-28.46l-2.75-7c-1-2.3-1.9-4.63-2.94-6.9A139.69,139.69,0,0,0,1402.59,461.86Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1449.59,528.26c0-1.2-.06-2.39-.14-3.59a79.52,79.52,0,0,1,5.48-17.64c.6-.58,1.18-1.17,1.71-1.78.66-.77,1.23-1.62,1.82-2.44s1.4-1.9,2.08-2.85a24.19,24.19,0,0,0,3.36-5.88c.37-1.06.51-2.15.8-3.23.19-.73.43-1.44.69-2.15,6.84-9.16,14-14.17,18.45-12a5,5,0,0,1,1.6,1.24c.1.32.2.64.28,1a13.85,13.85,0,0,1,.42,4.53,20.27,20.27,0,0,1-.9,4.35,28.63,28.63,0,0,0-1.46,5,18.08,18.08,0,0,0,.18,4.76,22.78,22.78,0,0,1,.35,4.81,6.5,6.5,0,0,1-1.39,4,12,12,0,0,1-2.53,1.81,12.11,12.11,0,0,0-2.71,2.54,3.37,3.37,0,0,0-.94,2.56c.12,1,.54,1.93.71,2.91a8.29,8.29,0,0,1-2,6.55,33.54,33.54,0,0,1-5.57,4.79c-1,.8-2.09,1.61-3.07,2.49-.49.45-1,.92-1.44,1.4s-1,1.17-1.47,1.74a29.62,29.62,0,0,1-7.35,5.66c-1.33.81-2.63,1.64-3.87,2.57-2.25-1.13-3.48-4-3.76-8A20.09,20.09,0,0,0,1449.59,528.26Z"
              fill="#2f4f2f"
            />
            <path
              d="M1485.51,476q-3.94,5.78-7.56,11.77t-7.12,12q-6.88,12.18-12.76,24.87a269,269,0,0,0-10.43,25.94c-1.35,4.46-2.84,8.88-3.86,13.43-1.28,4.49-2,9.11-2.86,13.69a166.44,166.44,0,0,1,6.39-27.23,269.7,269.7,0,0,1,10.28-26q6-12.67,12.94-24.83C1475.17,491.49,1480.11,483.56,1485.51,476Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1450,535c.16-.94.26-1.88.35-2.83a63,63,0,0,1,6.54-13.13c.54-.38,1.07-.76,1.56-1.18s1.17-1.11,1.74-1.68l2-2a19.13,19.13,0,0,0,3.38-4.18c.43-.78.68-1.62,1-2.43.24-.54.52-1.07.81-1.6,6.53-6.31,12.78-9.33,16-7.09a4.1,4.1,0,0,1,1.1,1.17c0,.27.07.53.1.79a11.23,11.23,0,0,1-.25,3.61,16.19,16.19,0,0,1-1.26,3.29,22.67,22.67,0,0,0-1.78,3.76,14.38,14.38,0,0,0-.46,3.75,18.69,18.69,0,0,1-.34,3.81,5.16,5.16,0,0,1-1.6,3,9.5,9.5,0,0,1-2.21,1.1,9.59,9.59,0,0,0-2.45,1.65,2.7,2.7,0,0,0-1.06,1.88c0,.79.18,1.58.19,2.37a6.59,6.59,0,0,1-2.44,4.87,25.87,25.87,0,0,1-5,3c-.92.49-1.84,1-2.71,1.56-.45.29-.89.6-1.31.92s-.91.79-1.38,1.18a23.75,23.75,0,0,1-6.48,3.5,36.12,36.12,0,0,0-3.35,1.52c-1.62-1.17-2.23-3.56-2-6.72A15.26,15.26,0,0,0,1450,535Z"
              fill="#396039"
            />
            <path
              d="M1484.83,498.6q-3.81,4-7.4,8.28t-7.1,8.53q-6.93,8.69-13.15,17.89a215,215,0,0,0-11.48,19c-1.62,3.32-3.36,6.6-4.73,10-1.59,3.36-2.72,6.88-4,10.36a128.83,128.83,0,0,1,8.44-20.55A212.57,212.57,0,0,1,1456.75,533q6.3-9.18,13.31-17.81C1474.73,509.44,1479.62,503.86,1484.83,498.6Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1434.21,535.56a1.36,1.36,0,0,0,.53-.87,1.47,1.47,0,0,0-.55-1,11.37,11.37,0,0,0-1.59-1.25v0a6.91,6.91,0,0,0,1-1,1.55,1.55,0,0,0,.42-.87c0-.63-.64-.91-1.13-1.1-.34-.14-.69-.27-1-.39-.23-1.08-.44-2.21-.64-3.38l.62-.16a12.83,12.83,0,0,0,1.52-.49,2.61,2.61,0,0,0,1-.68.26.26,0,0,0,0-.4c-.48-.28-1-.47-1.51-.7a3.55,3.55,0,0,1-1.31-.84c-.38-.49-.09-1.06-.09-1.6a1.5,1.5,0,0,0-.61-1.08c-.16-.14-.32-.28-.5-.41-.15-1.4-.28-2.84-.39-4.31.29-.07.58-.15.86-.24a4.69,4.69,0,0,0,2-1,1.63,1.63,0,0,0,.3-2,3.71,3.71,0,0,0-2-1.46,7.68,7.68,0,0,0-1.23-.4c-.08-.5-.18-1-.27-1.5,0-1.44-.06-2.9-.07-4.38l.12-.18a2.55,2.55,0,0,1,.82-.5,4.6,4.6,0,0,0,1.23-.92.28.28,0,0,0,0-.37c-.59-.49-2-1.22-1.59-2.19.11-.28.56-.31.8-.44a.77.77,0,0,0,.42-.88c-.18-.65-1-.9-1.35-1.42s.63-.79,1-.81a12.61,12.61,0,0,0,2.13-.07.26.26,0,0,0,.06-.47c-1.09-.78-2.18-1.56-3.33-2.26.21-3.08.51-6,.88-8.75l.48.14a.25.25,0,0,0,.32-.22,10.06,10.06,0,0,1,2.09,1.07c.38.27.76.55,1.12.85s.63-.15.37-.37a12.92,12.92,0,0,0-1.19-.91,24.21,24.21,0,0,0-3-1.82c.35-2.39.78-4.63,1.25-6.68a10.23,10.23,0,0,1,2.58,1.35c.31.28.61.56.93.83a.26.26,0,0,0,.37-.36,7.28,7.28,0,0,0-1-.88c-.61-.57-1.22-1.14-1.85-1.67-.24-.2-.48-.4-.74-.6a45.57,45.57,0,0,1,1.83-5.72,31.07,31.07,0,0,0,3.45,1.39.26.26,0,0,0,.33-.25,5.54,5.54,0,0,0-1.27-2.82,9.87,9.87,0,0,0-1.09-1.24c1.26-2.14,2.66-3.33,4.13-3.33,3,0,5.65,4.86,7.54,12.63-.78.7-1.53,1.44-2.26,2.17a.26.26,0,0,0,.31.41,17.74,17.74,0,0,0,2.19-1.56c.46,2.05.87,4.29,1.22,6.68a42,42,0,0,0-2.31,4.72.28.28,0,0,0,.1.36c1,.51,2,.92,3,1.37.31,3.38.51,7,.57,10.7a19.9,19.9,0,0,0-2.08,4.86,11.12,11.12,0,0,0-.17,3.86c.06.65.14,1.29.17,1.94s0,1.26.11,1.89c.18,1.2.63,2.34.84,3.54a2.92,2.92,0,0,1-.8,2.92,6.86,6.86,0,0,1-2.17.82,1,1,0,0,0-.65.55,1.31,1.31,0,0,0,.18,1,5.34,5.34,0,0,0,2.24,1.91l.82.45c-1.82,11.48-5.09,19.14-8.82,19.14-2.3,0-4.43-2.91-6.15-7.85C1433.87,535.85,1434,535.71,1434.21,535.56Z"
              fill="#659965"
            />
            <path
              d="M1439.84,477l.28,12.43.19,12.43.29,24.86q0,12.43,0,24.87,0,6.21-.12,12.43c-.14,4.14-.14,8.3-.62,12.42.39-4.13.31-8.28.36-12.42s0-8.29,0-12.43l-.16-24.86Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1423.6,495.13a3.32,3.32,0,0,1,2,0c.37.48.74.95,1.12,1.41.56.69,1.15,1.37,1.78,2a19.63,19.63,0,0,1,1.69,2,17.25,17.25,0,0,1,2,3.57,16.23,16.23,0,0,0,2,4.11c.8,1,1.82,1.72,2.7,2.61l0,0c.22.6.43,1.2.64,1.82A49.79,49.79,0,0,1,1440,524.4c0,.31,0,.62-.1.93-.39,2.82-1.43,5.62-1.49,8.48a3.28,3.28,0,0,1-1.62,1.22c-4,1.34-10.28-6.51-13.91-17.53S1419.54,496.46,1423.6,495.13Z"
              fill="#3b6818"
            />
            <path
              d="M1422.82,517.48s17.44,8.89,18,54.79"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.52"
            />
            <path
              d="M1426.35,499.28a9.82,9.82,0,0,1,2.41,4.56c.32,1.62.29,3.29,1,4.83a6.83,6.83,0,0,0,1.58,2.17c.63.59,1.3,1.09,1.91,1.7a5.2,5.2,0,0,1,1.41,2.32,4.5,4.5,0,0,1-.07,2.07,9.46,9.46,0,0,0-.32,2.15,7.16,7.16,0,0,0,.89,2.89,8.11,8.11,0,0,1,.87,3,6.52,6.52,0,0,1-.32,1.9,5.75,5.75,0,0,0-.13,2.08,5.36,5.36,0,0,0,.64,1.89,3.75,3.75,0,0,1,.57,1.62,4.92,4.92,0,0,1-.74,2.42l-.13.26a1.91,1.91,0,0,1-.71.42c-3.2,1.06-8.74-7-12.37-18s-4-20.81-.78-21.87a2.16,2.16,0,0,1,1.35,0A20,20,0,0,0,1426.35,499.28Z"
              fill="#659965"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1384.51,499.89c.06-.41.09-.81.11-1.22a9.53,9.53,0,0,0,0-1.77c-.07-.52-.23-1-.35-1.55a5.39,5.39,0,0,1-.15-1.39c0-.5.16-1,.2-1.5a3.41,3.41,0,0,0-.1-1.15c-.1-.27-.21-.52-.32-.76a4.36,4.36,0,0,0-.45-.67.11.11,0,0,1,0-.15,5.63,5.63,0,0,0-2.7-2.35,5.55,5.55,0,0,0-3.31-.23,1.81,1.81,0,0,1-.41.42,3.48,3.48,0,0,1-1.25.45,2.41,2.41,0,0,0-1.28.67,11.72,11.72,0,0,0-.87,1.4,2.8,2.8,0,0,1-.58.61,2.56,2.56,0,0,1-.71.33,1.78,1.78,0,0,0-.74.46,4.83,4.83,0,0,0-.51.68,7,7,0,0,1-.6.62c-.16.16-.3.32-.44.49a7.76,7.76,0,0,0-.92,3,4.37,4.37,0,0,1-.69,1.63,7.86,7.86,0,0,1-1,1,3.62,3.62,0,0,0-.79.91,3.88,3.88,0,0,0-.35,1.65c-.06,1.35,0,2.71-.11,4.06a8,8,0,0,1-.17,1c-.07.31-.18.61-.24.92a2,2,0,0,0,.09,1.2,9,9,0,0,0,.56,1,3.07,3.07,0,0,1,.51,1.62,2.48,2.48,0,0,0,0,.9,1.88,1.88,0,0,0,.39.65,8.33,8.33,0,0,1,1,1.14.13.13,0,0,1,0,.06,5.11,5.11,0,0,0,1.4.84,5.39,5.39,0,0,0,2.33.37,8,8,0,0,1,1.56-.83,17.89,17.89,0,0,0,1.86-.79,5.46,5.46,0,0,0,.82-.53c.26-.21.48-.45.74-.64.5-.38,1.08-.65,1.55-1a2.91,2.91,0,0,0,.66-.82c.16-.3.27-.62.4-.93a3,3,0,0,1,.52-.84,9.51,9.51,0,0,1,.71-.71l1-.87a26.15,26.15,0,0,0,1.22-2.49,5.24,5.24,0,0,0-.44-1c-.27-.49-.57-1-.84-1.45a.12.12,0,0,1,.06-.19,12.56,12.56,0,0,0,1.35-.31,1.84,1.84,0,0,0,.86-.48,1.9,1.9,0,0,0,.33-.59C1384.41,500.41,1384.46,500.15,1384.51,499.89Z"
              fill="#396039"
            />
            <path
              d="M1380.31,488.39a69.44,69.44,0,0,0-3.21,6.54c-1,2.22-1.89,4.48-2.76,6.75-1.73,4.54-3.22,9.17-4.6,13.83s-2.61,9.36-3.75,14.09c-.56,2.36-1.06,4.74-1.6,7.11l-1.46,7.15,1.34-7.17c.52-2.38,1-4.76,1.55-7.13,1.12-4.74,2.29-9.46,3.68-14.12s2.92-9.29,4.68-13.82A93.92,93.92,0,0,1,1380.31,488.39Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1357.46,520.66c0-.58,0-1.16.07-1.74a39,39,0,0,0-2.66-8.58c-.29-.28-.57-.56-.83-.86s-.6-.79-.89-1.19l-1-1.38a11.75,11.75,0,0,1-1.63-2.86c-.18-.51-.25-1.05-.39-1.57-.09-.35-.21-.7-.33-1-3.33-4.46-6.81-6.89-9-5.85a2.37,2.37,0,0,0-.78.59c0,.16-.1.32-.14.47a6.86,6.86,0,0,0-.2,2.21,10.29,10.29,0,0,0,.44,2.11,14.81,14.81,0,0,1,.71,2.44,9,9,0,0,1-.09,2.32,11.38,11.38,0,0,0-.17,2.33,3.16,3.16,0,0,0,.68,1.94,5.57,5.57,0,0,0,1.22.88,5.56,5.56,0,0,1,1.32,1.24,1.63,1.63,0,0,1,.46,1.24c-.06.48-.26.94-.35,1.41a4,4,0,0,0,1,3.18,15.82,15.82,0,0,0,2.71,2.33c.51.39,1,.79,1.49,1.22.24.21.47.44.7.68s.47.56.71.84a14.54,14.54,0,0,0,3.58,2.75c.64.4,1.28.8,1.88,1.25,1.09-.55,1.69-1.93,1.83-3.87A9.48,9.48,0,0,1,1357.46,520.66Z"
              fill="#2f4f2f"
            />
            <path
              d="M1340,495.24c2.63,3.7,5,7.55,7.29,11.49s4.35,8,6.28,12.07a127.34,127.34,0,0,1,5,12.65,81.35,81.35,0,0,1,3.11,13.24,90.45,90.45,0,0,0-3.27-13.19,133,133,0,0,0-5.06-12.6q-2.86-6.17-6.21-12.09C1344.9,502.87,1342.55,499,1340,495.24Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1357.25,524c-.08-.45-.13-.91-.17-1.37a30.49,30.49,0,0,0-3.18-6.38c-.26-.19-.52-.37-.76-.58s-.56-.54-.84-.81-.65-.64-1-1a9.67,9.67,0,0,1-1.64-2c-.21-.38-.33-.79-.51-1.18s-.25-.53-.39-.78c-3.17-3.07-6.21-4.53-7.77-3.45a2,2,0,0,0-.54.57c0,.13,0,.26,0,.39a5.16,5.16,0,0,0,.12,1.75,7,7,0,0,0,.61,1.6,11.2,11.2,0,0,1,.86,1.82,7.12,7.12,0,0,1,.23,1.83,8.84,8.84,0,0,0,.16,1.85,2.5,2.5,0,0,0,.78,1.43,4.3,4.3,0,0,0,1.07.54,4.36,4.36,0,0,1,1.19.8,1.3,1.3,0,0,1,.52.91c0,.39-.09.77-.09,1.16a3.16,3.16,0,0,0,1.18,2.36,12.8,12.8,0,0,0,2.42,1.49c.45.24.9.48,1.32.76.22.14.43.28.64.44s.44.38.67.57a11.29,11.29,0,0,0,3.15,1.7c.55.23,1.1.47,1.63.74.79-.56,1.08-1.72.94-3.26A7.43,7.43,0,0,1,1357.25,524Z"
              fill="#396039"
            />
            <path
              d="M1340.33,506.25A123.75,123.75,0,0,1,1354,523a100,100,0,0,1,5.52,9.29,62.42,62.42,0,0,1,4.1,10,72.8,72.8,0,0,0-4.25-9.91,106.62,106.62,0,0,0-5.57-9.23q-3-4.47-6.4-8.69C1345.13,511.62,1342.8,508.87,1340.33,506.25Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1364.94,524.21a.67.67,0,0,1-.26-.42.76.76,0,0,1,.27-.51,5.73,5.73,0,0,1,.77-.61v0a4.27,4.27,0,0,1-.48-.47.9.9,0,0,1-.2-.43c0-.3.31-.44.55-.53l.51-.19c.11-.53.21-1.08.31-1.64l-.31-.08a6.23,6.23,0,0,1-.73-.24,1.25,1.25,0,0,1-.51-.33.13.13,0,0,1,0-.2c.24-.13.49-.23.74-.34a1.57,1.57,0,0,0,.63-.41c.19-.23,0-.51,0-.77a.74.74,0,0,1,.3-.52l.24-.21c.08-.68.14-1.37.2-2.09l-.42-.12a2.27,2.27,0,0,1-1-.5.79.79,0,0,1-.14-1,1.76,1.76,0,0,1,1-.71,3.82,3.82,0,0,1,.6-.19c0-.25.08-.49.12-.73,0-.7,0-1.41,0-2.13l-.06-.09a1.15,1.15,0,0,0-.4-.24,2.37,2.37,0,0,1-.59-.45.12.12,0,0,1,0-.18c.28-.24,1-.59.77-1.07-.06-.13-.28-.15-.39-.21a.36.36,0,0,1-.21-.42c.09-.32.48-.44.66-.7s-.31-.38-.5-.39a7.23,7.23,0,0,1-1,0,.13.13,0,0,1,0-.23c.53-.38,1.07-.76,1.62-1.1-.1-1.5-.24-2.92-.43-4.25l-.23.06a.12.12,0,0,1-.15-.1,4.86,4.86,0,0,0-1,.51l-.54.42c-.13.1-.31-.07-.18-.18a4.92,4.92,0,0,1,.58-.44,11.38,11.38,0,0,1,1.46-.89c-.18-1.16-.38-2.25-.61-3.24a5.18,5.18,0,0,0-1.26.65l-.45.41c-.12.1-.29-.06-.18-.18a4.69,4.69,0,0,1,.47-.43c.3-.27.59-.55.9-.81l.36-.29a22.88,22.88,0,0,0-.89-2.78,14.39,14.39,0,0,1-1.68.68.13.13,0,0,1-.16-.13,2.76,2.76,0,0,1,.62-1.37,5.05,5.05,0,0,1,.53-.6c-.61-1-1.29-1.62-2-1.62-1.44,0-2.74,2.36-3.66,6.14.38.34.74.7,1.1,1.06a.13.13,0,0,1-.16.2,11.35,11.35,0,0,1-1.06-.76c-.22,1-.42,2.08-.59,3.24a20.33,20.33,0,0,1,1.12,2.3.12.12,0,0,1,0,.17c-.47.25-1,.45-1.44.67-.15,1.64-.25,3.39-.28,5.2a9.29,9.29,0,0,1,1,2.36,5.4,5.4,0,0,1,.09,1.88c0,.31-.07.62-.09.94s0,.61,0,.92c-.09.58-.3,1.14-.41,1.72a1.42,1.42,0,0,0,.39,1.42,3.35,3.35,0,0,0,1.05.4.47.47,0,0,1,.32.26.59.59,0,0,1-.09.48,2.48,2.48,0,0,1-1.09.93l-.39.22c.88,5.58,2.47,9.3,4.28,9.3,1.12,0,2.16-1.41,3-3.81Z"
              fill="#659965"
            />
            <path
              d="M1362.2,495.73l-.11,24.17L1362,532l0,6c0,2,0,4,.17,6-.37-4-.31-8.06-.36-12.08V519.9C1361.93,511.84,1362,503.79,1362.2,495.73Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1370.1,504.56a1.54,1.54,0,0,0-.95,0l-.54.68c-.28.34-.56.67-.87,1a10.53,10.53,0,0,0-.82.95,8.45,8.45,0,0,0-1,1.74,7.71,7.71,0,0,1-1,2,15.71,15.71,0,0,1-1.31,1.27l0,0c-.1.29-.21.58-.31.88a24.13,24.13,0,0,0-1.18,5.71c0,.15,0,.3,0,.45a36.23,36.23,0,0,1,.72,4.12,1.69,1.69,0,0,0,.79.6c2,.65,5-3.17,6.76-8.53S1372.07,505.21,1370.1,504.56Z"
              fill="#3b6818"
            />
            <path
              d="M1370.47,515.43s-8.47,4.32-8.77,26.63"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <path
              d="M1368.76,506.58a4.72,4.72,0,0,0-1.17,2.22,10.46,10.46,0,0,1-.48,2.34,3.33,3.33,0,0,1-.77,1.06c-.3.28-.63.52-.93.82a2.51,2.51,0,0,0-.68,1.13,2.15,2.15,0,0,0,0,1,4,4,0,0,1,.15,1,3.4,3.4,0,0,1-.43,1.41,3.86,3.86,0,0,0-.42,1.44,3.13,3.13,0,0,0,.16.93,2.83,2.83,0,0,1,.06,1,2.71,2.71,0,0,1-.31.92,1.88,1.88,0,0,0-.28.78,2.44,2.44,0,0,0,.36,1.18l.06.13a1,1,0,0,0,.35.2c1.56.52,4.25-3.41,6-8.77s1.93-10.11.38-10.62a1,1,0,0,0-.65,0A10.32,10.32,0,0,1,1368.76,506.58Z"
              fill="#659965"
            />
          </g>
        </g>
        <g>
          <path
            d="M196.49,271.34c4.07-6.72,5.46-8.25,3.73-12.77s-3.39-.67-1.66-9.18-4.86-11-7.85-11.38-17.17,8-14.77,12.51,3.41,17.36.84,18.42S191.7,279.25,196.49,271.34Z"
            fill="#396039"
          />
          <path
            d="M193.77,255.71c-.14-3.66,5.39-5.13,3.59-6.79s-3.93-6-5.66-3.73-3.06,5.59-4.39,3.73-2.79-1.93-3.65,0-.14,4.32-2.2,3.73-3,.33-2.73,2.32,1.8,1.2,3.13,3.6,7.32,2.06,6.32.73S193.77,255.71,193.77,255.71Z"
            fill="#447244"
          />
          <path
            d="M204.08,249.39c3-4.73,7.18-9,11.37-5s-2.79,11.31,0,14.17,2.2,10.11,0,10.37-12.64.27-15.36,1.53-6.26-3.39-6.32-7.91S204.08,249.39,204.08,249.39Z"
            fill="#6b996b"
          />
          <path
            d="M188.31,277.39c7,5.34,7.52-13.24,0-11.64s-10,1.13-12.37-2.19-8.38,2.52-8.58,4.19,1.73,7.25,5.85,8.84S184.12,274.2,188.31,277.39Z"
            fill="#447244"
          />
          <path
            d="M202.79,281.12c-7,5.34-7.51-13.24,0-11.64s10,1.13,12.38-2.2,8.38,2.53,8.58,4.19-1.73,7.25-5.85,8.85S207,277.92,202.79,281.12Z"
            fill="#447244"
          />
          <path
            d="M211.53,274.73c1-2,3.92,1.86,3.92,1.86s-.2-2.59,1.4-3.52,2.33,1.46,2.33,1.46c.13-1.86,3.92-.13,2.86,2.08h0a8.9,8.9,0,0,1-4.14,3.71,7.36,7.36,0,0,1-3,.38l-3.58-.91S210.53,276.73,211.53,274.73Z"
            fill="#396039"
          />
          <path
            d="M197.09,278.12c-1.39,2.47-2.19,24.62,0,34.8,0,0-6.38-1.13-8.38-.07-.2.67-.2.07-.2.07s8.85-30.8,1.13-39.85-16.1,0-16.1,0,2.27-5.32,7.25-5.72,11.85,6,12.18,7.31c0,0,.26-9.71-2.86-13.1s.86-5.85.86-5.85-4.12,1.26,2.53,9.91c3.45,4.48,1,12.84,1,12.84s2.13-6.52,7.45-5.13,8.51,7.59,13.5,7.19a26.11,26.11,0,0,1-10.51-3.13A6.16,6.16,0,0,0,197.09,278.12Z"
            fill="#704d3c"
          />
          <path
            d="M204.38,277.08a6.11,6.11,0,0,0-7.29,1c-.48.85-.89,4-1.13,8.26-1.6-5.51,1.27-12.05,2.17-12.63a5,5,0,0,1,3.82-.42,11.72,11.72,0,0,1,3.51,1.68Z"
            fill="#634b42"
          />
          <path
            d="M192.14,275c.73,1.66,1.53,6.54.63,9.06h0c-.17-4.57-1.05-8.58-3.13-11a15.8,15.8,0,0,0-1.38-1.43l-.31-.93A11.93,11.93,0,0,1,192.14,275Z"
            fill="#44322c"
          />
          <path
            d="M202.89,276.05c1.93-.63,2.06-3.33,4.34-3.18s2.55,3.45,4.45,5.58,3.44,1.66,4.95,2.4-4.14,8.86-9.4,5.92-4.76-2.44-6.58-3.64S198.6,277.44,202.89,276.05Z"
            fill="#6b996b"
          />
          <g>
            <path d="M192.91,271.87c0,.12,0,.14,0,.06v-.06Z" fill="#7f2c03" />
            <path
              d="M192.84,270.7c-.25-3.09-.92-7.18-2.73-9.14a3.94,3.94,0,0,1-1.19-2.41l.91-.17c.33,1.48,1.34,3.6,3.67,6.64l.16.21C193.49,267.58,193,269.37,192.84,270.7Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M185.63,270.46c-1.26-1.59.13-3.91-1.86-5s-4,1.46-6.79,2.19-3.79-.51-5.45-.73-1.44,9.67,4.57,10.12,5.32.6,7.49.6S188.44,274,185.63,270.46Z"
            fill="#6b996b"
          />
          <path
            d="M188.17,251.78c1.31-2.06,3.14-3.95,5-2.18s-1.22,5,0,6.2,1,4.43,0,4.54-5.53.12-6.72.67-2.74-1.48-2.76-3.46S188.17,251.78,188.17,251.78Z"
            fill="#6b996b"
          />
          <path
            d="M175.07,274.79c.38.57,1.48.47,2.13.21s1-2.22,2-1.88,1.54,1.36,2.69,1,.65-1.57,2.12-1.59,2.74.54,2.79,1.29a1.11,1.11,0,0,1,0,.19h0c0,.06,0,.12,0,.18a3.74,3.74,0,0,1-3.21,3.38c-2.17,0-1.48-.14-7.49-.6a4.77,4.77,0,0,1-2.21-.7C173.23,275.86,174.69,274.22,175.07,274.79Z"
            fill="#447244"
          />
          <path
            d="M202.08,283.11c1.47,0,4.39,1.6,4.79.14s3.33-1.8,3.66-1.13a2.91,2.91,0,0,0,3.13,1c1-.53,2,.8,1.54,1.32-1.86,2.1-5,4-8,2.34-3.65-2-4.53-2.43-5.33-2.87C201.56,283.65,201,283.11,202.08,283.11Z"
            fill="#396039"
          />
          <path
            d="M196.63,266.28c.93-2.06,3.19-1.66,4.79-1.39s1.13,2.39,2.39,1.39,4.06,1.4,3,3.13h0c-2.83.2-5.52.51-6.72,1.06-1.69.79-3.69-.7-5-3l-.56-1.17h0S195.7,268.34,196.63,266.28Z"
            fill="#447244"
          />
          <path
            d="M213.52,265c-.59-1.87,2.07-3.46,0-3.46s-5.45,2.06-5.12-.93-.6-4.59-2.86-4.39-4-4.66-2.72-5.76-7.06,2.1-3.4,5.23,5,2.12,4.86,3.59,0,4.52,2.79,5-.79,4.26,1.3,5.12S215.12,270,213.52,265Z"
            fill="#447244"
          />
          <path
            d="M188.51,312.92s.55-1.91,1.26-4.92c5.55-2.85,5.95-12.13,6-12.41a94.93,94.93,0,0,0,1.36,17.33s-6.38-1.13-8.38-.07C188.51,313.52,188.51,312.92,188.51,312.92Z"
            fill="#44322c"
          />
          <path
            d="M195.14,312.64c0-1.8-.58-3.5-.81-5.28a34.3,34.3,0,0,1-.11-5.36c.19-3.57.56-7.11.72-10.67.05-.89.1-1.78.11-2.66a11,11,0,0,0,0-1.3c-.07-.41-.22-.86-.32-1.29a15.9,15.9,0,0,1-.45-2.66,5.34,5.34,0,0,1,.36-2.7c.4-.8.79-1.6,1.25-2.38a6.18,6.18,0,0,1,1.78-2,4.5,4.5,0,0,1,2.6-.62,11.76,11.76,0,0,1,2.65.37,11.8,11.8,0,0,0-2.65-.27,4.31,4.31,0,0,0-2.49.68c-1.43,1-2.08,2.81-2.86,4.38a5.31,5.31,0,0,0-.3,2.54A16.27,16.27,0,0,0,195,286c.1.44.25.84.33,1.31a9.14,9.14,0,0,1,.06,1.37c0,.9-.05,1.79-.09,2.68-.2,3.56-.56,7.12-.82,10.66a36.47,36.47,0,0,0,0,5.33C194.68,309.09,195.24,310.84,195.14,312.64Z"
            fill="#44322c"
          />
          <path
            d="M193.73,295.59a14.69,14.69,0,0,0,0,2.2,3.33,3.33,0,0,1-.13,1.12,3.29,3.29,0,0,1-.59,1,5.89,5.89,0,0,0-1.64,3.86,8.59,8.59,0,0,0,0,2.15A14,14,0,0,0,192,308a18.71,18.71,0,0,1,.47,4.4,23.87,23.87,0,0,0-.77-4.31A13.14,13.14,0,0,1,191,306a9.42,9.42,0,0,1-.06-2.25,8.27,8.27,0,0,1,.53-2.18,5,5,0,0,1,1.28-1.84,2.94,2.94,0,0,0,.58-.87,3.31,3.31,0,0,0,.18-1.05A14.6,14.6,0,0,1,193.73,295.59Z"
            fill="#44322c"
          />
          <path
            d="M193.73,267.31c.08.85.41,1.63.46,2.51a10.24,10.24,0,0,1-.18,1.24,5.21,5.21,0,0,0,.24,1.2,11.93,11.93,0,0,1,.72,5c-.1.88-.45,1.65-.54,2.47a17.3,17.3,0,0,0-.13,2.5,30.14,30.14,0,0,0,.56,5,22.77,22.77,0,0,1-.86-5,13.7,13.7,0,0,1,.07-2.56c.09-.87.43-1.67.51-2.47a12.39,12.39,0,0,0-.63-4.91,5.35,5.35,0,0,1-.19-1.29,2.41,2.41,0,0,1,.14-.64,2.35,2.35,0,0,0,.09-.6C194,269,193.74,268.16,193.73,267.31Z"
            fill="#44322c"
          />
        </g>
        {/* <g>
          <path
            d="M182.19,207.69c2.76-4.57,3.71-5.61,2.53-8.69s-2.31-.45-1.13-6.25-3.31-7.52-5.34-7.74-11.69,5.43-10.06,8.51,2.33,11.82.58,12.54S178.93,213.08,182.19,207.69Z"
            fill="#396039"
          />
          <path
            d="M180.33,197.05c-.09-2.49,3.67-3.48,2.44-4.62s-2.67-4.07-3.84-2.53-2.09,3.8-3,2.53-1.9-1.31-2.49,0-.09,2.95-1.5,2.54-2,.23-1.85,1.58,1.22.82,2.12,2.45,5,1.4,4.31.5S180.33,197.05,180.33,197.05Z"
            fill="#447244"
          />
          <path
            d="M187.35,192.75c2-3.22,4.89-6.16,7.74-3.4s-1.9,7.7,0,9.65,1.5,6.88,0,7.06-8.6.18-10.46,1-4.26-2.3-4.3-5.38S187.35,192.75,187.35,192.75Z"
            fill="#6b996b"
          />
          <path
            d="M176.62,211.81c4.77,3.64,5.11-9,0-7.92s-6.8.77-8.43-1.49-5.7,1.72-5.84,2.85,1.18,4.93,4,6S173.76,209.64,176.62,211.81Z"
            fill="#447244"
          />
          <path
            d="M186.47,214.35c-4.77,3.64-5.11-9,0-7.92s6.8.77,8.43-1.5,5.7,1.72,5.84,2.85-1.18,4.94-4,6S189.33,212.18,186.47,214.35Z"
            fill="#447244"
          />
          <path
            d="M192.42,210c.68-1.36,2.67,1.27,2.67,1.27s-.13-1.77.95-2.4,1.59,1,1.59,1c.09-1.27,2.67-.09,2,1.41h0a6.07,6.07,0,0,1-2.83,2.53,5.06,5.06,0,0,1-2,.26l-2.43-.62A5.86,5.86,0,0,1,192.42,210Z"
            fill="#396039"
          />
          <path
            d="M182.59,212.31c-1,1.68-1.49,16.76,0,23.69,0,0-4.34-.77-5.7-.05-.14.45-.14.05-.14.05s6-21,.77-27.13-11,0-11,0,1.54-3.62,4.94-3.89,8.06,4.12,8.29,5c0,0,.18-6.61-1.95-8.92s.59-4,.59-4-2.81.86,1.72,6.75c2.35,3,.68,8.74.68,8.74s1.45-4.44,5.07-3.49,5.8,5.16,9.19,4.89a17.67,17.67,0,0,1-7.15-2.13A4.2,4.2,0,0,0,182.59,212.31Z"
            fill="#704d3c"
          />
          <path
            d="M187.55,211.6a4.17,4.17,0,0,0-5,.71,21.38,21.38,0,0,0-.77,5.62c-1.09-3.75.86-8.2,1.48-8.6a3.45,3.45,0,0,1,2.6-.28,7.86,7.86,0,0,1,2.39,1.14Z"
            fill="#634b42"
          />
          <path
            d="M179.22,210.21c.5,1.13,1,4.45.43,6.16h0c-.12-3.11-.71-5.84-2.13-7.5a8.72,8.72,0,0,0-.94-1l-.21-.64A8.1,8.1,0,0,1,179.22,210.21Z"
            fill="#44322c"
          />
          <path
            d="M186.54,210.9c1.32-.43,1.4-2.27,3-2.16s1.74,2.34,3,3.79,2.35,1.13,3.37,1.64-2.82,6-6.4,4-3.24-1.65-4.48-2.47S183.62,211.85,186.54,210.9Z"
            fill="#6b996b"
          />
          <g>
            <path d="M179.75,208.06c0,.08,0,.09,0,0v0Z" fill="#7f2c03" />
            <path
              d="M179.7,207.26c-.17-2.11-.63-4.89-1.86-6.22a2.76,2.76,0,0,1-.81-1.64l.62-.12a12.42,12.42,0,0,0,2.5,4.52l.1.14C180.14,205.13,179.77,206.36,179.7,207.26Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M174.79,207.09c-.86-1.08.09-2.66-1.27-3.43s-2.74,1-4.61,1.5-2.58-.35-3.72-.5-1,6.58,3.11,6.89,3.62.4,5.1.41S176.71,209.5,174.79,207.09Z"
            fill="#6b996b"
          />
          <path
            d="M176.52,194.38c.89-1.4,2.14-2.69,3.39-1.48s-.84,3.37,0,4.22.65,3,0,3.09-3.77.08-4.58.45-1.86-1-1.88-2.35S176.52,194.38,176.52,194.38Z"
            fill="#6b996b"
          />
          <path
            d="M167.6,210c.26.39,1,.32,1.45.15s.69-1.52,1.39-1.29,1.05.93,1.83.71.44-1.07,1.45-1.08,1.86.36,1.89.88a.49.49,0,0,1,0,.12h0s0,.08,0,.12A2.56,2.56,0,0,1,173.4,212c-1.48,0-1-.1-5.1-.41a3.32,3.32,0,0,1-1.5-.48C166.35,210.77,167.34,209.66,167.6,210Z"
            fill="#447244"
          />
          <path
            d="M186,215.71c1,0,3,1.09,3.26.09s2.26-1.22,2.49-.77a2,2,0,0,0,2.13.68c.68-.36,1.36.54,1,.9-1.26,1.42-3.39,2.72-5.43,1.58-2.48-1.38-3.08-1.64-3.62-1.95C185.63,216.07,185.23,215.71,186,215.71Z"
            fill="#396039"
          />
          <path
            d="M182.28,204.25c.63-1.4,2.17-1.13,3.26-.95s.77,1.63,1.63.95,2.76.95,2,2.13h0a17.07,17.07,0,0,0-4.58.72c-1.15.54-2.51-.48-3.38-2l-.39-.8h0S181.64,205.66,182.28,204.25Z"
            fill="#447244"
          />
          <path
            d="M193.78,203.39c-.41-1.27,1.4-2.35,0-2.35s-3.71,1.4-3.49-.64-.41-3.12-1.95-3-2.71-3.16-1.85-3.91-4.8,1.42-2.31,3.55,3.39,1.45,3.3,2.45,0,3.08,1.91,3.39-.54,2.9.88,3.49S194.87,206.79,193.78,203.39Z"
            fill="#447244"
          />
          <path
            d="M176.75,236s.38-1.3.86-3.35c3.78-1.94,4-8.26,4.06-8.45a63.71,63.71,0,0,0,.92,11.8s-4.34-.77-5.7-.05C176.75,236.4,176.75,236,176.75,236Z"
            fill="#44322c"
          />
          <path
            d="M181.27,235.8a24.56,24.56,0,0,0-.56-3.59,23.4,23.4,0,0,1-.06-3.65c.14-2.42.37-4.84.48-7.26,0-.6.07-1.21.08-1.81a6.51,6.51,0,0,0,0-.89c-.05-.28-.15-.58-.21-.87a12.45,12.45,0,0,1-.31-1.81,3.77,3.77,0,0,1,.25-1.84,7.63,7.63,0,0,1,2.05-3,3,3,0,0,1,1.77-.42,7.74,7.74,0,0,1,1.8.25,7.81,7.81,0,0,0-1.8-.19,3,3,0,0,0-1.7.47,7.68,7.68,0,0,0-2,3,5.94,5.94,0,0,0,.12,3.51c.07.3.16.57.22.89a5.86,5.86,0,0,1,.05.93c0,.61,0,1.22-.06,1.83-.14,2.42-.4,4.84-.57,7.25a24.43,24.43,0,0,0,0,3.63A24.07,24.07,0,0,1,181.27,235.8Z"
            fill="#44322c"
          />
          <path
            d="M180.31,224.2a10.72,10.72,0,0,0,0,1.5,1.85,1.85,0,0,1-.49,1.43,4.07,4.07,0,0,0-1.11,2.64,6,6,0,0,0,0,1.46,9.84,9.84,0,0,0,.39,1.43,12.56,12.56,0,0,1,.32,3,17.07,17.07,0,0,0-.52-2.94,7.3,7.3,0,0,1-.43-1.44,6,6,0,0,1,0-1.53,4.12,4.12,0,0,1,1.23-2.74,1.75,1.75,0,0,0,.51-1.31A10.73,10.73,0,0,1,180.31,224.2Z"
            fill="#44322c"
          />
          <path
            d="M180.31,205c.05.58.27,1.11.31,1.71,0,.29-.13.6-.12.84a3,3,0,0,0,.16.82,8.29,8.29,0,0,1,.49,3.43c-.07.6-.31,1.13-.37,1.68a12,12,0,0,0-.09,1.7,20.71,20.71,0,0,0,.39,3.41,15.14,15.14,0,0,1-.59-3.4,9.21,9.21,0,0,1,0-1.74c.05-.59.29-1.14.34-1.68a8.39,8.39,0,0,0-.42-3.35,3.1,3.1,0,0,1-.13-.87c0-.33.16-.55.15-.84C180.5,206.1,180.31,205.53,180.31,205Z"
            fill="#44322c"
          />
        </g> */}
        {/* <g>
          <g>
            <path
              d="M1449.54,150.85c0-.32.07-.65.09-1a7.5,7.5,0,0,0-.05-1.42c-.06-.42-.18-.83-.28-1.24a4.11,4.11,0,0,1-.12-1.11c0-.4.13-.8.16-1.2a2.59,2.59,0,0,0-.08-.92c-.08-.21-.16-.41-.25-.61a5.07,5.07,0,0,0-.36-.54.09.09,0,0,1,0-.11,4.3,4.3,0,0,0-4.8-2.07,1.52,1.52,0,0,1-.33.34,2.85,2.85,0,0,1-1,.36,2,2,0,0,0-1,.53,10,10,0,0,0-.7,1.12,2,2,0,0,1-.46.49,2.3,2.3,0,0,1-.57.27,1.53,1.53,0,0,0-.6.36,5.52,5.52,0,0,0-.4.55,5.55,5.55,0,0,1-.48.49,4.36,4.36,0,0,0-.35.4,6,6,0,0,0-.74,2.36,3.45,3.45,0,0,1-.55,1.31,6.51,6.51,0,0,1-.83.83,2.74,2.74,0,0,0-.63.73,3,3,0,0,0-.28,1.32c-.06,1.08,0,2.17-.09,3.25a7.09,7.09,0,0,1-.14.78c-.06.25-.14.49-.19.74a1.66,1.66,0,0,0,.07,1,7.82,7.82,0,0,0,.45.8,2.55,2.55,0,0,1,.41,1.3,1.75,1.75,0,0,0,0,.72,1.49,1.49,0,0,0,.31.51,7.76,7.76,0,0,1,.8.92.09.09,0,0,1,0,.05,4.13,4.13,0,0,0,3,1,6.49,6.49,0,0,1,1.25-.66,13.85,13.85,0,0,0,1.49-.63,3.49,3.49,0,0,0,.65-.43c.21-.16.39-.35.6-.51.4-.3.86-.51,1.24-.84a2.19,2.19,0,0,0,.52-.65,7,7,0,0,0,.32-.75,2.6,2.6,0,0,1,.42-.67,6.13,6.13,0,0,1,.57-.57l.8-.69a19.5,19.5,0,0,0,1-2,4.22,4.22,0,0,0-.35-.82c-.21-.39-.46-.77-.68-1.16,0,0,0-.14.06-.15.36-.07.72-.14,1.07-.24a1.48,1.48,0,0,0,.69-.39,1.28,1.28,0,0,0,.26-.47C1449.45,151.27,1449.5,151.06,1449.54,150.85Z"
              fill="#396039"
            />
            <path
              d="M1446.18,141.65a54.05,54.05,0,0,0-2.57,5.24c-.79,1.77-1.51,3.58-2.21,5.39-1.38,3.64-2.58,7.34-3.68,11.07s-2.08,7.49-3,11.26l-1.28,5.7-1.16,5.71,1.07-5.73c.41-1.9.8-3.81,1.24-5.71.89-3.78,1.82-7.56,2.94-11.29s2.34-7.43,3.74-11.06A74.66,74.66,0,0,1,1446.18,141.65Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1427.9,167.47c0-.46,0-.93.06-1.39a31.1,31.1,0,0,0-2.13-6.86c-.24-.23-.46-.46-.67-.7a11.17,11.17,0,0,1-.71-1c-.26-.37-.54-.73-.81-1.1a9.46,9.46,0,0,1-1.3-2.29c-.15-.41-.2-.84-.31-1.25s-.17-.56-.27-.84c-2.66-3.56-5.45-5.51-7.17-4.68a1.83,1.83,0,0,0-.63.48c0,.12-.07.25-.11.37a5.85,5.85,0,0,0-.16,1.77,8.19,8.19,0,0,0,.35,1.69,11.15,11.15,0,0,1,.57,1.95,7.16,7.16,0,0,1-.07,1.85,8.37,8.37,0,0,0-.13,1.87,2.47,2.47,0,0,0,.53,1.55,4.92,4.92,0,0,0,1,.7,4.94,4.94,0,0,1,1,1,1.34,1.34,0,0,1,.37,1c0,.38-.21.75-.28,1.13a3.17,3.17,0,0,0,.8,2.54,12.84,12.84,0,0,0,2.16,1.87c.41.31.82.62,1.2,1,.19.17.38.35.56.54s.37.45.57.68a11.61,11.61,0,0,0,2.86,2.2c.51.31,1,.64,1.5,1,.87-.43,1.36-1.54,1.46-3.09A8.31,8.31,0,0,1,1427.9,167.47Z"
              fill="#2f4f2f"
            />
            <path
              d="M1413.94,147.13A128.64,128.64,0,0,1,1424.79,166a104.78,104.78,0,0,1,4,10.12,64.12,64.12,0,0,1,2.48,10.59,72.25,72.25,0,0,0-2.61-10.55,107.05,107.05,0,0,0-4.05-10.08q-2.29-4.94-5-9.67C1417.85,153.24,1416,150.14,1413.94,147.13Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1427.73,170.1c-.06-.36-.1-.73-.13-1.1a24.23,24.23,0,0,0-2.55-5.1c-.21-.15-.41-.3-.6-.46a7.06,7.06,0,0,1-.68-.66L1423,162a7.39,7.39,0,0,1-1.31-1.63c-.16-.3-.26-.63-.4-.94s-.21-.42-.32-.62c-2.53-2.46-5-3.63-6.21-2.76a1.46,1.46,0,0,0-.43.46c0,.1,0,.2,0,.3a4.46,4.46,0,0,0,.1,1.41,6,6,0,0,0,.49,1.28,8.48,8.48,0,0,1,.69,1.46,5.46,5.46,0,0,1,.18,1.46,7.4,7.4,0,0,0,.13,1.48,2,2,0,0,0,.62,1.14,3.84,3.84,0,0,0,.86.43,4.06,4.06,0,0,1,1,.64,1.05,1.05,0,0,1,.41.73c0,.31-.06.62-.07.93a2.57,2.57,0,0,0,.95,1.89,9.58,9.58,0,0,0,1.94,1.18c.35.2.71.39,1,.61a4.67,4.67,0,0,1,.51.36c.19.14.35.3.53.46a9.75,9.75,0,0,0,2.52,1.36,14.11,14.11,0,0,1,1.31.59,2.76,2.76,0,0,0,.75-2.61A6.3,6.3,0,0,1,1427.73,170.1Z"
              fill="#396039"
            />
            <path
              d="M1414.2,155.94a99.63,99.63,0,0,1,10.92,13.38,81.58,81.58,0,0,1,4.41,7.43,50.06,50.06,0,0,1,3.28,8,58.41,58.41,0,0,0-3.4-7.93,81.25,81.25,0,0,0-4.46-7.38q-2.42-3.59-5.11-7C1418,160.24,1416.17,158,1414.2,155.94Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1433.88,170.31a.49.49,0,0,1-.2-.34.53.53,0,0,1,.21-.4,3.72,3.72,0,0,1,.62-.49v0a4.54,4.54,0,0,1-.38-.38.71.71,0,0,1-.16-.34c0-.24.25-.35.44-.43l.41-.15c.09-.42.17-.86.24-1.31l-.24-.06a5.84,5.84,0,0,1-.59-.2,1,1,0,0,1-.41-.26.11.11,0,0,1,0-.16,6.28,6.28,0,0,1,.59-.27,1.25,1.25,0,0,0,.51-.33c.15-.18,0-.4,0-.62a.59.59,0,0,1,.24-.41l.19-.17c.06-.54.11-1.1.16-1.67l-.34-.1a1.78,1.78,0,0,1-.76-.39.65.65,0,0,1-.12-.77,1.52,1.52,0,0,1,.77-.57l.48-.15c0-.19.07-.39.1-.58q0-.84,0-1.71l0-.06a1,1,0,0,0-.31-.2,1.68,1.68,0,0,1-.48-.36.1.1,0,0,1,0-.14c.22-.19.77-.48.62-.85,0-.11-.22-.12-.31-.17a.3.3,0,0,1-.17-.34c.07-.26.38-.36.52-.56s-.24-.31-.39-.31a5.66,5.66,0,0,1-.83,0,.1.1,0,0,1,0-.18c.43-.31.85-.61,1.3-.88-.08-1.2-.2-2.34-.34-3.4l-.19,0a.1.1,0,0,1-.13-.09,4.45,4.45,0,0,0-.81.42l-.43.33c-.1.08-.25-.06-.15-.14a3.82,3.82,0,0,1,.47-.35,8.19,8.19,0,0,1,1.16-.71c-.14-.93-.3-1.8-.48-2.6a4.2,4.2,0,0,0-1,.52l-.36.33a.1.1,0,0,1-.14-.15,3.07,3.07,0,0,1,.38-.34c.23-.22.47-.44.72-.65l.28-.23a16.65,16.65,0,0,0-.71-2.22,11,11,0,0,1-1.34.54.1.1,0,0,1-.13-.1,2.13,2.13,0,0,1,.5-1.1,3.7,3.7,0,0,1,.42-.48c-.49-.83-1-1.29-1.61-1.29-1.15,0-2.19,1.89-2.93,4.91.31.27.59.56.88.84a.1.1,0,0,1-.12.16,7.23,7.23,0,0,1-.85-.6c-.18.79-.34,1.66-.48,2.59a15.65,15.65,0,0,1,.9,1.84.1.1,0,0,1,0,.14c-.37.2-.77.35-1.15.53-.12,1.31-.2,2.71-.22,4.16a8.1,8.1,0,0,1,.81,1.89,4.44,4.44,0,0,1,.06,1.5c0,.25,0,.5-.07.75a6.12,6.12,0,0,1,0,.74c-.07.47-.24.91-.32,1.37a1.14,1.14,0,0,0,.31,1.14,2.44,2.44,0,0,0,.84.32.38.38,0,0,1,.25.21.5.5,0,0,1-.07.39,2.1,2.1,0,0,1-.87.74l-.32.17c.71,4.47,2,7.45,3.43,7.45.9,0,1.73-1.14,2.39-3.06Z"
              fill="#659965"
            />
            <path
              d="M1431.69,147.53l-.09,19.33-.06,9.67v4.83c0,1.61,0,3.23.14,4.83-.3-3.21-.25-6.44-.29-9.66v-9.67C1431.47,160.42,1431.52,154,1431.69,147.53Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1438,154.59a1.23,1.23,0,0,0-.76,0l-.44.54a10.26,10.26,0,0,1-.69.79,8,8,0,0,0-.66.76,6.7,6.7,0,0,0-.76,1.39,6.22,6.22,0,0,1-.79,1.59c-.31.38-.71.67-1.05,1l0,0-.24.71a19.26,19.26,0,0,0-.95,4.56c0,.12,0,.24,0,.36a31.23,31.23,0,0,1,.58,3.3,1.26,1.26,0,0,0,.63.47c1.57.52,4-2.53,5.41-6.81S1439.58,155.11,1438,154.59Z"
              fill="#3b6818"
            />
            <path
              d="M1438.31,163.28s-6.78,3.46-7,21.3"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.2"
            />
            <path
              d="M1436.94,156.2A3.88,3.88,0,0,0,1436,158a8.71,8.71,0,0,1-.38,1.88,2.62,2.62,0,0,1-.62.84c-.24.23-.5.42-.74.66a2,2,0,0,0-.55.9,1.7,1.7,0,0,0,0,.81,3.78,3.78,0,0,1,.12.83,2.9,2.9,0,0,1-.34,1.13,2.94,2.94,0,0,0-.34,1.15,2.55,2.55,0,0,0,.12.74,2.18,2.18,0,0,1,0,.81,2.09,2.09,0,0,1-.24.73,1.51,1.51,0,0,0-.23.63,2.12,2.12,0,0,0,.29.95l0,.1a.78.78,0,0,0,.28.16c1.24.41,3.4-2.73,4.81-7s1.54-8.09.3-8.5a.78.78,0,0,0-.52,0A7.88,7.88,0,0,1,1436.94,156.2Z"
              fill="#659965"
            />
          </g>
        </g> */}
        <g>
          <ellipse
            cx="1257.39"
            cy="567.08"
            rx="44.89"
            ry="7.92"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1233.83,560.25c-7.72,3.91-9.38,4.74-16.33,2s-20.85-18.9-5.28-29.74,31.41,3.61,31.41,10c0,0-27-28.08,0-35.31s18.07,21.13,16.12,25.3c0,0,9.73-19.18,20.85-13.34s4,41.92-16.5,32.63c0,0,27.62-13.18,36.23,1s-47,17-56.7,12.23S1233.83,560.25,1233.83,560.25Z"
            fill="#1f441f"
          />
          <path
            d="M1233.2,526.76c7,2.8,4.59-11,4.59-11s3.06-1.67,3.13-7.75C1230.54,511.92,1230.39,519.62,1233.2,526.76Z"
            fill="#659965"
          />
          <path
            d="M1257.25,536.92c-19.74-1.95-20-18.63-9.18-23.35S1257.25,536.92,1257.25,536.92Z"
            fill="#245624"
          />
          <path
            d="M1248.28,551.52c-32,5.21-38.17-17.46-22.57-28.23S1248.28,551.52,1248.28,551.52Z"
            fill="#245624"
          />
          <path
            d="M1261.68,550.84c24.06,14.18,38.23-4.55,29.83-18.93S1261.68,550.84,1261.68,550.84Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1259.75,532.47c10,6.67,12-5.28,12-5.28,4.28-.59,5.56-4.84,6-9.06C1267.81,516.57,1259.75,532.47,1259.75,532.47Z"
              fill="#659965"
            />
            <path d="M1259.75,532.47c.2-.43.47-1.12.77-2Z" fill="#659965" />
          </g>
          <path
            d="M1271.39,555c13.74,3.61,22.44-4.63,22.55-14.21-.51.45-1,.86-1.51,1.23-6.55,4.86-11.83,2.94-11.83,2.94s-.84,11.12-8.9,8.2Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1237.09,563.19s-24.46-8.62-18.62-22.52,14.18-6.39,18.62,11.12c0,0-5.83-37.25,15.57-32.25s5.28,31.41,0,32.25c0,0,15.57-21.13,25.58-5.84s-16.41,18.35-23.08,17.24S1237.09,563.19,1237.09,563.19Z"
              fill="#659965"
            />
            <path
              d="M1278.24,546a14.24,14.24,0,0,0-3.65-3.92c-3,11.17-14,9.9-14,9.9s.28,10.28-11.67,8.34l-1.18,2.42a48.79,48.79,0,0,1,7.43.5C1261.83,564.3,1288.24,561.24,1278.24,546Z"
              fill="#396039"
            />
            <path
              d="M1243.63,548.87s7.22,3.44,16-4.42c3.84-6.66,6.29-16.23,0-21.62-4.31,10.75-11.84,10.75-11.84,10.75S1255.86,546.92,1243.63,548.87Z"
              fill="#396039"
            />
            <path
              d="M1237.79,563.12a21.88,21.88,0,0,1-9.17-10.36c-6.74.87-9.74-6.92-10.73-10.36-3.24,12.88,19.2,20.79,19.2,20.79Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1219.16,557.21a29.66,29.66,0,0,1-9.51-1.45,21.47,21.47,0,0,0,7.85,6.45c6.46,2.59,8.36,2,14.78-1.18A31.5,31.5,0,0,1,1219.16,557.21Z"
            fill="#172d17"
          />
          <path
            d="M1300.19,552.54c-3.54,7.37-13,8.17-16.26,7.17,0,0-4.4,5.71-20.35,7.38,18.89-.34,42.6-4.71,36.75-14.33Z"
            fill="#172d17"
          />
          <path
            d="M1237.79,563.05c-8.06-3.34-5.28-11.4,0-10.29S1237.79,563.05,1237.79,563.05Z"
            fill="#245624"
          />
          <path
            d="M1237.3,562.66c12.79,12.41,25.65.66,19.28-8.34S1237.3,562.66,1237.3,562.66Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <ellipse
            cx="962.13"
            cy="395.09"
            rx="33.51"
            ry="5.91"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M944.55,390c-5.76,2.92-7,3.54-12.19,1.47s-15.56-14.11-3.94-22.2,23.44,2.69,23.44,7.46c0,0-20.12-21,0-26.35s13.49,15.77,12,18.89c0,0,7.26-14.32,15.56-10s3,31.29-12.32,24.36c0,0,20.62-9.84,27.05.74s-35.07,12.66-42.33,9.13S944.55,390,944.55,390Z"
            fill="#1f441f"
          />
          <path
            d="M944.08,365c5.19,2.09,3.42-8.19,3.42-8.19s2.29-1.25,2.34-5.79C942.09,353.92,942,359.67,944.08,365Z"
            fill="#659965"
          />
          <path
            d="M962,372.58c-14.73-1.46-14.94-13.91-6.85-17.43S962,372.58,962,372.58Z"
            fill="#245624"
          />
          <path
            d="M955.34,383.47c-23.9,3.9-28.5-13-16.85-21.07S955.34,383.47,955.34,383.47Z"
            fill="#245624"
          />
          <path
            d="M965.34,383c17.95,10.58,28.53-3.4,22.26-14.13S965.34,383,965.34,383Z"
            fill="#245624"
          />
          <g>
            <path
              d="M963.9,369.26c7.46,5,8.92-3.95,8.92-3.95,3.19-.43,4.15-3.61,4.44-6.76C969.92,357.39,963.9,369.26,963.9,369.26Z"
              fill="#659965"
            />
            <path
              d="M963.9,369.26a15.76,15.76,0,0,0,.57-1.49Z"
              fill="#659965"
            />
          </g>
          <path
            d="M972.59,386.09c10.25,2.69,16.75-3.46,16.82-10.61-.38.34-.75.64-1.12.92-4.89,3.63-8.83,2.19-8.83,2.19s-.63,8.3-6.64,6.12Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M947,392.18s-18.26-6.43-13.91-16.8,10.59-4.78,13.91,8.3c0,0-4.36-27.81,11.61-24.07s3.95,23.44,0,24.07c0,0,11.62-15.77,19.09-4.36S965.45,393,960.47,392.18,947,392.18,947,392.18Z"
              fill="#659965"
            />
            <path
              d="M977.69,379.32a10.38,10.38,0,0,0-2.72-2.93c-2.22,8.34-10.45,7.39-10.45,7.39s.21,7.68-8.72,6.22l-.88,1.81a36.55,36.55,0,0,1,5.55.37C965.45,393,985.16,390.73,977.69,379.32Z"
              fill="#396039"
            />
            <path
              d="M951.86,381.5s5.39,2.57,11.93-3.3c2.86-5,4.69-12.12,0-16.14-3.21,8-8.84,8-8.84,8S961,380,951.86,381.5Z"
              fill="#396039"
            />
            <path
              d="M947.5,392.14a16.42,16.42,0,0,1-6.84-7.74c-5,.65-7.27-5.16-8-7.73-2.41,9.61,14.34,15.51,14.34,15.51Z"
              fill="#396039"
            />
          </g>
          <path
            d="M933.6,387.72a22.1,22.1,0,0,1-7.1-1.08,16,16,0,0,0,5.86,4.82c4.82,1.92,6.24,1.52,11-.89A23.5,23.5,0,0,1,933.6,387.72Z"
            fill="#172d17"
          />
          <path
            d="M994.08,384.24c-2.64,5.5-9.72,6.09-12.13,5.35,0,0-3.29,4.26-15.19,5.51,14.1-.26,31.79-3.52,27.43-10.7Z"
            fill="#172d17"
          />
          <path
            d="M947.5,392.08c-6-2.49-3.94-8.51,0-7.68S947.5,392.08,947.5,392.08Z"
            fill="#245624"
          />
          <path
            d="M947.14,391.79c9.55,9.26,19.15.49,14.39-6.23S947.14,391.79,947.14,391.79Z"
            fill="#1f441f"
          />
        </g>
        <g transform="translate(-20 25)">
          <ellipse
            cx="276.17"
            cy="343.5"
            rx="48.15"
            ry="8.5"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M250.91,336.18c-8.27,4.19-10.06,5.09-17.52,2.11S211,318,227.73,306.39s33.69,3.87,33.69,10.73c0,0-28.92-30.11,0-37.86s19.37,22.66,17.29,27.13c0,0,10.43-20.57,22.36-14.31s4.26,45-17.7,35c0,0,29.62-14.13,38.86,1.07s-50.38,18.19-60.81,13.12S250.91,336.18,250.91,336.18Z"
            fill="#1f441f"
          />
          <path
            d="M250.23,300.27c7.46,3,4.93-11.77,4.93-11.77s3.28-1.79,3.35-8.32C247.38,284.35,247.22,292.61,250.23,300.27Z"
            fill="#659965"
          />
          <path
            d="M276,311.16c-21.16-2.09-21.46-20-9.83-25S276,311.16,276,311.16Z"
            fill="#245624"
          />
          <path
            d="M266.41,326.82c-34.33,5.59-40.94-18.72-24.21-30.28S266.41,326.82,266.41,326.82Z"
            fill="#245624"
          />
          <path
            d="M280.78,326.09c25.8,15.21,41-4.88,32-20.3S280.78,326.09,280.78,326.09Z"
            fill="#245624"
          />
          <g>
            <path
              d="M278.71,306.39c10.73,7.15,12.82-5.67,12.82-5.67,4.58-.62,6-5.19,6.38-9.71C287.36,289.34,278.71,306.39,278.71,306.39Z"
              fill="#659965"
            />
            <path d="M278.71,306.39c.21-.46.51-1.2.83-2.14Z" fill="#659965" />
          </g>
          <path
            d="M291.19,330.57c14.73,3.87,24.07-5,24.19-15.24q-.83.72-1.62,1.32c-7,5.21-12.69,3.15-12.69,3.15s-.9,11.93-9.54,8.8Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M254.41,339.33s-26.23-9.24-20-24.15,15.2-6.85,20,11.93c0,0-6.26-39.95,16.7-34.59s5.66,33.69,0,34.59c0,0,16.69-22.66,27.42-6.26s-17.59,19.67-24.74,18.48S254.41,339.33,254.41,339.33Z"
              fill="#659965"
            />
            <path
              d="M298.53,320.85a14.83,14.83,0,0,0-3.91-4.2c-3.19,12-15,10.61-15,10.61s.3,11-12.52,8.94l-1.27,2.6a51.86,51.86,0,0,1,8,.53C280.94,340.52,309.27,337.24,298.53,320.85Z"
              fill="#396039"
            />
            <path
              d="M261.42,324s7.74,3.69,17.13-4.74c4.12-7.15,6.74-17.41,0-23.19-4.62,11.53-12.7,11.53-12.7,11.53S274.53,321.89,261.42,324Z"
              fill="#396039"
            />
            <path
              d="M255.15,339.26c-7-3.76-9.83-11.11-9.83-11.11-7.22.93-10.44-7.42-11.5-11.11-3.47,13.81,20.59,22.29,20.59,22.29Z"
              fill="#396039"
            />
          </g>
          <path
            d="M235.18,332.92A31.8,31.8,0,0,1,225,331.36a23.15,23.15,0,0,0,8.42,6.93c6.93,2.77,9,2.19,15.86-1.28A33.68,33.68,0,0,1,235.18,332.92Z"
            fill="#172d17"
          />
          <path
            d="M322.08,327.91c-3.79,7.91-14,8.76-17.44,7.69,0,0-4.72,6.13-21.82,7.92,20.26-.37,45.68-5,39.41-15.37Z"
            fill="#172d17"
          />
          <path
            d="M255.16,339.18c-8.65-3.58-5.67-12.22,0-11S255.16,339.18,255.16,339.18Z"
            fill="#245624"
          />
          <path
            d="M254.63,338.77c13.72,13.31,27.51.7,20.68-8.95S254.63,338.77,254.63,338.77Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <ellipse
            cx="925.13"
            cy="354.09"
            rx="33.51"
            ry="5.91"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M907.55,349c-5.76,2.92-7,3.54-12.19,1.47s-15.56-14.11-3.94-22.2,23.44,2.69,23.44,7.46c0,0-20.12-21,0-26.35s13.49,15.77,12,18.89c0,0,7.26-14.32,15.56-10s3,31.29-12.32,24.36c0,0,20.62-9.84,27.05.74s-35.07,12.66-42.33,9.13S907.55,349,907.55,349Z"
            fill="#1f441f"
          />
          <path
            d="M907.08,324c5.19,2.09,3.42-8.19,3.42-8.19s2.29-1.25,2.34-5.79C905.09,312.92,905,318.67,907.08,324Z"
            fill="#659965"
          />
          <path
            d="M925,331.58c-14.73-1.46-14.94-13.91-6.85-17.43S925,331.58,925,331.58Z"
            fill="#245624"
          />
          <path
            d="M918.34,342.47c-23.9,3.9-28.5-13-16.85-21.07S918.34,342.47,918.34,342.47Z"
            fill="#245624"
          />
          <path
            d="M928.34,342c17.95,10.58,28.53-3.4,22.26-14.13S928.34,342,928.34,342Z"
            fill="#245624"
          />
          <g>
            <path
              d="M926.9,328.26c7.46,5,8.92-3.95,8.92-3.95,3.19-.43,4.15-3.61,4.44-6.76C932.92,316.39,926.9,328.26,926.9,328.26Z"
              fill="#659965"
            />
            <path
              d="M926.9,328.26a15.76,15.76,0,0,0,.57-1.49Z"
              fill="#659965"
            />
          </g>
          <path
            d="M935.59,345.09c10.25,2.69,16.75-3.46,16.82-10.61-.38.34-.75.64-1.12.92-4.89,3.63-8.83,2.19-8.83,2.19s-.63,8.3-6.64,6.12Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M910,351.18s-18.26-6.43-13.91-16.8,10.59-4.78,13.91,8.3c0,0-4.36-27.81,11.61-24.07s3.95,23.44,0,24.07c0,0,11.62-15.77,19.09-4.36S928.45,352,923.47,351.18,910,351.18,910,351.18Z"
              fill="#659965"
            />
            <path
              d="M940.69,338.32a10.38,10.38,0,0,0-2.72-2.93c-2.22,8.34-10.45,7.39-10.45,7.39s.21,7.68-8.72,6.22l-.88,1.81a36.55,36.55,0,0,1,5.55.37C928.45,352,948.16,349.73,940.69,338.32Z"
              fill="#396039"
            />
            <path
              d="M914.86,340.5s5.39,2.57,11.93-3.3c2.86-5,4.69-12.12,0-16.14-3.21,8-8.84,8-8.84,8S924,339,914.86,340.5Z"
              fill="#396039"
            />
            <path
              d="M910.5,351.14a16.42,16.42,0,0,1-6.84-7.74c-5,.65-7.27-5.16-8-7.73-2.41,9.61,14.34,15.51,14.34,15.51Z"
              fill="#396039"
            />
          </g>
          <path
            d="M896.6,346.72a22.1,22.1,0,0,1-7.1-1.08,16,16,0,0,0,5.86,4.82c4.82,1.92,6.24,1.52,11-.89A23.5,23.5,0,0,1,896.6,346.72Z"
            fill="#172d17"
          />
          <path
            d="M957.08,343.24c-2.64,5.5-9.72,6.09-12.13,5.35,0,0-3.29,4.26-15.19,5.51,14.1-.26,31.79-3.52,27.43-10.7Z"
            fill="#172d17"
          />
          <path
            d="M910.5,351.08c-6-2.49-3.94-8.51,0-7.68S910.5,351.08,910.5,351.08Z"
            fill="#245624"
          />
          <path
            d="M910.14,350.79c9.55,9.26,19.15.49,14.39-6.23S910.14,350.79,910.14,350.79Z"
            fill="#1f441f"
          />
        </g>
        {/* <g>
          <ellipse
            cx="1208.74"
            cy="184.24"
            rx="15.62"
            ry="2.76"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1216.93,181.87c2.68,1.36,3.26,1.65,5.68.68s7.25-6.57,1.84-10.34-10.93,1.25-10.93,3.48c0,0,9.38-9.77,0-12.28s-6.28,7.35-5.61,8.8c0,0-3.38-6.67-7.25-4.64s-1.38,14.58,5.74,11.35c0,0-9.6-4.59-12.6.34s16.34,5.9,19.72,4.26Z"
            fill="#1f441f"
          />
          <path
            d="M1217.15,170.22c-2.42,1-1.6-3.81-1.6-3.81s-1.06-.58-1.08-2.7C1218.07,165.06,1218.13,167.74,1217.15,170.22Z"
            fill="#659965"
          />
          <path
            d="M1208.79,173.75c6.86-.67,7-6.47,3.19-8.12S1208.79,173.75,1208.79,173.75Z"
            fill="#245624"
          />
          <path
            d="M1211.9,178.83c11.14,1.82,13.28-6.07,7.86-9.82S1211.9,178.83,1211.9,178.83Z"
            fill="#245624"
          />
          <path
            d="M1207.24,178.6c-8.36,4.93-13.29-1.59-10.37-6.59S1207.24,178.6,1207.24,178.6Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1207.91,172.21c-3.48,2.32-4.15-1.84-4.15-1.84-1.49-.2-1.94-1.68-2.07-3.15C1205.11,166.68,1207.91,172.21,1207.91,172.21Z"
              fill="#659965"
            />
            <path d="M1207.91,172.21c-.06-.15-.16-.39-.26-.7Z" fill="#659965" />
          </g>
          <path
            d="M1203.87,180.05c-4.78,1.25-7.81-1.61-7.85-4.94.18.15.36.3.53.42a4.6,4.6,0,0,0,4.11,1s.29,3.87,3.1,2.85Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1215.79,182.89s8.51-3,6.48-7.83-4.93-2.22-6.48,3.87c0,0,2-13-5.41-11.22s-1.84,10.93,0,11.22c0,0-5.41-7.35-8.89-2s5.7,6.38,8,6A31.21,31.21,0,0,1,1215.79,182.89Z"
              fill="#659965"
            />
            <path
              d="M1201.49,176.9a4.84,4.84,0,0,1,1.26-1.37,4.54,4.54,0,0,0,4.87,3.44s-.09,3.58,4.07,2.91l.41.84a17.24,17.24,0,0,0-2.59.17C1207.19,183.28,1198,182.21,1201.49,176.9Z"
              fill="#396039"
            />
            <path
              d="M1213.52,177.91s-2.51,1.2-5.55-1.54c-1.34-2.31-2.19-5.64,0-7.52,1.5,3.74,4.12,3.74,4.12,3.74S1209.27,177.23,1213.52,177.91Z"
              fill="#396039"
            />
            <path
              d="M1215.55,182.87a7.59,7.59,0,0,0,3.19-3.61c2.35.31,3.39-2.4,3.73-3.6,1.13,4.48-6.68,7.23-6.68,7.23Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1222,180.81a10.23,10.23,0,0,0,3.31-.5,7.45,7.45,0,0,1-2.73,2.24c-2.25.9-2.91.71-5.14-.41A11,11,0,0,0,1222,180.81Z"
            fill="#172d17"
          />
          <path
            d="M1193.85,179.19c1.23,2.56,4.53,2.84,5.65,2.49,0,0,1.54,2,7.08,2.57-6.57-.12-14.81-1.64-12.78-5Z"
            fill="#172d17"
          />
          <path
            d="M1215.55,182.84c2.81-1.16,1.84-4,0-3.58S1215.55,182.84,1215.55,182.84Z"
            fill="#245624"
          />
          <path
            d="M1215.72,182.71c-4.45,4.31-8.92.23-6.7-2.9S1215.72,182.71,1215.72,182.71Z"
            fill="#1f441f"
          />
        </g> */}
        <g>
          <ellipse
            cx="1170.74"
            cy="193.24"
            rx="15.62"
            ry="2.76"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1178.93,190.87c2.68,1.36,3.26,1.65,5.68.68s7.25-6.57,1.84-10.34-10.93,1.25-10.93,3.48c0,0,9.38-9.77,0-12.28s-6.28,7.35-5.61,8.8c0,0-3.38-6.67-7.25-4.64s-1.38,14.58,5.74,11.35c0,0-9.6-4.59-12.6.34s16.34,5.9,19.72,4.26Z"
            fill="#1f441f"
          />
          <path
            d="M1179.15,179.22c-2.42,1-1.6-3.81-1.6-3.81s-1.06-.58-1.08-2.7C1180.07,174.06,1180.13,176.74,1179.15,179.22Z"
            fill="#659965"
          />
          <path
            d="M1170.79,182.75c6.86-.67,7-6.47,3.19-8.12S1170.79,182.75,1170.79,182.75Z"
            fill="#245624"
          />
          <path
            d="M1173.9,187.83c11.14,1.82,13.28-6.07,7.86-9.82S1173.9,187.83,1173.9,187.83Z"
            fill="#245624"
          />
          <path
            d="M1169.24,187.6c-8.36,4.93-13.29-1.59-10.37-6.59S1169.24,187.6,1169.24,187.6Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1169.91,181.21c-3.48,2.32-4.15-1.84-4.15-1.84-1.49-.2-1.94-1.68-2.07-3.15C1167.11,175.68,1169.91,181.21,1169.91,181.21Z"
              fill="#659965"
            />
            <path d="M1169.91,181.21c-.06-.15-.16-.39-.26-.7Z" fill="#659965" />
          </g>
          <path
            d="M1165.87,189.05c-4.78,1.25-7.81-1.61-7.85-4.94.18.15.36.3.53.42a4.6,4.6,0,0,0,4.11,1s.29,3.87,3.1,2.85Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1177.79,191.89s8.51-3,6.48-7.83-4.93-2.22-6.48,3.87c0,0,2-13-5.41-11.22s-1.84,10.93,0,11.22c0,0-5.41-7.35-8.89-2s5.7,6.38,8,6A31.21,31.21,0,0,1,1177.79,191.89Z"
              fill="#659965"
            />
            <path
              d="M1163.49,185.9a4.84,4.84,0,0,1,1.26-1.37,4.54,4.54,0,0,0,4.87,3.44s-.09,3.58,4.07,2.91l.41.84a17.24,17.24,0,0,0-2.59.17C1169.19,192.28,1160,191.21,1163.49,185.9Z"
              fill="#396039"
            />
            <path
              d="M1175.52,186.91s-2.51,1.2-5.55-1.54c-1.34-2.31-2.19-5.64,0-7.52,1.5,3.74,4.12,3.74,4.12,3.74S1171.27,186.23,1175.52,186.91Z"
              fill="#396039"
            />
            <path
              d="M1177.55,191.87a7.59,7.59,0,0,0,3.19-3.61c2.35.31,3.39-2.4,3.73-3.6,1.13,4.48-6.68,7.23-6.68,7.23Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1184,189.81a10.23,10.23,0,0,0,3.31-.5,7.45,7.45,0,0,1-2.73,2.24c-2.25.9-2.91.71-5.14-.41A11,11,0,0,0,1184,189.81Z"
            fill="#172d17"
          />
          <path
            d="M1155.85,188.19c1.23,2.56,4.53,2.84,5.65,2.49,0,0,1.54,2,7.08,2.57-6.57-.12-14.81-1.64-12.78-5Z"
            fill="#172d17"
          />
          <path
            d="M1177.55,191.84c2.81-1.16,1.84-4,0-3.58S1177.55,191.84,1177.55,191.84Z"
            fill="#245624"
          />
          <path
            d="M1177.72,191.71c-4.45,4.31-8.92.23-6.7-2.9S1177.72,191.71,1177.72,191.71Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <ellipse
            cx="1075.74"
            cy="227.24"
            rx="15.62"
            ry="2.76"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1083.93,224.87c2.68,1.36,3.26,1.65,5.68.68s7.25-6.57,1.84-10.34-10.93,1.25-10.93,3.48c0,0,9.38-9.77,0-12.28s-6.28,7.35-5.61,8.8c0,0-3.38-6.67-7.25-4.64s-1.38,14.58,5.74,11.35c0,0-9.6-4.59-12.6.34s16.34,5.9,19.72,4.26Z"
            fill="#1f441f"
          />
          <path
            d="M1084.15,213.22c-2.42,1-1.6-3.81-1.6-3.81s-1.06-.58-1.08-2.7C1085.07,208.06,1085.13,210.74,1084.15,213.22Z"
            fill="#659965"
          />
          <path
            d="M1075.79,216.75c6.86-.67,7-6.47,3.19-8.12S1075.79,216.75,1075.79,216.75Z"
            fill="#245624"
          />
          <path
            d="M1078.9,221.83c11.14,1.82,13.28-6.07,7.86-9.82S1078.9,221.83,1078.9,221.83Z"
            fill="#245624"
          />
          <path
            d="M1074.24,221.6c-8.36,4.93-13.29-1.59-10.37-6.59S1074.24,221.6,1074.24,221.6Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1074.91,215.21c-3.48,2.32-4.15-1.84-4.15-1.84-1.49-.2-1.94-1.68-2.07-3.15C1072.11,209.68,1074.91,215.21,1074.91,215.21Z"
              fill="#659965"
            />
            <path d="M1074.91,215.21c-.06-.15-.16-.39-.26-.7Z" fill="#659965" />
          </g>
          <path
            d="M1070.87,223.05c-4.78,1.25-7.81-1.61-7.85-4.94.18.15.36.3.53.42a4.6,4.6,0,0,0,4.11,1s.29,3.87,3.1,2.85Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1082.79,225.89s8.51-3,6.48-7.83-4.93-2.22-6.48,3.87c0,0,2-13-5.41-11.22s-1.84,10.93,0,11.22c0,0-5.41-7.35-8.89-2s5.7,6.38,8,6A31.21,31.21,0,0,1,1082.79,225.89Z"
              fill="#659965"
            />
            <path
              d="M1068.49,219.9a4.84,4.84,0,0,1,1.26-1.37,4.54,4.54,0,0,0,4.87,3.44s-.09,3.58,4.07,2.91l.41.84a17.24,17.24,0,0,0-2.59.17C1074.19,226.28,1065,225.21,1068.49,219.9Z"
              fill="#396039"
            />
            <path
              d="M1080.52,220.91s-2.51,1.2-5.55-1.54c-1.34-2.31-2.19-5.64,0-7.52,1.5,3.74,4.12,3.74,4.12,3.74S1076.27,220.23,1080.52,220.91Z"
              fill="#396039"
            />
            <path
              d="M1082.55,225.87a7.59,7.59,0,0,0,3.19-3.61c2.35.31,3.39-2.4,3.73-3.6,1.13,4.48-6.68,7.23-6.68,7.23Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1089,223.81a10.23,10.23,0,0,0,3.31-.5,7.45,7.45,0,0,1-2.73,2.24c-2.25.9-2.91.71-5.14-.41A11,11,0,0,0,1089,223.81Z"
            fill="#172d17"
          />
          <path
            d="M1060.85,222.19c1.23,2.56,4.53,2.84,5.65,2.49,0,0,1.54,2,7.08,2.57-6.57-.12-14.81-1.64-12.78-5Z"
            fill="#172d17"
          />
          <path
            d="M1082.55,225.84c2.81-1.16,1.84-4,0-3.58S1082.55,225.84,1082.55,225.84Z"
            fill="#245624"
          />
          <path
            d="M1082.72,225.71c-4.45,4.31-8.92.23-6.7-2.9S1082.72,225.71,1082.72,225.71Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <ellipse
            cx="1036.83"
            cy="238.93"
            rx="11.71"
            ry="2.07"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1043,237.15c2,1,2.45,1.24,4.26.51s5.44-4.93,1.38-7.75-8.2.94-8.2,2.61c0,0,7-7.33,0-9.21s-4.71,5.51-4.2,6.6c0,0-2.54-5-5.44-3.49s-1,10.94,4.3,8.52c0,0-7.2-3.44-9.45.26s12.25,4.42,14.79,3.19Z"
            fill="#1f441f"
          />
          <path
            d="M1043.14,228.42c-1.81.73-1.19-2.87-1.19-2.87s-.8-.43-.82-2C1043.84,224.54,1043.88,226.55,1043.14,228.42Z"
            fill="#659965"
          />
          <path
            d="M1036.87,231.07c5.15-.51,5.22-4.86,2.39-6.1S1036.87,231.07,1036.87,231.07Z"
            fill="#245624"
          />
          <path
            d="M1039.21,234.87c8.35,1.36,10-4.55,5.89-7.36S1039.21,234.87,1039.21,234.87Z"
            fill="#245624"
          />
          <path
            d="M1035.71,234.7c-6.27,3.7-10-1.19-7.78-4.94S1035.71,234.7,1035.71,234.7Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1036.22,229.91c-2.61,1.74-3.12-1.38-3.12-1.38-1.12-.15-1.45-1.27-1.55-2.37C1034.11,225.76,1036.22,229.91,1036.22,229.91Z"
              fill="#659965"
            />
            <path d="M1036.22,229.91a4.84,4.84,0,0,1-.21-.53Z" fill="#659965" />
          </g>
          <path
            d="M1033.18,235.79c-3.58.94-5.85-1.21-5.88-3.71.13.12.26.22.39.32a3.48,3.48,0,0,0,3.09.77s.22,2.9,2.32,2.14Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1042.13,237.92s6.38-2.25,4.86-5.88-3.7-1.66-4.86,2.9c0,0,1.52-9.71-4.06-8.41s-1.38,8.2,0,8.41c0,0-4.07-5.51-6.68-1.52s4.28,4.79,6,4.5A23.71,23.71,0,0,1,1042.13,237.92Z"
              fill="#659965"
            />
            <path
              d="M1031.39,233.42a3.66,3.66,0,0,1,1-1A3.4,3.4,0,0,0,1036,235s-.07,2.68,3,2.18l.31.63a11.76,11.76,0,0,0-1.94.13C1035.67,238.21,1028.78,237.41,1031.39,233.42Z"
              fill="#396039"
            />
            <path
              d="M1040.42,234.18s-1.88.9-4.17-1.15c-1-1.74-1.63-4.23,0-5.64,1.12,2.81,3.08,2.81,3.08,2.81S1037.23,233.68,1040.42,234.18Z"
              fill="#396039"
            />
            <path
              d="M1042,237.9a5.72,5.72,0,0,0,2.39-2.7c1.75.23,2.54-1.81,2.8-2.7.84,3.36-5,5.42-5,5.42Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1046.8,236.36a7.89,7.89,0,0,0,2.49-.38,5.7,5.7,0,0,1-2,1.68c-1.69.68-2.18.54-3.86-.31A8.07,8.07,0,0,0,1046.8,236.36Z"
            fill="#172d17"
          />
          <path
            d="M1025.67,235.14a3.94,3.94,0,0,0,4.24,1.87s1.15,1.49,5.31,1.93c-4.93-.09-11.12-1.23-9.59-3.74Z"
            fill="#172d17"
          />
          <path
            d="M1042,237.88c2.1-.87,1.37-3,0-2.68S1042,237.88,1042,237.88Z"
            fill="#245624"
          />
          <path
            d="M1042.07,237.78c-3.33,3.24-6.69.17-5-2.18S1042.07,237.78,1042.07,237.78Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <ellipse
            cx="1277.74"
            cy="168.24"
            rx="15.62"
            ry="2.76"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1285.93,165.87c2.68,1.36,3.26,1.65,5.68.68s7.25-6.57,1.84-10.34-10.93,1.25-10.93,3.48c0,0,9.38-9.77,0-12.28s-6.28,7.35-5.61,8.8c0,0-3.38-6.67-7.25-4.64s-1.38,14.58,5.74,11.35c0,0-9.6-4.59-12.6.34s16.34,5.9,19.72,4.26Z"
            fill="#1f441f"
          />
          <path
            d="M1286.15,154.22c-2.42,1-1.6-3.81-1.6-3.81s-1.06-.58-1.08-2.7C1287.07,149.06,1287.13,151.74,1286.15,154.22Z"
            fill="#659965"
          />
          <path
            d="M1277.79,157.75c6.86-.67,7-6.47,3.19-8.12S1277.79,157.75,1277.79,157.75Z"
            fill="#245624"
          />
          <path
            d="M1280.9,162.83c11.14,1.82,13.28-6.07,7.86-9.82S1280.9,162.83,1280.9,162.83Z"
            fill="#245624"
          />
          <path
            d="M1276.24,162.6c-8.36,4.93-13.29-1.59-10.37-6.59S1276.24,162.6,1276.24,162.6Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1276.91,156.21c-3.48,2.32-4.15-1.84-4.15-1.84-1.49-.2-1.94-1.68-2.07-3.15C1274.11,150.68,1276.91,156.21,1276.91,156.21Z"
              fill="#659965"
            />
            <path d="M1276.91,156.21c-.06-.15-.16-.39-.26-.7Z" fill="#659965" />
          </g>
          <path
            d="M1272.87,164.05c-4.78,1.25-7.81-1.61-7.85-4.94.18.15.36.3.53.42a4.6,4.6,0,0,0,4.11,1s.29,3.87,3.1,2.85Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1284.79,166.89s8.51-3,6.48-7.83-4.93-2.22-6.48,3.87c0,0,2-13-5.41-11.22s-1.84,10.93,0,11.22c0,0-5.41-7.35-8.89-2s5.7,6.38,8,6A31.21,31.21,0,0,1,1284.79,166.89Z"
              fill="#659965"
            />
            <path
              d="M1270.49,160.9a4.84,4.84,0,0,1,1.26-1.37,4.54,4.54,0,0,0,4.87,3.44s-.09,3.58,4.07,2.91l.41.84a17.24,17.24,0,0,0-2.59.17C1276.19,167.28,1267,166.21,1270.49,160.9Z"
              fill="#396039"
            />
            <path
              d="M1282.52,161.91s-2.51,1.2-5.55-1.54c-1.34-2.31-2.19-5.64,0-7.52,1.5,3.74,4.12,3.74,4.12,3.74S1278.27,161.23,1282.52,161.91Z"
              fill="#396039"
            />
            <path
              d="M1284.55,166.87a7.59,7.59,0,0,0,3.19-3.61c2.35.31,3.39-2.4,3.73-3.6,1.13,4.48-6.68,7.23-6.68,7.23Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1291,164.81a10.23,10.23,0,0,0,3.31-.5,7.45,7.45,0,0,1-2.73,2.24c-2.25.9-2.91.71-5.14-.41A11,11,0,0,0,1291,164.81Z"
            fill="#172d17"
          />
          <path
            d="M1262.85,163.19c1.23,2.56,4.53,2.84,5.65,2.49,0,0,1.54,2,7.08,2.57-6.57-.12-14.81-1.64-12.78-5Z"
            fill="#172d17"
          />
          <path
            d="M1284.55,166.84c2.81-1.16,1.84-4,0-3.58S1284.55,166.84,1284.55,166.84Z"
            fill="#245624"
          />
          <path
            d="M1284.72,166.71c-4.45,4.31-8.92.23-6.7-2.9S1284.72,166.71,1284.72,166.71Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M1120.6,261.9c.16-.16.33-.31.5-.45a6.25,6.25,0,0,1,.81-.57c.26-.14.54-.24.81-.36a2.5,2.5,0,0,0,.67-.39c.22-.18.39-.4.6-.59a1.83,1.83,0,0,1,.55-.33l.45-.12a3.17,3.17,0,0,1,.44,0,.07.07,0,0,0,.07-.05,3.13,3.13,0,0,1,1.94.42,3.06,3.06,0,0,1,1.2,1.4,1.19,1.19,0,0,0-.05.32,2.23,2.23,0,0,0,.21.71,1.3,1.3,0,0,1,.13.8,6.78,6.78,0,0,1-.33.85,1.39,1.39,0,0,0-.08.46,1.56,1.56,0,0,0,.08.43,1.1,1.1,0,0,1,.05.48,3.36,3.36,0,0,1-.14.45,3.81,3.81,0,0,0-.07.47,3.21,3.21,0,0,1-.08.36,4.21,4.21,0,0,1-1,1.39,2.49,2.49,0,0,0-.5.86,4.29,4.29,0,0,0-.12.8,2.1,2.1,0,0,1-.14.66,2.3,2.3,0,0,1-.62.7c-.58.48-1.23.88-1.78,1.4-.13.13-.26.26-.38.4s-.21.28-.33.41a1.16,1.16,0,0,1-.56.36,4.69,4.69,0,0,1-.64.09,1.65,1.65,0,0,0-.89.31,1.68,1.68,0,0,1-.4.3,1.18,1.18,0,0,1-.42,0,4.76,4.76,0,0,0-.84-.07l0,0a3.18,3.18,0,0,1-.83-.35,3,3,0,0,1-.94-.92,4.65,4.65,0,0,0-.15-1,10.16,10.16,0,0,1-.26-1.09,3.27,3.27,0,0,1,0-.54c0-.18,0-.36,0-.55,0-.34-.07-.69,0-1a1.59,1.59,0,0,1,.14-.56c.08-.17.19-.33.28-.49a1.53,1.53,0,0,0,.21-.51,3.45,3.45,0,0,0,.07-.55c0-.25,0-.49.06-.73a15.05,15.05,0,0,1,.71-1.38,3.08,3.08,0,0,1,.6-.14c.31,0,.62-.06.93-.11a.06.06,0,0,0,.06-.09c-.1-.23-.22-.46-.31-.7a.85.85,0,0,1,.09-.89Z"
                fill="#141c66"
              />
              <path d="M1127.12,260s-4,10.1-19,26.16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1120.31,280.86c.27-.19.51-.4.76-.61a21.84,21.84,0,0,1,4.71-1.66,5,5,0,0,0,.66.08,7.48,7.48,0,0,0,.82,0h1a6.46,6.46,0,0,0,1.81-.22c.29-.09.55-.23.83-.34a5.66,5.66,0,0,1,.58-.2c3.09,0,5.33.75,5.58,2.06a1.23,1.23,0,0,1,0,.54l-.17.22a3.74,3.74,0,0,1-.91.82,6,6,0,0,1-1.09.51,7.85,7.85,0,0,0-1.33.49,5.15,5.15,0,0,0-1,.81,6.57,6.57,0,0,1-1,.85,1.74,1.74,0,0,1-1.09.34,3.72,3.72,0,0,1-.8-.25,3,3,0,0,0-1-.18.91.91,0,0,0-.71.21c-.19.18-.33.43-.51.62a2.22,2.22,0,0,1-1.75.61,8.51,8.51,0,0,1-1.94-.43c-.34-.1-.69-.19-1-.26l-.54-.09-.62,0a8.18,8.18,0,0,1-2.41-.68c-.39-.15-.78-.3-1.18-.42a2.42,2.42,0,0,1,1.12-2.1A5.18,5.18,0,0,0,1120.31,280.86Z"
                fill="#141c66"
              />
              <path d="M1137.45,280.2s-17.58.37-29.25,6.75" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1118.92,282.05c.23-.12.45-.25.67-.38a17.21,17.21,0,0,1,3.9-.71l.51.15c.21.05.43.08.64.11l.75.11a5,5,0,0,0,1.45.06c.24,0,.46-.12.7-.17l.47-.08c2.42.4,4.09,1.27,4.12,2.32a1.06,1.06,0,0,1-.08.43l-.15.15a3.11,3.11,0,0,1-.82.53,4.33,4.33,0,0,1-.92.25,6.7,6.7,0,0,0-1.1.22,3.94,3.94,0,0,0-.89.51,4.94,4.94,0,0,1-.88.54,1.4,1.4,0,0,1-.9.13,2.73,2.73,0,0,1-.59-.3,2.93,2.93,0,0,0-.75-.27.73.73,0,0,0-.58.08c-.18.12-.32.29-.49.42a1.77,1.77,0,0,1-1.45.26,6.57,6.57,0,0,1-1.46-.59,7.59,7.59,0,0,0-.78-.33l-.41-.14c-.15-.05-.31-.07-.47-.11a6.09,6.09,0,0,1-1.81-.84,9.17,9.17,0,0,0-.87-.48c0-.54.41-1.06,1.14-1.5A4.23,4.23,0,0,0,1118.92,282.05Z"
                fill="#141c66"
              />
              <path d="M1132.43,283.71s-13.82-1.95-23.78,1.58" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1116.25,278.7a.39.39,0,0,0,.28,0,.41.41,0,0,0,.13-.29,3.33,3.33,0,0,0,0-.55h0a2.25,2.25,0,0,0,.36.06.45.45,0,0,0,.26-.05c.14-.1.09-.29.06-.43l-.09-.29.63-.68.14.11a2.8,2.8,0,0,0,.35.25.74.74,0,0,0,.31.12s.09,0,.08-.08a3.43,3.43,0,0,0-.09-.44,1,1,0,0,1,0-.42c0-.16.22-.19.34-.27a.4.4,0,0,0,.13-.31,1.09,1.09,0,0,0,0-.18l.87-.78.19.15a1.13,1.13,0,0,0,.54.26.44.44,0,0,0,.47-.25.94.94,0,0,0,0-.66,1.6,1.6,0,0,0-.11-.33l.28-.3.94-.73h.06a.72.72,0,0,1,.24.1,1.08,1.08,0,0,0,.4.11s.07,0,.08-.06c0-.2-.06-.62.22-.69.07,0,.15.07.22.1a.21.21,0,0,0,.26-.05c.11-.15,0-.36.09-.52s.27,0,.34.09a3.09,3.09,0,0,0,.36.45.07.07,0,0,0,.11-.06c0-.37,0-.73,0-1.09.7-.45,1.39-.86,2-1.22,0,0,0,.09,0,.13a.07.07,0,0,0,.1,0,2.59,2.59,0,0,1,.1.62,2.54,2.54,0,0,1,0,.39c0,.09.13.11.14,0a2.81,2.81,0,0,0,0-.41,4.91,4.91,0,0,0-.09-.94c.58-.31,1.13-.58,1.66-.81a3,3,0,0,1,.12.78l0,.33a.07.07,0,0,0,.14,0,2,2,0,0,0,0-.35c0-.22,0-.44.06-.67,0-.08,0-.17,0-.25a11.71,11.71,0,0,1,1.53-.53,6.62,6.62,0,0,0,.26,1,.06.06,0,0,0,.1,0,1.44,1.44,0,0,0,.41-.73,3.12,3.12,0,0,0,.09-.44,1.5,1.5,0,0,1,1.39.36c.48.65-.14,2-1.52,3.68-.28-.06-.56-.1-.84-.14-.08,0-.11.1,0,.13a5.05,5.05,0,0,0,.69.22c-.37.43-.79.88-1.25,1.35a11.12,11.12,0,0,0-1.4.26.06.06,0,0,0-.06.08c0,.29.12.57.18.86-.68.61-1.43,1.24-2.23,1.85a5.45,5.45,0,0,0-1.38.33,3,3,0,0,0-.87.59l-.39.35c-.13.11-.27.21-.39.33s-.41.51-.64.75a.78.78,0,0,1-.76.3,2,2,0,0,1-.53-.34.25.25,0,0,0-.22-.05.35.35,0,0,0-.18.2,1.41,1.41,0,0,0-.06.79c0,.08,0,.17,0,.25-2.78,1.46-5,2-5.57,1.18-.38-.5-.09-1.43.71-2.6Z"
                fill="#141c66"
              />
              <path d="M1129.86,270.47s-19.82,15.19-21.55,16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1123.3,269.88a.91.91,0,0,1,.32.42c0,.16-.09.31-.13.47s-.11.47-.15.71a3.93,3.93,0,0,1-.15.68,4.58,4.58,0,0,1-.45,1,4.6,4.6,0,0,0-.57,1.1c-.08.33-.07.67-.13,1h0c-.09.15-.19.29-.29.43a13.4,13.4,0,0,1-2.15,2.42l-.22.13a19.28,19.28,0,0,0-2.08,1.05.94.94,0,0,1-.53-.15c-.94-.67-.24-3.28,1.56-5.85S1122.36,269.21,1123.3,269.88Z"
                fill="#141c66"
              />
              <path d="M1118.33,273.32s.89,5.21-9,12.75" fill="#141c66" />
              <path
                d="M1122.85,271.14a2.78,2.78,0,0,1-.6,1.26,5.64,5.64,0,0,0-.89,1,2,2,0,0,0-.22.69c0,.23,0,.46-.06.69a1.38,1.38,0,0,1-.27.68,1.32,1.32,0,0,1-.46.32,2.39,2.39,0,0,0-.52.28,1.84,1.84,0,0,0-.48.65,2.13,2.13,0,0,1-.51.67,1.68,1.68,0,0,1-.46.24,1.42,1.42,0,0,0-.47.31,1.35,1.35,0,0,0-.31.44,1.11,1.11,0,0,1-.26.39,1.42,1.42,0,0,1-.64.23h-.08a.5.5,0,0,1-.21-.09c-.74-.52.12-3,1.92-5.59s3.87-4.22,4.61-3.69a.49.49,0,0,1,.21.29A5.44,5.44,0,0,0,1122.85,271.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1090.78,251.23c0-.32-.07-.64-.09-1a7.37,7.37,0,0,1,0-1.41c0-.42.18-.82.27-1.23a4.08,4.08,0,0,0,.12-1.1c0-.41-.13-.79-.16-1.2a2.81,2.81,0,0,1,.08-.91,5.42,5.42,0,0,1,.26-.6,3.84,3.84,0,0,1,.35-.54.09.09,0,0,0,0-.11,4.29,4.29,0,0,1,4.77-2,1.26,1.26,0,0,0,.32.33,2.68,2.68,0,0,0,1,.36,2,2,0,0,1,1,.53,8.54,8.54,0,0,1,.69,1.11,1.7,1.7,0,0,0,1,.75,1.53,1.53,0,0,1,.6.36c.15.17.27.36.4.54a3.7,3.7,0,0,0,.48.49,4.23,4.23,0,0,1,.34.4,5.82,5.82,0,0,1,.73,2.34,3.34,3.34,0,0,0,.55,1.3,6.43,6.43,0,0,0,.82.83,2.56,2.56,0,0,1,.63.72,3.08,3.08,0,0,1,.28,1.31c0,1.07,0,2.15.09,3.22a7,7,0,0,0,.13.78c.06.24.15.48.19.73a1.54,1.54,0,0,1-.07.95,6.35,6.35,0,0,1-.44.81,2.43,2.43,0,0,0-.41,1.28,1.89,1.89,0,0,1,0,.71,1.46,1.46,0,0,1-.32.52,6.14,6.14,0,0,0-.79.9.13.13,0,0,0,0,.06,4.18,4.18,0,0,1-3,.95,5.63,5.63,0,0,0-1.24-.65c-.49-.21-1-.38-1.48-.63a4.48,4.48,0,0,1-.64-.43c-.21-.16-.38-.35-.59-.51-.4-.29-.86-.51-1.23-.83a2.23,2.23,0,0,1-.53-.65c-.12-.23-.21-.49-.32-.74a2.48,2.48,0,0,0-.4-.66c-.18-.2-.38-.39-.57-.57l-.8-.68a19.28,19.28,0,0,1-1-2,3.89,3.89,0,0,1,.35-.81c.21-.39.45-.76.67-1.15,0,0,0-.14-.06-.15-.35-.08-.71-.14-1.06-.25a1.43,1.43,0,0,1-.69-.38,1.45,1.45,0,0,1-.26-.47C1090.86,251.64,1090.82,251.44,1090.78,251.23Z"
                fill="#396039"
              />
              <path
                d="M1094.12,242.1a75.1,75.1,0,0,1,4.86,10.5c1.4,3.61,2.6,7.28,3.72,11s2,7.46,2.92,11.21c.43,1.89.82,3.78,1.23,5.66l1.06,5.7-1.16-5.68-1.26-5.65c-.91-3.74-1.86-7.49-3-11.18s-2.27-7.37-3.64-11c-.7-1.8-1.41-3.59-2.2-5.35A55.51,55.51,0,0,0,1094.12,242.1Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1112.25,267.72c0-.46,0-.92,0-1.38a30.78,30.78,0,0,1,2.11-6.81c.23-.22.46-.45.66-.68a10.54,10.54,0,0,0,.7-1l.81-1.1a8.94,8.94,0,0,0,1.29-2.27c.15-.4.2-.83.31-1.24s.17-.56.27-.83c2.64-3.54,5.4-5.47,7.12-4.64a2,2,0,0,1,.62.47l.1.37a5.16,5.16,0,0,1,.16,1.75,7.48,7.48,0,0,1-.34,1.68,11.69,11.69,0,0,0-.57,1.94,7.1,7.1,0,0,0,.08,1.84,9.54,9.54,0,0,1,.13,1.85,2.51,2.51,0,0,1-.54,1.54,4.79,4.79,0,0,1-1,.7,4.65,4.65,0,0,0-1.05,1,1.29,1.29,0,0,0-.36,1c0,.39.21.75.27,1.13a3.16,3.16,0,0,1-.79,2.52,12.65,12.65,0,0,1-2.15,1.85c-.4.31-.8.62-1.18,1l-.56.54c-.2.22-.37.45-.57.68a11.56,11.56,0,0,1-2.83,2.18,16.74,16.74,0,0,0-1.49,1c-.87-.43-1.35-1.53-1.46-3.07A7.29,7.29,0,0,0,1112.25,267.72Z"
                fill="#2f4f2f"
              />
              <path
                d="M1126.11,247.54c-2,3-3.88,6.06-5.66,9.19s-3.42,6.33-4.93,9.6a105.38,105.38,0,0,0-4,10,72.12,72.12,0,0,0-2.59,10.47,64.16,64.16,0,0,1,2.46-10.51,103.32,103.32,0,0,1,4-10.05A127.54,127.54,0,0,1,1126.11,247.54Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M1112.42,270.34c.06-.37.1-.73.14-1.1a24,24,0,0,1,2.52-5.06c.21-.15.41-.3.6-.46s.45-.43.67-.65.52-.5.77-.76a7.28,7.28,0,0,0,1.31-1.61c.16-.3.26-.62.4-.94s.2-.41.31-.61c2.52-2.44,4.93-3.6,6.17-2.74a1.51,1.51,0,0,1,.42.45c0,.1,0,.21,0,.31a4.33,4.33,0,0,1-.1,1.39,5.92,5.92,0,0,1-.48,1.27,8.75,8.75,0,0,0-.69,1.45,5.88,5.88,0,0,0-.18,1.45,7.24,7.24,0,0,1-.13,1.47,2,2,0,0,1-.61,1.13,3.84,3.84,0,0,1-.86.43,3.69,3.69,0,0,0-.94.63,1.05,1.05,0,0,0-.41.73c0,.31.07.61.07.92a2.55,2.55,0,0,1-.94,1.88,10.16,10.16,0,0,1-1.92,1.17c-.36.19-.71.39-1,.61a5.62,5.62,0,0,0-.5.35c-.19.14-.35.3-.53.45a9.17,9.17,0,0,1-2.5,1.35c-.44.18-.88.37-1.3.59a2.77,2.77,0,0,1-.75-2.59A6.15,6.15,0,0,0,1112.42,270.34Z"
                fill="#396039"
              />
              <path
                d="M1125.85,256.28c-1.95,2.08-3.8,4.26-5.6,6.49s-3.47,4.53-5.07,6.9a83.75,83.75,0,0,0-4.43,7.32,58.77,58.77,0,0,0-3.37,7.87,49.66,49.66,0,0,1,3.25-7.93q2-3.8,4.38-7.38A100.11,100.11,0,0,1,1125.85,256.28Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1106.32,270.54a.52.52,0,0,0,.2-.34.55.55,0,0,0-.21-.4,4.78,4.78,0,0,0-.61-.48v0a2.28,2.28,0,0,0,.38-.38.64.64,0,0,0,.16-.33c0-.24-.25-.35-.44-.43l-.4-.15c-.09-.41-.17-.85-.25-1.3l.25-.06c.19-.06.39-.11.58-.19a1,1,0,0,0,.4-.26.1.1,0,0,0,0-.16,5.14,5.14,0,0,0-.58-.27,1.38,1.38,0,0,1-.5-.32c-.15-.19,0-.41,0-.62a.6.6,0,0,0-.23-.42l-.19-.16c-.06-.53-.11-1.09-.16-1.66l.34-.09a1.82,1.82,0,0,0,.75-.4.62.62,0,0,0,.12-.76,1.52,1.52,0,0,0-.76-.56l-.48-.15c0-.19-.06-.39-.1-.58,0-.56,0-1.12,0-1.69l0-.07a1,1,0,0,1,.31-.19,1.68,1.68,0,0,0,.48-.36.11.11,0,0,0,0-.14c-.23-.19-.77-.47-.61-.85,0-.1.21-.12.3-.17a.28.28,0,0,0,.17-.33c-.07-.26-.38-.35-.52-.55s.24-.31.39-.32a4.61,4.61,0,0,0,.83,0c.09,0,.09-.14,0-.19-.42-.3-.84-.6-1.29-.87.08-1.18.2-2.31.34-3.37l.19,0a.09.09,0,0,0,.12-.08,3.86,3.86,0,0,1,.81.41c.14.1.29.21.43.33s.24-.06.14-.14a3.1,3.1,0,0,0-.46-.35,8.57,8.57,0,0,0-1.16-.71c.14-.92.31-1.79.49-2.58a4.45,4.45,0,0,1,1,.52l.36.33a.1.1,0,0,0,.14-.15,2.91,2.91,0,0,0-.37-.33l-.71-.65-.29-.23a17.86,17.86,0,0,1,.71-2.2,12.7,12.7,0,0,0,1.33.53.1.1,0,0,0,.13-.1,2.16,2.16,0,0,0-.49-1.09,4.69,4.69,0,0,0-.42-.47c.48-.83,1-1.29,1.59-1.29,1.15,0,2.18,1.88,2.91,4.88-.3.27-.59.55-.87.83a.1.1,0,0,0,.12.16,7.12,7.12,0,0,0,.84-.6c.18.79.34,1.66.47,2.58a17,17,0,0,0-.89,1.82.11.11,0,0,0,0,.14c.37.19.76.35,1.15.52.12,1.31.19,2.7.22,4.14a7.41,7.41,0,0,0-.81,1.87,4.39,4.39,0,0,0-.06,1.49c0,.25.05.5.06.75s0,.48,0,.73c.07.46.24.9.32,1.36a1.12,1.12,0,0,1-.31,1.13,2.66,2.66,0,0,1-.84.32.35.35,0,0,0-.25.21.58.58,0,0,0,.07.38,2.07,2.07,0,0,0,.87.73l.31.18c-.7,4.43-2,7.38-3.4,7.38-.89,0-1.71-1.12-2.37-3Z"
                fill="#659965"
              />
              <path
                d="M1108.49,247.93c.17,6.4.22,12.79.29,19.19v9.59c0,3.2,0,6.41-.29,9.59.15-1.59.12-3.19.14-4.79v-4.8l-.06-9.59Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1102.22,254.94a1.23,1.23,0,0,1,.76,0l.43.54c.22.27.44.53.68.78a7.7,7.7,0,0,1,.66.75,7.43,7.43,0,0,1,.76,1.38,6.53,6.53,0,0,0,.78,1.59c.31.37.7.66,1,1l0,0,.24.71a18.53,18.53,0,0,1,.94,4.52c0,.12,0,.24,0,.36a28.12,28.12,0,0,0-.57,3.28,1.26,1.26,0,0,1-.63.47c-1.56.51-4-2.52-5.36-6.77S1100.66,255.45,1102.22,254.94Z"
                fill="#3b6818"
              />
              <path
                d="M1101.92,263.57s6.73,3.43,7,21.14"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.2"
              />
              <path
                d="M1103.28,256.54a3.71,3.71,0,0,1,.93,1.76,9.13,9.13,0,0,0,.38,1.87,2.58,2.58,0,0,0,.62.83c.24.23.5.42.73.66a2,2,0,0,1,.55.89,1.65,1.65,0,0,1,0,.8,3.78,3.78,0,0,0-.12.83,2.8,2.8,0,0,0,.34,1.12,3.12,3.12,0,0,1,.34,1.15,2.54,2.54,0,0,1-.13.73,2.37,2.37,0,0,0-.05.8,2.11,2.11,0,0,0,.25.73,1.58,1.58,0,0,1,.22.63,1.82,1.82,0,0,1-.29.93.47.47,0,0,1,0,.1.63.63,0,0,1-.27.16c-1.24.41-3.37-2.71-4.77-7s-1.54-8-.3-8.43a.78.78,0,0,1,.52,0A7.71,7.71,0,0,0,1103.28,256.54Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M418.6,240.9c.16-.16.33-.31.5-.45a6.25,6.25,0,0,1,.81-.57c.26-.14.54-.24.81-.36a2.5,2.5,0,0,0,.67-.39c.22-.18.39-.4.6-.59a1.83,1.83,0,0,1,.55-.33,3.74,3.74,0,0,1,.45-.12,3.17,3.17,0,0,1,.44,0,.07.07,0,0,0,.07,0,3.13,3.13,0,0,1,1.94.42,3.06,3.06,0,0,1,1.2,1.4,1.19,1.19,0,0,0-.05.32,2.23,2.23,0,0,0,.21.71,1.3,1.3,0,0,1,.13.8,6.78,6.78,0,0,1-.33.85,1.39,1.39,0,0,0-.08.46,1.56,1.56,0,0,0,.08.43,1.1,1.1,0,0,1,0,.48,3.36,3.36,0,0,1-.14.45,3.81,3.81,0,0,0-.07.47,3.21,3.21,0,0,1-.08.36,4.21,4.21,0,0,1-1,1.39,2.49,2.49,0,0,0-.5.86,4.29,4.29,0,0,0-.12.8,2.1,2.1,0,0,1-.14.66,2.3,2.3,0,0,1-.62.7c-.58.48-1.23.88-1.78,1.4-.13.13-.26.26-.38.4s-.21.28-.33.41a1.16,1.16,0,0,1-.56.36,4.69,4.69,0,0,1-.64.09,1.65,1.65,0,0,0-.89.31,1.68,1.68,0,0,1-.4.3,1.18,1.18,0,0,1-.42,0,4.76,4.76,0,0,0-.84-.07l0,0a3.18,3.18,0,0,1-.83-.35,3,3,0,0,1-.94-.92,4.65,4.65,0,0,0-.15-1,10.16,10.16,0,0,1-.26-1.09,3.27,3.27,0,0,1,0-.54c0-.18,0-.36,0-.55s-.07-.69,0-1a1.59,1.59,0,0,1,.14-.56c.08-.17.19-.33.28-.49a1.53,1.53,0,0,0,.21-.51,3.45,3.45,0,0,0,.07-.55c0-.25,0-.49.06-.73a15.05,15.05,0,0,1,.71-1.38,3.08,3.08,0,0,1,.6-.14c.31-.05.62-.06.93-.11a.06.06,0,0,0,.06-.09c-.1-.23-.22-.46-.31-.7a.85.85,0,0,1,.09-.89Z"
                fill="#141c66"
              />
              <path d="M425.12,239s-4,10.1-19,26.16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M418.31,259.86c.27-.19.51-.4.76-.61a21.84,21.84,0,0,1,4.71-1.66,5,5,0,0,0,.66.08,7.48,7.48,0,0,0,.82,0h1a6.46,6.46,0,0,0,1.81-.22c.29-.09.55-.23.83-.34a5.66,5.66,0,0,1,.58-.2c3.09,0,5.33.75,5.58,2.06a1.23,1.23,0,0,1,0,.54l-.17.22a3.74,3.74,0,0,1-.91.82,6,6,0,0,1-1.09.51,7.85,7.85,0,0,0-1.33.49,5.15,5.15,0,0,0-1,.81,6.57,6.57,0,0,1-1,.85,1.74,1.74,0,0,1-1.09.34,3.72,3.72,0,0,1-.8-.25,3,3,0,0,0-1-.18.91.91,0,0,0-.71.21c-.19.18-.33.43-.51.62a2.22,2.22,0,0,1-1.75.61,8.51,8.51,0,0,1-1.94-.43c-.34-.1-.69-.19-1-.26l-.54-.09-.62,0a8.18,8.18,0,0,1-2.41-.68c-.39-.15-.78-.3-1.18-.42a2.42,2.42,0,0,1,1.12-2.1A5.18,5.18,0,0,0,418.31,259.86Z"
                fill="#141c66"
              />
              <path d="M435.45,259.2s-17.58.37-29.25,6.75" fill="#141c66" />
            </g>
            <g>
              <path
                d="M416.92,261.05c.23-.12.45-.25.67-.38a17.21,17.21,0,0,1,3.9-.71l.51.15c.21.05.43.08.64.11l.75.11a5,5,0,0,0,1.45.06c.24,0,.46-.12.7-.17l.47-.08c2.42.4,4.09,1.27,4.12,2.32a1.06,1.06,0,0,1-.08.43l-.15.15a3.11,3.11,0,0,1-.82.53,4.33,4.33,0,0,1-.92.25,6.7,6.7,0,0,0-1.1.22,3.94,3.94,0,0,0-.89.51,4.94,4.94,0,0,1-.88.54,1.4,1.4,0,0,1-.9.13,2.73,2.73,0,0,1-.59-.3,2.93,2.93,0,0,0-.75-.27.73.73,0,0,0-.58.08c-.18.12-.32.29-.49.42a1.77,1.77,0,0,1-1.45.26,6.57,6.57,0,0,1-1.46-.59,7.59,7.59,0,0,0-.78-.33l-.41-.14c-.15-.05-.31-.07-.47-.11a6.09,6.09,0,0,1-1.81-.84,9.17,9.17,0,0,0-.87-.48c0-.54.41-1.06,1.14-1.5A4.23,4.23,0,0,0,416.92,261.05Z"
                fill="#141c66"
              />
              <path d="M430.43,262.71s-13.82-1.95-23.78,1.58" fill="#141c66" />
            </g>
            <g>
              <path
                d="M414.25,257.7a.39.39,0,0,0,.28,0,.41.41,0,0,0,.13-.29,3.33,3.33,0,0,0,0-.55h0a2.25,2.25,0,0,0,.36.06.45.45,0,0,0,.26-.05c.14-.1.09-.29.06-.43l-.09-.29.63-.68.14.11a2.8,2.8,0,0,0,.35.25.74.74,0,0,0,.31.12c.05,0,.09,0,.08-.08a3.43,3.43,0,0,0-.09-.44,1,1,0,0,1,0-.42c.05-.16.22-.19.34-.27a.4.4,0,0,0,.13-.31,1.09,1.09,0,0,0,0-.18l.87-.78.19.15a1.13,1.13,0,0,0,.54.26.44.44,0,0,0,.47-.25.94.94,0,0,0,0-.66,1.6,1.6,0,0,0-.11-.33l.28-.3.94-.73h.06a.72.72,0,0,1,.24.1,1.08,1.08,0,0,0,.4.11s.07,0,.08-.06c0-.2-.06-.62.22-.69.07,0,.15.07.22.1a.21.21,0,0,0,.26,0c.11-.15,0-.36.09-.52s.27,0,.34.09a3.09,3.09,0,0,0,.36.45.07.07,0,0,0,.11-.06c0-.37,0-.73,0-1.09.7-.45,1.39-.86,2-1.22,0,0,0,.09.05.13a.07.07,0,0,0,.1,0,2.59,2.59,0,0,1,.1.62,2.54,2.54,0,0,1,0,.39c0,.09.13.11.14,0a2.81,2.81,0,0,0,0-.41,4.91,4.91,0,0,0-.09-.94c.58-.31,1.13-.58,1.66-.81a3,3,0,0,1,.12.78l0,.33a.07.07,0,0,0,.14,0,2,2,0,0,0,0-.35c0-.22.05-.44.06-.67,0-.08,0-.17,0-.25a11.71,11.71,0,0,1,1.53-.53,6.62,6.62,0,0,0,.26,1,.06.06,0,0,0,.1,0,1.44,1.44,0,0,0,.41-.73,3.12,3.12,0,0,0,.09-.44,1.5,1.5,0,0,1,1.39.36c.48.65-.14,2-1.52,3.68-.28-.06-.56-.1-.84-.14-.08,0-.11.1,0,.13a5.05,5.05,0,0,0,.69.22c-.37.43-.79.88-1.25,1.35a11.12,11.12,0,0,0-1.4.26.06.06,0,0,0-.06.08c0,.29.12.57.18.86-.68.61-1.43,1.24-2.23,1.85a5.45,5.45,0,0,0-1.38.33,3,3,0,0,0-.87.59l-.39.35c-.13.11-.27.21-.39.33s-.41.51-.64.75a.78.78,0,0,1-.76.3,2,2,0,0,1-.53-.34.25.25,0,0,0-.22-.05.35.35,0,0,0-.18.2,1.41,1.41,0,0,0-.06.79c0,.08,0,.17,0,.25-2.78,1.46-5,2-5.57,1.18-.38-.5-.09-1.43.71-2.6Z"
                fill="#141c66"
              />
              <path d="M427.86,249.47s-19.82,15.19-21.55,16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M421.3,248.88a.91.91,0,0,1,.32.42c0,.16-.09.31-.13.47s-.11.47-.15.71a3.93,3.93,0,0,1-.15.68,4.58,4.58,0,0,1-.45,1,4.6,4.6,0,0,0-.57,1.1c-.08.33-.07.67-.13,1h0c-.09.15-.19.29-.29.43a13.4,13.4,0,0,1-2.15,2.42l-.22.13a19.28,19.28,0,0,0-2.08,1.05.94.94,0,0,1-.53-.15c-.94-.67-.24-3.28,1.56-5.85S420.36,248.21,421.3,248.88Z"
                fill="#141c66"
              />
              <path d="M416.33,252.32s.89,5.21-9,12.75" fill="#141c66" />
              <path
                d="M420.85,250.14a2.78,2.78,0,0,1-.6,1.26,5.64,5.64,0,0,0-.89,1,2,2,0,0,0-.22.69c0,.23,0,.46-.06.69a1.38,1.38,0,0,1-.27.68,1.32,1.32,0,0,1-.46.32,2.39,2.39,0,0,0-.52.28,1.84,1.84,0,0,0-.48.65,2.13,2.13,0,0,1-.51.67,1.68,1.68,0,0,1-.46.24,1.42,1.42,0,0,0-.47.31,1.35,1.35,0,0,0-.31.44,1.11,1.11,0,0,1-.26.39,1.42,1.42,0,0,1-.64.23h-.08a.5.5,0,0,1-.21-.09c-.74-.52.12-3,1.92-5.59s3.87-4.22,4.61-3.69a.49.49,0,0,1,.21.29A5.44,5.44,0,0,0,420.85,250.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M388.78,230.23c0-.32-.07-.64-.09-1a7.37,7.37,0,0,1,.05-1.41c.05-.42.18-.82.27-1.23a4.08,4.08,0,0,0,.12-1.1c0-.41-.13-.79-.16-1.2a2.81,2.81,0,0,1,.08-.91,5.42,5.42,0,0,1,.26-.6,3.84,3.84,0,0,1,.35-.54.09.09,0,0,0,0-.11,4.29,4.29,0,0,1,4.77-2,1.26,1.26,0,0,0,.32.33,2.68,2.68,0,0,0,1,.36,2,2,0,0,1,1,.53,8.54,8.54,0,0,1,.69,1.11,1.7,1.7,0,0,0,1,.75,1.53,1.53,0,0,1,.6.36c.15.17.27.36.4.54a3.7,3.7,0,0,0,.48.49,4.23,4.23,0,0,1,.34.4,5.82,5.82,0,0,1,.73,2.34,3.34,3.34,0,0,0,.55,1.3,6.43,6.43,0,0,0,.82.83,2.56,2.56,0,0,1,.63.72,3.08,3.08,0,0,1,.28,1.31c.05,1.07,0,2.15.09,3.22a7,7,0,0,0,.13.78c.06.24.15.48.19.73a1.54,1.54,0,0,1-.07.95,6.35,6.35,0,0,1-.44.81,2.43,2.43,0,0,0-.41,1.28,1.89,1.89,0,0,1,0,.71,1.46,1.46,0,0,1-.32.52,6.14,6.14,0,0,0-.79.9.13.13,0,0,0,0,.06,4.18,4.18,0,0,1-3,1,5.63,5.63,0,0,0-1.24-.65c-.49-.21-1-.38-1.48-.63a4.48,4.48,0,0,1-.64-.43c-.21-.16-.38-.35-.59-.51-.4-.29-.86-.51-1.23-.83a2.23,2.23,0,0,1-.53-.65c-.12-.23-.21-.49-.32-.74a2.48,2.48,0,0,0-.4-.66c-.18-.2-.38-.39-.57-.57l-.8-.68a19.28,19.28,0,0,1-1-2,3.89,3.89,0,0,1,.35-.81c.21-.39.45-.76.67-1.15,0,0,0-.14-.06-.15-.35-.08-.71-.14-1.06-.25a1.43,1.43,0,0,1-.69-.38,1.45,1.45,0,0,1-.26-.47C388.86,230.64,388.82,230.44,388.78,230.23Z"
                fill="#396039"
              />
              <path
                d="M392.12,221.1A75.1,75.1,0,0,1,397,231.6c1.4,3.61,2.6,7.28,3.72,11s2,7.46,2.92,11.21c.43,1.89.82,3.78,1.23,5.66l1.06,5.7-1.16-5.68-1.26-5.65c-.91-3.74-1.86-7.49-3-11.18s-2.27-7.37-3.64-11c-.7-1.8-1.41-3.59-2.2-5.35A55.51,55.51,0,0,0,392.12,221.1Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M410.25,246.72c0-.46,0-.92-.05-1.38a30.78,30.78,0,0,1,2.11-6.81c.23-.22.46-.45.66-.68a10.54,10.54,0,0,0,.7-.95l.81-1.1a8.94,8.94,0,0,0,1.29-2.27c.15-.4.2-.83.31-1.24s.17-.56.27-.83c2.64-3.54,5.4-5.47,7.12-4.64a2,2,0,0,1,.62.47l.1.37a5.16,5.16,0,0,1,.16,1.75,7.48,7.48,0,0,1-.34,1.68,11.69,11.69,0,0,0-.57,1.94,7.1,7.1,0,0,0,.08,1.84,9.54,9.54,0,0,1,.13,1.85,2.51,2.51,0,0,1-.54,1.54,4.79,4.79,0,0,1-1,.7,4.65,4.65,0,0,0-1.05,1,1.29,1.29,0,0,0-.36,1c0,.39.21.75.27,1.13a3.16,3.16,0,0,1-.79,2.52,12.65,12.65,0,0,1-2.15,1.85c-.4.31-.8.62-1.18,1l-.56.54c-.2.22-.37.45-.57.68a11.56,11.56,0,0,1-2.83,2.18,16.74,16.74,0,0,0-1.49,1c-.87-.43-1.35-1.53-1.46-3.07A7.29,7.29,0,0,0,410.25,246.72Z"
                fill="#2f4f2f"
              />
              <path
                d="M424.11,226.54c-2,3-3.88,6.06-5.66,9.19s-3.42,6.33-4.93,9.6a105.38,105.38,0,0,0-4,10,72.12,72.12,0,0,0-2.59,10.47,64.16,64.16,0,0,1,2.46-10.51,103.32,103.32,0,0,1,4-10A127.54,127.54,0,0,1,424.11,226.54Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M410.42,249.34c.06-.37.1-.73.14-1.1a24,24,0,0,1,2.52-5.06c.21-.15.41-.3.6-.46s.45-.43.67-.65.52-.5.77-.76a7.28,7.28,0,0,0,1.31-1.61c.16-.3.26-.62.4-.94s.2-.41.31-.61c2.52-2.44,4.93-3.6,6.17-2.74a1.51,1.51,0,0,1,.42.45c0,.1,0,.21,0,.31a4.33,4.33,0,0,1-.1,1.39,5.92,5.92,0,0,1-.48,1.27,8.75,8.75,0,0,0-.69,1.45,5.88,5.88,0,0,0-.18,1.45,7.24,7.24,0,0,1-.13,1.47,2,2,0,0,1-.61,1.13,3.84,3.84,0,0,1-.86.43,3.69,3.69,0,0,0-.94.63,1.05,1.05,0,0,0-.41.73c0,.31.07.61.07.92a2.55,2.55,0,0,1-.94,1.88,10.16,10.16,0,0,1-1.92,1.17c-.36.19-.71.39-1.05.61a5.62,5.62,0,0,0-.5.35c-.19.14-.35.3-.53.45a9.17,9.17,0,0,1-2.5,1.35c-.44.18-.88.37-1.3.59a2.77,2.77,0,0,1-.75-2.59A6.15,6.15,0,0,0,410.42,249.34Z"
                fill="#396039"
              />
              <path
                d="M423.85,235.28c-2,2.08-3.8,4.26-5.6,6.49s-3.47,4.53-5.07,6.9a83.75,83.75,0,0,0-4.43,7.32,58.77,58.77,0,0,0-3.37,7.87,49.66,49.66,0,0,1,3.25-7.93q2-3.8,4.38-7.38A100.11,100.11,0,0,1,423.85,235.28Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M404.32,249.54a.52.52,0,0,0,.2-.34.55.55,0,0,0-.21-.4,4.78,4.78,0,0,0-.61-.48v0a2.28,2.28,0,0,0,.38-.38.64.64,0,0,0,.16-.33c0-.24-.25-.35-.44-.43l-.4-.15c-.09-.41-.17-.85-.25-1.3l.25-.06c.19-.06.39-.11.58-.19a1,1,0,0,0,.4-.26.1.1,0,0,0,0-.16,5.14,5.14,0,0,0-.58-.27,1.38,1.38,0,0,1-.5-.32c-.15-.19,0-.41,0-.62a.6.6,0,0,0-.23-.42l-.19-.16c-.06-.53-.11-1.09-.16-1.66l.34-.09a1.82,1.82,0,0,0,.75-.4.62.62,0,0,0,.12-.76,1.52,1.52,0,0,0-.76-.56l-.48-.15c0-.19-.06-.39-.1-.58,0-.56,0-1.12,0-1.69l.05-.07a1,1,0,0,1,.31-.19,1.68,1.68,0,0,0,.48-.36.11.11,0,0,0,0-.14c-.23-.19-.77-.47-.61-.85,0-.1.21-.12.3-.17a.28.28,0,0,0,.17-.33c-.07-.26-.38-.35-.52-.55s.24-.31.39-.32a4.61,4.61,0,0,0,.83,0c.09,0,.09-.14,0-.19-.42-.3-.84-.6-1.29-.87.08-1.18.2-2.31.34-3.37l.19,0a.09.09,0,0,0,.12-.08,3.86,3.86,0,0,1,.81.41c.14.1.29.21.43.33s.24-.06.14-.14a3.1,3.1,0,0,0-.46-.35,8.57,8.57,0,0,0-1.16-.71c.14-.92.31-1.79.49-2.58a4.45,4.45,0,0,1,1,.52l.36.33a.1.1,0,0,0,.14-.15,2.91,2.91,0,0,0-.37-.33l-.71-.65-.29-.23a17.86,17.86,0,0,1,.71-2.2,12.7,12.7,0,0,0,1.33.53.1.1,0,0,0,.13-.1,2.16,2.16,0,0,0-.49-1.09,4.69,4.69,0,0,0-.42-.47c.48-.83,1-1.29,1.59-1.29,1.15,0,2.18,1.88,2.91,4.88-.3.27-.59.55-.87.83a.1.1,0,0,0,.12.16,7.12,7.12,0,0,0,.84-.6c.18.79.34,1.66.47,2.58a17,17,0,0,0-.89,1.82.11.11,0,0,0,0,.14c.37.19.76.35,1.15.52.12,1.31.19,2.7.22,4.14a7.41,7.41,0,0,0-.81,1.87,4.39,4.39,0,0,0-.06,1.49c0,.25.05.5.06.75s0,.48.05.73c.07.46.24.9.32,1.36a1.12,1.12,0,0,1-.31,1.13,2.66,2.66,0,0,1-.84.32.35.35,0,0,0-.25.21.58.58,0,0,0,.07.38,2.07,2.07,0,0,0,.87.73l.31.18c-.7,4.43-2,7.38-3.4,7.38-.89,0-1.71-1.12-2.37-3Z"
                fill="#659965"
              />
              <path
                d="M406.49,226.93c.17,6.4.22,12.79.29,19.19v9.59c0,3.2,0,6.41-.29,9.59.15-1.59.12-3.19.14-4.79v-4.8l-.06-9.59Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M400.22,233.94a1.23,1.23,0,0,1,.76,0l.43.54c.22.27.44.53.68.78a7.7,7.7,0,0,1,.66.75,7.43,7.43,0,0,1,.76,1.38,6.53,6.53,0,0,0,.78,1.59c.31.37.7.66,1,1l0,0,.24.71a18.53,18.53,0,0,1,.94,4.52c0,.12,0,.24,0,.36a28.12,28.12,0,0,0-.57,3.28,1.26,1.26,0,0,1-.63.47c-1.56.51-4-2.52-5.36-6.77S398.66,234.45,400.22,233.94Z"
                fill="#3b6818"
              />
              <path
                d="M399.92,242.57s6.73,3.43,7,21.14"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.2"
              />
              <path
                d="M401.28,235.54a3.71,3.71,0,0,1,.93,1.76,9.13,9.13,0,0,0,.38,1.87,2.58,2.58,0,0,0,.62.83c.24.23.5.42.73.66a2,2,0,0,1,.55.89,1.65,1.65,0,0,1,0,.8,3.78,3.78,0,0,0-.12.83,2.8,2.8,0,0,0,.34,1.12,3.12,3.12,0,0,1,.34,1.15,2.54,2.54,0,0,1-.13.73,2.37,2.37,0,0,0-.05.8,2.11,2.11,0,0,0,.25.73,1.58,1.58,0,0,1,.22.63,1.82,1.82,0,0,1-.29.93l0,.1a.63.63,0,0,1-.27.16c-1.24.41-3.37-2.71-4.77-7s-1.54-8-.3-8.43a.78.78,0,0,1,.52,0A7.71,7.71,0,0,0,401.28,235.54Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M383.6,274.9c.16-.16.33-.31.5-.45a6.25,6.25,0,0,1,.81-.57c.26-.14.54-.24.81-.36a2.5,2.5,0,0,0,.67-.39c.22-.18.39-.4.6-.59a1.83,1.83,0,0,1,.55-.33l.45-.12a3.17,3.17,0,0,1,.44,0,.07.07,0,0,0,.07-.05,3.13,3.13,0,0,1,1.94.42,3.06,3.06,0,0,1,1.2,1.4,1.19,1.19,0,0,0-.05.32,2.23,2.23,0,0,0,.21.71,1.3,1.3,0,0,1,.13.8,6.78,6.78,0,0,1-.33.85,1.39,1.39,0,0,0-.08.46,1.56,1.56,0,0,0,.08.43,1.1,1.1,0,0,1,0,.48,3.36,3.36,0,0,1-.14.45,3.81,3.81,0,0,0-.07.47,3.21,3.21,0,0,1-.08.36,4.21,4.21,0,0,1-1,1.39,2.49,2.49,0,0,0-.5.86,4.29,4.29,0,0,0-.12.8,2.1,2.1,0,0,1-.14.66,2.3,2.3,0,0,1-.62.7c-.58.48-1.23.88-1.78,1.4-.13.13-.26.26-.38.4s-.21.28-.33.41a1.16,1.16,0,0,1-.56.36,4.69,4.69,0,0,1-.64.09,1.65,1.65,0,0,0-.89.31,1.68,1.68,0,0,1-.4.3,1.18,1.18,0,0,1-.42,0,4.76,4.76,0,0,0-.84-.07l0,0a3.18,3.18,0,0,1-.83-.35,3,3,0,0,1-.94-.92,4.65,4.65,0,0,0-.15-1,10.16,10.16,0,0,1-.26-1.09,3.27,3.27,0,0,1,0-.54c0-.18,0-.36,0-.55,0-.34-.07-.69,0-1a1.59,1.59,0,0,1,.14-.56c.08-.17.19-.33.28-.49a1.53,1.53,0,0,0,.21-.51,3.45,3.45,0,0,0,.07-.55c0-.25,0-.49.06-.73a15.05,15.05,0,0,1,.71-1.38,3.08,3.08,0,0,1,.6-.14c.31,0,.62-.06.93-.11a.06.06,0,0,0,.06-.09c-.1-.23-.22-.46-.31-.7a.85.85,0,0,1,.09-.89Z"
                fill="#141c66"
              />
              <path d="M390.12,273s-4,10.1-19,26.16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M383.31,293.86c.27-.19.51-.4.76-.61a21.84,21.84,0,0,1,4.71-1.66,5,5,0,0,0,.66.08,7.48,7.48,0,0,0,.82,0h1a6.46,6.46,0,0,0,1.81-.22c.29-.09.55-.23.83-.34a5.66,5.66,0,0,1,.58-.2c3.09,0,5.33.75,5.58,2.06a1.23,1.23,0,0,1,0,.54l-.17.22a3.74,3.74,0,0,1-.91.82,6,6,0,0,1-1.09.51,7.85,7.85,0,0,0-1.33.49,5.15,5.15,0,0,0-1,.81,6.57,6.57,0,0,1-1,.85,1.74,1.74,0,0,1-1.09.34,3.72,3.72,0,0,1-.8-.25,3,3,0,0,0-1-.18.91.91,0,0,0-.71.21c-.19.18-.33.43-.51.62a2.22,2.22,0,0,1-1.75.61,8.51,8.51,0,0,1-1.94-.43c-.34-.1-.69-.19-1-.26l-.54-.09-.62,0a8.18,8.18,0,0,1-2.41-.68c-.39-.15-.78-.3-1.18-.42a2.42,2.42,0,0,1,1.12-2.1A5.18,5.18,0,0,0,383.31,293.86Z"
                fill="#141c66"
              />
              <path d="M400.45,293.2s-17.58.37-29.25,6.75" fill="#141c66" />
            </g>
            <g>
              <path
                d="M381.92,295.05c.23-.12.45-.25.67-.38a17.21,17.21,0,0,1,3.9-.71l.51.15c.21.05.43.08.64.11l.75.11a5,5,0,0,0,1.45.06c.24,0,.46-.12.7-.17l.47-.08c2.42.4,4.09,1.27,4.12,2.32a1.06,1.06,0,0,1-.08.43l-.15.15a3.11,3.11,0,0,1-.82.53,4.33,4.33,0,0,1-.92.25,6.7,6.7,0,0,0-1.1.22,3.94,3.94,0,0,0-.89.51,4.94,4.94,0,0,1-.88.54,1.4,1.4,0,0,1-.9.13,2.73,2.73,0,0,1-.59-.3,2.93,2.93,0,0,0-.75-.27.73.73,0,0,0-.58.08c-.18.12-.32.29-.49.42a1.77,1.77,0,0,1-1.45.26,6.57,6.57,0,0,1-1.46-.59,7.59,7.59,0,0,0-.78-.33l-.41-.14c-.15-.05-.31-.07-.47-.11a6.09,6.09,0,0,1-1.81-.84,9.17,9.17,0,0,0-.87-.48c0-.54.41-1.06,1.14-1.5A4.23,4.23,0,0,0,381.92,295.05Z"
                fill="#141c66"
              />
              <path d="M395.43,296.71s-13.82-1.95-23.78,1.58" fill="#141c66" />
            </g>
            <g>
              <path
                d="M379.25,291.7a.39.39,0,0,0,.28,0,.41.41,0,0,0,.13-.29,3.33,3.33,0,0,0,0-.55h0a2.25,2.25,0,0,0,.36.06.45.45,0,0,0,.26-.05c.14-.1.09-.29.06-.43l-.09-.29.63-.68.14.11a2.8,2.8,0,0,0,.35.25.74.74,0,0,0,.31.12c.05,0,.09,0,.08-.08a3.43,3.43,0,0,0-.09-.44,1,1,0,0,1,0-.42c.05-.16.22-.19.34-.27a.4.4,0,0,0,.13-.31,1.09,1.09,0,0,0,0-.18l.87-.78.19.15a1.13,1.13,0,0,0,.54.26.44.44,0,0,0,.47-.25.94.94,0,0,0,0-.66,1.6,1.6,0,0,0-.11-.33l.28-.3.94-.73h.06a.72.72,0,0,1,.24.1,1.08,1.08,0,0,0,.4.11s.07,0,.08-.06c0-.2-.06-.62.22-.69.07,0,.15.07.22.1a.21.21,0,0,0,.26-.05c.11-.15,0-.36.09-.52s.27,0,.34.09a3.09,3.09,0,0,0,.36.45.07.07,0,0,0,.11-.06c0-.37,0-.73,0-1.09.7-.45,1.39-.86,2-1.22,0,0,0,.09.05.13a.07.07,0,0,0,.1,0,2.59,2.59,0,0,1,.1.62,2.54,2.54,0,0,1,0,.39c0,.09.13.11.14,0a2.81,2.81,0,0,0,0-.41,4.91,4.91,0,0,0-.09-.94c.58-.31,1.13-.58,1.66-.81a3,3,0,0,1,.12.78l0,.33a.07.07,0,0,0,.14,0,2,2,0,0,0,0-.35c0-.22.05-.44.06-.67,0-.08,0-.17,0-.25a11.71,11.71,0,0,1,1.53-.53,6.62,6.62,0,0,0,.26,1,.06.06,0,0,0,.1,0,1.44,1.44,0,0,0,.41-.73,3.12,3.12,0,0,0,.09-.44,1.5,1.5,0,0,1,1.39.36c.48.65-.14,2-1.52,3.68-.28-.06-.56-.1-.84-.14-.08,0-.11.1,0,.13a5.05,5.05,0,0,0,.69.22c-.37.43-.79.88-1.25,1.35a11.12,11.12,0,0,0-1.4.26.06.06,0,0,0-.06.08c0,.29.12.57.18.86-.68.61-1.43,1.24-2.23,1.85a5.45,5.45,0,0,0-1.38.33,3,3,0,0,0-.87.59l-.39.35c-.13.11-.27.21-.39.33s-.41.51-.64.75a.78.78,0,0,1-.76.3,2,2,0,0,1-.53-.34.25.25,0,0,0-.22-.05.35.35,0,0,0-.18.2,1.41,1.41,0,0,0-.06.79c0,.08,0,.17,0,.25-2.78,1.46-5,2-5.57,1.18-.38-.5-.09-1.43.71-2.6Z"
                fill="#141c66"
              />
              <path d="M392.86,283.47s-19.82,15.19-21.55,16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M386.3,282.88a.91.91,0,0,1,.32.42c0,.16-.09.31-.13.47s-.11.47-.15.71a3.93,3.93,0,0,1-.15.68,4.58,4.58,0,0,1-.45,1,4.6,4.6,0,0,0-.57,1.1c-.08.33-.07.67-.13,1h0c-.09.15-.19.29-.29.43a13.4,13.4,0,0,1-2.15,2.42l-.22.13a19.28,19.28,0,0,0-2.08,1.05.94.94,0,0,1-.53-.15c-.94-.67-.24-3.28,1.56-5.85S385.36,282.21,386.3,282.88Z"
                fill="#141c66"
              />
              <path d="M381.33,286.32s.89,5.21-9,12.75" fill="#141c66" />
              <path
                d="M385.85,284.14a2.78,2.78,0,0,1-.6,1.26,5.64,5.64,0,0,0-.89,1,2,2,0,0,0-.22.69c0,.23,0,.46-.06.69a1.38,1.38,0,0,1-.27.68,1.32,1.32,0,0,1-.46.32,2.39,2.39,0,0,0-.52.28,1.84,1.84,0,0,0-.48.65,2.13,2.13,0,0,1-.51.67,1.68,1.68,0,0,1-.46.24,1.42,1.42,0,0,0-.47.31,1.35,1.35,0,0,0-.31.44,1.11,1.11,0,0,1-.26.39,1.42,1.42,0,0,1-.64.23h-.08a.5.5,0,0,1-.21-.09c-.74-.52.12-3,1.92-5.59s3.87-4.22,4.61-3.69a.49.49,0,0,1,.21.29A5.44,5.44,0,0,0,385.85,284.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M353.78,264.23c0-.32-.07-.64-.09-1a7.37,7.37,0,0,1,.05-1.41c.05-.42.18-.82.27-1.23a4.08,4.08,0,0,0,.12-1.1c0-.41-.13-.79-.16-1.2a2.81,2.81,0,0,1,.08-.91,5.42,5.42,0,0,1,.26-.6,3.84,3.84,0,0,1,.35-.54.09.09,0,0,0,0-.11,4.29,4.29,0,0,1,4.77-2.05,1.26,1.26,0,0,0,.32.33,2.68,2.68,0,0,0,1,.36,2,2,0,0,1,1,.53,8.54,8.54,0,0,1,.69,1.11,1.7,1.7,0,0,0,1,.75,1.53,1.53,0,0,1,.6.36c.15.17.27.36.4.54a3.7,3.7,0,0,0,.48.49,4.23,4.23,0,0,1,.34.4,5.82,5.82,0,0,1,.73,2.34,3.34,3.34,0,0,0,.55,1.3,6.43,6.43,0,0,0,.82.83,2.56,2.56,0,0,1,.63.72,3.08,3.08,0,0,1,.28,1.31c.05,1.07,0,2.15.09,3.22a7,7,0,0,0,.13.78c.06.24.15.48.19.73a1.54,1.54,0,0,1-.07.95,6.35,6.35,0,0,1-.44.81,2.43,2.43,0,0,0-.41,1.28,1.89,1.89,0,0,1,0,.71,1.46,1.46,0,0,1-.32.52,6.14,6.14,0,0,0-.79.9.13.13,0,0,0,0,.06,4.18,4.18,0,0,1-3,.95,5.63,5.63,0,0,0-1.24-.65c-.49-.21-1-.38-1.48-.63a4.48,4.48,0,0,1-.64-.43c-.21-.16-.38-.35-.59-.51-.4-.29-.86-.51-1.23-.83a2.23,2.23,0,0,1-.53-.65c-.12-.23-.21-.49-.32-.74a2.48,2.48,0,0,0-.4-.66c-.18-.2-.38-.39-.57-.57l-.8-.68a19.28,19.28,0,0,1-1-2,3.89,3.89,0,0,1,.35-.81c.21-.39.45-.76.67-1.15,0-.05,0-.14-.06-.15-.35-.08-.71-.14-1.06-.25a1.43,1.43,0,0,1-.69-.38,1.45,1.45,0,0,1-.26-.47C353.86,264.64,353.82,264.44,353.78,264.23Z"
                fill="#396039"
              />
              <path
                d="M357.12,255.1A75.1,75.1,0,0,1,362,265.6c1.4,3.61,2.6,7.28,3.72,11s2,7.46,2.92,11.21c.43,1.89.82,3.78,1.23,5.66l1.06,5.7-1.16-5.68-1.26-5.65c-.91-3.74-1.86-7.49-3-11.18s-2.27-7.37-3.64-11c-.7-1.8-1.41-3.59-2.2-5.35A55.51,55.51,0,0,0,357.12,255.1Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M375.25,280.72c0-.46,0-.92-.05-1.38a30.78,30.78,0,0,1,2.11-6.81c.23-.22.46-.45.66-.68a10.54,10.54,0,0,0,.7-1l.81-1.1a8.94,8.94,0,0,0,1.29-2.27c.15-.4.2-.83.31-1.24s.17-.56.27-.83c2.64-3.54,5.4-5.47,7.12-4.64a2,2,0,0,1,.62.47l.1.37a5.16,5.16,0,0,1,.16,1.75,7.48,7.48,0,0,1-.34,1.68,11.69,11.69,0,0,0-.57,1.94,7.1,7.1,0,0,0,.08,1.84,9.54,9.54,0,0,1,.13,1.85,2.51,2.51,0,0,1-.54,1.54,4.79,4.79,0,0,1-1,.7,4.65,4.65,0,0,0-1.05,1,1.29,1.29,0,0,0-.36,1c0,.39.21.75.27,1.13a3.16,3.16,0,0,1-.79,2.52,12.65,12.65,0,0,1-2.15,1.85c-.4.31-.8.62-1.18,1l-.56.54c-.2.22-.37.45-.57.68a11.56,11.56,0,0,1-2.83,2.18,16.74,16.74,0,0,0-1.49,1c-.87-.43-1.35-1.53-1.46-3.07A7.29,7.29,0,0,0,375.25,280.72Z"
                fill="#2f4f2f"
              />
              <path
                d="M389.11,260.54c-2,3-3.88,6.06-5.66,9.19s-3.42,6.33-4.93,9.6a105.38,105.38,0,0,0-4,10,72.12,72.12,0,0,0-2.59,10.47,64.16,64.16,0,0,1,2.46-10.51,103.32,103.32,0,0,1,4-10.05A127.54,127.54,0,0,1,389.11,260.54Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M375.42,283.34c.06-.37.1-.73.14-1.1a24,24,0,0,1,2.52-5.06c.21-.15.41-.3.6-.46s.45-.43.67-.65.52-.5.77-.76a7.28,7.28,0,0,0,1.31-1.61c.16-.3.26-.62.4-.94s.2-.41.31-.61c2.52-2.44,4.93-3.6,6.17-2.74a1.51,1.51,0,0,1,.42.45c0,.1,0,.21,0,.31a4.33,4.33,0,0,1-.1,1.39,5.92,5.92,0,0,1-.48,1.27,8.75,8.75,0,0,0-.69,1.45,5.88,5.88,0,0,0-.18,1.45,7.24,7.24,0,0,1-.13,1.47,2,2,0,0,1-.61,1.13,3.84,3.84,0,0,1-.86.43,3.69,3.69,0,0,0-.94.63,1.05,1.05,0,0,0-.41.73c0,.31.07.61.07.92a2.55,2.55,0,0,1-.94,1.88,10.16,10.16,0,0,1-1.92,1.17c-.36.19-.71.39-1.05.61a5.62,5.62,0,0,0-.5.35c-.19.14-.35.3-.53.45a9.17,9.17,0,0,1-2.5,1.35c-.44.18-.88.37-1.3.59a2.77,2.77,0,0,1-.75-2.59A6.15,6.15,0,0,0,375.42,283.34Z"
                fill="#396039"
              />
              <path
                d="M388.85,269.28c-2,2.08-3.8,4.26-5.6,6.49s-3.47,4.53-5.07,6.9a83.75,83.75,0,0,0-4.43,7.32,58.77,58.77,0,0,0-3.37,7.87,49.66,49.66,0,0,1,3.25-7.93q2-3.8,4.38-7.38A100.11,100.11,0,0,1,388.85,269.28Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M369.32,283.54a.52.52,0,0,0,.2-.34.55.55,0,0,0-.21-.4,4.78,4.78,0,0,0-.61-.48v0a2.28,2.28,0,0,0,.38-.38.64.64,0,0,0,.16-.33c0-.24-.25-.35-.44-.43l-.4-.15c-.09-.41-.17-.85-.25-1.3l.25-.06c.19-.06.39-.11.58-.19a1,1,0,0,0,.4-.26.1.1,0,0,0,0-.16,5.14,5.14,0,0,0-.58-.27,1.38,1.38,0,0,1-.5-.32c-.15-.19,0-.41,0-.62a.6.6,0,0,0-.23-.42l-.19-.16c-.06-.53-.11-1.09-.16-1.66l.34-.09a1.82,1.82,0,0,0,.75-.4.62.62,0,0,0,.12-.76,1.52,1.52,0,0,0-.76-.56l-.48-.15c0-.19-.06-.39-.1-.58,0-.56,0-1.12,0-1.69l.05-.07a1,1,0,0,1,.31-.19,1.68,1.68,0,0,0,.48-.36.11.11,0,0,0,0-.14c-.23-.19-.77-.47-.61-.85,0-.1.21-.12.3-.17a.28.28,0,0,0,.17-.33c-.07-.26-.38-.35-.52-.55s.24-.31.39-.32a4.61,4.61,0,0,0,.83,0c.09,0,.09-.14,0-.19-.42-.3-.84-.6-1.29-.87.08-1.18.2-2.31.34-3.37l.19.05a.09.09,0,0,0,.12-.08,3.86,3.86,0,0,1,.81.41c.14.1.29.21.43.33s.24-.06.14-.14a3.1,3.1,0,0,0-.46-.35,8.57,8.57,0,0,0-1.16-.71c.14-.92.31-1.79.49-2.58a4.45,4.45,0,0,1,1,.52l.36.33a.1.1,0,0,0,.14-.15,2.91,2.91,0,0,0-.37-.33l-.71-.65-.29-.23a17.86,17.86,0,0,1,.71-2.2,12.7,12.7,0,0,0,1.33.53.1.1,0,0,0,.13-.1,2.16,2.16,0,0,0-.49-1.09,4.69,4.69,0,0,0-.42-.47c.48-.83,1-1.29,1.59-1.29,1.15,0,2.18,1.88,2.91,4.88-.3.27-.59.55-.87.83a.1.1,0,0,0,.12.16,7.12,7.12,0,0,0,.84-.6c.18.79.34,1.66.47,2.58a17,17,0,0,0-.89,1.82.11.11,0,0,0,0,.14c.37.19.76.35,1.15.52.12,1.31.19,2.7.22,4.14a7.41,7.41,0,0,0-.81,1.87,4.39,4.39,0,0,0-.06,1.49c0,.25.05.5.06.75s0,.48.05.73c.07.46.24.9.32,1.36a1.12,1.12,0,0,1-.31,1.13,2.66,2.66,0,0,1-.84.32.35.35,0,0,0-.25.21.58.58,0,0,0,.07.38,2.07,2.07,0,0,0,.87.73l.31.18c-.7,4.43-2,7.38-3.4,7.38-.89,0-1.71-1.12-2.37-3Z"
                fill="#659965"
              />
              <path
                d="M371.49,260.93c.17,6.4.22,12.79.29,19.19v9.59c0,3.2,0,6.41-.29,9.59.15-1.59.12-3.19.14-4.79v-4.8l-.06-9.59Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M365.22,267.94a1.23,1.23,0,0,1,.76,0l.43.54c.22.27.44.53.68.78a7.7,7.7,0,0,1,.66.75,7.43,7.43,0,0,1,.76,1.38,6.53,6.53,0,0,0,.78,1.59c.31.37.7.66,1,1l0,0,.24.71a18.53,18.53,0,0,1,.94,4.52c0,.12,0,.24,0,.36a28.12,28.12,0,0,0-.57,3.28,1.26,1.26,0,0,1-.63.47c-1.56.51-4-2.52-5.36-6.77S363.66,268.45,365.22,267.94Z"
                fill="#3b6818"
              />
              <path
                d="M364.92,276.57s6.73,3.43,7,21.14"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.2"
              />
              <path
                d="M366.28,269.54a3.71,3.71,0,0,1,.93,1.76,9.13,9.13,0,0,0,.38,1.87,2.58,2.58,0,0,0,.62.83c.24.23.5.42.73.66a2,2,0,0,1,.55.89,1.65,1.65,0,0,1,0,.8,3.78,3.78,0,0,0-.12.83,2.8,2.8,0,0,0,.34,1.12,3.12,3.12,0,0,1,.34,1.15,2.54,2.54,0,0,1-.13.73,2.37,2.37,0,0,0-.05.8,2.11,2.11,0,0,0,.25.73,1.58,1.58,0,0,1,.22.63,1.82,1.82,0,0,1-.29.93.47.47,0,0,1,0,.1.63.63,0,0,1-.27.16c-1.24.41-3.37-2.71-4.77-7s-1.54-8-.3-8.43a.78.78,0,0,1,.52,0A7.71,7.71,0,0,0,366.28,269.54Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M486.05,212.22c.12-.11.24-.23.37-.33a3.15,3.15,0,0,1,.61-.42,6.46,6.46,0,0,1,.6-.27,2,2,0,0,0,.5-.3c.16-.13.29-.3.45-.44a1.55,1.55,0,0,1,.41-.25l.33-.08a1.94,1.94,0,0,1,.34,0,0,0,0,0,0,0,0,2.41,2.41,0,0,1,1.46.32,2.38,2.38,0,0,1,.9,1.05.61.61,0,0,0,0,.24,1.26,1.26,0,0,0,.16.52,1,1,0,0,1,.09.6,3.75,3.75,0,0,1-.25.63,1.43,1.43,0,0,0-.06.35,1.23,1.23,0,0,0,.07.32.88.88,0,0,1,0,.36,1.91,1.91,0,0,1-.1.34c0,.11,0,.24-.06.35a1.31,1.31,0,0,1-.06.27,3.08,3.08,0,0,1-.75,1,1.65,1.65,0,0,0-.37.64,2.42,2.42,0,0,0-.09.6,1.66,1.66,0,0,1-.11.49,1.53,1.53,0,0,1-.46.52c-.44.36-.92.66-1.33,1a2.68,2.68,0,0,0-.28.3c-.09.1-.16.21-.25.31a1,1,0,0,1-.42.27,3.93,3.93,0,0,1-.48.06,1.31,1.31,0,0,0-.67.23,1.05,1.05,0,0,1-.29.23,1.12,1.12,0,0,1-.32,0,2.64,2.64,0,0,0-.63-.05h0a2.47,2.47,0,0,1-.63-.26,2.19,2.19,0,0,1-.7-.69,3,3,0,0,0-.11-.72,7.54,7.54,0,0,1-.2-.82,1.79,1.79,0,0,1,0-.4c0-.14,0-.27,0-.41s-.05-.52,0-.78a1.24,1.24,0,0,1,.11-.42c.06-.13.14-.24.21-.36a1.12,1.12,0,0,0,.15-.38,3,3,0,0,0,.06-.42c0-.18,0-.36,0-.55.16-.34.33-.68.53-1a1.92,1.92,0,0,1,.46-.11l.69-.08a.05.05,0,0,0,.05-.07c-.08-.17-.17-.34-.24-.52a.82.82,0,0,1-.05-.41.68.68,0,0,1,.12-.26Z"
                fill="#141c66"
              />
              <path d="M490.92,210.77s-3,7.56-14.18,19.56" fill="#141c66" />
            </g>
            <g>
              <path
                d="M485.83,226.4c.2-.15.38-.3.57-.46a16,16,0,0,1,3.52-1.24,4.1,4.1,0,0,0,.49.06,4.28,4.28,0,0,0,.62,0h.71a4.83,4.83,0,0,0,1.36-.17,5.45,5.45,0,0,0,.62-.26l.43-.14c2.31,0,4,.56,4.17,1.53a1,1,0,0,1,0,.41,1,1,0,0,1-.13.16,2.87,2.87,0,0,1-.68.62,4,4,0,0,1-.81.38,4.91,4.91,0,0,0-1,.37,3.35,3.35,0,0,0-.75.6,5,5,0,0,1-.74.64,1.32,1.32,0,0,1-.81.25,2.47,2.47,0,0,1-.6-.19,2.35,2.35,0,0,0-.74-.13.72.72,0,0,0-.53.15c-.14.14-.25.32-.38.47a1.71,1.71,0,0,1-1.31.46,6.49,6.49,0,0,1-1.45-.33c-.26-.07-.51-.14-.77-.19l-.4-.07-.46,0a5.69,5.69,0,0,1-1.81-.51c-.29-.11-.58-.22-.88-.31a1.81,1.81,0,0,1,.83-1.57A3.9,3.9,0,0,0,485.83,226.4Z"
                fill="#141c66"
              />
              <path d="M498.64,225.91s-13.14.27-21.86,5" fill="#141c66" />
            </g>
            <g>
              <path
                d="M484.79,227.29l.5-.29a12.42,12.42,0,0,1,2.92-.52l.37.11.49.08.56.08a3.9,3.9,0,0,0,1.08,0,4.37,4.37,0,0,0,.52-.12,2.25,2.25,0,0,1,.36-.06c1.81.29,3.05.94,3.07,1.73a.7.7,0,0,1-.05.32l-.12.11a2.22,2.22,0,0,1-.61.4,3.2,3.2,0,0,1-.69.19,4.59,4.59,0,0,0-.82.17,3.36,3.36,0,0,0-.67.37,3.46,3.46,0,0,1-.66.41,1.08,1.08,0,0,1-.66.1,2.38,2.38,0,0,1-.45-.23,1.88,1.88,0,0,0-.56-.2.54.54,0,0,0-.43.06c-.14.09-.24.22-.37.31a1.29,1.29,0,0,1-1.08.2,6.06,6.06,0,0,1-1.09-.44c-.19-.09-.39-.18-.58-.25a2.22,2.22,0,0,0-.31-.1l-.36-.09a4.86,4.86,0,0,1-1.35-.62,5.13,5.13,0,0,0-.65-.36c0-.41.31-.79.86-1.13A3.6,3.6,0,0,0,484.79,227.29Z"
                fill="#141c66"
              />
              <path d="M494.89,228.53s-10.33-1.46-17.78,1.18" fill="#141c66" />
            </g>
            <g>
              <path
                d="M482.79,224.79a.23.23,0,0,0,.31-.24,1.86,1.86,0,0,0,0-.41h0l.27,0a.34.34,0,0,0,.2,0c.1-.07.07-.22,0-.32l-.06-.21c.14-.17.3-.34.47-.51l.1.08a2.4,2.4,0,0,0,.26.18.42.42,0,0,0,.24.09.06.06,0,0,0,.06-.06c0-.11-.05-.21-.07-.32a.7.7,0,0,1,0-.32c0-.12.16-.14.24-.2a.27.27,0,0,0,.1-.23.62.62,0,0,0,0-.13l.65-.59.15.11a.84.84,0,0,0,.4.2.32.32,0,0,0,.35-.19.78.78,0,0,0,0-.5,2.25,2.25,0,0,0-.08-.24l.21-.23.7-.54h0a.36.36,0,0,1,.18.07.86.86,0,0,0,.3.09s.06,0,.06,0,0-.47.16-.53.12.06.17.08a.15.15,0,0,0,.19,0c.09-.11,0-.26.07-.39s.21,0,.26.07a3,3,0,0,0,.26.34.06.06,0,0,0,.09-.05c0-.27,0-.54,0-.81.53-.34,1-.64,1.53-.91l0,.09a.06.06,0,0,0,.08,0,1.77,1.77,0,0,1,.07.46,1.41,1.41,0,0,1,0,.29c0,.06.1.08.11,0v-.3a5.69,5.69,0,0,0-.07-.71c.43-.23.85-.43,1.24-.6a2.33,2.33,0,0,1,.09.58,2.29,2.29,0,0,0,0,.25.05.05,0,1,0,.1,0,1.18,1.18,0,0,0,0-.26c0-.17,0-.34.05-.51a1.15,1.15,0,0,0,0-.19,9.21,9.21,0,0,1,1.15-.39,6.54,6.54,0,0,0,.19.73.05.05,0,0,0,.08,0,1.07,1.07,0,0,0,.3-.55,1.65,1.65,0,0,0,.07-.32,1.08,1.08,0,0,1,1,.27c.36.48-.11,1.5-1.14,2.74l-.62-.1a.05.05,0,0,0,0,.1,4.48,4.48,0,0,0,.52.16c-.28.32-.59.66-.94,1a7.32,7.32,0,0,0-1,.19.06.06,0,0,0,0,.06c0,.22.09.43.14.65-.51.46-1.07.92-1.67,1.38a3.69,3.69,0,0,0-1,.25,2.07,2.07,0,0,0-.65.44l-.29.26a3.5,3.5,0,0,0-.3.24c-.17.18-.3.39-.47.57a.6.6,0,0,1-.57.22,1.24,1.24,0,0,1-.39-.25.21.21,0,0,0-.17,0,.26.26,0,0,0-.14.15,1.07,1.07,0,0,0,0,.59l0,.19c-2.08,1.09-3.72,1.48-4.17.88-.28-.38-.06-1.07.53-1.95Z"
                fill="#141c66"
              />
              <path d="M493,218.63s-14.82,11.36-16.11,12" fill="#141c66" />
            </g>
            <g>
              <path
                d="M488.07,218.19a.65.65,0,0,1,.23.32l-.09.35a3.12,3.12,0,0,0-.11.53,4.7,4.7,0,0,1-.12.51,3.6,3.6,0,0,1-.34.75,3.53,3.53,0,0,0-.42.82c-.06.25-.06.5-.1.75v0l-.22.32a9.7,9.7,0,0,1-1.61,1.81l-.16.1a13.22,13.22,0,0,0-1.55.78.62.62,0,0,1-.39-.12c-.71-.49-.19-2.45,1.16-4.37S487.36,217.69,488.07,218.19Z"
                fill="#141c66"
              />
              <path d="M484.35,220.76s.66,3.9-6.7,9.53" fill="#141c66" />
              <path
                d="M487.72,219.14a2,2,0,0,1-.44.94,4.27,4.27,0,0,0-.67.74,1.37,1.37,0,0,0-.16.52c0,.17,0,.34,0,.51a1.09,1.09,0,0,1-.21.51.88.88,0,0,1-.34.24,1.2,1.2,0,0,0-.75.7,1.7,1.7,0,0,1-.38.5,1.29,1.29,0,0,1-.35.18,1.06,1.06,0,0,0-.35.23,1,1,0,0,0-.23.33.91.91,0,0,1-.19.29,1.11,1.11,0,0,1-.48.17h-.06a.26.26,0,0,1-.15-.07c-.56-.39.08-2.26,1.43-4.18s2.89-3.15,3.45-2.76a.44.44,0,0,1,.15.22A5,5,0,0,0,487.72,219.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M463.75,204.25q0-.36-.06-.72a5.27,5.27,0,0,1,0-1.05c0-.31.14-.62.21-.92a3.27,3.27,0,0,0,.09-.82c0-.31-.1-.6-.12-.9a1.94,1.94,0,0,1,.06-.68,4.68,4.68,0,0,1,.19-.45,3.42,3.42,0,0,1,.26-.4s0-.06,0-.09a3.36,3.36,0,0,1,1.6-1.39,3.29,3.29,0,0,1,2-.14.82.82,0,0,0,.24.25,2.12,2.12,0,0,0,.74.27,1.41,1.41,0,0,1,.76.4,8.73,8.73,0,0,1,.52.82,1.5,1.5,0,0,0,.34.37,1.75,1.75,0,0,0,.42.19,1.18,1.18,0,0,1,.44.28,3,3,0,0,1,.31.4,3.06,3.06,0,0,0,.35.37,3.58,3.58,0,0,1,.26.29,4.48,4.48,0,0,1,.55,1.75,2.5,2.5,0,0,0,.41,1,4.4,4.4,0,0,0,.61.61,2.2,2.2,0,0,1,.47.54,2.37,2.37,0,0,1,.21,1c0,.8,0,1.61.06,2.41a5.4,5.4,0,0,0,.11.58c0,.18.1.36.14.55a1.23,1.23,0,0,1-.06.71,5,5,0,0,1-.33.6,1.84,1.84,0,0,0-.3,1,1.57,1.57,0,0,1,0,.53,1.18,1.18,0,0,1-.23.39,3.84,3.84,0,0,0-.59.68,0,0,0,0,0,0,0,3.06,3.06,0,0,1-.83.5,3.23,3.23,0,0,1-1.38.22,4.59,4.59,0,0,0-.93-.49,10.69,10.69,0,0,1-1.1-.47,2.76,2.76,0,0,1-.49-.32c-.15-.12-.28-.26-.44-.38s-.64-.38-.92-.62a1.79,1.79,0,0,1-.39-.48,5.55,5.55,0,0,1-.24-.56,1.74,1.74,0,0,0-.31-.5,5.55,5.55,0,0,0-.42-.42l-.59-.51a14.47,14.47,0,0,1-.72-1.48,2.2,2.2,0,0,1,.26-.61c.15-.3.34-.57.5-.86,0,0,0-.11,0-.12a7.13,7.13,0,0,1-.8-.18,1.08,1.08,0,0,1-.51-.29,1.1,1.1,0,0,1-.2-.35C463.82,204.56,463.78,204.4,463.75,204.25Z"
                fill="#396039"
              />
              <path
                d="M466.25,197.43a55.91,55.91,0,0,1,3.64,7.85c1,2.69,1.94,5.43,2.77,8.2s1.52,5.57,2.19,8.38l.92,4.23.79,4.25c-.56-2.83-1.15-5.65-1.81-8.46s-1.39-5.6-2.23-8.36-1.7-5.51-2.73-8.21c-.52-1.34-1.05-2.68-1.64-4A39.78,39.78,0,0,0,466.25,197.43Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M479.8,216.58a9,9,0,0,0,0-1,23.21,23.21,0,0,1,1.59-5.08c.17-.17.33-.34.49-.52s.35-.46.52-.7.41-.55.6-.82a7,7,0,0,0,1-1.7c.11-.3.15-.62.23-.93s.13-.42.2-.62c2-2.64,4-4.09,5.32-3.47a1.45,1.45,0,0,1,.47.35,2.29,2.29,0,0,0,.08.28,4.14,4.14,0,0,1,.12,1.31,6.61,6.61,0,0,1-.26,1.25,8.27,8.27,0,0,0-.42,1.45,5.32,5.32,0,0,0,.05,1.38,7.13,7.13,0,0,1,.1,1.38,1.89,1.89,0,0,1-.4,1.15,3.45,3.45,0,0,1-.73.52,3.65,3.65,0,0,0-.78.74.92.92,0,0,0-.27.73c0,.29.15.56.2.84a2.38,2.38,0,0,1-.59,1.89,9.18,9.18,0,0,1-1.61,1.38c-.3.23-.6.47-.88.72s-.28.27-.42.41-.28.33-.42.5a8.63,8.63,0,0,1-2.12,1.63c-.38.23-.76.47-1.12.74a2.57,2.57,0,0,1-1.08-2.29A5.68,5.68,0,0,0,479.8,216.58Z"
                fill="#2f4f2f"
              />
              <path
                d="M490.17,201.49c-1.51,2.23-2.91,4.53-4.24,6.87s-2.55,4.73-3.68,7.17a77.85,77.85,0,0,0-3,7.48,54,54,0,0,0-1.94,7.83,48.25,48.25,0,0,1,1.85-7.86,78,78,0,0,1,3-7.51A95.12,95.12,0,0,1,490.17,201.49Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M479.93,218.53a7.46,7.46,0,0,0,.1-.81,18,18,0,0,1,1.89-3.79c.15-.11.31-.22.45-.34a5.78,5.78,0,0,0,.5-.49l.58-.56a5.93,5.93,0,0,0,1-1.21c.12-.23.19-.47.3-.7s.15-.31.23-.46c1.89-1.82,3.69-2.69,4.62-2a1.13,1.13,0,0,1,.31.34l0,.23a3.3,3.3,0,0,1-.07,1,4.76,4.76,0,0,1-.36,1,6.31,6.31,0,0,0-.52,1.08,4.4,4.4,0,0,0-.13,1.09,5.74,5.74,0,0,1-.1,1.09,1.46,1.46,0,0,1-.46.85,3,3,0,0,1-.64.32,2.81,2.81,0,0,0-.7.48.74.74,0,0,0-.31.54c0,.23.05.46.05.68a1.86,1.86,0,0,1-.7,1.41,7.74,7.74,0,0,1-1.43.88c-.27.14-.53.29-.79.45s-.25.17-.37.26l-.4.34a6.64,6.64,0,0,1-1.87,1c-.33.14-.66.28-1,.44a2.06,2.06,0,0,1-.56-1.94A4,4,0,0,0,479.93,218.53Z"
                fill="#396039"
              />
              <path
                d="M490,208c-1.46,1.56-2.84,3.19-4.18,4.85s-2.6,3.39-3.8,5.16-2.3,3.6-3.31,5.48a44.27,44.27,0,0,0-2.52,5.88,37.69,37.69,0,0,1,2.43-5.93,62.48,62.48,0,0,1,3.28-5.51A74.23,74.23,0,0,1,490,208Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M475.37,218.68a.35.35,0,0,0,.15-.25.41.41,0,0,0-.16-.3,3.23,3.23,0,0,0-.45-.36h0a2.47,2.47,0,0,0,.28-.28.42.42,0,0,0,.12-.25c0-.18-.18-.27-.32-.32l-.3-.11c-.07-.32-.13-.64-.19-1l.18,0a3.26,3.26,0,0,0,.44-.15.73.73,0,0,0,.3-.19.08.08,0,0,0,0-.12c-.14-.08-.29-.13-.44-.2a1.17,1.17,0,0,1-.38-.24c-.11-.14,0-.31,0-.46a.42.42,0,0,0-.18-.31.53.53,0,0,0-.14-.12c0-.41-.08-.82-.11-1.25l.24-.07a1.34,1.34,0,0,0,.57-.29.49.49,0,0,0,.09-.57,1.14,1.14,0,0,0-.57-.42,2.47,2.47,0,0,0-.36-.11c0-.15-.05-.29-.07-.44,0-.41,0-.83,0-1.26l0-.05a.65.65,0,0,1,.24-.15,1.1,1.1,0,0,0,.35-.26.09.09,0,0,0,0-.11c-.17-.14-.57-.35-.46-.63,0-.08.16-.09.23-.13a.22.22,0,0,0,.12-.25c0-.19-.28-.26-.38-.41s.18-.23.29-.24a4.28,4.28,0,0,0,.62,0,.08.08,0,0,0,0-.14c-.31-.23-.63-.45-1-.65.06-.89.15-1.74.26-2.53l.14,0c.05,0,.08,0,.09-.06a2.85,2.85,0,0,1,.6.31l.32.24c.08.06.18,0,.11-.1a3.85,3.85,0,0,0-.34-.26,6.52,6.52,0,0,0-.87-.53c.1-.69.23-1.34.36-1.93a3,3,0,0,1,.75.39l.26.24c.08.07.18,0,.11-.1a2.27,2.27,0,0,0-.28-.26l-.53-.48-.21-.17a12,12,0,0,1,.52-1.65,7.72,7.72,0,0,0,1,.4.07.07,0,0,0,.09-.07,1.69,1.69,0,0,0-.36-.82,3.49,3.49,0,0,0-.32-.35c.37-.62.77-1,1.19-1,.86,0,1.63,1.4,2.18,3.64-.23.2-.44.42-.65.63s0,.16.09.12a7.17,7.17,0,0,0,.63-.45c.13.59.25,1.23.35,1.92a13.2,13.2,0,0,0-.67,1.36s0,.09,0,.11c.28.14.57.26.86.39.09,1,.14,2,.16,3.09a5.8,5.8,0,0,0-.6,1.4,3.19,3.19,0,0,0-.05,1.11c0,.19,0,.38.05.56s0,.37,0,.55c.06.34.18.67.24,1a.84.84,0,0,1-.22.84,2.1,2.1,0,0,1-.63.24.28.28,0,0,0-.19.16.36.36,0,0,0,.06.28,1.49,1.49,0,0,0,.64.55l.24.13c-.53,3.31-1.47,5.52-2.55,5.52-.66,0-1.28-.84-1.77-2.26Z"
                fill="#659965"
              />
              <path
                d="M477,201.79c.13,4.78.17,9.56.22,14.34v7.17c0,2.39,0,4.78-.22,7.17.12-1.19.09-2.39.11-3.59V223.3l-.05-7.17Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M472.31,207a1,1,0,0,1,.56,0l.32.41c.17.2.34.39.52.58a6.55,6.55,0,0,1,.49.56,5.14,5.14,0,0,1,.56,1,4.72,4.72,0,0,0,.59,1.19c.23.28.52.49.78.75h0l.18.53a14.13,14.13,0,0,1,.7,3.39,2.46,2.46,0,0,1,0,.26,19.06,19.06,0,0,0-.43,2.45,1,1,0,0,1-.47.35c-1.17.39-3-1.88-4-5.05S471.14,207.41,472.31,207Z"
                fill="#3b6818"
              />
              <path
                d="M472.08,213.47s5,2.57,5.21,15.8"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.15"
              />
              <path
                d="M473.1,208.22a2.91,2.91,0,0,1,.7,1.32,6.12,6.12,0,0,0,.28,1.39,1.94,1.94,0,0,0,.46.63c.18.16.37.31.55.49a1.4,1.4,0,0,1,.4.66,1.11,1.11,0,0,1,0,.6,3.09,3.09,0,0,0-.09.62,2.28,2.28,0,0,0,.26.84,2.37,2.37,0,0,1,.25.85,1.92,1.92,0,0,1-.09.55,1.72,1.72,0,0,0,0,.6,1.55,1.55,0,0,0,.18.55,1.12,1.12,0,0,1,.17.46,1.44,1.44,0,0,1-.21.7l0,.08a.55.55,0,0,1-.21.12c-.92.3-2.52-2-3.56-5.2s-1.15-6-.23-6.31a.58.58,0,0,1,.39,0A6.21,6.21,0,0,0,473.1,208.22Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1067.82,317c20.71-2-9.51,74.15,47.59,81s76.14,18.26,70.19,32-65.43,20.53-86.85,10.26-86.84-42.21-71.38-82.13S1055.93,318.18,1067.82,317Z"
            fill="#396039"
          />
          <path
            d="M1070.07,323.85c16.61-1.66-7.63,62,38.17,67.74s61.06,15.27,56.29,26.71-52.48,17.18-69.65,8.59-69.65-35.3-57.25-68.69S1060.53,324.8,1070.07,323.85Z"
            fill="#493b1b"
          />
          <g>
            <path
              d="M1141.57,406.11a14.26,14.26,0,0,1-1.2-4.14,11.34,11.34,0,0,1-.09-2.18,4.15,4.15,0,0,1,.62-2.09,6.7,6.7,0,0,0-.1,2.09c.06.7.13,1.4.23,2.09C1141.21,403.28,1141.44,404.67,1141.57,406.11Z"
              fill="#396039"
            />
            <path
              d="M1141.35,397.26c-4.65-1.33-2.66-7.08,3.32-6.2S1141.35,397.26,1141.35,397.26Z"
              fill="#a04d90"
            />
            <path
              d="M1141.35,397.26s4.42-3.76,6.86-2.43-.22,5.08-3.54,4.2S1141.35,397.26,1141.35,397.26Z"
              fill="#a04d90"
            />
            <path
              d="M1140.68,397.26a3.9,3.9,0,0,0-3.54-2.66c-2.88-.22-4,4.65-1.1,4.65A6.64,6.64,0,0,0,1140.68,397.26Z"
              fill="#a04d90"
            />
            <path
              d="M1140.9,396.82s5.31,1.55,2,3.32S1136.92,399.25,1140.9,396.82Z"
              fill="#a04d90"
            />
            <path
              d="M1134.42,398.07a1.54,1.54,0,0,0,1.62,1.18,6.64,6.64,0,0,0,4.64-2C1139.36,397.83,1136,398.55,1134.42,398.07Z"
              fill="#7f3374"
            />
            <path d="M1137.14,396.37a3.64,3.64,0,0,1,3.54.89" fill="#7f3374" />
            <path d="M1141.79,392.61s-2.66,1.77-1.11,4.21" fill="#7f3374" />
            <path d="M1145.55,392.39s-4.42,1.77-4.65,4.43" fill="#7f3374" />
            <path
              d="M1141.35,397.26a5.81,5.81,0,0,1,4.64-1.11"
              fill="#7f3374"
            />
            <path d="M1141.56,397.63s4.21-1.26,6.65-.81" fill="#7f3374" />
            <path
              d="M1148.68,397.63s-4.47,1-6.89.2a8.11,8.11,0,0,0,2.88,1.2A3.73,3.73,0,0,0,1148.68,397.63Z"
              fill="#7f3374"
            />
            <path
              d="M1143.91,399.25c-2.72,1.06-4.43.43-5,.13.07,1.23,1.9,1.87,4,.76A2.16,2.16,0,0,0,1143.91,399.25Z"
              fill="#7f3374"
            />
            <path d="M1140.9,397.7a1.31,1.31,0,0,0-.44,1.55" fill="#7f3374" />
            <path d="M1140.9,397.26s.45,2,1.77,2" fill="#7f3374" />
            <ellipse
              cx="1141.01"
              cy="397.04"
              rx="1.22"
              ry="0.66"
              fill="#b7b720"
            />
            <path
              d="M1141.45,405.66s-1.32-2.09,1.33-3.86C1142.78,401.8,1143.65,405.09,1141.45,405.66Z"
              fill="#396039"
            />
            <path
              d="M1140.46,402.57s.67-.66-2-1.77C1138.47,400.8,1138.25,402.35,1140.46,402.57Z"
              fill="#396039"
            />
            <path
              d="M1142.78,401.8c-.2.65-.46,1.28-.69,1.92q-.18.48-.33,1a2.81,2.81,0,0,0-.19,1,2.24,2.24,0,0,1,0-1,8.78,8.78,0,0,1,.29-1A10.8,10.8,0,0,1,1142.78,401.8Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1121.47,421.08c.07-.8.22-1.56.3-2.33a11,11,0,0,0,.13-1.14,4,4,0,0,0-.06-1.15,2.21,2.21,0,0,1,.34,1.15,7.84,7.84,0,0,1,0,1.19A8,8,0,0,1,1121.47,421.08Z"
              fill="#396039"
            />
            <path
              d="M1121.6,416.22c2.55-.73,1.45-3.89-1.83-3.41S1121.6,416.22,1121.6,416.22Z"
              fill="#a04d90"
            />
            <path
              d="M1121.6,416.22s-2.43-2.07-3.77-1.34.12,2.79,1.94,2.31S1121.6,416.22,1121.6,416.22Z"
              fill="#a04d90"
            />
            <path
              d="M1122,416.22a2.13,2.13,0,0,1,1.94-1.46c1.58-.12,2.19,2.55.61,2.55A3.65,3.65,0,0,1,1122,416.22Z"
              fill="#a04d90"
            />
            <path
              d="M1121.84,416s-2.92.85-1.09,1.83S1124,417.31,1121.84,416Z"
              fill="#a04d90"
            />
            <path
              d="M1125.4,416.66a.85.85,0,0,1-.89.65,3.65,3.65,0,0,1-2.55-1.09A6.91,6.91,0,0,0,1125.4,416.66Z"
              fill="#7f3374"
            />
            <path d="M1123.9,415.73a2,2,0,0,0-1.94.49" fill="#7f3374" />
            <path d="M1121.35,413.66s1.46,1,.61,2.31" fill="#7f3374" />
            <path d="M1119.29,413.54s2.43,1,2.55,2.43" fill="#7f3374" />
            <path d="M1121.6,416.22a3.19,3.19,0,0,0-2.56-.61" fill="#7f3374" />
            <path
              d="M1121.48,416.42a10.51,10.51,0,0,0-3.65-.45"
              fill="#7f3374"
            />
            <path
              d="M1117.57,416.42a9.24,9.24,0,0,0,3.78.11,4.48,4.48,0,0,1-1.58.66A2,2,0,0,1,1117.57,416.42Z"
              fill="#7f3374"
            />
            <path
              d="M1120.19,417.31a3.31,3.31,0,0,0,2.74.07c0,.68-1,1-2.18.42A1.16,1.16,0,0,1,1120.19,417.31Z"
              fill="#7f3374"
            />
            <path d="M1121.84,416.46a.71.71,0,0,1,.24.85" fill="#7f3374" />
            <path d="M1121.84,416.22s-.24,1.09-1,1.09" fill="#7f3374" />
            <ellipse
              cx="1121.78"
              cy="416.09"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1121.54,420.83s.72-1.15-.73-2.12C1120.81,418.71,1120.33,420.52,1121.54,420.83Z"
              fill="#396039"
            />
            <path
              d="M1122.08,419.13s-.36-.36,1.1-1C1123.18,418.16,1123.3,419,1122.08,419.13Z"
              fill="#396039"
            />
            <path
              d="M1120.81,418.71a7.24,7.24,0,0,1,.49,1,2.13,2.13,0,0,1,.17,1.11,2,2,0,0,0-.09-.54c-.06-.18-.12-.35-.19-.53C1121.08,419.41,1120.92,419.07,1120.81,418.71Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1125.63,406.11c.06-.79.21-1.55.3-2.32.06-.38.09-.77.12-1.15a3.72,3.72,0,0,0,0-1.15,2.32,2.32,0,0,1,.33,1.15,6.88,6.88,0,0,1,0,1.2A8.21,8.21,0,0,1,1125.63,406.11Z"
              fill="#396039"
            />
            <path
              d="M1125.75,401.25c2.55-.73,1.46-3.89-1.82-3.4S1125.75,401.25,1125.75,401.25Z"
              fill="#a04d90"
            />
            <path
              d="M1125.75,401.25s-2.43-2.07-3.76-1.34.12,2.8,1.94,2.31S1125.75,401.25,1125.75,401.25Z"
              fill="#a04d90"
            />
            <path
              d="M1126.12,401.25a2.13,2.13,0,0,1,1.94-1.46c1.58-.12,2.19,2.55.61,2.55A3.65,3.65,0,0,1,1126.12,401.25Z"
              fill="#a04d90"
            />
            <path
              d="M1126,401s-2.92.85-1.1,1.82S1128.18,402.34,1126,401Z"
              fill="#a04d90"
            />
            <path
              d="M1129.55,401.69a.82.82,0,0,1-.88.65,3.65,3.65,0,0,1-2.55-1.09A6.87,6.87,0,0,0,1129.55,401.69Z"
              fill="#7f3374"
            />
            <path d="M1128.06,400.76a2,2,0,0,0-1.94.49" fill="#7f3374" />
            <path d="M1125.51,398.7a1.71,1.71,0,0,1,.61,2.31" fill="#7f3374" />
            <path d="M1123.44,398.58s2.43,1,2.56,2.43" fill="#7f3374" />
            <path d="M1125.75,401.25a3.2,3.2,0,0,0-2.55-.61" fill="#7f3374" />
            <path
              d="M1125.63,401.45A10.31,10.31,0,0,0,1122,401"
              fill="#7f3374"
            />
            <path
              d="M1121.72,401.46a9.69,9.69,0,0,0,3.79.11,4.63,4.63,0,0,1-1.58.65A2,2,0,0,1,1121.72,401.46Z"
              fill="#7f3374"
            />
            <path
              d="M1124.34,402.34a3.25,3.25,0,0,0,2.75.07c0,.68-1,1-2.19.42A1.27,1.27,0,0,1,1124.34,402.34Z"
              fill="#7f3374"
            />
            <path d="M1126,401.49a.72.72,0,0,1,.24.85" fill="#7f3374" />
            <path d="M1126,401.25s-.25,1.09-1,1.09" fill="#7f3374" />
            <ellipse
              cx="1125.94"
              cy="401.13"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1125.7,405.86s.72-1.15-.74-2.12C1125,403.74,1124.49,405.55,1125.7,405.86Z"
              fill="#396039"
            />
            <path
              d="M1126.24,404.17s-.37-.37,1.09-1C1127.33,403.19,1127.45,404.05,1126.24,404.17Z"
              fill="#396039"
            />
            <path
              d="M1125,403.74a6.42,6.42,0,0,1,.5,1,2.34,2.34,0,0,1,.17,1.11,1.72,1.72,0,0,0-.1-.55,5.44,5.44,0,0,0-.19-.52C1125.23,404.44,1125.08,404.1,1125,403.74Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1138.31,417.75a8.19,8.19,0,0,1-.65-2.27,6.89,6.89,0,0,1-.05-1.2,2.24,2.24,0,0,1,.34-1.15,4.06,4.06,0,0,0-.06,1.15,11.24,11.24,0,0,0,.13,1.15C1138.1,416.2,1138.25,417,1138.31,417.75Z"
              fill="#396039"
            />
            <path
              d="M1138.19,412.89c-2.55-.73-1.46-3.89,1.83-3.4S1138.19,412.89,1138.19,412.89Z"
              fill="#a04d90"
            />
            <path
              d="M1138.19,412.89s2.43-2.07,3.77-1.34-.12,2.8-1.94,2.31S1138.19,412.89,1138.19,412.89Z"
              fill="#a04d90"
            />
            <path
              d="M1137.83,412.89a2.15,2.15,0,0,0-1.95-1.46c-1.58-.12-2.18,2.55-.6,2.55A3.65,3.65,0,0,0,1137.83,412.89Z"
              fill="#a04d90"
            />
            <path
              d="M1138,412.65s2.92.85,1.09,1.82S1135.76,414,1138,412.65Z"
              fill="#a04d90"
            />
            <path
              d="M1134.39,413.33a.84.84,0,0,0,.89.65,3.65,3.65,0,0,0,2.55-1.09A6.91,6.91,0,0,1,1134.39,413.33Z"
              fill="#7f3374"
            />
            <path d="M1135.88,412.4a2,2,0,0,1,1.95.49" fill="#7f3374" />
            <path d="M1138.44,410.34a1.71,1.71,0,0,0-.61,2.31" fill="#7f3374" />
            <path d="M1140.5,410.22s-2.43,1-2.55,2.43" fill="#7f3374" />
            <path d="M1138.19,412.89a3.23,3.23,0,0,1,2.56-.61" fill="#7f3374" />
            <path
              d="M1138.31,413.09a10.34,10.34,0,0,1,3.65-.44"
              fill="#7f3374"
            />
            <path
              d="M1142.22,413.09a9.37,9.37,0,0,1-3.78.12,4.53,4.53,0,0,0,1.58.65A2,2,0,0,0,1142.22,413.09Z"
              fill="#7f3374"
            />
            <path
              d="M1139.6,414a3.26,3.26,0,0,1-2.75.07c.05.68,1.05,1,2.19.42A1.16,1.16,0,0,0,1139.6,414Z"
              fill="#7f3374"
            />
            <path d="M1138,413.13a.71.71,0,0,0-.24.85" fill="#7f3374" />
            <path d="M1138,412.89s.24,1.09,1,1.09" fill="#7f3374" />
            <ellipse
              cx="1138.01"
              cy="412.77"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1138.25,417.5s-.73-1.15.73-2.12C1139,415.38,1139.46,417.19,1138.25,417.5Z"
              fill="#396039"
            />
            <path
              d="M1137.71,415.81s.36-.37-1.1-1C1136.61,414.83,1136.49,415.68,1137.71,415.81Z"
              fill="#396039"
            />
            <path
              d="M1139,415.38c-.11.36-.27.7-.38,1.06-.07.17-.13.35-.19.52a2.54,2.54,0,0,0-.1.55,2.23,2.23,0,0,1,.18-1.11A7.36,7.36,0,0,1,1139,415.38Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1111.08,405.28c.06-.79.21-1.55.3-2.32.06-.38.09-.77.12-1.15a3.72,3.72,0,0,0,0-1.15,2.29,2.29,0,0,1,.33,1.15,6.88,6.88,0,0,1,0,1.2A8.21,8.21,0,0,1,1111.08,405.28Z"
              fill="#396039"
            />
            <path
              d="M1111.2,400.42c2.56-.73,1.46-3.89-1.82-3.4S1111.2,400.42,1111.2,400.42Z"
              fill="#a04d90"
            />
            <path
              d="M1111.2,400.42s-2.43-2.07-3.76-1.34.12,2.8,1.94,2.31S1111.2,400.42,1111.2,400.42Z"
              fill="#a04d90"
            />
            <path
              d="M1111.57,400.42a2.13,2.13,0,0,1,1.94-1.46c1.58-.12,2.19,2.55.61,2.55A3.65,3.65,0,0,1,1111.57,400.42Z"
              fill="#a04d90"
            />
            <path
              d="M1111.45,400.18s-2.92.85-1.1,1.82S1113.63,401.51,1111.45,400.18Z"
              fill="#a04d90"
            />
            <path
              d="M1115,400.86a.85.85,0,0,1-.89.65,3.65,3.65,0,0,1-2.55-1.09A6.9,6.9,0,0,0,1115,400.86Z"
              fill="#7f3374"
            />
            <path d="M1113.51,399.93a2,2,0,0,0-1.94.49" fill="#7f3374" />
            <path d="M1111,397.87a1.71,1.71,0,0,1,.61,2.31" fill="#7f3374" />
            <path d="M1108.89,397.75s2.44,1,2.56,2.43" fill="#7f3374" />
            <path d="M1111.2,400.42a3.2,3.2,0,0,0-2.55-.61" fill="#7f3374" />
            <path
              d="M1111.08,400.62a10.31,10.31,0,0,0-3.64-.44"
              fill="#7f3374"
            />
            <path
              d="M1107.17,400.62a9.3,9.3,0,0,0,3.79.11,4.38,4.38,0,0,1-1.58.66A2.05,2.05,0,0,1,1107.17,400.62Z"
              fill="#7f3374"
            />
            <path
              d="M1109.79,401.51a3.25,3.25,0,0,0,2.75.07c0,.68-1,1-2.19.42A1.27,1.27,0,0,1,1109.79,401.51Z"
              fill="#7f3374"
            />
            <path d="M1111.45,400.66a.72.72,0,0,1,.24.85" fill="#7f3374" />
            <path d="M1111.45,400.42s-.25,1.09-1,1.09" fill="#7f3374" />
            <ellipse
              cx="1111.39"
              cy="400.3"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1111.15,405s.72-1.15-.74-2.12C1110.41,402.91,1109.94,404.72,1111.15,405Z"
              fill="#396039"
            />
            <path
              d="M1111.69,403.34s-.36-.37,1.09-1C1112.78,402.36,1112.9,403.21,1111.69,403.34Z"
              fill="#396039"
            />
            <path
              d="M1110.41,402.91a6.42,6.42,0,0,1,.5,1,2.34,2.34,0,0,1,.17,1.11,1.72,1.72,0,0,0-.1-.55,4.6,4.6,0,0,0-.19-.52C1110.69,403.61,1110.53,403.27,1110.41,402.91Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1079.49,381.59c.06-.8.21-1.56.3-2.33.06-.38.09-.76.12-1.14a3.42,3.42,0,0,0-.06-1.15,2.21,2.21,0,0,1,.34,1.15,6.74,6.74,0,0,1,0,1.19A8.28,8.28,0,0,1,1079.49,381.59Z"
              fill="#396039"
            />
            <path
              d="M1079.61,376.72c2.55-.72,1.46-3.88-1.82-3.4S1079.61,376.72,1079.61,376.72Z"
              fill="#a04d90"
            />
            <path
              d="M1079.61,376.72s-2.43-2.06-3.77-1.33.13,2.79,2,2.31S1079.61,376.72,1079.61,376.72Z"
              fill="#a04d90"
            />
            <path
              d="M1080,376.72a2.13,2.13,0,0,1,1.94-1.45c1.58-.13,2.19,2.55.61,2.55A3.64,3.64,0,0,1,1080,376.72Z"
              fill="#a04d90"
            />
            <path
              d="M1079.85,376.48s-2.91.85-1.09,1.82S1082,377.82,1079.85,376.48Z"
              fill="#a04d90"
            />
            <path
              d="M1083.41,377.17a.83.83,0,0,1-.88.65,3.64,3.64,0,0,1-2.55-1.1A6.88,6.88,0,0,0,1083.41,377.17Z"
              fill="#7f3374"
            />
            <path d="M1081.92,376.24a2,2,0,0,0-1.94.48" fill="#7f3374" />
            <path d="M1079.37,374.17a1.71,1.71,0,0,1,.61,2.31" fill="#7f3374" />
            <path d="M1077.3,374.05s2.43,1,2.55,2.43" fill="#7f3374" />
            <path d="M1079.61,376.72a3.17,3.17,0,0,0-2.55-.6" fill="#7f3374" />
            <path
              d="M1079.49,376.93a10.51,10.51,0,0,0-3.65-.45"
              fill="#7f3374"
            />
            <path
              d="M1075.58,376.93a9.49,9.49,0,0,0,3.79.11,4.68,4.68,0,0,1-1.58.66A2.07,2.07,0,0,1,1075.58,376.93Z"
              fill="#7f3374"
            />
            <path
              d="M1078.2,377.82a3.34,3.34,0,0,0,2.75.07c0,.68-1,1-2.19.41A1.21,1.21,0,0,1,1078.2,377.82Z"
              fill="#7f3374"
            />
            <path d="M1079.85,377a.71.71,0,0,1,.25.85" fill="#7f3374" />
            <path d="M1079.85,376.72s-.24,1.1-1,1.1" fill="#7f3374" />
            <ellipse
              cx="1079.79"
              cy="376.6"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1079.56,381.34s.72-1.15-.74-2.12C1078.82,379.22,1078.35,381,1079.56,381.34Z"
              fill="#396039"
            />
            <path
              d="M1080.1,379.64s-.37-.36,1.09-1C1081.19,378.67,1081.31,379.52,1080.1,379.64Z"
              fill="#396039"
            />
            <path
              d="M1078.82,379.22a7.3,7.3,0,0,1,.5,1,2.36,2.36,0,0,1,.17,1.11,1.66,1.66,0,0,0-.1-.54,5.62,5.62,0,0,0-.19-.53C1079.09,379.92,1078.93,379.58,1078.82,379.22Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1053.3,368.28c.06-.79.21-1.55.3-2.32.06-.38.09-.76.12-1.15a3.64,3.64,0,0,0,0-1.14,2.29,2.29,0,0,1,.33,1.14,6.88,6.88,0,0,1,0,1.2A8.11,8.11,0,0,1,1053.3,368.28Z"
              fill="#396039"
            />
            <path
              d="M1053.42,363.42c2.55-.73,1.46-3.89-1.82-3.4S1053.42,363.42,1053.42,363.42Z"
              fill="#a04d90"
            />
            <path
              d="M1053.42,363.42s-2.43-2.06-3.76-1.33.12,2.79,1.94,2.3S1053.42,363.42,1053.42,363.42Z"
              fill="#a04d90"
            />
            <path
              d="M1053.79,363.42a2.14,2.14,0,0,1,1.94-1.46c1.58-.12,2.19,2.56.61,2.56A3.64,3.64,0,0,1,1053.79,363.42Z"
              fill="#a04d90"
            />
            <path
              d="M1053.67,363.18s-2.92.85-1.1,1.82S1055.85,364.52,1053.67,363.18Z"
              fill="#a04d90"
            />
            <path
              d="M1057.22,363.87a.83.83,0,0,1-.88.65,3.64,3.64,0,0,1-2.55-1.1A7,7,0,0,0,1057.22,363.87Z"
              fill="#7f3374"
            />
            <path d="M1055.73,362.94a2,2,0,0,0-1.94.48" fill="#7f3374" />
            <path d="M1053.18,360.87a1.71,1.71,0,0,1,.61,2.31" fill="#7f3374" />
            <path d="M1051.11,360.75s2.43,1,2.56,2.43" fill="#7f3374" />
            <path d="M1053.42,363.42a3.2,3.2,0,0,0-2.55-.61" fill="#7f3374" />
            <path
              d="M1053.3,363.63a10.48,10.48,0,0,0-3.64-.45"
              fill="#7f3374"
            />
            <path
              d="M1049.39,363.63a9.69,9.69,0,0,0,3.79.11,4.43,4.43,0,0,1-1.58.65A2,2,0,0,1,1049.39,363.63Z"
              fill="#7f3374"
            />
            <path
              d="M1052,364.52a3.33,3.33,0,0,0,2.75.07c0,.67-1,1-2.19.41A1.26,1.26,0,0,1,1052,364.52Z"
              fill="#7f3374"
            />
            <path d="M1053.67,363.67a.71.71,0,0,1,.24.85" fill="#7f3374" />
            <path d="M1053.67,363.42s-.25,1.1-1,1.1" fill="#7f3374" />
            <ellipse
              cx="1053.6"
              cy="363.3"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1053.37,368s.72-1.14-.74-2.12C1052.63,365.91,1052.16,367.72,1053.37,368Z"
              fill="#396039"
            />
            <path
              d="M1053.91,366.34s-.37-.37,1.09-1C1055,365.37,1055.12,366.22,1053.91,366.34Z"
              fill="#396039"
            />
            <path
              d="M1052.63,365.91a6.42,6.42,0,0,1,.5,1,2.36,2.36,0,0,1,.17,1.11,1.62,1.62,0,0,0-.1-.54,4.76,4.76,0,0,0-.19-.53C1052.9,366.61,1052.74,366.27,1052.63,365.91Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1067,342.93c.06-.8.21-1.56.29-2.33a11,11,0,0,0,.13-1.14,3.42,3.42,0,0,0-.06-1.15,2.21,2.21,0,0,1,.34,1.15,6.74,6.74,0,0,1,0,1.19A8.28,8.28,0,0,1,1067,342.93Z"
              fill="#396039"
            />
            <path
              d="M1067.14,338.07c2.55-.73,1.46-3.89-1.82-3.41S1067.14,338.07,1067.14,338.07Z"
              fill="#a04d90"
            />
            <path
              d="M1067.14,338.07s-2.43-2.07-3.77-1.34.12,2.79,2,2.31S1067.14,338.07,1067.14,338.07Z"
              fill="#a04d90"
            />
            <path
              d="M1067.5,338.07a2.15,2.15,0,0,1,2-1.46c1.58-.12,2.19,2.55.61,2.55A3.69,3.69,0,0,1,1067.5,338.07Z"
              fill="#a04d90"
            />
            <path
              d="M1067.38,337.82s-2.91.85-1.09,1.82S1069.57,339.16,1067.38,337.82Z"
              fill="#a04d90"
            />
            <path
              d="M1070.94,338.51a.83.83,0,0,1-.88.65,3.69,3.69,0,0,1-2.56-1.09A6.91,6.91,0,0,0,1070.94,338.51Z"
              fill="#7f3374"
            />
            <path d="M1069.45,337.58a2,2,0,0,0-2,.49" fill="#7f3374" />
            <path d="M1066.9,335.51a1.71,1.71,0,0,1,.6,2.31" fill="#7f3374" />
            <path d="M1064.83,335.39s2.43,1,2.55,2.43" fill="#7f3374" />
            <path d="M1067.14,338.07a3.17,3.17,0,0,0-2.55-.61" fill="#7f3374" />
            <path d="M1067,338.27a10.51,10.51,0,0,0-3.65-.45" fill="#7f3374" />
            <path
              d="M1063.11,338.27a9.3,9.3,0,0,0,3.79.11,4.68,4.68,0,0,1-1.58.66A2.07,2.07,0,0,1,1063.11,338.27Z"
              fill="#7f3374"
            />
            <path
              d="M1065.73,339.16a3.34,3.34,0,0,0,2.75.07c0,.68-1,1-2.19.41A1.21,1.21,0,0,1,1065.73,339.16Z"
              fill="#7f3374"
            />
            <path d="M1067.38,338.31a.71.71,0,0,1,.25.85" fill="#7f3374" />
            <path d="M1067.38,338.07s-.24,1.09-1,1.09" fill="#7f3374" />
            <ellipse
              cx="1067.32"
              cy="337.94"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1067.09,342.68s.72-1.15-.74-2.12C1066.35,340.56,1065.88,342.37,1067.09,342.68Z"
              fill="#396039"
            />
            <path
              d="M1067.63,341s-.37-.36,1.09-1C1068.72,340,1068.84,340.86,1067.63,341Z"
              fill="#396039"
            />
            <path
              d="M1066.35,340.56a7.3,7.3,0,0,1,.5,1,2.36,2.36,0,0,1,.17,1.11,1.66,1.66,0,0,0-.1-.54,5.62,5.62,0,0,0-.19-.53C1066.62,341.26,1066.46,340.92,1066.35,340.56Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1070.76,332.12c.06-.8.21-1.56.3-2.32.06-.39.09-.77.12-1.15a3.44,3.44,0,0,0-.06-1.15,2.21,2.21,0,0,1,.34,1.15,6.74,6.74,0,0,1,0,1.19A8.18,8.18,0,0,1,1070.76,332.12Z"
              fill="#396039"
            />
            <path
              d="M1070.88,327.26c2.55-.73,1.46-3.89-1.82-3.41S1070.88,327.26,1070.88,327.26Z"
              fill="#a04d90"
            />
            <path
              d="M1070.88,327.26s-2.43-2.07-3.77-1.34.13,2.8,2,2.31S1070.88,327.26,1070.88,327.26Z"
              fill="#a04d90"
            />
            <path
              d="M1071.25,327.26a2.13,2.13,0,0,1,1.94-1.46c1.58-.12,2.19,2.55.61,2.55A3.65,3.65,0,0,1,1071.25,327.26Z"
              fill="#a04d90"
            />
            <path
              d="M1071.12,327s-2.91.85-1.09,1.83S1073.31,328.35,1071.12,327Z"
              fill="#a04d90"
            />
            <path
              d="M1074.68,327.7a.83.83,0,0,1-.88.65,3.65,3.65,0,0,1-2.55-1.09A6.87,6.87,0,0,0,1074.68,327.7Z"
              fill="#7f3374"
            />
            <path d="M1073.19,326.77a2,2,0,0,0-1.94.49" fill="#7f3374" />
            <path d="M1070.64,324.71a1.71,1.71,0,0,1,.61,2.3" fill="#7f3374" />
            <path d="M1068.57,324.58s2.43,1,2.55,2.43" fill="#7f3374" />
            <path d="M1070.88,327.26a3.2,3.2,0,0,0-2.55-.61" fill="#7f3374" />
            <path
              d="M1070.76,327.46a10.51,10.51,0,0,0-3.65-.45"
              fill="#7f3374"
            />
            <path
              d="M1066.85,327.46a9.3,9.3,0,0,0,3.79.11,4.58,4.58,0,0,1-1.58.66A2.07,2.07,0,0,1,1066.85,327.46Z"
              fill="#7f3374"
            />
            <path
              d="M1069.47,328.35a3.33,3.33,0,0,0,2.75.07c0,.68-1,1-2.19.42A1.21,1.21,0,0,1,1069.47,328.35Z"
              fill="#7f3374"
            />
            <path d="M1071.12,327.5a.71.71,0,0,1,.25.85" fill="#7f3374" />
            <path d="M1071.12,327.26s-.24,1.09-1,1.09" fill="#7f3374" />
            <ellipse
              cx="1071.06"
              cy="327.14"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1070.83,331.87s.72-1.15-.74-2.12C1070.09,329.75,1069.62,331.56,1070.83,331.87Z"
              fill="#396039"
            />
            <path
              d="M1071.37,330.17s-.37-.36,1.09-1C1072.46,329.2,1072.58,330.05,1071.37,330.17Z"
              fill="#396039"
            />
            <path
              d="M1070.09,329.75a7.9,7.9,0,0,1,.5,1,2.36,2.36,0,0,1,.17,1.11,1.71,1.71,0,0,0-.1-.54,4.6,4.6,0,0,0-.19-.52C1070.36,330.45,1070.2,330.11,1070.09,329.75Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1048.73,359.14c.06-.8.21-1.56.29-2.32a11.57,11.57,0,0,0,.13-1.15,3.44,3.44,0,0,0-.06-1.15,2.21,2.21,0,0,1,.34,1.15,6.73,6.73,0,0,1,0,1.19A7.84,7.84,0,0,1,1048.73,359.14Z"
              fill="#396039"
            />
            <path
              d="M1048.85,354.28c2.55-.73,1.46-3.89-1.82-3.41S1048.85,354.28,1048.85,354.28Z"
              fill="#a04d90"
            />
            <path
              d="M1048.85,354.28s-2.43-2.07-3.77-1.34.12,2.8,2,2.31S1048.85,354.28,1048.85,354.28Z"
              fill="#a04d90"
            />
            <path
              d="M1049.21,354.28a2.15,2.15,0,0,1,2-1.46c1.58-.12,2.19,2.55.61,2.55A3.69,3.69,0,0,1,1049.21,354.28Z"
              fill="#a04d90"
            />
            <path
              d="M1049.09,354s-2.91.85-1.09,1.83S1051.28,355.37,1049.09,354Z"
              fill="#a04d90"
            />
            <path
              d="M1052.65,354.72a.84.84,0,0,1-.88.65,3.69,3.69,0,0,1-2.56-1.09A6.91,6.91,0,0,0,1052.65,354.72Z"
              fill="#7f3374"
            />
            <path d="M1051.16,353.79a2,2,0,0,0-2,.49" fill="#7f3374" />
            <path d="M1048.61,351.73a1.71,1.71,0,0,1,.6,2.3" fill="#7f3374" />
            <path d="M1046.54,351.6s2.43,1,2.55,2.43" fill="#7f3374" />
            <path d="M1048.85,354.28a3.21,3.21,0,0,0-2.55-.61" fill="#7f3374" />
            <path
              d="M1048.73,354.48a10.51,10.51,0,0,0-3.65-.45"
              fill="#7f3374"
            />
            <path
              d="M1044.82,354.48a9.3,9.3,0,0,0,3.79.11,4.68,4.68,0,0,1-1.58.66A2.07,2.07,0,0,1,1044.82,354.48Z"
              fill="#7f3374"
            />
            <path
              d="M1047.44,355.37a3.34,3.34,0,0,0,2.75.07c0,.68-1,1-2.19.42A1.21,1.21,0,0,1,1047.44,355.37Z"
              fill="#7f3374"
            />
            <path d="M1049.09,354.52a.71.71,0,0,1,.25.85" fill="#7f3374" />
            <path d="M1049.09,354.28s-.24,1.09-1,1.09" fill="#7f3374" />
            <ellipse
              cx="1049.03"
              cy="354.16"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1048.8,358.89s.72-1.15-.74-2.12C1048.06,356.77,1047.59,358.58,1048.8,358.89Z"
              fill="#396039"
            />
            <path
              d="M1049.34,357.19s-.37-.36,1.09-1C1050.43,356.22,1050.55,357.07,1049.34,357.19Z"
              fill="#396039"
            />
            <path
              d="M1048.06,356.77a6.71,6.71,0,0,1,.49,1,2.25,2.25,0,0,1,.18,1.11,1.71,1.71,0,0,0-.1-.54,4.6,4.6,0,0,0-.19-.52C1048.33,357.47,1048.17,357.13,1048.06,356.77Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1040,367c.06-.8.21-1.56.29-2.33a11,11,0,0,0,.13-1.14,3.43,3.43,0,0,0-.06-1.15,2.21,2.21,0,0,1,.34,1.15,6.74,6.74,0,0,1,0,1.19A8.28,8.28,0,0,1,1040,367Z"
              fill="#396039"
            />
            <path
              d="M1040.12,362.18c2.55-.73,1.46-3.89-1.82-3.41S1040.12,362.18,1040.12,362.18Z"
              fill="#a04d90"
            />
            <path
              d="M1040.12,362.18s-2.43-2.07-3.77-1.34.12,2.79,2,2.31S1040.12,362.18,1040.12,362.18Z"
              fill="#a04d90"
            />
            <path
              d="M1040.48,362.18a2.15,2.15,0,0,1,2-1.46c1.58-.12,2.19,2.55.61,2.55A3.69,3.69,0,0,1,1040.48,362.18Z"
              fill="#a04d90"
            />
            <path
              d="M1040.36,361.93s-2.91.85-1.09,1.83S1042.55,363.27,1040.36,361.93Z"
              fill="#a04d90"
            />
            <path
              d="M1043.92,362.62a.83.83,0,0,1-.88.65,3.69,3.69,0,0,1-2.56-1.09A6.91,6.91,0,0,0,1043.92,362.62Z"
              fill="#7f3374"
            />
            <path d="M1042.43,361.69a2,2,0,0,0-2,.49" fill="#7f3374" />
            <path d="M1039.88,359.62a1.71,1.71,0,0,1,.6,2.31" fill="#7f3374" />
            <path d="M1037.81,359.5s2.43,1,2.55,2.43" fill="#7f3374" />
            <path d="M1040.12,362.18a3.17,3.17,0,0,0-2.55-.61" fill="#7f3374" />
            <path d="M1040,362.38a10.51,10.51,0,0,0-3.65-.45" fill="#7f3374" />
            <path
              d="M1036.09,362.38a9.3,9.3,0,0,0,3.79.11,4.68,4.68,0,0,1-1.58.66A2.07,2.07,0,0,1,1036.09,362.38Z"
              fill="#7f3374"
            />
            <path
              d="M1038.71,363.27a3.34,3.34,0,0,0,2.75.07c0,.68-1,1-2.19.42A1.21,1.21,0,0,1,1038.71,363.27Z"
              fill="#7f3374"
            />
            <path d="M1040.36,362.42a.71.71,0,0,1,.25.85" fill="#7f3374" />
            <path d="M1040.36,362.18s-.24,1.09-1,1.09" fill="#7f3374" />
            <ellipse
              cx="1040.3"
              cy="362.05"
              rx="0.67"
              ry="0.36"
              fill="#b7b720"
            />
            <path
              d="M1040.07,366.79s.72-1.15-.74-2.12C1039.33,364.67,1038.86,366.48,1040.07,366.79Z"
              fill="#396039"
            />
            <path
              d="M1040.61,365.09s-.37-.36,1.09-1C1041.7,364.12,1041.82,365,1040.61,365.09Z"
              fill="#396039"
            />
            <path
              d="M1039.33,364.67a7.3,7.3,0,0,1,.5,1,2.36,2.36,0,0,1,.17,1.11,1.66,1.66,0,0,0-.1-.54,5.62,5.62,0,0,0-.19-.53C1039.6,365.37,1039.44,365,1039.33,364.67Z"
              fill="#204220"
            />
          </g>
          <path
            d="M1155.25,402.75h0c4.5,12.3,2,18.95-6.72,18.95s-35.34,5.82-47.81-2.08-62-23.27-64.86-53.62c-2.54,29.71,43.21,53,59,60.89,17.17,8.59,64.88,2.86,69.65-8.59C1166.92,412.56,1164.27,407.3,1155.25,402.75Z"
            fill="#35280f"
          />
          <g>
            <path
              d="M1094.18,421.49a14.26,14.26,0,0,1-1.2-4.14,11.33,11.33,0,0,1-.08-2.18,4,4,0,0,1,.61-2.09,7.06,7.06,0,0,0-.1,2.1c.06.69.13,1.39.23,2.08C1093.82,418.66,1094.05,420.05,1094.18,421.49Z"
              fill="#396039"
            />
            <path
              d="M1094,412.64c-4.65-1.33-2.66-7.08,3.32-6.2S1094,412.64,1094,412.64Z"
              fill="#4d4d9e"
            />
            <path
              d="M1094,412.64s4.42-3.76,6.86-2.43-.22,5.09-3.54,4.2S1094,412.64,1094,412.64Z"
              fill="#4d4d9e"
            />
            <path
              d="M1093.29,412.64a3.9,3.9,0,0,0-3.54-2.66c-2.87-.22-4,4.65-1.1,4.65A6.64,6.64,0,0,0,1093.29,412.64Z"
              fill="#4d4d9e"
            />
            <path
              d="M1093.51,412.2s5.32,1.55,2,3.32S1089.53,414.63,1093.51,412.2Z"
              fill="#4d4d9e"
            />
            <path
              d="M1087,413.45a1.53,1.53,0,0,0,1.62,1.18,6.64,6.64,0,0,0,4.64-2C1092,413.21,1088.56,413.93,1087,413.45Z"
              fill="#36367a"
            />
            <path d="M1089.75,411.75a3.64,3.64,0,0,1,3.54.89" fill="#36367a" />
            <path d="M1094.4,408s-2.66,1.77-1.11,4.21" fill="#36367a" />
            <path d="M1098.16,407.77s-4.42,1.77-4.65,4.43" fill="#36367a" />
            <path d="M1094,412.64a5.81,5.81,0,0,1,4.64-1.11" fill="#36367a" />
            <path d="M1094.17,413s4.21-1.26,6.65-.81" fill="#36367a" />
            <path
              d="M1101.3,413c-.06,0-4.48,1-6.9.2a8.11,8.11,0,0,0,2.88,1.2A3.75,3.75,0,0,0,1101.3,413Z"
              fill="#36367a"
            />
            <path
              d="M1096.52,414.63c-2.72,1.06-4.43.43-5,.13.07,1.23,1.9,1.87,4,.76A2.16,2.16,0,0,0,1096.52,414.63Z"
              fill="#36367a"
            />
            <path d="M1093.51,413.08a1.31,1.31,0,0,0-.44,1.55" fill="#36367a" />
            <path d="M1093.51,412.64s.45,2,1.78,2" fill="#36367a" />
            <ellipse
              cx="1093.63"
              cy="412.42"
              rx="1.22"
              ry="0.66"
              fill="#b7b720"
            />
            <path
              d="M1094.06,421s-1.32-2.09,1.34-3.86C1095.4,417.18,1096.26,420.47,1094.06,421Z"
              fill="#396039"
            />
            <path
              d="M1093.07,418s.67-.66-2-1.77C1091.08,416.18,1090.86,417.73,1093.07,418Z"
              fill="#396039"
            />
            <path
              d="M1095.4,417.18c-.21.65-.47,1.28-.7,1.92q-.18.48-.33,1a3.05,3.05,0,0,0-.19,1,2.24,2.24,0,0,1,0-1,10.31,10.31,0,0,1,.29-1A10.59,10.59,0,0,1,1095.4,417.18Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1079.63,413.59a14.17,14.17,0,0,1-1.2-4.14,11.31,11.31,0,0,1-.08-2.18,4,4,0,0,1,.62-2.09,6.77,6.77,0,0,0-.11,2.1c.06.69.13,1.39.23,2.08C1079.27,410.76,1079.51,412.15,1079.63,413.59Z"
              fill="#396039"
            />
            <path
              d="M1079.41,404.74c-4.65-1.33-2.66-7.08,3.32-6.19S1079.41,404.74,1079.41,404.74Z"
              fill="#4d4d9e"
            />
            <path
              d="M1079.41,404.74s4.42-3.76,6.86-2.43-.22,5.09-3.54,4.2S1079.41,404.74,1079.41,404.74Z"
              fill="#4d4d9e"
            />
            <path
              d="M1078.74,404.74a3.89,3.89,0,0,0-3.54-2.65c-2.87-.23-4,4.64-1.1,4.64A6.64,6.64,0,0,0,1078.74,404.74Z"
              fill="#4d4d9e"
            />
            <path
              d="M1079,404.3s5.31,1.55,2,3.32S1075,406.73,1079,404.3Z"
              fill="#4d4d9e"
            />
            <path
              d="M1072.48,405.55a1.53,1.53,0,0,0,1.62,1.18,6.64,6.64,0,0,0,4.64-2C1077.42,405.31,1074,406,1072.48,405.55Z"
              fill="#36367a"
            />
            <path d="M1075.2,403.86a3.62,3.62,0,0,1,3.54.88" fill="#36367a" />
            <path d="M1079.85,400.09s-2.65,1.77-1.11,4.21" fill="#36367a" />
            <path d="M1083.61,399.87s-4.42,1.77-4.64,4.43" fill="#36367a" />
            <path d="M1079.41,404.74a5.8,5.8,0,0,1,4.65-1.1" fill="#36367a" />
            <path d="M1079.62,405.11s4.21-1.25,6.65-.81" fill="#36367a" />
            <path
              d="M1086.75,405.11c-.06,0-4.48,1-6.9.21a8.16,8.16,0,0,0,2.88,1.19A3.75,3.75,0,0,0,1086.75,405.11Z"
              fill="#36367a"
            />
            <path
              d="M1082,406.73c-2.72,1.07-4.43.43-5,.13.07,1.23,1.9,1.87,4,.76A2.16,2.16,0,0,0,1082,406.73Z"
              fill="#36367a"
            />
            <path d="M1079,405.18a1.31,1.31,0,0,0-.45,1.55" fill="#36367a" />
            <path d="M1079,404.74s.44,2,1.77,2" fill="#36367a" />
            <ellipse
              cx="1079.08"
              cy="404.52"
              rx="1.22"
              ry="0.66"
              fill="#b7b720"
            />
            <path
              d="M1079.51,413.14s-1.32-2.09,1.34-3.86C1080.85,409.28,1081.71,412.57,1079.51,413.14Z"
              fill="#396039"
            />
            <path
              d="M1078.52,410.05s.67-.66-2-1.77C1076.53,408.28,1076.31,409.83,1078.52,410.05Z"
              fill="#396039"
            />
            <path
              d="M1080.85,409.28c-.21.65-.47,1.28-.7,1.92q-.18.48-.33,1a3.05,3.05,0,0,0-.19,1,2.24,2.24,0,0,1,0-1,8.1,8.1,0,0,1,.3-1A9.88,9.88,0,0,1,1080.85,409.28Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1052.45,344.59a9.24,9.24,0,0,1-.56-1.52,10.32,10.32,0,0,1-.34-1.58,8.75,8.75,0,0,1-.06-1.62,3,3,0,0,1,.46-1.56,5.12,5.12,0,0,0-.08,1.56c.05.52.1,1,.18,1.56C1052.18,342.47,1052.35,343.51,1052.45,344.59Z"
              fill="#396039"
            />
            <path
              d="M1052.28,338c-3.47-1-2-5.29,2.48-4.63S1052.28,338,1052.28,338Z"
              fill="#4d4d9e"
            />
            <path
              d="M1052.28,338s3.31-2.81,5.13-1.81-.17,3.8-2.65,3.14S1052.28,338,1052.28,338Z"
              fill="#4d4d9e"
            />
            <path
              d="M1051.79,338a2.92,2.92,0,0,0-2.65-2c-2.15-.17-3,3.47-.83,3.47A5,5,0,0,0,1051.79,338Z"
              fill="#4d4d9e"
            />
            <path
              d="M1052,337.64s4,1.16,1.49,2.48S1049,339.46,1052,337.64Z"
              fill="#4d4d9e"
            />
            <path
              d="M1047.11,338.58a1.14,1.14,0,0,0,1.2.88,5,5,0,0,0,3.48-1.49A9.4,9.4,0,0,1,1047.11,338.58Z"
              fill="#36367a"
            />
            <path d="M1049.14,337.31a2.74,2.74,0,0,1,2.65.66" fill="#36367a" />
            <path d="M1052.61,334.5s-2,1.32-.82,3.14" fill="#36367a" />
            <path d="M1055.42,334.34s-3.3,1.32-3.47,3.3" fill="#36367a" />
            <path d="M1052.28,338a4.36,4.36,0,0,1,3.48-.82" fill="#36367a" />
            <path d="M1052.44,338.25a14.27,14.27,0,0,1,5-.61" fill="#36367a" />
            <path
              d="M1057.77,338.25s-3.35.74-5.16.15a6.26,6.26,0,0,0,2.15.9A2.82,2.82,0,0,0,1057.77,338.25Z"
              fill="#36367a"
            />
            <path
              d="M1054.2,339.46a4.49,4.49,0,0,1-3.74.1c.06.92,1.42,1.4,3,.56A1.6,1.6,0,0,0,1054.2,339.46Z"
              fill="#36367a"
            />
            <path d="M1052,338.31a1,1,0,0,0-.33,1.15" fill="#36367a" />
            <path d="M1052,338s.33,1.49,1.32,1.49" fill="#36367a" />
            <ellipse
              cx="1052.03"
              cy="337.81"
              rx="0.91"
              ry="0.5"
              fill="#b7b720"
            />
            <path
              d="M1052.36,344.25s-1-1.56,1-2.89C1053.36,341.36,1054,343.83,1052.36,344.25Z"
              fill="#396039"
            />
            <path
              d="M1051.62,341.94s.5-.49-1.49-1.32C1050.13,340.62,1050,341.78,1051.62,341.94Z"
              fill="#396039"
            />
            <path
              d="M1053.36,341.36c-.16.5-.37,1-.52,1.44-.09.24-.19.47-.26.72a2.61,2.61,0,0,0-.13.74,1.55,1.55,0,0,1,0-.77c.06-.25.14-.5.21-.74A10.51,10.51,0,0,1,1053.36,341.36Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1065.75,356.64a8.81,8.81,0,0,1-.56-1.51,12.32,12.32,0,0,1-.33-1.58,8.06,8.06,0,0,1-.07-1.63,3.05,3.05,0,0,1,.46-1.56,5.12,5.12,0,0,0-.07,1.56c0,.52.09,1,.17,1.56C1065.48,354.53,1065.66,355.57,1065.75,356.64Z"
              fill="#396039"
            />
            <path
              d="M1065.59,350c-3.48-1-2-5.29,2.48-4.63S1065.59,350,1065.59,350Z"
              fill="#4d4d9e"
            />
            <path
              d="M1065.59,350s3.3-2.81,5.12-1.82-.16,3.8-2.64,3.14S1065.59,350,1065.59,350Z"
              fill="#4d4d9e"
            />
            <path
              d="M1065.09,350a2.91,2.91,0,0,0-2.65-2c-2.15-.17-3,3.47-.82,3.47A5,5,0,0,0,1065.09,350Z"
              fill="#4d4d9e"
            />
            <path
              d="M1065.25,349.7s4,1.16,1.49,2.48S1062.28,351.52,1065.25,349.7Z"
              fill="#4d4d9e"
            />
            <path
              d="M1060.41,350.63a1.14,1.14,0,0,0,1.21.89,5,5,0,0,0,3.47-1.49C1064.1,350.45,1061.55,351,1060.41,350.63Z"
              fill="#36367a"
            />
            <path d="M1062.44,349.37a2.71,2.71,0,0,1,2.65.66" fill="#36367a" />
            <path d="M1065.92,346.56s-2,1.32-.83,3.14" fill="#36367a" />
            <path d="M1068.73,346.39s-3.31,1.32-3.48,3.31" fill="#36367a" />
            <path d="M1065.59,350a4.36,4.36,0,0,1,3.47-.83" fill="#36367a" />
            <path d="M1065.75,350.31a14.2,14.2,0,0,1,5-.61" fill="#36367a" />
            <path
              d="M1071.07,350.31s-3.35.74-5.15.15a5.93,5.93,0,0,0,2.15.89A2.79,2.79,0,0,0,1071.07,350.31Z"
              fill="#36367a"
            />
            <path
              d="M1067.5,351.52a4.47,4.47,0,0,1-3.74.09c.06.92,1.42,1.4,3,.57A1.65,1.65,0,0,0,1067.5,351.52Z"
              fill="#36367a"
            />
            <path d="M1065.25,350.36a1,1,0,0,0-.33,1.16" fill="#36367a" />
            <path d="M1065.25,350s.34,1.49,1.33,1.49" fill="#36367a" />
            <ellipse
              cx="1065.34"
              cy="349.86"
              rx="0.91"
              ry="0.5"
              fill="#b7b720"
            />
            <path
              d="M1065.66,356.3s-1-1.56,1-2.88C1066.66,353.42,1067.3,355.88,1065.66,356.3Z"
              fill="#396039"
            />
            <path
              d="M1064.92,354s.5-.5-1.48-1.32C1063.44,352.68,1063.27,353.83,1064.92,354Z"
              fill="#396039"
            />
            <path
              d="M1066.66,353.42c-.15.49-.37.95-.52,1.44-.09.23-.18.47-.26.71a2.74,2.74,0,0,0-.13.74,1.44,1.44,0,0,1,0-.77,6.84,6.84,0,0,1,.21-.74A8.79,8.79,0,0,1,1066.66,353.42Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1047.46,383.25a9.24,9.24,0,0,1-.56-1.52,10.3,10.3,0,0,1-.33-1.58,8,8,0,0,1-.07-1.62A3.09,3.09,0,0,1,1047,377a5.19,5.19,0,0,0-.07,1.57c0,.52.09,1,.17,1.56C1047.19,381.13,1047.37,382.17,1047.46,383.25Z"
              fill="#396039"
            />
            <path
              d="M1047.29,376.63c-3.47-1-2-5.29,2.48-4.63S1047.29,376.63,1047.29,376.63Z"
              fill="#4d4d9e"
            />
            <path
              d="M1047.29,376.63s3.31-2.81,5.13-1.81-.16,3.8-2.65,3.14S1047.29,376.63,1047.29,376.63Z"
              fill="#4d4d9e"
            />
            <path
              d="M1046.8,376.63a2.92,2.92,0,0,0-2.65-2c-2.15-.17-3,3.47-.82,3.47A5,5,0,0,0,1046.8,376.63Z"
              fill="#4d4d9e"
            />
            <path
              d="M1047,376.3s4,1.16,1.49,2.48S1044,378.12,1047,376.3Z"
              fill="#4d4d9e"
            />
            <path
              d="M1042.12,377.24a1.14,1.14,0,0,0,1.21.88,5,5,0,0,0,3.47-1.49A9.4,9.4,0,0,1,1042.12,377.24Z"
              fill="#36367a"
            />
            <path d="M1044.15,376a2.74,2.74,0,0,1,2.65.66" fill="#36367a" />
            <path d="M1047.63,373.16s-2,1.32-.83,3.14" fill="#36367a" />
            <path d="M1050.44,373s-3.31,1.32-3.48,3.3" fill="#36367a" />
            <path d="M1047.29,376.63a4.36,4.36,0,0,1,3.48-.82" fill="#36367a" />
            <path d="M1047.46,376.91a14.2,14.2,0,0,1,5-.61" fill="#36367a" />
            <path
              d="M1052.78,376.91s-3.35.74-5.15.15a6.08,6.08,0,0,0,2.14.9A2.82,2.82,0,0,0,1052.78,376.91Z"
              fill="#36367a"
            />
            <path
              d="M1049.21,378.12a4.49,4.49,0,0,1-3.74.1c.06.92,1.42,1.4,3,.56A1.6,1.6,0,0,0,1049.21,378.12Z"
              fill="#36367a"
            />
            <path d="M1047,377a1,1,0,0,0-.33,1.16" fill="#36367a" />
            <path d="M1047,376.63s.33,1.49,1.33,1.49" fill="#36367a" />
            <ellipse
              cx="1047.05"
              cy="376.47"
              rx="0.91"
              ry="0.5"
              fill="#b7b720"
            />
            <path
              d="M1047.37,382.91s-1-1.56,1-2.89C1048.37,380,1049,382.49,1047.37,382.91Z"
              fill="#396039"
            />
            <path
              d="M1046.63,380.6s.5-.49-1.49-1.32C1045.14,379.28,1045,380.44,1046.63,380.6Z"
              fill="#396039"
            />
            <path
              d="M1048.37,380c-.15.49-.37,1-.52,1.44-.09.24-.18.47-.26.72a2.61,2.61,0,0,0-.13.74,1.44,1.44,0,0,1,0-.77,6.25,6.25,0,0,1,.21-.74A8.89,8.89,0,0,1,1048.37,380Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1129.63,413.59c.09-1.07.27-2.11.4-3.16.08-.52.13-1,.17-1.56a4.82,4.82,0,0,0-.08-1.56,3,3,0,0,1,.46,1.56,7.4,7.4,0,0,1-.06,1.63,12.32,12.32,0,0,1-.33,1.58A8.81,8.81,0,0,1,1129.63,413.59Z"
              fill="#396039"
            />
            <path
              d="M1129.79,407c3.48-1,2-5.29-2.48-4.63S1129.79,407,1129.79,407Z"
              fill="#4d4d9e"
            />
            <path
              d="M1129.79,407s-3.3-2.81-5.12-1.82.16,3.8,2.64,3.14S1129.79,407,1129.79,407Z"
              fill="#4d4d9e"
            />
            <path
              d="M1130.29,407a2.91,2.91,0,0,1,2.65-2c2.14-.17,3,3.47.82,3.47A5,5,0,0,1,1130.29,407Z"
              fill="#4d4d9e"
            />
            <path
              d="M1130.12,406.65s-4,1.16-1.48,2.48S1133.1,408.47,1130.12,406.65Z"
              fill="#4d4d9e"
            />
            <path
              d="M1135,407.58a1.15,1.15,0,0,1-1.21.89,5,5,0,0,1-3.47-1.49C1131.28,407.4,1133.83,408,1135,407.58Z"
              fill="#36367a"
            />
            <path d="M1132.94,406.32a2.71,2.71,0,0,0-2.65.66" fill="#36367a" />
            <path d="M1129.46,403.51s2,1.32.83,3.14" fill="#36367a" />
            <path d="M1126.65,403.34s3.31,1.32,3.47,3.31" fill="#36367a" />
            <path d="M1129.79,407a4.36,4.36,0,0,0-3.47-.83" fill="#36367a" />
            <path d="M1129.63,407.26a14.2,14.2,0,0,0-5-.61" fill="#36367a" />
            <path
              d="M1124.31,407.26s3.34.74,5.15.15a5.93,5.93,0,0,1-2.15.89A2.79,2.79,0,0,1,1124.31,407.26Z"
              fill="#36367a"
            />
            <path
              d="M1127.88,408.47a4.48,4.48,0,0,0,3.74.09c-.06.92-1.42,1.4-3,.57A1.6,1.6,0,0,1,1127.88,408.47Z"
              fill="#36367a"
            />
            <path d="M1130.12,407.31a1,1,0,0,1,.33,1.16" fill="#36367a" />
            <path d="M1130.12,407s-.33,1.49-1.32,1.49" fill="#36367a" />
            <ellipse
              cx="1130.04"
              cy="406.81"
              rx="0.91"
              ry="0.5"
              fill="#b7b720"
            />
            <path
              d="M1129.72,413.25s1-1.56-1-2.88C1128.72,410.37,1128.07,412.83,1129.72,413.25Z"
              fill="#396039"
            />
            <path
              d="M1130.45,411s-.49-.5,1.49-1.32C1131.94,409.63,1132.11,410.78,1130.45,411Z"
              fill="#396039"
            />
            <path
              d="M1128.72,410.37a8.79,8.79,0,0,1,.67,1.38,6.84,6.84,0,0,1,.21.74,1.55,1.55,0,0,1,0,.77,2.74,2.74,0,0,0-.13-.74c-.08-.24-.17-.48-.26-.71C1129.09,411.32,1128.87,410.86,1128.72,410.37Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1151.51,416.92c.13-1.52.38-3,.57-4.47.11-.73.18-1.47.24-2.2a7.15,7.15,0,0,0-.11-2.21,4.17,4.17,0,0,1,.65,2.21,10.93,10.93,0,0,1-.09,2.29A15.18,15.18,0,0,1,1151.51,416.92Z"
              fill="#396039"
            />
            <path
              d="M1151.74,407.57c4.91-1.4,2.81-7.48-3.5-6.54S1151.74,407.57,1151.74,407.57Z"
              fill="#4d4d9e"
            />
            <path
              d="M1151.74,407.57s-4.67-4-7.24-2.57.23,5.37,3.74,4.44S1151.74,407.57,1151.74,407.57Z"
              fill="#4d4d9e"
            />
            <path
              d="M1152.44,407.57a4.12,4.12,0,0,1,3.74-2.8c3-.24,4.21,4.9,1.17,4.9A7,7,0,0,1,1152.44,407.57Z"
              fill="#4d4d9e"
            />
            <path
              d="M1152.21,407.1s-5.61,1.64-2.1,3.51S1156.42,409.67,1152.21,407.1Z"
              fill="#4d4d9e"
            />
            <path
              d="M1159.06,408.42a1.62,1.62,0,0,1-1.71,1.25,7,7,0,0,1-4.91-2.1C1153.84,408.17,1157.44,408.94,1159.06,408.42Z"
              fill="#36367a"
            />
            <path d="M1156.18,406.64a3.82,3.82,0,0,0-3.74.93" fill="#36367a" />
            <path d="M1151.28,402.66s2.8,1.87,1.16,4.44" fill="#36367a" />
            <path d="M1147.3,402.43s4.68,1.87,4.91,4.67" fill="#36367a" />
            <path
              d="M1151.74,407.57a6.14,6.14,0,0,0-4.91-1.17"
              fill="#36367a"
            />
            <path d="M1151.51,408s-4.44-1.32-7-.86" fill="#36367a" />
            <path
              d="M1144,408c.06,0,4.73,1.05,7.28.22a8.67,8.67,0,0,1-3,1.26A4,4,0,0,1,1144,408Z"
              fill="#36367a"
            />
            <path
              d="M1149,409.67c2.88,1.13,4.68.45,5.29.14-.08,1.3-2,2-4.21.8A2.3,2.3,0,0,1,1149,409.67Z"
              fill="#36367a"
            />
            <path d="M1152.21,408a1.36,1.36,0,0,1,.47,1.63" fill="#36367a" />
            <path d="M1152.21,407.57s-.47,2.1-1.87,2.1" fill="#36367a" />
            <ellipse
              cx="1152.09"
              cy="407.34"
              rx="1.29"
              ry="0.7"
              fill="#b7b720"
            />
            <path
              d="M1151.64,416.44s1.39-2.21-1.42-4.08C1150.22,412.36,1149.31,415.84,1151.64,416.44Z"
              fill="#396039"
            />
            <path
              d="M1152.68,413.18s-.7-.7,2.1-1.87C1154.78,411.31,1155,413,1152.68,413.18Z"
              fill="#396039"
            />
            <path
              d="M1150.22,412.36a11,11,0,0,1,1,1.95,9.65,9.65,0,0,1,.3,1.05,2.37,2.37,0,0,1,0,1.09,3.1,3.1,0,0,0-.2-1c-.11-.34-.22-.68-.35-1C1150.72,413.72,1150.44,413.05,1150.22,412.36Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1108.27,424.82c.12-1.44.35-2.84.54-4.23.1-.7.17-1.39.22-2.09a6.7,6.7,0,0,0-.1-2.09,4.05,4.05,0,0,1,.62,2.09,10.59,10.59,0,0,1-.09,2.18A13.94,13.94,0,0,1,1108.27,424.82Z"
              fill="#396039"
            />
            <path
              d="M1108.49,416c4.65-1.33,2.65-7.09-3.32-6.2S1108.49,416,1108.49,416Z"
              fill="#a04d90"
            />
            <path
              d="M1108.49,416s-4.43-3.77-6.86-2.44.22,5.09,3.54,4.21S1108.49,416,1108.49,416Z"
              fill="#a04d90"
            />
            <path
              d="M1109.15,416a3.91,3.91,0,0,1,3.54-2.66c2.88-.22,4,4.65,1.11,4.65A6.65,6.65,0,0,1,1109.15,416Z"
              fill="#a04d90"
            />
            <path
              d="M1108.93,415.52s-5.31,1.55-2,3.32S1112.91,418,1108.93,415.52Z"
              fill="#a04d90"
            />
            <path
              d="M1115.41,416.77a1.52,1.52,0,0,1-1.61,1.19,6.65,6.65,0,0,1-4.65-2C1110.47,416.53,1113.89,417.26,1115.41,416.77Z"
              fill="#7f3374"
            />
            <path d="M1112.69,415.08a3.64,3.64,0,0,0-3.54.89" fill="#7f3374" />
            <path d="M1108.05,411.32s2.65,1.77,1.1,4.2" fill="#7f3374" />
            <path d="M1104.28,411.1s4.43,1.77,4.65,4.42" fill="#7f3374" />
            <path d="M1108.49,416a5.84,5.84,0,0,0-4.65-1.11" fill="#7f3374" />
            <path d="M1108.27,416.34s-4.21-1.26-6.64-.82" fill="#7f3374" />
            <path
              d="M1101.15,416.34s4.48,1,6.89.2a8.32,8.32,0,0,1-2.87,1.2A3.74,3.74,0,0,1,1101.15,416.34Z"
              fill="#7f3374"
            />
            <path
              d="M1105.92,418c2.73,1.06,4.43.42,5,.13-.08,1.23-1.9,1.87-4,.75A2.19,2.19,0,0,1,1105.92,418Z"
              fill="#7f3374"
            />
            <path d="M1108.93,416.41a1.29,1.29,0,0,1,.44,1.55" fill="#7f3374" />
            <path d="M1108.93,416s-.44,2-1.77,2" fill="#7f3374" />
            <ellipse
              cx="1108.82"
              cy="415.74"
              rx="1.22"
              ry="0.66"
              fill="#b7b720"
            />
            <path
              d="M1108.39,424.36s1.31-2.09-1.34-3.86C1107.05,420.5,1106.19,423.8,1108.39,424.36Z"
              fill="#396039"
            />
            <path
              d="M1109.37,421.28s-.66-.67,2-1.77C1111.36,419.51,1111.59,421.06,1109.37,421.28Z"
              fill="#396039"
            />
            <path
              d="M1107.05,420.5a10.54,10.54,0,0,1,.9,1.85,8.62,8.62,0,0,1,.29,1,2.12,2.12,0,0,1,0,1,3.28,3.28,0,0,0-.19-1,9.9,9.9,0,0,0-.34-1C1107.52,421.79,1107.26,421.16,1107.05,420.5Z"
              fill="#204220"
            />
          </g>
          <path
            d="M1055.21,353.32c4.2-3.5-8.32,26.19,20,37.83s38.24,18.7,42.82,17c0,0-11.64,3.33-33.26-10.39s-24.11-7.48-29.1-16.21S1052.71,355.4,1055.21,353.32Z"
            fill="#35280f"
          />
          <path
            d="M1072.66,372.44c-1.66,4.16,3.33,9.15,7.9,10.81s14.14,9.14,15.8,10.81,7.9-1.25,10.39.83c0,0-12,3.74-15.79-.83s-17.46-7.9-20-11.23-4.15-12.47-2.91-17.87S1074.33,368.28,1072.66,372.44Z"
            fill="#35280f"
          />
          <path
            d="M1106.75,426.06c1.66-1.24,1.25-1.66,3.74-1.24"
            fill="#493b1b"
          />
          <path
            d="M1093.45,422.32c1.66-2.08,4.57-.83,4.57-.83"
            fill="#493b1b"
          />
          <path
            d="M1077.65,414.43c1.67-2.08,4.58-.84,4.58-.84"
            fill="#493b1b"
          />
          <path d="M1064.35,405.7c1.66-2.08,4.57-.84,4.57-.84" fill="#493b1b" />
          <path
            d="M1056.45,398.63c1.67-2.08,4.58-.83,4.58-.83"
            fill="#493b1b"
          />
          <path d="M1049.39,392c1.66-2.08,4.57-.83,4.57-.83" fill="#493b1b" />
          <g>
            <path
              d="M1067.54,395.72c.13-1.52.38-3,.57-4.47.1-.73.18-1.47.24-2.2a7.15,7.15,0,0,0-.11-2.21,4.17,4.17,0,0,1,.65,2.21,10.93,10.93,0,0,1-.09,2.29A15.18,15.18,0,0,1,1067.54,395.72Z"
              fill="#396039"
            />
            <path
              d="M1067.77,386.37c4.91-1.4,2.81-7.48-3.5-6.54S1067.77,386.37,1067.77,386.37Z"
              fill="#4d4d9e"
            />
            <path
              d="M1067.77,386.37s-4.67-4-7.24-2.57.23,5.37,3.74,4.44S1067.77,386.37,1067.77,386.37Z"
              fill="#4d4d9e"
            />
            <path
              d="M1068.47,386.37a4.12,4.12,0,0,1,3.74-2.81c3-.23,4.21,4.91,1.17,4.91A7,7,0,0,1,1068.47,386.37Z"
              fill="#4d4d9e"
            />
            <path
              d="M1068.24,385.9s-5.61,1.64-2.1,3.51S1072.45,388.47,1068.24,385.9Z"
              fill="#4d4d9e"
            />
            <path
              d="M1075.08,387.22a1.6,1.6,0,0,1-1.7,1.25,7,7,0,0,1-4.91-2.1C1069.87,387,1073.47,387.74,1075.08,387.22Z"
              fill="#36367a"
            />
            <path d="M1072.21,385.43a3.84,3.84,0,0,0-3.74.94" fill="#36367a" />
            <path d="M1067.31,381.46s2.8,1.87,1.16,4.44" fill="#36367a" />
            <path d="M1063.33,381.23s4.68,1.87,4.91,4.67" fill="#36367a" />
            <path
              d="M1067.77,386.37a6.14,6.14,0,0,0-4.91-1.17"
              fill="#36367a"
            />
            <path d="M1067.54,386.76s-4.44-1.33-7-.86" fill="#36367a" />
            <path
              d="M1060,386.76c.06,0,4.73,1.05,7.28.22a8.87,8.87,0,0,1-3,1.26A4,4,0,0,1,1060,386.76Z"
              fill="#36367a"
            />
            <path
              d="M1065.06,388.47c2.88,1.13,4.68.45,5.29.14-.08,1.3-2,2-4.21.8A2.3,2.3,0,0,1,1065.06,388.47Z"
              fill="#36367a"
            />
            <path d="M1068.24,386.84a1.38,1.38,0,0,1,.47,1.63" fill="#36367a" />
            <path d="M1068.24,386.37s-.47,2.1-1.87,2.1" fill="#36367a" />
            <ellipse
              cx="1068.12"
              cy="386.14"
              rx="1.29"
              ry="0.7"
              fill="#b7b720"
            />
            <path
              d="M1067.67,395.24s1.39-2.21-1.42-4.08C1066.25,391.16,1065.34,394.64,1067.67,395.24Z"
              fill="#396039"
            />
            <path
              d="M1068.71,392s-.7-.7,2.1-1.87C1070.81,390.11,1071,391.75,1068.71,392Z"
              fill="#396039"
            />
            <path
              d="M1066.25,391.16a11,11,0,0,1,1,1.95,9.65,9.65,0,0,1,.3,1.05,2.37,2.37,0,0,1,0,1.09,3.1,3.1,0,0,0-.2-1c-.11-.34-.22-.68-.35-1C1066.75,392.52,1066.47,391.85,1066.25,391.16Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1089.88,399c.06-.71.19-1.39.27-2.09.06-.34.08-.68.11-1a3,3,0,0,0,0-1,1.94,1.94,0,0,1,.3,1,5.58,5.58,0,0,1,0,1.08A6.92,6.92,0,0,1,1089.88,399Z"
              fill="#396039"
            />
            <path
              d="M1090,394.67c2.3-.66,1.31-3.5-1.64-3.07S1090,394.67,1090,394.67Z"
              fill="#4d4d9e"
            />
            <path
              d="M1090,394.67s-2.19-1.86-3.39-1.21.11,2.52,1.75,2.08S1090,394.67,1090,394.67Z"
              fill="#4d4d9e"
            />
            <path
              d="M1090.32,394.67a1.92,1.92,0,0,1,1.75-1.31c1.42-.11,2,2.29.55,2.29A3.31,3.31,0,0,1,1090.32,394.67Z"
              fill="#4d4d9e"
            />
            <path
              d="M1090.21,394.45s-2.63.77-1,1.64S1092.18,395.65,1090.21,394.45Z"
              fill="#4d4d9e"
            />
            <path
              d="M1093.41,395.07a.74.74,0,0,1-.79.58,3.31,3.31,0,0,1-2.3-1A6.22,6.22,0,0,0,1093.41,395.07Z"
              fill="#36367a"
            />
            <path d="M1092.07,394.23a1.79,1.79,0,0,0-1.75.44" fill="#36367a" />
            <path d="M1089.77,392.37s1.32.88.55,2.08" fill="#36367a" />
            <path d="M1087.91,392.26s2.19.88,2.3,2.19" fill="#36367a" />
            <path d="M1090,394.67a2.86,2.86,0,0,0-2.3-.55" fill="#36367a" />
            <path d="M1089.88,394.85a9.39,9.39,0,0,0-3.28-.4" fill="#36367a" />
            <path
              d="M1086.36,394.85a8.47,8.47,0,0,0,3.41.1,3.89,3.89,0,0,1-1.42.59A1.85,1.85,0,0,1,1086.36,394.85Z"
              fill="#36367a"
            />
            <path
              d="M1088.72,395.65a3,3,0,0,0,2.48.07c0,.61-.94.92-2,.37A1.1,1.1,0,0,1,1088.72,395.65Z"
              fill="#36367a"
            />
            <path d="M1090.21,394.89a.64.64,0,0,1,.22.76" fill="#36367a" />
            <path d="M1090.21,394.67s-.22,1-.87,1" fill="#36367a" />
            <ellipse
              cx="1090.16"
              cy="394.56"
              rx="0.6"
              ry="0.33"
              fill="#b7b720"
            />
            <path
              d="M1089.94,398.82s.65-1-.66-1.91C1089.28,396.91,1088.85,398.54,1089.94,398.82Z"
              fill="#396039"
            />
            <path
              d="M1090.43,397.29s-.33-.32,1-.87C1091.41,396.42,1091.52,397.18,1090.43,397.29Z"
              fill="#396039"
            />
            <path
              d="M1089.28,396.91a6,6,0,0,1,.45.92,2,2,0,0,1,.15,1,1.37,1.37,0,0,0-.09-.49,3.06,3.06,0,0,0-.17-.48C1089.53,397.54,1089.38,397.24,1089.28,396.91Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1103.18,395.3c.06-.71.2-1.4.27-2.09a9,9,0,0,0,.11-1,3,3,0,0,0,0-1,2,2,0,0,1,.31,1,7.8,7.8,0,0,1,0,1.08A7.26,7.26,0,0,1,1103.18,395.3Z"
              fill="#396039"
            />
            <path
              d="M1103.29,390.93c2.3-.66,1.32-3.5-1.64-3.07S1103.29,390.93,1103.29,390.93Z"
              fill="#4d4d9e"
            />
            <path
              d="M1103.29,390.93s-2.18-1.86-3.39-1.21.11,2.52,1.75,2.08S1103.29,390.93,1103.29,390.93Z"
              fill="#4d4d9e"
            />
            <path
              d="M1103.62,390.93a1.93,1.93,0,0,1,1.75-1.32c1.43-.11,2,2.3.55,2.3A3.31,3.31,0,0,1,1103.62,390.93Z"
              fill="#4d4d9e"
            />
            <path
              d="M1103.51,390.71s-2.62.76-1,1.64S1105.48,391.91,1103.51,390.71Z"
              fill="#4d4d9e"
            />
            <path
              d="M1106.72,391.33a.76.76,0,0,1-.8.58,3.31,3.31,0,0,1-2.3-1A6.26,6.26,0,0,0,1106.72,391.33Z"
              fill="#36367a"
            />
            <path d="M1105.37,390.49a1.79,1.79,0,0,0-1.75.44" fill="#36367a" />
            <path d="M1103.08,388.63a1.54,1.54,0,0,1,.54,2.08" fill="#36367a" />
            <path d="M1101.22,388.52s2.18.88,2.29,2.19" fill="#36367a" />
            <path d="M1103.29,390.93a2.85,2.85,0,0,0-2.29-.55" fill="#36367a" />
            <path d="M1103.19,391.11a9.42,9.42,0,0,0-3.29-.4" fill="#36367a" />
            <path
              d="M1099.67,391.11a8.4,8.4,0,0,0,3.4.1,3.9,3.9,0,0,1-1.42.59A1.84,1.84,0,0,1,1099.67,391.11Z"
              fill="#36367a"
            />
            <path
              d="M1102,391.91a2.93,2.93,0,0,0,2.47.06c0,.61-.94.93-2,.38A1.06,1.06,0,0,1,1102,391.91Z"
              fill="#36367a"
            />
            <path d="M1103.51,391.15a.63.63,0,0,1,.22.76" fill="#36367a" />
            <path d="M1103.51,390.93s-.22,1-.87,1" fill="#36367a" />
            <ellipse
              cx="1103.46"
              cy="390.82"
              rx="0.6"
              ry="0.33"
              fill="#b7b720"
            />
            <path
              d="M1103.24,395.08s.66-1-.66-1.91C1102.58,393.17,1102.16,394.8,1103.24,395.08Z"
              fill="#396039"
            />
            <path
              d="M1103.73,393.55s-.33-.33,1-.87C1104.72,392.68,1104.83,393.44,1103.73,393.55Z"
              fill="#396039"
            />
            <path
              d="M1102.58,393.17a6.41,6.41,0,0,1,.45.91,1.93,1.93,0,0,1,.15,1,1.67,1.67,0,0,0-.08-.49c0-.16-.11-.31-.17-.47C1102.83,393.8,1102.68,393.49,1102.58,393.17Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1058.71,397c0-.72.19-1.4.26-2.1.06-.34.09-.68.12-1a3.27,3.27,0,0,0-.06-1,2,2,0,0,1,.31,1,6.63,6.63,0,0,1-.63,3.13Z"
              fill="#396039"
            />
            <path
              d="M1058.81,392.59c2.3-.66,1.32-3.5-1.64-3.06S1058.81,392.59,1058.81,392.59Z"
              fill="#4d4d9e"
            />
            <path
              d="M1058.81,392.59s-2.18-1.86-3.39-1.2.11,2.51,1.75,2.07S1058.81,392.59,1058.81,392.59Z"
              fill="#4d4d9e"
            />
            <path
              d="M1059.14,392.59a1.93,1.93,0,0,1,1.75-1.31c1.43-.11,2,2.29.55,2.29A3.31,3.31,0,0,1,1059.14,392.59Z"
              fill="#4d4d9e"
            />
            <path
              d="M1059,392.37s-2.62.77-1,1.64S1061,393.57,1059,392.37Z"
              fill="#4d4d9e"
            />
            <path
              d="M1062.24,393a.76.76,0,0,1-.8.58,3.31,3.31,0,0,1-2.3-1A6.26,6.26,0,0,0,1062.24,393Z"
              fill="#36367a"
            />
            <path d="M1060.89,392.15a1.79,1.79,0,0,0-1.75.44" fill="#36367a" />
            <path d="M1058.6,390.29a1.54,1.54,0,0,1,.54,2.08" fill="#36367a" />
            <path d="M1056.74,390.18s2.18.88,2.29,2.19" fill="#36367a" />
            <path d="M1058.81,392.59a2.85,2.85,0,0,0-2.29-.55" fill="#36367a" />
            <path d="M1058.71,392.77a9.42,9.42,0,0,0-3.29-.4" fill="#36367a" />
            <path
              d="M1055.19,392.77a8.43,8.43,0,0,0,3.41.1,3.88,3.88,0,0,1-1.43.59A1.82,1.82,0,0,1,1055.19,392.77Z"
              fill="#36367a"
            />
            <path
              d="M1057.55,393.57a3,3,0,0,0,2.47.07c0,.61-.94.92-2,.37A1.06,1.06,0,0,1,1057.55,393.57Z"
              fill="#36367a"
            />
            <path d="M1059,392.81a.64.64,0,0,1,.22.76" fill="#36367a" />
            <path d="M1059,392.59s-.22,1-.87,1" fill="#36367a" />
            <ellipse
              cx="1058.98"
              cy="392.48"
              rx="0.6"
              ry="0.33"
              fill="#b7b720"
            />
            <path
              d="M1058.77,396.74s.65-1-.67-1.91C1058.1,394.83,1057.68,396.46,1058.77,396.74Z"
              fill="#396039"
            />
            <path
              d="M1059.25,395.22s-.33-.33,1-.88C1060.24,394.34,1060.35,395.11,1059.25,395.22Z"
              fill="#396039"
            />
            <path
              d="M1058.1,394.83a6.52,6.52,0,0,1,.45.92,2,2,0,0,1,.16,1,2,2,0,0,0-.09-.49c0-.16-.11-.32-.17-.48C1058.35,395.46,1058.21,395.16,1058.1,394.83Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1117.54,391s-4.17,14,.5,19.32"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.21"
            />
            <path
              d="M1117.65,389.77c-3.63-1.81-7.52.78-7.26,3s3.63,5.57,3.63,5.57a44.75,44.75,0,0,0,2.46-3.89A15,15,0,0,0,1117.65,389.77Z"
              fill="#ba8419"
            />
            <path
              d="M1117.78,389.77s-2.94-1.55-2.38-2.07-.21.13.56-.52,4.8.78,4.54,1.94S1117.78,389.77,1117.78,389.77Z"
              fill="#ba8419"
            />
            <path
              d="M1117.91,390.42a3.19,3.19,0,0,1,3.63.91c1.43,1.82-1,3.37-1,3.37"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.13"
            />
            <path
              d="M1115.46,387.65l.22.73a12.64,12.64,0,0,0,2.1,1.39s2.47.52,2.72-.65a.62.62,0,0,0-.13-.51l-.45-.2a4.5,4.5,0,0,1-3.43-1.23l-.16-.14a.78.78,0,0,0-.37.14C1115.21,387.81,1115.91,387.22,1115.46,387.65Z"
              fill="#a06f18"
            />
            <path
              d="M1116.48,389.77s3.38,3,2.47,6.49c-.13.26,5.06-2.08,4.28-4.8S1116.48,389.77,1116.48,389.77Z"
              fill="#ba8419"
            />
            <path
              d="M1114,389.51c-2.84-.39-3.36.52-5.18,1.82,0,0,3.76-7.91,8.82-1.56Z"
              fill="#ba8419"
            />
            <path
              d="M1117.26,389.9l.28,1.05a6.34,6.34,0,0,1,1.41,5.31A4.54,4.54,0,0,0,1117.26,389.9Z"
              fill="#a06f18"
            />
            <path
              d="M1123.27,392.45s-1.54,2.64-3.65.63l-.58,1.17a4.92,4.92,0,0,1-.09,2C1118.83,396.49,1122.8,394.72,1123.27,392.45Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1114,389.51l3,.21.44-.14a5.82,5.82,0,0,0-3.8-1.23c-2.21.13-4.8,3-4.8,3C1110.65,390,1111.17,389.12,1114,389.51Z"
              fill="#a06f18"
            />
            <path
              d="M1117.65,389.77c-3.63-1.81-7.52.78-7.26,3s3.63,5.57,3.63,5.57a44.75,44.75,0,0,0,2.46-3.89A15,15,0,0,0,1117.65,389.77Z"
              fill="#ba8419"
            />
            <path d="M1115.84,389.9a3.39,3.39,0,0,0-3.38,2.86" fill="#a06f18" />
            <path
              d="M1116.48,390.42a3.41,3.41,0,0,0-2.33,3.37"
              fill="#a06f18"
            />
            <path
              d="M1110.67,393.75a18.12,18.12,0,0,0,3.35,4.58,44.75,44.75,0,0,0,2.46-3.89,2.29,2.29,0,0,0,.14-.27C1113.61,395.79,1111.69,394.76,1110.67,393.75Z"
              fill="#a06f18"
            />
            <path d="M1118.43,390.16s2.07,0,2.72,1.43" fill="#a06f18" />
            <path
              d="M1116.26,406.51s0-5.58,7-5.84"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.21"
            />
            <path
              d="M1121.54,397.17s-2.8,1.56-1.59,4.15A4.57,4.57,0,0,0,1121.54,397.17Z"
              fill="#396039"
            />
            <path
              d="M1116.49,405.12a3.16,3.16,0,0,1,3.11-2S1118.57,405.43,1116.49,405.12Z"
              fill="#396039"
            />
            <path
              d="M1122,400.78s1.5-3.61,5.13-2.45C1127.12,398.33,1125,401.41,1122,400.78Z"
              fill="#396039"
            />
            <path
              d="M1117.91,402.67s-1.56-.57-.65-2.78C1117.26,399.89,1118.69,401.29,1117.91,402.67Z"
              fill="#396039"
            />
            <path
              d="M1119.6,401.48a1.88,1.88,0,0,1,2.33,1.13A2.73,2.73,0,0,1,1119.6,401.48Z"
              fill="#396039"
            />
            <path
              d="M1115.84,403.59a11.82,11.82,0,0,0-4.29-4.74A5.74,5.74,0,0,0,1115.84,403.59Z"
              fill="#396039"
            />
            <path
              d="M1127.12,398.33l-.39-.1c-.81.81-2.7,2.55-4.26,2.62C1125.24,401.09,1127.12,398.33,1127.12,398.33Z"
              fill="#204220"
            />
            <path
              d="M1119.57,403.13a2.71,2.71,0,0,0-.49,0,4.16,4.16,0,0,1-2.41,2c1.83.15,2.8-1.74,2.91-2Z"
              fill="#204220"
            />
            <g>
              <path d="M1119.93,401.27l0,0,0,0Z" fill="#204220" />
              <path
                d="M1120,401.24c.17-.13.33-.25.47-.38a4.78,4.78,0,0,0,1.11-3.69l-.08.05C1121.27,398.21,1120.73,400.59,1120,401.24Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1119.62,401.47h0a1.17,1.17,0,0,0,.05.11,2.78,2.78,0,0,0,2.27,1,2.56,2.56,0,0,0-.39-.61A3.6,3.6,0,0,1,1119.62,401.47Z"
              fill="#204220"
            />
            <path
              d="M1111.55,398.85a5.73,5.73,0,0,0,4.19,4.71l.07,0v0c-2-.57-3.19-3-3.69-4.29C1111.93,399.09,1111.75,399,1111.55,398.85Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1095,387s-3.5,11.77.42,16.24"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.17"
            />
            <path
              d="M1095.05,386c-3.06-1.53-6.33.65-6.11,2.51s3,4.69,3,4.69,1.31-1.86,2.08-3.28A12.71,12.71,0,0,0,1095.05,386Z"
              fill="#ba8419"
            />
            <path
              d="M1095.16,386s-2.47-1.31-2-1.75-.19.11.47-.44,4,.66,3.82,1.64S1095.16,386,1095.16,386Z"
              fill="#ba8419"
            />
            <path
              d="M1095.27,386.51a2.69,2.69,0,0,1,3,.77c1.2,1.52-.87,2.83-.87,2.83"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.11"
            />
            <path
              d="M1093.2,384.18l.19.62a10.47,10.47,0,0,0,1.77,1.17s2.07.43,2.29-.55a.55.55,0,0,0-.12-.43l-.37-.17a3.78,3.78,0,0,1-2.89-1l-.13-.11a.63.63,0,0,0-.31.11C1093,384.31,1093.59,383.82,1093.2,384.18Z"
              fill="#a06f18"
            />
            <path
              d="M1094.07,386s2.83,2.51,2.07,5.45c-.11.22,4.25-1.74,3.6-4S1094.07,386,1094.07,386Z"
              fill="#ba8419"
            />
            <path
              d="M1092,385.74c-2.4-.32-2.83.44-4.36,1.54,0,0,3.16-6.66,7.42-1.31Z"
              fill="#ba8419"
            />
            <path
              d="M1094.72,386.08l.23.88a5.31,5.31,0,0,1,1.19,4.46A3.81,3.81,0,0,0,1094.72,386.08Z"
              fill="#a06f18"
            />
            <path
              d="M1099.77,388.22s-1.29,2.22-3.06.53l-.49,1a4.23,4.23,0,0,1-.08,1.69C1096,391.61,1099.38,390.13,1099.77,388.22Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1092,385.74l2.5.19.37-.13a4.9,4.9,0,0,0-3.19-1c-1.86.11-4,2.51-4,2.51C1089.16,386.18,1089.59,385.42,1092,385.74Z"
              fill="#a06f18"
            />
            <path
              d="M1095.05,386c-3.06-1.53-6.33.65-6.11,2.51s3,4.69,3,4.69,1.31-1.86,2.08-3.28A12.71,12.71,0,0,0,1095.05,386Z"
              fill="#ba8419"
            />
            <path d="M1093.52,386.08a2.85,2.85,0,0,0-2.84,2.4" fill="#a06f18" />
            <path d="M1094.07,386.51a2.88,2.88,0,0,0-2,2.84" fill="#a06f18" />
            <path
              d="M1089.17,389.31a15.64,15.64,0,0,0,2.82,3.86s1.31-1.86,2.08-3.28c0-.07.07-.15.11-.23C1091.65,391,1090,390.16,1089.17,389.31Z"
              fill="#a06f18"
            />
            <path d="M1095.7,386.29s1.75,0,2.29,1.2" fill="#a06f18" />
            <path
              d="M1093.88,400s0-4.69,5.86-4.91"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.17"
            />
            <path
              d="M1098.32,392.18s-2.35,1.32-1.34,3.5A3.86,3.86,0,0,0,1098.32,392.18Z"
              fill="#396039"
            />
            <path
              d="M1094.07,398.88a2.66,2.66,0,0,1,2.61-1.68S1095.82,399.13,1094.07,398.88Z"
              fill="#396039"
            />
            <path
              d="M1098.69,395.22s1.27-3,4.32-2.05C1103,393.17,1101.25,395.75,1098.69,395.22Z"
              fill="#396039"
            />
            <path
              d="M1095.27,396.81s-1.31-.48-.55-2.34C1094.72,394.47,1095.92,395.65,1095.27,396.81Z"
              fill="#396039"
            />
            <path
              d="M1096.68,395.81a1.59,1.59,0,0,1,2,1A2.33,2.33,0,0,1,1096.68,395.81Z"
              fill="#396039"
            />
            <path
              d="M1093.52,397.58a9.92,9.92,0,0,0-3.6-4A4.81,4.81,0,0,0,1093.52,397.58Z"
              fill="#396039"
            />
            <path
              d="M1103,393.17a2,2,0,0,0-.33-.09c-.68.68-2.27,2.14-3.58,2.2C1101.43,395.48,1103,393.17,1103,393.17Z"
              fill="#204220"
            />
            <path
              d="M1096.66,397.2a1.89,1.89,0,0,0-.41,0,3.5,3.5,0,0,1-2,1.7,2.74,2.74,0,0,0,2.45-1.67Z"
              fill="#204220"
            />
            <g>
              <path d="M1097,395.63l0,0,0,0Z" fill="#204220" />
              <path
                d="M1097,395.61l.4-.32a4.06,4.06,0,0,0,.93-3.11l-.07.05C1098.09,393.06,1097.63,395.06,1097,395.61Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1096.71,395.8h0l0,.1a2.37,2.37,0,0,0,1.91.87,2.33,2.33,0,0,0-.33-.52A2.9,2.9,0,0,1,1096.71,395.8Z"
              fill="#204220"
            />
            <path
              d="M1089.92,393.6a4.82,4.82,0,0,0,3.52,4l.06,0v0c-1.7-.48-2.68-2.5-3.1-3.61C1090.24,393.8,1090.08,393.7,1089.92,393.6Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1078.64,377s3.51,11.77-.42,16.24"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.17"
            />
            <path
              d="M1078.55,376c3-1.53,6.33.65,6.11,2.51s-3.06,4.69-3.06,4.69-1.31-1.86-2.07-3.27A12.81,12.81,0,0,1,1078.55,376Z"
              fill="#ba8419"
            />
            <path
              d="M1078.44,376s2.47-1.31,2-1.75.18.11-.47-.43-4,.65-3.82,1.63S1078.44,376,1078.44,376Z"
              fill="#ba8419"
            />
            <path
              d="M1078.33,376.54a2.67,2.67,0,0,0-3,.76c-1.2,1.53.87,2.83.87,2.83"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.11"
            />
            <path
              d="M1080.4,374.2l-.19.62a10.9,10.9,0,0,1-1.77,1.17s-2.07.44-2.29-.55a.54.54,0,0,1,.11-.43l.38-.17a3.8,3.8,0,0,0,2.89-1l.13-.12a.67.67,0,0,1,.31.12C1080.6,374.34,1080,373.84,1080.4,374.2Z"
              fill="#a06f18"
            />
            <path
              d="M1079.53,376s-2.84,2.51-2.07,5.45c.11.22-4.26-1.74-3.6-4S1079.53,376,1079.53,376Z"
              fill="#ba8419"
            />
            <path
              d="M1081.61,375.77c2.39-.33,2.83.44,4.36,1.53,0,0-3.17-6.66-7.42-1.31Z"
              fill="#ba8419"
            />
            <path
              d="M1078.88,376.1l-.24.88a5.35,5.35,0,0,0-1.18,4.46A3.8,3.8,0,0,1,1078.88,376.1Z"
              fill="#a06f18"
            />
            <path
              d="M1073.83,378.24s1.29,2.22,3.06.53l.49,1a4.19,4.19,0,0,0,.08,1.68C1077.55,381.64,1074.22,380.15,1073.83,378.24Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1081.61,375.77l-2.5.18-.38-.12a4.92,4.92,0,0,1,3.2-1c1.86.11,4,2.51,4,2.51C1084.44,376.21,1084,375.44,1081.61,375.77Z"
              fill="#a06f18"
            />
            <path
              d="M1078.55,376c3-1.53,6.33.65,6.11,2.51s-3.06,4.69-3.06,4.69-1.31-1.86-2.07-3.27A12.81,12.81,0,0,1,1078.55,376Z"
              fill="#ba8419"
            />
            <path d="M1080.08,376.1a2.83,2.83,0,0,1,2.83,2.4" fill="#a06f18" />
            <path d="M1079.53,376.54a2.85,2.85,0,0,1,2,2.83" fill="#a06f18" />
            <path
              d="M1084.42,379.33a15.43,15.43,0,0,1-2.82,3.86s-1.31-1.86-2.07-3.27a2.4,2.4,0,0,1-.11-.23C1081.94,381.05,1083.56,380.19,1084.42,379.33Z"
              fill="#a06f18"
            />
            <path d="M1077.89,376.32s-1.74,0-2.29,1.2" fill="#a06f18" />
            <path
              d="M1079.72,390.06s0-4.69-5.86-4.91"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.17"
            />
            <path
              d="M1075.28,382.21s2.35,1.31,1.34,3.49A3.84,3.84,0,0,1,1075.28,382.21Z"
              fill="#396039"
            />
            <path
              d="M1079.53,388.9a2.66,2.66,0,0,0-2.62-1.67S1077.78,389.15,1079.53,388.9Z"
              fill="#396039"
            />
            <path
              d="M1074.9,385.25s-1.26-3-4.31-2.06C1070.59,383.19,1072.35,385.77,1074.9,385.25Z"
              fill="#396039"
            />
            <path
              d="M1078.33,386.83s1.31-.48.55-2.33C1078.88,384.5,1077.68,385.67,1078.33,386.83Z"
              fill="#396039"
            />
            <path
              d="M1076.91,385.83a1.58,1.58,0,0,0-2,1A2.28,2.28,0,0,0,1076.91,385.83Z"
              fill="#396039"
            />
            <path
              d="M1080.08,387.61a9.86,9.86,0,0,1,3.6-4A4.83,4.83,0,0,1,1080.08,387.61Z"
              fill="#396039"
            />
            <path
              d="M1070.59,383.19l.32-.09c.68.68,2.28,2.15,3.59,2.2C1072.16,385.5,1070.59,383.19,1070.59,383.19Z"
              fill="#204220"
            />
            <path
              d="M1076.93,387.22h.42a3.48,3.48,0,0,0,2,1.71,2.79,2.79,0,0,1-2.46-1.67Z"
              fill="#204220"
            />
            <g>
              <path d="M1076.64,385.66l0,0,0,0Z" fill="#204220" />
              <path
                d="M1076.61,385.63l-.4-.31a4,4,0,0,1-.93-3.11l.07,0C1075.51,383.08,1076,385.08,1076.61,385.63Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1076.89,385.82h0l0,.09a2.37,2.37,0,0,1-1.91.87,2,2,0,0,1,.33-.51A3,3,0,0,0,1076.89,385.82Z"
              fill="#204220"
            />
            <path
              d="M1083.68,383.63a4.82,4.82,0,0,1-3.52,3.95l-.06,0v0c1.7-.48,2.68-2.5,3.1-3.61C1083.36,383.83,1083.52,383.72,1083.68,383.63Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1066.23,395.21s2.09,7-.25,9.65"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1066.18,394.62c1.81-.91,3.76.39,3.63,1.49s-1.82,2.79-1.82,2.79-.78-1.11-1.23-1.95A7.59,7.59,0,0,1,1066.18,394.62Z"
              fill="#ba8419"
            />
            <path
              d="M1066.11,394.62s1.47-.78,1.19-1,.11.06-.28-.26-2.4.39-2.27,1S1066.11,394.62,1066.11,394.62Z"
              fill="#ba8419"
            />
            <path
              d="M1066.05,394.94a1.62,1.62,0,0,0-1.82.45c-.71.91.52,1.69.52,1.69"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.06"
            />
            <path
              d="M1067.27,393.55l-.11.37a5.94,5.94,0,0,1-1.05.7s-1.23.26-1.36-.33a.34.34,0,0,1,.07-.26l.22-.09a2.26,2.26,0,0,0,1.72-.62l.07-.07a.33.33,0,0,1,.19.07C1067.4,393.63,1067,393.34,1067.27,393.55Z"
              fill="#a06f18"
            />
            <path
              d="M1066.76,394.62s-1.69,1.49-1.23,3.24c.06.13-2.53-1-2.14-2.4S1066.76,394.62,1066.76,394.62Z"
              fill="#ba8419"
            />
            <path
              d="M1068,394.48c1.42-.19,1.68.27,2.59.91,0,0-1.88-3.95-4.41-.77Z"
              fill="#ba8419"
            />
            <path
              d="M1066.37,394.68l-.14.53a3.15,3.15,0,0,0-.7,2.65A2.26,2.26,0,0,1,1066.37,394.68Z"
              fill="#a06f18"
            />
            <path
              d="M1063.37,396s.77,1.33,1.82.32l.29.59a2.45,2.45,0,0,0,0,1C1065.58,398,1063.6,397.09,1063.37,396Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1068,394.48l-1.49.11-.22-.07a2.92,2.92,0,0,1,1.9-.62,4.88,4.88,0,0,1,2.4,1.49C1069.68,394.75,1069.42,394.29,1068,394.48Z"
              fill="#a06f18"
            />
            <path
              d="M1066.18,394.62c1.81-.91,3.76.39,3.63,1.49s-1.82,2.79-1.82,2.79-.78-1.11-1.23-1.95A7.59,7.59,0,0,1,1066.18,394.62Z"
              fill="#ba8419"
            />
            <path d="M1067.08,394.68a1.7,1.7,0,0,1,1.69,1.43" fill="#a06f18" />
            <path
              d="M1066.76,394.94a1.71,1.71,0,0,1,1.17,1.69"
              fill="#a06f18"
            />
            <path
              d="M1069.67,396.6a9.16,9.16,0,0,1-1.68,2.3s-.78-1.11-1.23-1.95l-.07-.13A2.32,2.32,0,0,0,1069.67,396.6Z"
              fill="#a06f18"
            />
            <path d="M1065.79,394.81s-1,0-1.37.71" fill="#a06f18" />
            <path
              d="M1066.87,403s0-2.79-3.48-2.92"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1064.23,398.31a1.67,1.67,0,0,1,.8,2.08A2.29,2.29,0,0,1,1064.23,398.31Z"
              fill="#396039"
            />
            <path
              d="M1066.76,402.29a1.58,1.58,0,0,0-1.56-1S1065.72,402.44,1066.76,402.29Z"
              fill="#396039"
            />
            <path
              d="M1064,400.12a2.09,2.09,0,0,0-2.57-1.22A2.8,2.8,0,0,0,1064,400.12Z"
              fill="#396039"
            />
            <path
              d="M1066.05,401.06s.77-.28.32-1.38C1066.37,399.68,1065.66,400.38,1066.05,401.06Z"
              fill="#396039"
            />
            <path
              d="M1065.2,400.47a.93.93,0,0,0-1.16.57A1.35,1.35,0,0,0,1065.2,400.47Z"
              fill="#396039"
            />
            <path
              d="M1067.08,401.52a5.86,5.86,0,0,1,2.14-2.36A2.85,2.85,0,0,1,1067.08,401.52Z"
              fill="#396039"
            />
            <path
              d="M1061.44,398.9l.2-.06a4.08,4.08,0,0,0,2.13,1.31A2.9,2.9,0,0,1,1061.44,398.9Z"
              fill="#204220"
            />
            <path
              d="M1065.22,401.3h.24a2.09,2.09,0,0,0,1.21,1,1.65,1.65,0,0,1-1.46-1Z"
              fill="#204220"
            />
            <g>
              <path d="M1065,400.36h0Z" fill="#204220" />
              <path
                d="M1065,400.35l-.23-.19a2.35,2.35,0,0,1-.56-1.85l0,0A4.88,4.88,0,0,0,1065,400.35Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1065.19,400.46h0l0,0a1.41,1.41,0,0,1-1.13.52,1,1,0,0,1,.19-.31A1.79,1.79,0,0,0,1065.19,400.46Z"
              fill="#204220"
            />
            <path
              d="M1069.22,399.16a2.84,2.84,0,0,1-2.09,2.35h0a3.42,3.42,0,0,0,1.85-2.15Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1130.66,418.07s2.09,7-.25,9.66"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1130.61,417.48c1.81-.91,3.76.39,3.63,1.49s-1.82,2.79-1.82,2.79-.77-1.1-1.23-1.95A7.59,7.59,0,0,1,1130.61,417.48Z"
              fill="#ba8419"
            />
            <path
              d="M1130.54,417.48s1.47-.78,1.19-1,.11.07-.28-.26-2.4.39-2.27,1S1130.54,417.48,1130.54,417.48Z"
              fill="#ba8419"
            />
            <path
              d="M1130.48,417.8a1.61,1.61,0,0,0-1.82.46c-.71.91.52,1.68.52,1.68"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.06"
            />
            <path
              d="M1131.71,416.42l-.11.36a6.27,6.27,0,0,1-1.06.7s-1.23.26-1.36-.32a.32.32,0,0,1,.07-.26l.22-.1a2.25,2.25,0,0,0,1.72-.62l.08-.07a.42.42,0,0,1,.18.07C1131.83,416.5,1131.48,416.2,1131.71,416.42Z"
              fill="#a06f18"
            />
            <path
              d="M1131.19,417.48s-1.68,1.49-1.23,3.24c.06.13-2.53-1-2.14-2.4S1131.19,417.48,1131.19,417.48Z"
              fill="#ba8419"
            />
            <path
              d="M1132.43,417.35c1.42-.19,1.68.26,2.59.91,0,0-1.88-4-4.41-.78Z"
              fill="#ba8419"
            />
            <path
              d="M1130.8,417.54l-.14.53a3.15,3.15,0,0,0-.7,2.65A2.27,2.27,0,0,1,1130.8,417.54Z"
              fill="#a06f18"
            />
            <path
              d="M1127.8,418.82s.77,1.32,1.82.31l.29.59a2.44,2.44,0,0,0,0,1C1130,420.84,1128,420,1127.8,418.82Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1132.43,417.35l-1.49.11-.22-.08a2.91,2.91,0,0,1,1.9-.61c1.1.06,2.4,1.49,2.4,1.49C1134.11,417.61,1133.85,417.16,1132.43,417.35Z"
              fill="#a06f18"
            />
            <path
              d="M1130.61,417.48c1.81-.91,3.76.39,3.63,1.49s-1.82,2.79-1.82,2.79-.77-1.1-1.23-1.95A7.59,7.59,0,0,1,1130.61,417.48Z"
              fill="#ba8419"
            />
            <path
              d="M1131.52,417.54a1.69,1.69,0,0,1,1.68,1.43"
              fill="#a06f18"
            />
            <path d="M1131.19,417.8a1.71,1.71,0,0,1,1.17,1.69" fill="#a06f18" />
            <path
              d="M1134.1,419.47a9,9,0,0,1-1.68,2.29s-.77-1.1-1.23-1.95l-.07-.13A2.32,2.32,0,0,0,1134.1,419.47Z"
              fill="#a06f18"
            />
            <path d="M1130.22,417.67s-1,0-1.36.72" fill="#a06f18" />
            <path
              d="M1131.3,425.85s0-2.79-3.48-2.92"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1128.66,421.18s1.4.78.8,2.07A2.28,2.28,0,0,1,1128.66,421.18Z"
              fill="#396039"
            />
            <path
              d="M1131.19,425.16a1.58,1.58,0,0,0-1.55-1S1130.15,425.31,1131.19,425.16Z"
              fill="#396039"
            />
            <path
              d="M1128.44,423a2.1,2.1,0,0,0-2.57-1.22A2.78,2.78,0,0,0,1128.44,423Z"
              fill="#396039"
            />
            <path
              d="M1130.48,423.93s.78-.29.32-1.39C1130.8,422.54,1130.09,423.24,1130.48,423.93Z"
              fill="#396039"
            />
            <path
              d="M1129.64,423.33a1,1,0,0,0-1.17.57A1.37,1.37,0,0,0,1129.64,423.33Z"
              fill="#396039"
            />
            <path
              d="M1131.52,424.39a5.92,5.92,0,0,1,2.14-2.37A2.87,2.87,0,0,1,1131.52,424.39Z"
              fill="#396039"
            />
            <path
              d="M1125.87,421.76l.2-.05a4.21,4.21,0,0,0,2.13,1.31A2.9,2.9,0,0,1,1125.87,421.76Z"
              fill="#204220"
            />
            <path
              d="M1129.65,424.16h.25a2,2,0,0,0,1.2,1,1.63,1.63,0,0,1-1.46-1Z"
              fill="#204220"
            />
            <g>
              <path d="M1129.47,423.23l0,0,0,0Z" fill="#204220" />
              <path
                d="M1129.45,423.21a2.11,2.11,0,0,1-.23-.19,2.38,2.38,0,0,1-.56-1.84l0,0A4.78,4.78,0,0,0,1129.45,423.21Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1129.62,423.33h0l0,.06a1.38,1.38,0,0,1-1.13.51,1.41,1.41,0,0,1,.19-.3A1.79,1.79,0,0,0,1129.62,423.33Z"
              fill="#204220"
            />
            <path
              d="M1133.66,422a2.86,2.86,0,0,1-2.1,2.35h0a3.4,3.4,0,0,0,1.85-2.15Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1145.63,416s2.08,7-.25,9.66"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1145.57,415.4c1.82-.91,3.77.39,3.64,1.49s-1.82,2.79-1.82,2.79a22.81,22.81,0,0,1-1.23-1.94A7.51,7.51,0,0,1,1145.57,415.4Z"
              fill="#ba8419"
            />
            <path
              d="M1145.51,415.4s1.47-.78,1.19-1,.11.07-.28-.26-2.4.39-2.27,1S1145.51,415.4,1145.51,415.4Z"
              fill="#ba8419"
            />
            <path
              d="M1145.44,415.73a1.58,1.58,0,0,0-1.81.45c-.72.91.52,1.69.52,1.69"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.06"
            />
            <path
              d="M1146.67,414.34l-.11.36a6.34,6.34,0,0,1-1,.7s-1.23.26-1.36-.32a.31.31,0,0,1,.06-.26l.23-.1a2.23,2.23,0,0,0,1.71-.62l.08-.07a.69.69,0,0,1,.19.07C1146.79,414.42,1146.44,414.12,1146.67,414.34Z"
              fill="#a06f18"
            />
            <path
              d="M1146.16,415.4s-1.69,1.49-1.24,3.24c.07.13-2.52-1-2.14-2.4S1146.16,415.4,1146.16,415.4Z"
              fill="#ba8419"
            />
            <path
              d="M1147.39,415.27c1.43-.19,1.69.26,2.59.91,0,0-1.88-4-4.41-.78Z"
              fill="#ba8419"
            />
            <path
              d="M1145.77,415.47l-.14.52a3.16,3.16,0,0,0-.71,2.65A2.26,2.26,0,0,1,1145.77,415.47Z"
              fill="#a06f18"
            />
            <path
              d="M1142.77,416.74s.76,1.32,1.82.32l.29.58a2.43,2.43,0,0,0,0,1C1145,418.76,1143,417.88,1142.77,416.74Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1147.39,415.27l-1.49.11-.22-.08a2.91,2.91,0,0,1,1.9-.61c1.11.06,2.4,1.49,2.4,1.49C1149.08,415.53,1148.82,415.08,1147.39,415.27Z"
              fill="#a06f18"
            />
            <path
              d="M1145.57,415.4c1.82-.91,3.77.39,3.64,1.49s-1.82,2.79-1.82,2.79a22.81,22.81,0,0,1-1.23-1.94A7.51,7.51,0,0,1,1145.57,415.4Z"
              fill="#ba8419"
            />
            <path
              d="M1146.48,415.47a1.69,1.69,0,0,1,1.69,1.42"
              fill="#a06f18"
            />
            <path
              d="M1146.16,415.73a1.69,1.69,0,0,1,1.16,1.68"
              fill="#a06f18"
            />
            <path
              d="M1149.07,417.39a9.29,9.29,0,0,1-1.68,2.29,22.81,22.81,0,0,1-1.23-1.94.91.91,0,0,1-.07-.14A2.32,2.32,0,0,0,1149.07,417.39Z"
              fill="#a06f18"
            />
            <path d="M1145.18,415.6s-1,0-1.36.71" fill="#a06f18" />
            <path
              d="M1146.27,423.77s0-2.79-3.49-2.92"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1143.63,419.1s1.4.78.79,2.07A2.27,2.27,0,0,1,1143.63,419.1Z"
              fill="#396039"
            />
            <path
              d="M1146.15,423.08a1.58,1.58,0,0,0-1.55-1S1145.12,423.23,1146.15,423.08Z"
              fill="#396039"
            />
            <path
              d="M1143.41,420.9a2.11,2.11,0,0,0-2.57-1.22A2.78,2.78,0,0,0,1143.41,420.9Z"
              fill="#396039"
            />
            <path
              d="M1145.44,421.85s.78-.29.33-1.39C1145.77,420.46,1145.05,421.16,1145.44,421.85Z"
              fill="#396039"
            />
            <path
              d="M1144.6,421.25a1,1,0,0,0-1.17.57A1.36,1.36,0,0,0,1144.6,421.25Z"
              fill="#396039"
            />
            <path
              d="M1146.48,422.31a5.92,5.92,0,0,1,2.14-2.37A2.87,2.87,0,0,1,1146.48,422.31Z"
              fill="#396039"
            />
            <path
              d="M1140.84,419.68l.19-.05a4.28,4.28,0,0,0,2.14,1.31A2.9,2.9,0,0,1,1140.84,419.68Z"
              fill="#204220"
            />
            <path
              d="M1144.61,422.08h.25a2.07,2.07,0,0,0,1.21,1,1.62,1.62,0,0,1-1.46-1Z"
              fill="#204220"
            />
            <g>
              <path d="M1144.44,421.15l0,0,0,0Z" fill="#204220" />
              <path
                d="M1144.42,421.13l-.24-.18a2.41,2.41,0,0,1-.55-1.85l0,0A4.65,4.65,0,0,0,1144.42,421.13Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1144.59,421.25h0a.14.14,0,0,1,0,.06.9.9,0,1,1-.94.21A1.79,1.79,0,0,0,1144.59,421.25Z"
              fill="#204220"
            />
            <path
              d="M1148.62,419.94a2.86,2.86,0,0,1-2.09,2.35h0c1-.29,1.59-1.49,1.85-2.15Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1075.79,353.22s2.09,7-.25,9.66"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1075.74,352.63c1.81-.91,3.76.39,3.63,1.49s-1.82,2.79-1.82,2.79a22.81,22.81,0,0,1-1.23-1.94A7.69,7.69,0,0,1,1075.74,352.63Z"
              fill="#ba8419"
            />
            <path
              d="M1075.67,352.63s1.47-.78,1.19-1,.11.07-.28-.26-2.4.39-2.27,1S1075.67,352.63,1075.67,352.63Z"
              fill="#ba8419"
            />
            <path
              d="M1075.61,353a1.6,1.6,0,0,0-1.82.45c-.71.91.52,1.69.52,1.69"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.06"
            />
            <path
              d="M1076.83,351.57l-.11.36a5.94,5.94,0,0,1-1,.7s-1.23.26-1.36-.32a.32.32,0,0,1,.07-.26l.22-.1a2.25,2.25,0,0,0,1.72-.62l.08-.07a.61.61,0,0,1,.18.07C1077,351.65,1076.61,351.36,1076.83,351.57Z"
              fill="#a06f18"
            />
            <path
              d="M1076.32,352.63s-1.69,1.49-1.23,3.24c.06.13-2.53-1-2.14-2.4S1076.32,352.63,1076.32,352.63Z"
              fill="#ba8419"
            />
            <path
              d="M1077.56,352.5c1.42-.19,1.68.26,2.59.91,0,0-1.88-4-4.41-.78Z"
              fill="#ba8419"
            />
            <path
              d="M1075.93,352.7l-.14.52a3.15,3.15,0,0,0-.7,2.65A2.26,2.26,0,0,1,1075.93,352.7Z"
              fill="#a06f18"
            />
            <path
              d="M1072.93,354s.77,1.32,1.82.32l.29.58a2.43,2.43,0,0,0,0,1C1075.15,356,1073.16,355.11,1072.93,354Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1077.56,352.5l-1.49.11-.22-.08a2.88,2.88,0,0,1,1.9-.61c1.1.06,2.4,1.49,2.4,1.49C1079.24,352.76,1079,352.31,1077.56,352.5Z"
              fill="#a06f18"
            />
            <path
              d="M1075.74,352.63c1.81-.91,3.76.39,3.63,1.49s-1.82,2.79-1.82,2.79a22.81,22.81,0,0,1-1.23-1.94A7.69,7.69,0,0,1,1075.74,352.63Z"
              fill="#ba8419"
            />
            <path d="M1076.64,352.7a1.68,1.68,0,0,1,1.69,1.42" fill="#a06f18" />
            <path d="M1076.32,353a1.7,1.7,0,0,1,1.17,1.68" fill="#a06f18" />
            <path
              d="M1079.23,354.62a9,9,0,0,1-1.68,2.29,22.81,22.81,0,0,1-1.23-1.94l-.07-.14A2.32,2.32,0,0,0,1079.23,354.62Z"
              fill="#a06f18"
            />
            <path d="M1075.35,352.83s-1,0-1.36.71" fill="#a06f18" />
            <path
              d="M1076.43,361s0-2.79-3.48-2.92"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1073.79,356.33s1.4.78.8,2.07A2.26,2.26,0,0,1,1073.79,356.33Z"
              fill="#396039"
            />
            <path
              d="M1076.32,360.31a1.58,1.58,0,0,0-1.56-1S1075.28,360.46,1076.32,360.31Z"
              fill="#396039"
            />
            <path
              d="M1073.57,358.13a2.1,2.1,0,0,0-2.57-1.22A2.78,2.78,0,0,0,1073.57,358.13Z"
              fill="#396039"
            />
            <path
              d="M1075.61,359.08s.78-.29.32-1.39C1075.93,357.69,1075.22,358.39,1075.61,359.08Z"
              fill="#396039"
            />
            <path
              d="M1074.76,358.48a.94.94,0,0,0-1.16.57A1.35,1.35,0,0,0,1074.76,358.48Z"
              fill="#396039"
            />
            <path
              d="M1076.64,359.54a5.9,5.9,0,0,1,2.15-2.37A2.87,2.87,0,0,1,1076.64,359.54Z"
              fill="#396039"
            />
            <path
              d="M1071,356.91l.2-.05a4.14,4.14,0,0,0,2.13,1.31A2.9,2.9,0,0,1,1071,356.91Z"
              fill="#204220"
            />
            <path
              d="M1074.78,359.31h.24a2.14,2.14,0,0,0,1.21,1,1.64,1.64,0,0,1-1.46-1Z"
              fill="#204220"
            />
            <g>
              <path d="M1074.6,358.38l0,0,0,0Z" fill="#204220" />
              <path
                d="M1074.58,358.36l-.23-.18a2.4,2.4,0,0,1-.56-1.85l0,0A4.78,4.78,0,0,0,1074.58,358.36Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1074.75,358.48h0l0,.06a1.38,1.38,0,0,1-1.13.51,1.1,1.1,0,0,1,.19-.3A1.79,1.79,0,0,0,1074.75,358.48Z"
              fill="#204220"
            />
            <path
              d="M1078.79,357.17a2.86,2.86,0,0,1-2.1,2.35h0a3.42,3.42,0,0,0,1.85-2.15Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1051.27,381.49s2.08,7-.25,9.66"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1051.21,380.9c1.82-.91,3.76.39,3.63,1.49s-1.81,2.79-1.81,2.79-.78-1.1-1.24-1.95A7.59,7.59,0,0,1,1051.21,380.9Z"
              fill="#ba8419"
            />
            <path
              d="M1051.15,380.9s1.47-.78,1.18-1,.11.07-.28-.26-2.4.39-2.27,1S1051.15,380.9,1051.15,380.9Z"
              fill="#ba8419"
            />
            <path
              d="M1051.08,381.22a1.59,1.59,0,0,0-1.81.46c-.72.9.51,1.68.51,1.68"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.06"
            />
            <path
              d="M1052.31,379.84l-.11.36a6.34,6.34,0,0,1-1,.7s-1.24.26-1.37-.33a.35.35,0,0,1,.07-.25l.23-.1a2.23,2.23,0,0,0,1.71-.62l.08-.07a.38.38,0,0,1,.18.07C1052.43,379.91,1052.08,379.62,1052.31,379.84Z"
              fill="#a06f18"
            />
            <path
              d="M1051.79,380.9s-1.68,1.49-1.23,3.24c.07.13-2.53-1-2.14-2.4S1051.79,380.9,1051.79,380.9Z"
              fill="#ba8419"
            />
            <path
              d="M1053,380.77c1.42-.2,1.68.26,2.59.91,0,0-1.88-4-4.41-.78Z"
              fill="#ba8419"
            />
            <path
              d="M1051.41,381l-.14.53a3.16,3.16,0,0,0-.71,2.65A2.27,2.27,0,0,1,1051.41,381Z"
              fill="#a06f18"
            />
            <path
              d="M1048.4,382.24s.77,1.32,1.82.31l.3.59a2.43,2.43,0,0,0,0,1C1050.62,384.26,1048.63,383.37,1048.4,382.24Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1053,380.77l-1.49.1-.22-.07a2.91,2.91,0,0,1,1.9-.61c1.1.06,2.4,1.49,2.4,1.49C1054.71,381,1054.45,380.57,1053,380.77Z"
              fill="#a06f18"
            />
            <path
              d="M1051.21,380.9c1.82-.91,3.76.39,3.63,1.49s-1.81,2.79-1.81,2.79-.78-1.1-1.24-1.95A7.59,7.59,0,0,1,1051.21,380.9Z"
              fill="#ba8419"
            />
            <path d="M1052.12,381a1.7,1.7,0,0,1,1.69,1.43" fill="#a06f18" />
            <path
              d="M1051.79,381.22a1.71,1.71,0,0,1,1.17,1.69"
              fill="#a06f18"
            />
            <path
              d="M1054.7,382.89a9.09,9.09,0,0,1-1.67,2.29s-.78-1.1-1.24-1.95l-.06-.13A2.32,2.32,0,0,0,1054.7,382.89Z"
              fill="#a06f18"
            />
            <path d="M1050.82,381.09s-1,0-1.36.72" fill="#a06f18" />
            <path
              d="M1051.91,389.27s0-2.79-3.49-2.92"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.1"
            />
            <path
              d="M1049.27,384.6a1.66,1.66,0,0,1,.79,2.07A2.29,2.29,0,0,1,1049.27,384.6Z"
              fill="#396039"
            />
            <path
              d="M1051.79,388.57a1.58,1.58,0,0,0-1.55-1S1050.75,388.73,1051.79,388.57Z"
              fill="#396039"
            />
            <path
              d="M1049,386.4a2.09,2.09,0,0,0-2.56-1.22A2.76,2.76,0,0,0,1049,386.4Z"
              fill="#396039"
            />
            <path
              d="M1051.08,387.35s.78-.29.33-1.39C1051.41,386,1050.69,386.66,1051.08,387.35Z"
              fill="#396039"
            />
            <path
              d="M1050.24,386.75a1,1,0,0,0-1.17.57A1.37,1.37,0,0,0,1050.24,386.75Z"
              fill="#396039"
            />
            <path
              d="M1052.12,387.81a5.92,5.92,0,0,1,2.14-2.37A2.87,2.87,0,0,1,1052.12,387.81Z"
              fill="#396039"
            />
            <path
              d="M1046.48,385.18l.19-.05a4.21,4.21,0,0,0,2.13,1.31A2.9,2.9,0,0,1,1046.48,385.18Z"
              fill="#204220"
            />
            <path
              d="M1050.25,387.58h.25a2,2,0,0,0,1.2,1c-.91.08-1.4-.87-1.46-1Z"
              fill="#204220"
            />
            <g>
              <path d="M1050.07,386.65v0h0Z" fill="#204220" />
              <path
                d="M1050.06,386.63a1.55,1.55,0,0,1-.24-.19,2.38,2.38,0,0,1-.55-1.84l0,0A4.52,4.52,0,0,0,1050.06,386.63Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1050.22,386.75h0l0,.05a1.4,1.4,0,0,1-1.14.52,1,1,0,0,1,.2-.31A1.75,1.75,0,0,0,1050.22,386.75Z"
              fill="#204220"
            />
            <path
              d="M1054.26,385.44a2.86,2.86,0,0,1-2.09,2.35h0c1-.29,1.59-1.49,1.84-2.15Z"
              fill="#204220"
            />
          </g>
          <g>
            <path
              d="M1063.26,361.6s3.51,11.77-.42,16.24"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.17"
            />
            <path
              d="M1063.17,360.61c3-1.53,6.33.65,6.11,2.51s-3.06,4.69-3.06,4.69-1.31-1.86-2.07-3.27A12.81,12.81,0,0,1,1063.17,360.61Z"
              fill="#ba8419"
            />
            <path
              d="M1063.06,360.61s2.47-1.31,2-1.75.18.11-.47-.43-4,.65-3.82,1.63S1063.06,360.61,1063.06,360.61Z"
              fill="#ba8419"
            />
            <path
              d="M1063,361.15a2.69,2.69,0,0,0-3,.77c-1.2,1.53.87,2.83.87,2.83"
              fill="none"
              stroke="#a06f18"
              strokeMiterlimit="10"
              strokeWidth="0.11"
            />
            <path
              d="M1065,358.82l-.19.62a10.9,10.9,0,0,1-1.77,1.17s-2.07.44-2.29-.55a.54.54,0,0,1,.11-.43l.38-.17a3.8,3.8,0,0,0,2.89-1l.13-.12a.67.67,0,0,1,.31.12C1065.22,359,1064.63,358.46,1065,358.82Z"
              fill="#a06f18"
            />
            <path
              d="M1064.15,360.61s-2.84,2.51-2.07,5.45c.11.22-4.26-1.74-3.6-4S1064.15,360.61,1064.15,360.61Z"
              fill="#ba8419"
            />
            <path
              d="M1066.23,360.39c2.39-.33,2.83.44,4.36,1.53,0,0-3.17-6.66-7.42-1.31Z"
              fill="#ba8419"
            />
            <path
              d="M1063.5,360.72l-.24.88a5.32,5.32,0,0,0-1.18,4.46A3.8,3.8,0,0,1,1063.5,360.72Z"
              fill="#a06f18"
            />
            <path
              d="M1058.45,362.86s1.29,2.22,3.06.53l.49,1a4.19,4.19,0,0,0,.08,1.68C1062.17,366.25,1058.84,364.77,1058.45,362.86Z"
              fill="#a06f18"
              opacity="0.65"
            />
            <path
              d="M1066.23,360.39l-2.5.18-.38-.12a4.92,4.92,0,0,1,3.2-1c1.85.11,4,2.51,4,2.51C1069.06,360.83,1068.62,360.06,1066.23,360.39Z"
              fill="#a06f18"
            />
            <path
              d="M1063.17,360.61c3-1.53,6.33.65,6.11,2.51s-3.06,4.69-3.06,4.69-1.31-1.86-2.07-3.27A12.81,12.81,0,0,1,1063.17,360.61Z"
              fill="#ba8419"
            />
            <path d="M1064.7,360.72a2.83,2.83,0,0,1,2.83,2.4" fill="#a06f18" />
            <path d="M1064.15,361.15a2.87,2.87,0,0,1,2,2.84" fill="#a06f18" />
            <path
              d="M1069,364a15.43,15.43,0,0,1-2.82,3.86s-1.31-1.86-2.07-3.27a2.4,2.4,0,0,1-.11-.23C1066.56,365.67,1068.18,364.81,1069,364Z"
              fill="#a06f18"
            />
            <path d="M1062.51,360.94s-1.74,0-2.29,1.2" fill="#a06f18" />
            <path
              d="M1064.34,374.68s0-4.69-5.86-4.91"
              fill="none"
              stroke="#396039"
              strokeMiterlimit="10"
              strokeWidth="0.17"
            />
            <path
              d="M1059.9,366.83s2.35,1.31,1.34,3.49A3.84,3.84,0,0,1,1059.9,366.83Z"
              fill="#396039"
            />
            <path
              d="M1064.15,373.52a2.68,2.68,0,0,0-2.62-1.68S1062.4,373.77,1064.15,373.52Z"
              fill="#396039"
            />
            <path
              d="M1059.52,369.86s-1.26-3-4.31-2.05C1055.21,367.81,1057,370.39,1059.52,369.86Z"
              fill="#396039"
            />
            <path
              d="M1063,371.45s1.31-.48.55-2.33C1063.5,369.12,1062.3,370.29,1063,371.45Z"
              fill="#396039"
            />
            <path
              d="M1061.53,370.45a1.58,1.58,0,0,0-2,1A2.28,2.28,0,0,0,1061.53,370.45Z"
              fill="#396039"
            />
            <path
              d="M1064.7,372.23a9.92,9.92,0,0,1,3.6-4A4.83,4.83,0,0,1,1064.7,372.23Z"
              fill="#396039"
            />
            <path
              d="M1055.21,367.81l.32-.09c.68.68,2.28,2.15,3.59,2.2C1056.78,370.12,1055.21,367.81,1055.21,367.81Z"
              fill="#204220"
            />
            <path
              d="M1061.55,371.84a3,3,0,0,1,.42,0,3.47,3.47,0,0,0,2,1.7,2.77,2.77,0,0,1-2.46-1.66Z"
              fill="#204220"
            />
            <g>
              <path d="M1061.26,370.27l0,0,0,0Z" fill="#204220" />
              <path
                d="M1061.23,370.25a3.3,3.3,0,0,1-.4-.32,4,4,0,0,1-.93-3.1l.06,0C1060.13,367.7,1060.58,369.7,1061.23,370.25Z"
                fill="#204220"
              />
            </g>
            <path
              d="M1061.51,370.44h0l0,.09a2.37,2.37,0,0,1-1.91.87,2.33,2.33,0,0,1,.33-.52A2.92,2.92,0,0,0,1061.51,370.44Z"
              fill="#204220"
            />
            <path
              d="M1068.3,368.24a4.82,4.82,0,0,1-3.52,4l-.06,0v0c1.7-.48,2.68-2.5,3.1-3.61A5.46,5.46,0,0,1,1068.3,368.24Z"
              fill="#204220"
            />
          </g>
          <path
            d="M1128.37,428.56c1.66-1.25,1.24-1.66,3.74-1.25"
            fill="#493b1b"
          />
          <path
            d="M1143.75,426.48c1.66-1.25,1.25-1.66,3.74-1.25"
            fill="#493b1b"
          />
          <path
            d="M1060.61,378.26c1.66-2.08,4.57-.83,4.57-.83"
            fill="#35280f"
          />
          <path
            d="M1075.57,393.64c1.67-2.08,4.58-.83,4.58-.83"
            fill="#35280f"
          />
          <path d="M1093,403.62c1.67-2.08,4.58-.83,4.58-.83" fill="#35280f" />
          <path
            d="M1109.66,406.11c1.66-2.08,4.57-.83,4.57-.83"
            fill="#35280f"
          />
          <path d="M1116.31,411.1c1.67-2.08,4.58-.83,4.58-.83" fill="#35280f" />
          <path
            d="M1138.34,406.94c1.67-2.08,4.58-.83,4.58-.83"
            fill="#35280f"
          />
          <path d="M1150.4,417.75c1.66-2.08,4.57-.83,4.57-.83" fill="#35280f" />
          <path
            d="M1181.58,436.87c4.15-7.9-2.5-14.55-5.41-11.64s0,8.32,0,8.32-8.73-7.07-10.81-2.5,4,8.42,4,8.42Z"
            fill="#1f441f"
          />
          <path
            d="M1142.5,448.1c6.65-4.16,6.65-16.22,6.65-16.22s-5.82-.41-7.9,3.75S1142.5,448.1,1142.5,448.1Z"
            fill="#1f441f"
          />
          <path
            d="M1144.16,447.27c-3.32-7.9-9.14-12.89-16.21-13.31,0,0,2.08,11.23,7.9,13.31S1144.16,447.27,1144.16,447.27Z"
            fill="#1f441f"
          />
          <path
            d="M1149.15,431.88s-5.82-.41-7.9,3.75,1.25,12.47,1.25,12.47C1140.42,437.7,1149.15,431.88,1149.15,431.88Z"
            fill="#659965"
          />
          <g>
            <path
              d="M1180.39,425.68c-1.4-1.26-3.09-1.57-4.22-.45-1.93,1.93-1.3,5-.66,6.78C1175.33,428.68,1178.57,426.32,1180.39,425.68Z"
              fill="#659965"
            />
            <path
              d="M1175.44,433l-.13-.1C1175.36,433,1175.4,433,1175.44,433Z"
              fill="#659965"
            />
          </g>
          <path
            d="M1169.13,429.68c-1.61-.38-3.07-.16-3.77,1.37-1.1,2.44.09,4.68,1.45,6.23C1165.09,434.15,1167.72,431,1169.13,429.68Z"
            fill="#659965"
          />
        </g>
        <g>
          <polygon
            points="1124.64 311 1138.64 318 1168.64 301 1154.64 290.49 1124.64 311"
            fill="#141c66"
            opacity="0.2"
          />
          <g>
            <g>
              <polygon
                points="1154.43 260.5 1154.43 295.42 1156.46 294.24 1156.43 259.35 1154.43 260.5"
                fill="#54392e"
              />
              <polygon
                points="1153.34 294.79 1154.43 295.42 1154.43 260.5 1153.34 259.88 1153.34 294.79"
                fill="#96695c"
              />
              <polygon
                points="1153.34 259.88 1154.43 260.5 1156.43 259.35 1155.34 258.8 1153.34 259.88"
                fill="#704d3c"
              />
            </g>
            <line
              x1="1129.22"
              y1="298.31"
              x2="1161.56"
              y2="279.73"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <line
              x1="1134.25"
              y1="301.21"
              x2="1166.6"
              y2="282.64"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="1149.37 298.31 1134.25 289.58 1134.26 292.61 1149.37 301.21 1149.37 298.31"
                fill="#96695c"
              />
              <polygon
                points="1134.25 289.58 1136.29 288.41 1151.48 297.1 1149.37 298.31 1134.25 289.58"
                fill="#704d3c"
              />
              <polygon
                points="1149.37 298.31 1151.48 297.1 1151.48 299.88 1149.37 301.21 1149.37 298.31"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1154.41 295.41 1139.29 286.68 1139.29 289.71 1154.41 298.31 1154.41 295.41"
                fill="#96695c"
              />
              <polygon
                points="1139.29 286.68 1141.33 285.51 1156.52 294.2 1154.41 295.41 1139.29 286.68"
                fill="#704d3c"
              />
              <polygon
                points="1154.41 295.41 1156.52 294.2 1156.52 296.97 1154.41 298.31 1154.41 295.41"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1159.45 292.49 1144.33 283.77 1144.33 286.8 1159.45 295.4 1159.45 292.49"
                fill="#96695c"
              />
              <polygon
                points="1144.33 283.77 1146.37 282.59 1161.56 291.29 1159.45 292.49 1144.33 283.77"
                fill="#704d3c"
              />
              <polygon
                points="1159.45 292.49 1161.56 291.29 1161.56 294.06 1159.45 295.4 1159.45 292.49"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1164.49 289.59 1149.37 280.86 1149.37 283.89 1164.49 292.49 1164.49 289.59"
                fill="#96695c"
              />
              <polygon
                points="1149.37 280.86 1151.41 279.69 1166.6 288.38 1164.49 289.59 1149.37 280.86"
                fill="#704d3c"
              />
              <polygon
                points="1164.49 289.59 1166.6 288.38 1166.6 291.16 1164.49 292.49 1164.49 289.59"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1169.53 286.71 1154.41 277.98 1154.41 281.01 1169.53 289.61 1169.53 286.71"
                fill="#96695c"
              />
              <polygon
                points="1154.41 277.98 1156.45 276.81 1171.64 285.5 1169.53 286.71 1154.41 277.98"
                fill="#704d3c"
              />
              <polygon
                points="1169.53 286.71 1171.64 285.5 1171.64 288.27 1169.53 289.61 1169.53 286.71"
                fill="#a06338"
              />
            </g>
            <g>
              <polygon
                points="1144.33 301.22 1129.21 292.49 1129.21 295.52 1144.33 304.12 1144.33 301.22"
                fill="#96695c"
              />
              <polygon
                points="1129.21 292.49 1131.25 291.32 1146.44 300.01 1144.33 301.22 1129.21 292.49"
                fill="#704d3c"
              />
              <polygon
                points="1144.33 301.22 1146.44 300.01 1146.44 302.79 1144.33 304.12 1144.33 301.22"
                fill="#54392e"
              />
            </g>
            <polygon
              points="1124.18 277.94 1124.17 312.86 1126.21 311.68 1126.18 276.79 1124.18 277.94"
              fill="#54392e"
            />
            <polygon
              points="1123.09 312.23 1124.17 312.86 1124.18 277.94 1123.09 277.31 1123.09 312.23"
              fill="#96695c"
            />
            <g>
              <polygon
                points="1139.29 304.12 1124.17 295.4 1124.18 298.43 1139.29 307.03 1139.29 304.12"
                fill="#96695c"
              />
              <polygon
                points="1124.17 295.4 1126.21 294.22 1141.4 302.92 1139.29 304.12 1124.17 295.4"
                fill="#704d3c"
              />
              <polygon
                points="1139.29 304.12 1141.4 302.92 1141.4 305.69 1139.29 307.03 1139.29 304.12"
                fill="#a06338"
              />
            </g>
            <polygon
              points="1123.09 277.31 1124.18 277.94 1126.18 276.79 1125.09 276.24 1123.09 277.31"
              fill="#704d3c"
            />
            <polygon
              points="1139.29 321.59 1139.29 304.12 1137.19 302.92 1137.19 320.37 1139.29 321.59"
              fill="#96695c"
            />
            <polygon
              points="1139.29 321.59 1141.4 320.37 1141.4 302.92 1139.29 304.12 1139.29 321.59"
              fill="#54392e"
            />
            <polygon
              points="1169.54 304.12 1169.53 286.71 1171.64 285.5 1171.64 302.91 1169.54 304.12"
              fill="#54392e"
            />
            <polygon
              points="1167.97 285.81 1167.97 303.23 1169.54 304.12 1169.53 286.71 1167.97 285.81"
              fill="#96695c"
            />
            <polygon
              points="1124.18 283.76 1154.41 266.31 1154.41 269.54 1124.18 286.68 1124.18 283.76"
              fill="#54392e"
            />
            <polygon
              points="1153.34 265.69 1154.41 266.31 1126.18 282.6 1126.18 280.86 1153.34 265.69"
              fill="#704d3c"
            />
          </g>
        </g>
        <g>
          <polygon
            points="1268.64 253 1282.64 260 1312.64 243 1298.64 232.49 1268.64 253"
            fill="#141c66"
            opacity="0.2"
          />
          <g>
            <g>
              <polygon
                points="1291.43 219.86 1291.43 237.42 1293.46 236.83 1293.43 219.28 1291.43 219.86"
                fill="#54392e"
              />
              <polygon
                points="1290.34 237.1 1291.43 237.42 1291.43 219.86 1290.64 220 1290.34 237.1"
                fill="#96695c"
              />
              <polyline
                points="1291.43 219.86 1293.43 219.28 1292.34 219"
                fill="#704d3c"
              />
            </g>
            <line
              x1="1266.22"
              y1="240.31"
              x2="1298.56"
              y2="221.73"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <line
              x1="1271.25"
              y1="243.21"
              x2="1303.6"
              y2="224.64"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="1286.37 240.31 1271.25 231.58 1271.26 234.61 1286.37 243.21 1286.37 240.31"
                fill="#96695c"
              />
              <polygon
                points="1271.25 231.58 1273.29 230.41 1288.48 239.1 1286.37 240.31 1271.25 231.58"
                fill="#704d3c"
              />
              <polygon
                points="1286.37 240.31 1288.48 239.1 1288.48 241.88 1286.37 243.21 1286.37 240.31"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1291.41 237.41 1276.29 228.68 1276.29 231.71 1291.41 240.31 1291.41 237.41"
                fill="#96695c"
              />
              <polygon
                points="1276.29 228.68 1278.33 227.51 1293.52 236.2 1291.41 237.41 1276.29 228.68"
                fill="#704d3c"
              />
              <polygon
                points="1291.41 237.41 1293.52 236.2 1293.52 238.97 1291.41 240.31 1291.41 237.41"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1296.45 234.49 1281.33 225.77 1281.33 228.8 1296.45 237.4 1296.45 234.49"
                fill="#96695c"
              />
              <polygon
                points="1281.33 225.77 1283.37 224.59 1298.56 233.29 1296.45 234.49 1281.33 225.77"
                fill="#704d3c"
              />
              <polygon
                points="1296.45 234.49 1298.56 233.29 1298.56 236.06 1296.45 237.4 1296.45 234.49"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1301.49 231.59 1286.37 222.86 1286.37 225.89 1301.49 234.49 1301.49 231.59"
                fill="#96695c"
              />
              <polygon
                points="1286.37 222.86 1288.41 221.69 1303.6 230.38 1301.49 231.59 1286.37 222.86"
                fill="#704d3c"
              />
              <polygon
                points="1301.49 231.59 1303.6 230.38 1303.6 233.16 1301.49 234.49 1301.49 231.59"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1306.43 228.52 1290.64 219.25 1290.64 222.47 1306.43 231.61 1306.43 228.52"
                fill="#96695c"
              />
              <polygon
                points="1290.64 219.25 1292.77 218 1308.64 227.24 1306.43 228.52 1290.64 219.25"
                fill="#704d3c"
              />
              <polygon
                points="1306.43 228.52 1308.64 227.24 1308.64 230.19 1306.43 231.61 1306.43 228.52"
                fill="#a06338"
              />
            </g>
            <g>
              <polygon
                points="1281.33 243.22 1266.21 234.49 1266.21 237.52 1281.33 246.12 1281.33 243.22"
                fill="#96695c"
              />
              <polygon
                points="1266.21 234.49 1268.25 233.32 1283.44 242.01 1281.33 243.22 1266.21 234.49"
                fill="#704d3c"
              />
              <polygon
                points="1281.33 243.22 1283.44 242.01 1283.44 244.79 1281.33 246.12 1281.33 243.22"
                fill="#54392e"
              />
            </g>
            <polygon
              points="1262.18 237.83 1262.17 254.86 1264.21 254.28 1264.18 237.27 1262.18 237.83"
              fill="#54392e"
            />
            <polygon
              points="1261.09 254.55 1262.17 254.86 1262.18 237.83 1261.09 237.52 1261.09 254.55"
              fill="#96695c"
            />
            <g>
              <polygon
                points="1276.29 246.12 1261.17 237.4 1261.18 240.43 1276.29 249.03 1276.29 246.12"
                fill="#96695c"
              />
              <polygon
                points="1261.17 237.4 1263.21 236.22 1278.4 244.92 1276.29 246.12 1261.17 237.4"
                fill="#704d3c"
              />
              <polygon
                points="1276.29 246.12 1278.4 244.92 1278.4 247.69 1276.29 249.03 1276.29 246.12"
                fill="#a06338"
              />
            </g>
            <polygon
              points="1276.29 263.59 1276.29 246.12 1274.19 244.92 1274.19 262.37 1276.29 263.59"
              fill="#96695c"
            />
            <polygon
              points="1276.29 263.59 1278.4 262.37 1278.4 244.92 1276.29 246.12 1276.29 263.59"
              fill="#54392e"
            />
            <polygon
              points="1306.54 246.12 1306.53 228.71 1308.64 227.5 1308.64 244.91 1306.54 246.12"
              fill="#54392e"
            />
            <polygon
              points="1304.97 227.81 1304.97 245.23 1306.54 246.12 1306.53 228.71 1304.97 227.81"
              fill="#96695c"
            />
          </g>
        </g>
        {/* <g transform="translate(-20 0)">
          <polygon
            points="1424.09 271 1410.09 278 1380.09 261 1394.09 250.49 1424.09 271"
            fill="#141c66"
            opacity="0.2"
          />
          <g>
            <g>
              <polygon
                points="1401.3 237.86 1401.3 255.42 1399.26 254.83 1399.29 237.28 1401.3 237.86"
                fill="#54392e"
              />
              <polygon
                points="1402.39 255.1 1401.3 255.42 1401.3 237.86 1402.09 238 1402.39 255.1"
                fill="#96695c"
              />
              <polyline
                points="1401.3 237.86 1399.29 237.28 1400.38 237"
                fill="#704d3c"
              />
            </g>
            <line
              x1="1426.51"
              y1="258.31"
              x2="1394.16"
              y2="239.73"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <line
              x1="1421.47"
              y1="261.21"
              x2="1389.13"
              y2="242.64"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="1406.36 258.31 1421.47 249.58 1421.47 252.61 1406.36 261.21 1406.36 258.31"
                fill="#96695c"
              />
              <polygon
                points="1421.47 249.58 1419.44 248.41 1404.24 257.1 1406.36 258.31 1421.47 249.58"
                fill="#704d3c"
              />
              <polygon
                points="1406.36 258.31 1404.24 257.1 1404.24 259.88 1406.36 261.21 1406.36 258.31"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1401.32 255.41 1416.43 246.68 1416.43 249.71 1401.32 258.31 1401.32 255.41"
                fill="#96695c"
              />
              <polygon
                points="1416.43 246.68 1414.4 245.51 1399.2 254.2 1401.32 255.41 1416.43 246.68"
                fill="#704d3c"
              />
              <polygon
                points="1401.32 255.41 1399.2 254.2 1399.2 256.97 1401.32 258.31 1401.32 255.41"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1396.28 252.49 1411.39 243.77 1411.39 246.8 1396.28 255.4 1396.28 252.49"
                fill="#96695c"
              />
              <polygon
                points="1411.39 243.77 1409.36 242.59 1394.16 251.29 1396.28 252.49 1411.39 243.77"
                fill="#704d3c"
              />
              <polygon
                points="1396.28 252.49 1394.16 251.29 1394.16 254.06 1396.28 255.4 1396.28 252.49"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1391.24 249.59 1406.36 240.86 1406.35 243.89 1391.24 252.49 1391.24 249.59"
                fill="#96695c"
              />
              <polygon
                points="1406.36 240.86 1404.32 239.69 1389.13 248.38 1391.24 249.59 1406.36 240.86"
                fill="#704d3c"
              />
              <polygon
                points="1391.24 249.59 1389.13 248.38 1389.13 251.16 1391.24 252.49 1391.24 249.59"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="1386.29 246.52 1402.09 237.25 1402.08 240.47 1386.29 249.61 1386.29 246.52"
                fill="#96695c"
              />
              <polygon
                points="1402.09 237.25 1399.96 236 1384.09 245.24 1386.29 246.52 1402.09 237.25"
                fill="#704d3c"
              />
              <polygon
                points="1386.29 246.52 1384.09 245.24 1384.09 248.19 1386.29 249.61 1386.29 246.52"
                fill="#a06338"
              />
            </g>
            <g>
              <polygon
                points="1411.39 261.22 1426.51 252.49 1426.51 255.52 1411.39 264.12 1411.39 261.22"
                fill="#96695c"
              />
              <polygon
                points="1426.51 252.49 1424.47 251.32 1409.28 260.01 1411.39 261.22 1426.51 252.49"
                fill="#704d3c"
              />
              <polygon
                points="1411.39 261.22 1409.28 260.01 1409.28 262.79 1411.39 264.12 1411.39 261.22"
                fill="#54392e"
              />
            </g>
            <polygon
              points="1430.55 255.83 1430.55 272.86 1428.52 272.28 1428.55 255.27 1430.55 255.83"
              fill="#54392e"
            />
            <polygon
              points="1431.64 272.55 1430.55 272.86 1430.55 255.83 1431.64 255.52 1431.64 272.55"
              fill="#96695c"
            />
            <g>
              <polygon
                points="1416.43 264.12 1431.55 255.4 1431.55 258.43 1416.43 267.03 1416.43 264.12"
                fill="#96695c"
              />
              <polygon
                points="1431.55 255.4 1429.52 254.22 1414.32 262.92 1416.43 264.12 1431.55 255.4"
                fill="#704d3c"
              />
              <polygon
                points="1416.43 264.12 1414.32 262.92 1414.32 265.69 1416.43 267.03 1416.43 264.12"
                fill="#a06338"
              />
            </g>
            <polygon
              points="1416.43 281.59 1416.43 264.12 1418.53 262.92 1418.53 280.37 1416.43 281.59"
              fill="#96695c"
            />
            <polygon
              points="1416.43 281.59 1414.32 280.37 1414.32 262.92 1416.43 264.12 1416.43 281.59"
              fill="#54392e"
            />
            <polygon
              points="1386.19 264.12 1386.2 246.71 1384.09 245.5 1384.09 262.91 1386.19 264.12"
              fill="#54392e"
            />
            <polygon
              points="1387.76 245.81 1387.76 263.23 1386.19 264.12 1386.2 246.71 1387.76 245.81"
              fill="#96695c"
            />
          </g>
        </g> */}
        <g transform="translate(-20 -20)">
          <polygon
            points="326.64 394 340.64 401 370.64 384 356.64 373.49 326.64 394"
            fill="#141c66"
            opacity="0.2"
          />
          <g>
            <g>
              <polygon
                points="349.43 360.86 349.43 378.42 351.46 377.83 351.43 360.28 349.43 360.86"
                fill="#54392e"
              />
              <polygon
                points="348.34 378.1 349.43 378.42 349.43 360.86 348.64 361 348.34 378.1"
                fill="#96695c"
              />
              <polyline
                points="349.43 360.86 351.43 360.28 350.34 360"
                fill="#704d3c"
              />
            </g>
            <line
              x1="324.22"
              y1="381.31"
              x2="356.56"
              y2="362.73"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <line
              x1="329.25"
              y1="384.21"
              x2="361.6"
              y2="365.64"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="344.37 381.31 329.25 372.58 329.25 375.61 344.37 384.21 344.37 381.31"
                fill="#96695c"
              />
              <polygon
                points="329.25 372.58 331.29 371.41 346.48 380.1 344.37 381.31 329.25 372.58"
                fill="#704d3c"
              />
              <polygon
                points="344.37 381.31 346.48 380.1 346.48 382.88 344.37 384.21 344.37 381.31"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="349.41 378.41 334.29 369.68 334.29 372.71 349.41 381.31 349.41 378.41"
                fill="#96695c"
              />
              <polygon
                points="334.29 369.68 336.33 368.51 351.52 377.2 349.41 378.41 334.29 369.68"
                fill="#704d3c"
              />
              <polygon
                points="349.41 378.41 351.52 377.2 351.52 379.97 349.41 381.31 349.41 378.41"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="354.45 375.49 339.33 366.77 339.33 369.8 354.45 378.4 354.45 375.49"
                fill="#96695c"
              />
              <polygon
                points="339.33 366.77 341.37 365.59 356.56 374.29 354.45 375.49 339.33 366.77"
                fill="#704d3c"
              />
              <polygon
                points="354.45 375.49 356.56 374.29 356.56 377.06 354.45 378.4 354.45 375.49"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="359.49 372.59 344.37 363.86 344.37 366.89 359.49 375.49 359.49 372.59"
                fill="#96695c"
              />
              <polygon
                points="344.37 363.86 346.41 362.69 361.6 371.38 359.49 372.59 344.37 363.86"
                fill="#704d3c"
              />
              <polygon
                points="359.49 372.59 361.6 371.38 361.6 374.16 359.49 375.49 359.49 372.59"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="364.43 369.52 348.64 360.25 348.64 363.47 364.43 372.61 364.43 369.52"
                fill="#96695c"
              />
              <polygon
                points="348.64 360.25 350.77 359 366.64 368.24 364.43 369.52 348.64 360.25"
                fill="#704d3c"
              />
              <polygon
                points="364.43 369.52 366.64 368.24 366.64 371.19 364.43 372.61 364.43 369.52"
                fill="#a06338"
              />
            </g>
            <g>
              <polygon
                points="339.33 384.22 324.21 375.49 324.21 378.52 339.33 387.12 339.33 384.22"
                fill="#96695c"
              />
              <polygon
                points="324.21 375.49 326.25 374.32 341.44 383.01 339.33 384.22 324.21 375.49"
                fill="#704d3c"
              />
              <polygon
                points="339.33 384.22 341.44 383.01 341.44 385.79 339.33 387.12 339.33 384.22"
                fill="#54392e"
              />
            </g>
            <polygon
              points="320.18 378.83 320.17 395.86 322.21 395.28 322.18 378.27 320.18 378.83"
              fill="#54392e"
            />
            <polygon
              points="319.08 395.55 320.17 395.86 320.18 378.83 319.08 378.52 319.08 395.55"
              fill="#96695c"
            />
            <g>
              <polygon
                points="334.29 387.12 319.17 378.4 319.18 381.43 334.29 390.03 334.29 387.12"
                fill="#96695c"
              />
              <polygon
                points="319.17 378.4 321.21 377.22 336.4 385.92 334.29 387.12 319.17 378.4"
                fill="#704d3c"
              />
              <polygon
                points="334.29 387.12 336.4 385.92 336.4 388.69 334.29 390.03 334.29 387.12"
                fill="#a06338"
              />
            </g>
            <polygon
              points="334.29 404.59 334.29 387.12 332.19 385.92 332.19 403.37 334.29 404.59"
              fill="#96695c"
            />
            <polygon
              points="334.29 404.59 336.4 403.37 336.4 385.92 334.29 387.12 334.29 404.59"
              fill="#54392e"
            />
            <polygon
              points="364.54 387.12 364.53 369.71 366.64 368.5 366.64 385.91 364.54 387.12"
              fill="#54392e"
            />
            <polygon
              points="362.97 368.81 362.97 386.23 364.54 387.12 364.53 369.71 362.97 368.81"
              fill="#96695c"
            />
          </g>
        </g>
        <g>
          <polygon
            points="418.64 233 432.64 240 462.64 223 448.64 212.49 418.64 233"
            fill="#141c66"
            opacity="0.2"
          />
          <g>
            <g>
              <polygon
                points="441.43 199.86 441.43 217.42 443.46 216.83 443.43 199.28 441.43 199.86"
                fill="#54392e"
              />
              <polygon
                points="440.34 217.1 441.43 217.42 441.43 199.86 440.64 200 440.34 217.1"
                fill="#96695c"
              />
              <polyline
                points="441.43 199.86 443.43 199.28 442.34 199"
                fill="#704d3c"
              />
            </g>
            <line
              x1="416.22"
              y1="220.31"
              x2="448.56"
              y2="201.73"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <line
              x1="421.25"
              y1="223.21"
              x2="453.6"
              y2="204.64"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="436.37 220.31 421.25 211.58 421.25 214.61 436.37 223.21 436.37 220.31"
                fill="#96695c"
              />
              <polygon
                points="421.25 211.58 423.29 210.41 438.48 219.1 436.37 220.31 421.25 211.58"
                fill="#704d3c"
              />
              <polygon
                points="436.37 220.31 438.48 219.1 438.48 221.88 436.37 223.21 436.37 220.31"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="441.41 217.41 426.29 208.68 426.29 211.71 441.41 220.31 441.41 217.41"
                fill="#96695c"
              />
              <polygon
                points="426.29 208.68 428.33 207.51 443.52 216.2 441.41 217.41 426.29 208.68"
                fill="#704d3c"
              />
              <polygon
                points="441.41 217.41 443.52 216.2 443.52 218.97 441.41 220.31 441.41 217.41"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="446.45 214.49 431.33 205.77 431.33 208.8 446.45 217.4 446.45 214.49"
                fill="#96695c"
              />
              <polygon
                points="431.33 205.77 433.37 204.59 448.56 213.29 446.45 214.49 431.33 205.77"
                fill="#704d3c"
              />
              <polygon
                points="446.45 214.49 448.56 213.29 448.56 216.06 446.45 217.4 446.45 214.49"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="451.49 211.59 436.37 202.86 436.37 205.89 451.49 214.49 451.49 211.59"
                fill="#96695c"
              />
              <polygon
                points="436.37 202.86 438.41 201.69 453.6 210.38 451.49 211.59 436.37 202.86"
                fill="#704d3c"
              />
              <polygon
                points="451.49 211.59 453.6 210.38 453.6 213.16 451.49 214.49 451.49 211.59"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="456.43 208.52 440.64 199.25 440.64 202.47 456.43 211.61 456.43 208.52"
                fill="#96695c"
              />
              <polygon
                points="440.64 199.25 442.77 198 458.64 207.24 456.43 208.52 440.64 199.25"
                fill="#704d3c"
              />
              <polygon
                points="456.43 208.52 458.64 207.24 458.64 210.19 456.43 211.61 456.43 208.52"
                fill="#a06338"
              />
            </g>
            <g>
              <polygon
                points="431.33 223.22 416.21 214.49 416.21 217.52 431.33 226.12 431.33 223.22"
                fill="#96695c"
              />
              <polygon
                points="416.21 214.49 418.25 213.32 433.44 222.01 431.33 223.22 416.21 214.49"
                fill="#704d3c"
              />
              <polygon
                points="431.33 223.22 433.44 222.01 433.44 224.79 431.33 226.12 431.33 223.22"
                fill="#54392e"
              />
            </g>
            <polygon
              points="412.18 217.83 412.17 234.86 414.21 234.28 414.18 217.27 412.18 217.83"
              fill="#54392e"
            />
            <polygon
              points="411.08 234.55 412.17 234.86 412.18 217.83 411.08 217.52 411.08 234.55"
              fill="#96695c"
            />
            <g>
              <polygon
                points="426.29 226.12 411.17 217.4 411.18 220.43 426.29 229.03 426.29 226.12"
                fill="#96695c"
              />
              <polygon
                points="411.17 217.4 413.21 216.22 428.4 224.92 426.29 226.12 411.17 217.4"
                fill="#704d3c"
              />
              <polygon
                points="426.29 226.12 428.4 224.92 428.4 227.69 426.29 229.03 426.29 226.12"
                fill="#a06338"
              />
            </g>
            <polygon
              points="426.29 243.59 426.29 226.12 424.19 224.92 424.19 242.37 426.29 243.59"
              fill="#96695c"
            />
            <polygon
              points="426.29 243.59 428.4 242.37 428.4 224.92 426.29 226.12 426.29 243.59"
              fill="#54392e"
            />
            <polygon
              points="456.54 226.12 456.53 208.71 458.64 207.5 458.64 224.91 456.54 226.12"
              fill="#54392e"
            />
            <polygon
              points="454.97 207.81 454.97 225.23 456.54 226.12 456.53 208.71 454.97 207.81"
              fill="#96695c"
            />
          </g>
        </g>
        <g>
          <g opacity="0.2">
            <path
              d="M1127.26,214.13c4.12-.42,5.2-.32,6.56-2.48s-.8-1.64,3.33-3.62,3.11-5.54,2.3-6.91-8.81-4.69-10-2.24-6.22,6.94-7.48,6.2S1122.41,214.63,1127.26,214.13Z"
              fill="#141c66"
            />
            <path
              d="M1133,208c1.5-1.21,3.87.65,4-.64s1.27-3.55-.23-3.56-3.32.49-3-.66-.07-1.79-1.16-1.54-1.86,1.31-2.26.26-1.09-1.16-1.85-.41.07,1.13-.52,2.45,1.46,3.73,1.7,2.89S1133,208,1133,208Z"
              fill="#141c66"
            />
            <path
              d="M1138.9,210.36c2.94-.24,6.09.15,5.71,3.2s-5.64,2.41-6,4.5-3.56,4.13-4.37,3.29-4.12-5.24-5.52-6-.55-3.71,1.33-5.17S1138.9,210.36,1138.9,210.36Z"
              fill="#141c66"
            />
            <path
              d="M1122.12,212.61c0,4.64,8-1,4.9-3.7s-3.64-3.83-3-5.9-3.73-2.72-4.49-2.28a5.68,5.68,0,0,0-1.87,5.27C1118.3,208.24,1122.13,209.83,1122.12,212.61Z"
              fill="#141c66"
            />
            <path
              d="M1125.14,219.88c-4.47-1.25,3.19-7.36,4.9-3.69s2.69,4.56,4.85,4.51,1.6,4.33,1,4.94a5.66,5.66,0,0,1-5.58.34C1128.29,224.75,1127.82,220.63,1125.14,219.88Z"
              fill="#141c66"
            />
            <path
              d="M1130.6,221.53c1.16-.21.46,2.24.46,2.24s1-.9,1.93-.53.12,1.45.12,1.45c.83-.54,1.3,1.61,0,1.86h0a4.6,4.6,0,0,1-2.87-.57,3.84,3.84,0,0,1-1.1-1.13l-.75-1.79A4.51,4.51,0,0,1,1130.6,221.53Z"
              fill="#141c66"
            />
            <path
              d="M1124.6,216.53c-1.48.2-11.06,6.89-14.64,11,0,0-1.55-3-2.63-3.55-.35.13-.09-.06-.09-.06s15.76-6.05,17.12-12.16-5.11-6.78-5.11-6.78,3-.73,4.71,1.24,1.21,6.9.78,7.44c0,0,4.17-3,4.61-5.36a1.93,1.93,0,0,1,2.74-1.49s-1.84-1.34-3.37,4.21c-.79,2.87-5.09,4.49-5.09,4.49s3.42-1.17,4.52,1.51-.49,6,1.26,8a13.77,13.77,0,0,1-2-5.42A3.24,3.24,0,0,0,1124.6,216.53Z"
              fill="#141c66"
            />
            <path
              d="M1127.34,219.27a3.21,3.21,0,0,0-2.74-2.74,16.36,16.36,0,0,0-3.84,2.15c1.81-2.42,5.47-3.29,6-3.1a2.66,2.66,0,0,1,1.38,1.48,6.26,6.26,0,0,1,.41,2Z"
              fill="#141c66"
            />
            <path
              d="M1124.33,213.47a8.77,8.77,0,0,1-3.62,3.14h0c1.87-1.52,3.28-3.17,3.65-4.81a8.51,8.51,0,0,0,.16-1l.3-.43A6.46,6.46,0,0,1,1124.33,213.47Z"
              fill="#141c66"
            />
            <path
              d="M1127.31,218.32c.87.61,2-.2,2.71.81s-.64,2.17-.93,3.64.39,2,.56,2.85-5,1.07-5.48-2.08-.48-2.78-.55-3.92S1125.36,217,1127.31,218.32Z"
              fill="#141c66"
            />
            <g>
              <path d="M1125.9,212.79c0,.06,0,.06,0,0l0,0Z" fill="#141c66" />
              <path
                d="M1126.37,212.39c1.22-1.09,2.73-2.66,3-4a2.14,2.14,0,0,1,.63-1.26l.37.33a9.42,9.42,0,0,0-1.63,3.65s0,.08,0,.13C1127.89,211.67,1127,212,1126.37,212.39Z"
                fill="#141c66"
              />
            </g>
            <path
              d="M1124.19,209.28c.26-1,1.68-1.19,1.52-2.38s-1.89-1.23-3.07-2.16-1-1.76-1.42-2.53-4.53,2.46-2.81,5.14,1.43,2.42,2.12,3.34S1123.59,211.58,1124.19,209.28Z"
              fill="#141c66"
            />
            <path
              d="M1132.85,204.42c1.28-.1,2.66.07,2.49,1.41s-2.47,1-2.61,2-1.55,1.81-1.91,1.44a19.31,19.31,0,0,0-2.41-2.61c-.61-.33-.24-1.63.58-2.27S1132.85,204.42,1132.85,204.42Z"
              fill="#141c66"
            />
            <path
              d="M1119,206.21c-.12.34.28.77.59,1s1.26-.28,1.44.27-.09,1.08.42,1.45.86-.22,1.34.39.64,1.32.34,1.59l-.08,0h0l-.09.05a2,2,0,0,1-2.44-.28c-.69-.92-.4-.67-2.12-3.34a2.66,2.66,0,0,1-.41-1.16C1118,205.77,1119.13,205.87,1119,206.21Z"
              fill="#141c66"
            />
            <path
              d="M1124.08,220.22c.46.61.72,2.35,1.46,2.05s1.81.83,1.64,1.18a1.54,1.54,0,0,0,.57,1.64c.54.25.3,1.09-.07,1.06-1.47-.11-3.26-.82-3.51-2.61-.3-2.18-.41-2.67-.48-3.15C1123.69,220.17,1123.72,219.74,1124.08,220.22Z"
              fill="#141c66"
            />
            <path
              d="M1129.43,212.58c1.16-.26,1.71.82,2.11,1.57s-.65,1.24.17,1.45.7,2.16-.36,2.26h0a12.84,12.84,0,0,0-2.59-2.49c-.86-.47-.87-1.78-.3-3.06l.31-.6h0S1128.27,212.84,1129.43,212.58Z"
              fill="#141c66"
            />
            <path
              d="M1135.32,219.29c.6-.85,2.11-.23,1.46-1.1s-2.6-1.64-1.24-2.45,1.74-1.71.94-2.59.7-3.16,1.56-3-3.12-2.31-3.27.22.68,2.78,0,3.19-1.91,1.43-1.22,2.75-2,1-1.74,2.18S1133.73,221.54,1135.32,219.29Z"
              fill="#141c66"
            />
            <path
              d="M1107.24,224s1-.38,2.46-1c3,1.43,7-1.35,7.11-1.43a49.81,49.81,0,0,0-6.85,6.07s-1.55-3-2.63-3.55C1107,224.15,1107.24,224,1107.24,224Z"
              fill="#141c66"
            />
            <path
              d="M1109.46,226.66a12.32,12.32,0,0,0,1.77-1.77,20.54,20.54,0,0,1,3.31-2.48,63.31,63.31,0,0,0,5.64-3.82c.42-.54,1.51-2,2.59-2.21s2.22-.49,3.07,0a4.75,4.75,0,0,1,1.46,1.93"
              fill="#141c66"
            />
            <path
              d="M1116.18,220.66c-1.14.64-1.13,1.12-2.26,1a4,4,0,0,0-3.33,1.81,10.09,10.09,0,0,1-1.9,2"
              fill="#141c66"
            />
            <path
              d="M1128.08,211.69c-.63.56-.74.95-1.37,1.16s-1.26,2.05-3,2.7a10.65,10.65,0,0,0-3.62,2.95"
              fill="#141c66"
            />
          </g>
          <g>
            <path
              d="M1113.12,190.75c3.73-6.18,5-7.58,3.42-11.74s-3.12-.61-1.53-8.43-4.46-10.14-7.21-10.45-15.76,7.34-13.56,11.49,3.14,15.95.77,16.93S1108.72,198,1113.12,190.75Z"
              fill="#396039"
            />
            <path
              d="M1110.61,176.39c-.12-3.36,5-4.71,3.3-6.24s-3.6-5.49-5.19-3.42-2.81,5.14-4,3.42-2.57-1.77-3.36,0-.13,4-2,3.43-2.75.3-2.51,2.13,1.65,1.1,2.88,3.3,6.72,1.9,5.8.68S1110.61,176.39,1110.61,176.39Z"
              fill="#447244"
            />
            <path
              d="M1120.09,170.58c2.74-4.34,6.59-8.31,10.44-4.58s-2.56,10.39,0,13,2,9.29,0,9.54-11.61.24-14.11,1.4-5.74-3.11-5.81-7.27S1120.09,170.58,1120.09,170.58Z"
              fill="#6b996b"
            />
            <path
              d="M1105.6,196.31c6.44,4.9,6.91-12.16,0-10.7s-9.16,1-11.36-2-7.7,2.32-7.88,3.85,1.58,6.66,5.37,8.12S1101.75,193.37,1105.6,196.31Z"
              fill="#447244"
            />
            <path
              d="M1118.91,199.73c-6.44,4.9-6.91-12.16,0-10.69s9.16,1,11.36-2,7.7,2.32,7.88,3.85-1.59,6.66-5.37,8.13S1122.76,196.8,1118.91,199.73Z"
              fill="#447244"
            />
            <path
              d="M1126.93,193.86c.92-1.83,3.6,1.71,3.6,1.71s-.18-2.38,1.29-3.23,2.14,1.34,2.14,1.34c.12-1.71,3.6-.12,2.62,1.91h0a8.14,8.14,0,0,1-3.8,3.41,6.91,6.91,0,0,1-2.73.35l-3.28-.84S1126,195.7,1126.93,193.86Z"
              fill="#396039"
            />
            <path
              d="M1113.67,197c-1.28,2.26-2,22.61,0,32,0,0-5.87-1-7.7-.06-.18.61-.18.06-.18.06s8.12-28.29,1-36.6-14.79,0-14.79,0,2.08-4.89,6.66-5.26,10.88,5.56,11.18,6.72c0,0,.25-8.92-2.63-12s.8-5.37.8-5.37-3.79,1.16,2.32,9.1c3.17,4.12.92,11.79.92,11.79s2-6,6.84-4.7,7.82,7,12.4,6.6a24.14,24.14,0,0,1-9.65-2.87A5.65,5.65,0,0,0,1113.67,197Z"
              fill="#704d3c"
            />
            <path
              d="M1120.36,196a5.61,5.61,0,0,0-6.69,1c-.44.78-.82,3.7-1,7.58-1.47-5.06,1.16-11.06,2-11.6a4.6,4.6,0,0,1,3.51-.38,10.84,10.84,0,0,1,3.22,1.53Z"
              fill="#634b42"
            />
            <path
              d="M1109.12,194.14c.67,1.53,1.4,6,.58,8.32h0c-.16-4.2-1-7.89-2.87-10.12a16.19,16.19,0,0,0-1.27-1.32l-.29-.85A11,11,0,0,1,1109.12,194.14Z"
              fill="#44322c"
            />
            <path
              d="M1119,195.07c1.77-.57,1.88-3,4-2.91s2.34,3.16,4.09,5.12,3.16,1.52,4.54,2.2-3.8,8.14-8.63,5.44-4.37-2.24-6-3.34S1115.05,196.35,1119,195.07Z"
              fill="#6b996b"
            />
            <g>
              <path d="M1109.83,191.24c0,.11,0,.12,0,0v0Z" fill="#7f2c03" />
              <path
                d="M1109.76,190.16c-.23-2.84-.84-6.59-2.51-8.4a3.66,3.66,0,0,1-1.09-2.21l.84-.16c.3,1.36,1.22,3.31,3.37,6.1l.14.19C1110.36,187.29,1109.86,188.94,1109.76,190.16Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M1103.14,189.94c-1.16-1.46.12-3.59-1.71-4.63s-3.7,1.34-6.23,2-3.48-.47-5-.67-1.32,8.88,4.2,9.3,4.88.55,6.88.55S1105.72,193.18,1103.14,189.94Z"
              fill="#6b996b"
            />
            <path
              d="M1105.47,172.79c1.2-1.9,2.89-3.64,4.57-2s-1.12,4.55,0,5.7.88,4.06,0,4.17-5.08.1-6.17.61-2.52-1.36-2.54-3.18S1105.47,172.79,1105.47,172.79Z"
              fill="#6b996b"
            />
            <path
              d="M1093.44,193.92c.35.52,1.36.43,2,.19s.93-2,1.88-1.73,1.41,1.26,2.47,1,.6-1.44,2-1.46,2.51.49,2.56,1.19c0,.06,0,.11,0,.17h0a.78.78,0,0,0,0,.16,3.46,3.46,0,0,1-3,3.11c-2,0-1.36-.13-6.88-.55a4.39,4.39,0,0,1-2-.65C1091.75,194.9,1093.09,193.39,1093.44,193.92Z"
              fill="#447244"
            />
            <path
              d="M1118.25,201.56c1.35,0,4,1.47,4.4.12s3.06-1.65,3.36-1a2.68,2.68,0,0,0,2.87.91c.92-.49,1.84.74,1.42,1.22-1.7,1.92-4.57,3.67-7.32,2.14-3.36-1.88-4.16-2.23-4.9-2.64C1117.77,202.05,1117.22,201.56,1118.25,201.56Z"
              fill="#396039"
            />
            <path
              d="M1113.24,186.1c.86-1.89,2.93-1.52,4.4-1.28s1,2.2,2.2,1.28,3.73,1.29,2.76,2.87h0a22.7,22.7,0,0,0-6.18,1c-1.55.72-3.38-.65-4.57-2.78l-.52-1.07h0S1112.39,188,1113.24,186.1Z"
              fill="#447244"
            />
            <path
              d="M1128.76,184.94c-.55-1.72,1.9-3.18,0-3.18s-5,1.9-4.7-.85-.55-4.22-2.63-4-3.66-4.28-2.5-5.29-6.48,1.93-3.12,4.8,4.58,2,4.46,3.3,0,4.15,2.56,4.58-.72,3.91,1.2,4.71S1130.23,189.52,1128.76,184.94Z"
              fill="#447244"
            />
            <path
              d="M1105.79,228.94s.5-1.76,1.15-4.52c5.1-2.62,5.47-11.14,5.48-11.4a85.93,85.93,0,0,0,1.25,15.92s-5.87-1-7.7-.06C1105.79,229.49,1105.79,228.94,1105.79,228.94Z"
              fill="#44322c"
            />
            <path
              d="M1111.88,228.68a33.68,33.68,0,0,0-.75-4.85,31.09,31.09,0,0,1-.08-4.92c.19-3.28.5-6.53.64-9.8,0-.82.1-1.63.11-2.45a9.28,9.28,0,0,0,0-1.19c-.06-.38-.2-.79-.28-1.18a13.63,13.63,0,0,1-.41-2.45,4.88,4.88,0,0,1,.33-2.47c.36-.74.71-1.47,1.13-2.19a5.82,5.82,0,0,1,1.63-1.86,4.13,4.13,0,0,1,2.39-.58,11.76,11.76,0,0,1,2.44.34,11.11,11.11,0,0,0-2.44-.25,4.06,4.06,0,0,0-2.29.63c-1.31,1-1.92,2.57-2.64,4a4.78,4.78,0,0,0-.28,2.35,15,15,0,0,0,.43,2.39c.1.4.23.77.31,1.2a10.83,10.83,0,0,1,.06,1.26c0,.82,0,1.64-.08,2.46-.19,3.27-.54,6.53-.77,9.79a33.25,33.25,0,0,0,0,4.89A33.2,33.2,0,0,1,1111.88,228.68Z"
              fill="#44322c"
            />
            <path
              d="M1110.58,213a13.62,13.62,0,0,0,0,2,3,3,0,0,1-.12,1,3.09,3.09,0,0,1-.54.91,5.43,5.43,0,0,0-1.51,3.55,8.11,8.11,0,0,0,0,2,14.19,14.19,0,0,0,.52,1.93,16.24,16.24,0,0,1,.43,4,21.89,21.89,0,0,0-.7-4,10.89,10.89,0,0,1-.58-2,8.35,8.35,0,0,1,0-2.06,5.66,5.66,0,0,1,1.66-3.7,2.74,2.74,0,0,0,.53-.79,2.8,2.8,0,0,0,.16-1A15.16,15.16,0,0,1,1110.58,213Z"
              fill="#44322c"
            />
            <path
              d="M1110.58,187.05c.07.78.37,1.49.42,2.3a9,9,0,0,1-.16,1.14,4.3,4.3,0,0,0,.22,1.1,11.16,11.16,0,0,1,.66,4.63c-.1.81-.42,1.52-.5,2.27a14.64,14.64,0,0,0-.11,2.29,27.45,27.45,0,0,0,.51,4.6,21.53,21.53,0,0,1-.8-4.59,13.08,13.08,0,0,1,.07-2.34c.08-.8.39-1.54.47-2.27a11.27,11.27,0,0,0-.57-4.51,4.61,4.61,0,0,1-.18-1.18,2,2,0,0,1,.13-.59,2.61,2.61,0,0,0,.08-.55C1110.84,188.6,1110.59,187.82,1110.58,187.05Z"
              fill="#44322c"
            />
          </g>
        </g>
        <g>
          <g opacity="0.2">
            <path
              d="M965,271.67c4.79-.49,6-.37,7.63-2.89s-.93-1.9,3.88-4.2,3.61-6.45,2.67-8-10.24-5.46-11.57-2.62-7.24,8.08-8.71,7.22S959.31,272.25,965,271.67Z"
              fill="#141c66"
            />
            <path
              d="M971.6,264.57c1.74-1.42,4.49.74,4.64-.75s1.49-4.13-.26-4.14-3.86.56-3.44-.78-.09-2.08-1.35-1.79-2.17,1.53-2.64.3-1.26-1.34-2.14-.47.07,1.32-.61,2.85,1.69,4.35,2,3.37S971.6,264.57,971.6,264.57Z"
              fill="#141c66"
            />
            <path
              d="M978.5,267.28c3.41-.28,7.08.18,6.64,3.73s-6.57,2.81-6.94,5.23-4.14,4.81-5.08,3.83-4.79-6.09-6.42-7-.65-4.31,1.54-6S978.5,267.28,978.5,267.28Z"
              fill="#141c66"
            />
            <path
              d="M959,269.9c0,5.4,9.25-1.21,5.7-4.3s-4.24-4.46-3.49-6.86-4.34-3.17-5.22-2.66-2.91,3.52-2.17,6.13S959,266.67,959,269.9Z"
              fill="#141c66"
            />
            <path
              d="M962.49,278.36c-5.2-1.46,3.71-8.56,5.7-4.29s3.13,5.3,5.64,5.24,1.85,5,1.11,5.75-4.18,1.83-6.49.4S965.6,279.24,962.49,278.36Z"
              fill="#141c66"
            />
            <path
              d="M968.84,280.28c1.34-.24.54,2.61.54,2.61s1.19-1.05,2.24-.62.14,1.68.14,1.68c1-.62,1.51,1.88,0,2.17h0a5.48,5.48,0,0,1-3.35-.66,4.58,4.58,0,0,1-1.28-1.31l-.87-2.09A5.24,5.24,0,0,1,968.84,280.28Z"
              fill="#141c66"
            />
            <path
              d="M961.85,274.47c-1.72.22-12.86,8-17,12.84,0,0-1.8-3.55-3.06-4.13-.4.15-.11-.07-.11-.07s18.34-7,19.93-14.15-6-7.89-6-7.89,3.44-.85,5.48,1.44,1.41,8,.91,8.66c0,0,4.85-3.45,5.36-6.23s3.19-1.74,3.19-1.74-2.14-1.55-3.92,4.89c-.92,3.35-5.92,5.23-5.92,5.23s4-1.36,5.26,1.76-.57,7,1.46,9.26a16.1,16.1,0,0,1-2.34-6.3A3.78,3.78,0,0,0,961.85,274.47Z"
              fill="#141c66"
            />
            <path
              d="M965.05,277.65a3.74,3.74,0,0,0-3.2-3.18,18.86,18.86,0,0,0-4.46,2.49c2.11-2.81,6.37-3.83,7-3.6a3.11,3.11,0,0,1,1.61,1.72,7.16,7.16,0,0,1,.47,2.33Z"
              fill="#141c66"
            />
            <path
              d="M961.54,270.9a10.23,10.23,0,0,1-4.2,3.65h0c2.17-1.77,3.81-3.68,4.24-5.59a9.59,9.59,0,0,0,.18-1.21l.35-.5A7.4,7.4,0,0,1,961.54,270.9Z"
              fill="#141c66"
            />
            <path
              d="M965,276.54c1,.72,2.38-.22,3.15.95s-.74,2.52-1.09,4.24.46,2.3.66,3.31-5.87,1.24-6.37-2.42-.56-3.23-.65-4.56S962.74,275,965,276.54Z"
              fill="#141c66"
            />
            <g>
              <path d="M963.37,270.12c0,.06,0,.06,0,0l0,0Z" fill="#141c66" />
              <path
                d="M963.92,269.64c1.42-1.26,3.17-3.09,3.46-4.7a2.46,2.46,0,0,1,.74-1.47l.43.38a11,11,0,0,0-1.9,4.24c0,.06,0,.11,0,.16C965.68,268.81,964.6,269.21,963.92,269.64Z"
                fill="#141c66"
              />
            </g>
            <path
              d="M961.37,266c.31-1.2,2-1.38,1.78-2.77s-2.2-1.44-3.57-2.52-1.15-2-1.66-2.94-5.26,2.87-3.27,6,1.67,2.82,2.47,3.89S960.68,268.71,961.37,266Z"
              fill="#141c66"
            />
            <path
              d="M971.45,260.38c1.5-.12,3.1.08,2.91,1.63s-2.88,1.23-3,2.29-1.81,2.1-2.22,1.67a23.11,23.11,0,0,0-2.81-3c-.71-.38-.28-1.89.67-2.63S971.45,260.38,971.45,260.38Z"
              fill="#141c66"
            />
            <path
              d="M955.35,262.46c-.14.39.32.9.69,1.11s1.46-.32,1.67.31-.1,1.26.49,1.7,1-.26,1.56.45.75,1.54.4,1.84l-.1.07h0l-.1.05a2.3,2.3,0,0,1-2.84-.32c-.8-1.07-.47-.78-2.47-3.89a3,3,0,0,1-.47-1.34C954.15,262,955.49,262.06,955.35,262.46Z"
              fill="#141c66"
            />
            <path
              d="M961.25,278.75c.54.72.84,2.74,1.7,2.4s2.11,1,1.91,1.37a1.77,1.77,0,0,0,.66,1.9c.63.29.35,1.27-.08,1.24-1.71-.13-3.79-1-4.08-3-.35-2.54-.48-3.11-.56-3.67C960.79,278.69,960.84,278.2,961.25,278.75Z"
              fill="#141c66"
            />
            <path
              d="M967.48,269.87c1.35-.3,2,.95,2.45,1.83s-.76,1.44.2,1.69.81,2.5-.43,2.62h0a15,15,0,0,0-3-2.9c-1-.54-1-2.06-.35-3.55l.36-.71h0S966.12,270.18,967.48,269.87Z"
              fill="#141c66"
            />
            <path
              d="M974.33,277.68c.7-1,2.45-.27,1.69-1.28s-3-1.91-1.43-2.85,2-2,1.09-3,.81-3.67,1.81-3.46-3.63-2.68-3.81.26.8,3.23,0,3.71-2.22,1.67-1.41,3.21-2.38,1.18-2,2.52S972.48,280.3,974.33,277.68Z"
              fill="#141c66"
            />
            <path
              d="M941.65,283.11s1.14-.44,2.87-1.2c3.45,1.66,8.14-1.57,8.28-1.66a57,57,0,0,0-8,7.06s-1.8-3.55-3.06-4.13C941.36,283.33,941.65,283.11,941.65,283.11Z"
              fill="#141c66"
            />
            <path
              d="M944.24,286.25a14.21,14.21,0,0,0,2.06-2.05,23.46,23.46,0,0,1,3.85-2.9c1.28-.81,6.06-3.81,6.56-4.44s1.76-2.34,3-2.57,2.59-.57,3.58,0a5.54,5.54,0,0,1,1.7,2.25"
              fill="#141c66"
            />
            <path
              d="M952.06,279.27c-1.33.74-1.32,1.3-2.63,1.11a4.75,4.75,0,0,0-3.88,2.11,11.66,11.66,0,0,1-2.21,2.35"
              fill="#141c66"
            />
            <path
              d="M965.9,268.83c-.73.66-.85,1.11-1.58,1.35s-1.47,2.39-3.56,3.15-4.21,3.42-4.21,3.42"
              fill="#141c66"
            />
          </g>
          <g>
            <path
              d="M948.5,244.46c4.34-7.18,5.83-8.81,4-13.65s-3.63-.71-1.78-9.81-5.19-11.8-8.39-12.15-18.34,8.53-15.78,13.36,3.65,18.55.9,19.69S943.38,252.93,948.5,244.46Z"
              fill="#396039"
            />
            <path
              d="M945.58,227.76c-.14-3.91,5.76-5.48,3.84-7.25s-4.19-6.4-6-4-3.27,6-4.69,4-3-2.07-3.91,0-.15,4.62-2.35,4-3.2.35-2.91,2.49,1.91,1.27,3.34,3.83,7.82,2.21,6.75.79S945.58,227.76,945.58,227.76Z"
              fill="#447244"
            />
            <path
              d="M956.6,221c3.2-5,7.68-9.67,12.16-5.33s-3,12.09,0,15.14,2.35,10.81,0,11.1-13.51.28-16.42,1.63-6.69-3.63-6.76-8.46S956.6,221,956.6,221Z"
              fill="#6b996b"
            />
            <path
              d="M939.75,250.93c7.49,5.71,8-14.14,0-12.44s-10.66,1.21-13.22-2.34-9,2.7-9.17,4.48,1.85,7.74,6.25,9.45S935.27,247.52,939.75,250.93Z"
              fill="#447244"
            />
            <path
              d="M955.23,254.92c-7.49,5.7-8-14.15,0-12.45s10.66,1.21,13.22-2.34,9,2.7,9.18,4.48-1.85,7.75-6.26,9.45S959.71,251.5,955.23,254.92Z"
              fill="#447244"
            />
            <path
              d="M964.57,248.09c1.06-2.13,4.19,2,4.19,2s-.21-2.77,1.49-3.77,2.49,1.57,2.49,1.57c.14-2,4.2-.14,3.06,2.22h0a9.44,9.44,0,0,1-4.43,4,7.78,7.78,0,0,1-3.17.41l-3.82-1S963.5,250.22,964.57,248.09Z"
              fill="#396039"
            />
            <path
              d="M949.14,251.72c-1.5,2.63-2.35,26.3,0,37.18,0,0-6.83-1.21-9-.07-.21.71-.21.07-.21.07s9.45-32.92,1.2-42.59-17.2,0-17.2,0,2.42-5.68,7.75-6.11,12.65,6.47,13,7.82c0,0,.28-10.38-3.06-14s.93-6.25.93-6.25-4.41,1.35,2.7,10.59c3.68,4.79,1.06,13.72,1.06,13.72s2.28-7,8-5.47,9.1,8.1,14.43,7.68a28,28,0,0,1-11.23-3.35A6.58,6.58,0,0,0,949.14,251.72Z"
              fill="#704d3c"
            />
            <path
              d="M956.92,250.6a6.51,6.51,0,0,0-7.78,1.12c-.52.9-1,4.31-1.21,8.82-1.71-5.89,1.35-12.88,2.32-13.5a5.36,5.36,0,0,1,4.08-.44,12.68,12.68,0,0,1,3.75,1.78Z"
              fill="#634b42"
            />
            <path
              d="M943.84,248.41c.78,1.78,1.64,7,.68,9.68h0c-.19-4.88-1.12-9.17-3.35-11.78a16.49,16.49,0,0,0-1.47-1.52l-.34-1A12.69,12.69,0,0,1,943.84,248.41Z"
              fill="#44322c"
            />
            <path
              d="M955.34,249.5c2.06-.67,2.19-3.56,4.63-3.39s2.73,3.68,4.75,5.95,3.68,1.78,5.3,2.57-4.43,9.46-10,6.32-5.09-2.6-7-3.88S950.75,251,955.34,249.5Z"
              fill="#6b996b"
            />
            <g>
              <path d="M944.67,245c0,.13,0,.15,0,.07V245Z" fill="#7f2c03" />
              <path
                d="M944.59,243.78c-.26-3.3-1-7.67-2.92-9.77a4.27,4.27,0,0,1-1.27-2.57l1-.19c.35,1.58,1.42,3.86,3.92,7.1l.16.22C945.29,240.44,944.7,242.36,944.59,243.78Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M936.89,243.52c-1.35-1.69.13-4.17-2-5.38s-4.31,1.56-7.25,2.34-4-.55-5.83-.78-1.54,10.33,4.88,10.82,5.68.63,8,.64S939.89,247.3,936.89,243.52Z"
              fill="#6b996b"
            />
            <path
              d="M939.6,223.57c1.4-2.21,3.36-4.23,5.32-2.34s-1.31,5.29,0,6.63,1,4.73,0,4.85-5.91.13-7.19.72-2.92-1.59-3-3.7S939.6,223.57,939.6,223.57Z"
              fill="#6b996b"
            />
            <path
              d="M925.6,248.16c.41.61,1.59.5,2.27.22s1.08-2.38,2.19-2,1.64,1.46,2.87,1.1.7-1.68,2.27-1.7,2.93.57,3,1.38c0,.07,0,.14,0,.21h0a1,1,0,0,0,0,.18c-.28,2.09-2,3.62-3.43,3.62-2.33,0-1.58-.16-8-.64a5.26,5.26,0,0,1-2.36-.75C923.63,249.3,925.2,247.54,925.6,248.16Z"
              fill="#447244"
            />
            <path
              d="M954.47,257.05c1.56,0,4.69,1.7,5.12.14s3.55-1.92,3.91-1.21,2.27,1.64,3.34,1.07,2.13.85,1.65,1.41c-2,2.24-5.32,4.28-8.52,2.49-3.9-2.18-4.84-2.59-5.7-3.06C953.91,257.62,953.27,257.05,954.47,257.05Z"
              fill="#396039"
            />
            <path
              d="M948.64,239.06c1-2.2,3.41-1.78,5.12-1.49s1.21,2.56,2.56,1.49,4.33,1.49,3.21,3.34h0c-3,.21-5.91.55-7.19,1.14-1.81.84-3.94-.75-5.32-3.23l-.6-1.26h0S947.64,241.27,948.64,239.06Z"
              fill="#447244"
            />
            <path
              d="M966.7,237.71c-.64-2,2.2-3.7,0-3.7s-5.83,2.21-5.48-1-.64-4.91-3.05-4.69-4.26-5-2.92-6.15-7.53,2.24-3.62,5.58,5.33,2.27,5.19,3.84,0,4.83,3,5.33-.85,4.55,1.39,5.47S968.4,243,966.7,237.71Z"
              fill="#447244"
            />
            <path
              d="M940,288.9s.58-2,1.34-5.26c5.93-3,6.36-13,6.37-13.25,0,6.74.44,13.82,1.46,18.51,0,0-6.83-1.21-9-.07C940,289.54,940,288.9,940,288.9Z"
              fill="#44322c"
            />
            <path
              d="M947.05,288.6c0-1.92-.62-3.74-.87-5.64a37.82,37.82,0,0,1-.12-5.73c.21-3.81.6-7.6.78-11.4,0-.95.1-1.9.12-2.85a10.64,10.64,0,0,0-.05-1.39c-.08-.43-.24-.91-.34-1.37a17,17,0,0,1-.49-2.84,5.87,5.87,0,0,1,.39-2.89c.43-.86.84-1.71,1.34-2.54a6.59,6.59,0,0,1,1.9-2.17,4.79,4.79,0,0,1,2.78-.67,12.79,12.79,0,0,1,2.83.4,12.25,12.25,0,0,0-2.83-.29,4.62,4.62,0,0,0-2.66.73c-1.53,1.12-2.23,3-3.06,4.68a5.66,5.66,0,0,0-.32,2.72,17.83,17.83,0,0,0,.5,2.78c.1.47.26.89.35,1.4a10.31,10.31,0,0,1,.06,1.46c0,1-.05,1.91-.1,2.86-.21,3.81-.59,7.61-.87,11.4a37.27,37.27,0,0,0,0,5.69C946.56,284.82,947.16,286.68,947.05,288.6Z"
              fill="#44322c"
            />
            <path
              d="M945.55,270.38a15.36,15.36,0,0,0,0,2.35,3.52,3.52,0,0,1-.14,1.2,3.24,3.24,0,0,1-.63,1.06,6.32,6.32,0,0,0-1.75,4.13,9.83,9.83,0,0,0,0,2.3,16.66,16.66,0,0,0,.61,2.24,19.17,19.17,0,0,1,.5,4.7,25.44,25.44,0,0,0-.82-4.61,12.57,12.57,0,0,1-.67-2.28,10.14,10.14,0,0,1-.07-2.4,9,9,0,0,1,.57-2.33,5.3,5.3,0,0,1,1.37-2,3,3,0,0,0,.62-.93,3.36,3.36,0,0,0,.18-1.11A15.44,15.44,0,0,1,945.55,270.38Z"
              fill="#44322c"
            />
            <path
              d="M945.55,240.16c.08.91.43,1.74.48,2.68a3.17,3.17,0,0,1-.07.69,2.24,2.24,0,0,0-.12.64,5.94,5.94,0,0,0,.26,1.28,12.9,12.9,0,0,1,.77,5.39c-.11.94-.49,1.76-.58,2.64a18.17,18.17,0,0,0-.14,2.66,32.24,32.24,0,0,0,.61,5.35,24,24,0,0,1-.93-5.34,14.69,14.69,0,0,1,.08-2.73c.09-.92.45-1.78.54-2.64a13.18,13.18,0,0,0-.67-5.25,5.6,5.6,0,0,1-.2-1.37,2.27,2.27,0,0,1,.15-.68,2.83,2.83,0,0,0,.09-.65C945.85,242,945.56,241.06,945.55,240.16Z"
              fill="#44322c"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <rect
                x="365.88"
                y="429.29"
                width="1.91"
                height="33.71"
                rx="0.95"
                fill="#a39bb2"
              />
              <g>
                <ellipse
                  cx="366.84"
                  cy="420.36"
                  rx="3.91"
                  ry="0.77"
                  fill="url(#e560be48-7cb1-4f74-a7a8-dcec9f99f3a8)"
                />
                <ellipse
                  cx="366.84"
                  cy="421.7"
                  rx="5.39"
                  ry="1.01"
                  fill="url(#b0ad335c-ae5a-4ad8-8856-006e91eaa192)"
                />
                <ellipse
                  cx="366.84"
                  cy="423.03"
                  rx="6.88"
                  ry="1.25"
                  fill="url(#b2532a7c-b025-4629-a1ba-879ad9a784ea)"
                />
                <ellipse
                  cx="366.84"
                  cy="424.37"
                  rx="8.36"
                  ry="1.49"
                  fill="url(#ac7fb9b1-8f34-4162-ae8a-aa7bde386270)"
                />
                <ellipse
                  cx="366.84"
                  cy="425.7"
                  rx="9.84"
                  ry="1.72"
                  fill="url(#f67fb4c4-79b3-45b3-bf2b-b191552aa565)"
                />
                <ellipse
                  cx="366.84"
                  cy="427.04"
                  rx="11.33"
                  ry="1.96"
                  fill="url(#a339ba60-5c48-46a8-9a06-61d9669c4262)"
                />
                <ellipse
                  cx="366.84"
                  cy="429"
                  rx="10.21"
                  ry="1.8"
                  fill="url(#e83cef85-fd5b-476d-bf09-12e81c1f22fb)"
                />
                <ellipse
                  cx="366.84"
                  cy="430.97"
                  rx="9.1"
                  ry="1.63"
                  fill="url(#e553b056-e908-4785-8200-8045662cf26c)"
                />
                <ellipse
                  cx="366.84"
                  cy="432.94"
                  rx="7.99"
                  ry="1.46"
                  fill="url(#ac1d384a-3614-4216-a566-1371bbfa2521)"
                />
                <ellipse
                  cx="366.84"
                  cy="434.91"
                  rx="6.87"
                  ry="1.3"
                  fill="url(#b98359e4-e056-4c70-af5d-a24d0c5e842a)"
                />
                <ellipse
                  cx="366.84"
                  cy="436.87"
                  rx="5.76"
                  ry="1.13"
                  fill="url(#bc4ae6c0-8b48-4b46-90c4-2e4e03306f1b)"
                />
              </g>
            </g>
            <circle
              cx="366.64"
              cy="428"
              r="19"
              fill="url(#f1df4704-fc35-40a7-a4a2-9caee2738a43)"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <rect
                x="360.88"
                y="323.29"
                width="1.91"
                height="33.71"
                rx="0.95"
                fill="#a39bb2"
              />
              <g>
                <ellipse
                  cx="361.84"
                  cy="314.36"
                  rx="3.91"
                  ry="0.77"
                  fill="url(#e4dcb444-f9c9-4f6f-8cd7-92fd96adb20b)"
                />
                <ellipse
                  cx="361.84"
                  cy="315.7"
                  rx="5.39"
                  ry="1.01"
                  fill="url(#b91ad7b7-39c0-4c4e-bf6d-654a03b33b57)"
                />
                <ellipse
                  cx="361.84"
                  cy="317.03"
                  rx="6.88"
                  ry="1.25"
                  fill="url(#af442fd8-1490-485e-b4d0-637c8b94ca56)"
                />
                <ellipse
                  cx="361.84"
                  cy="318.37"
                  rx="8.36"
                  ry="1.49"
                  fill="url(#fdef9908-9612-4c09-89a0-96bc1f634221)"
                />
                <ellipse
                  cx="361.84"
                  cy="319.7"
                  rx="9.84"
                  ry="1.72"
                  fill="url(#f46d8305-7d1f-4d0b-a54f-486f4d6680cc)"
                />
                <ellipse
                  cx="361.84"
                  cy="321.04"
                  rx="11.33"
                  ry="1.96"
                  fill="url(#fece5287-b9aa-4d6d-ac27-b0ce06521360)"
                />
                <ellipse
                  cx="361.84"
                  cy="323"
                  rx="10.21"
                  ry="1.8"
                  fill="url(#b1aeb61a-f9b8-4367-9093-4405bd5e099d)"
                />
                <ellipse
                  cx="361.84"
                  cy="324.97"
                  rx="9.1"
                  ry="1.63"
                  fill="url(#e314ec30-29e7-4d5a-9496-36c76f206df4)"
                />
                <ellipse
                  cx="361.84"
                  cy="326.94"
                  rx="7.99"
                  ry="1.46"
                  fill="url(#e87301aa-0f2c-47a9-b9b1-498014ab04c8)"
                />
                <ellipse
                  cx="361.84"
                  cy="328.91"
                  rx="6.87"
                  ry="1.3"
                  fill="url(#bbb109ad-1a54-436e-93f8-dd5e52aa0049)"
                />
                <ellipse
                  cx="361.84"
                  cy="330.87"
                  rx="5.76"
                  ry="1.13"
                  fill="url(#ae929960-be27-4ea6-88c7-50df15c2cf4f)"
                />
              </g>
            </g>
            <circle
              cx="361.64"
              cy="322"
              r="19"
              fill="url(#a88c4ca5-9797-4cbf-9c1e-9afdc769d89d)"
            />
          </g>
        </g>
        <g>
          <ellipse
            cx="1307.64"
            cy="356.12"
            rx="161"
            ry="50.88"
            fill="#324b77"
          />
          <ellipse
            cx="1307.64"
            cy="346.87"
            rx="161"
            ry="50.88"
            fill="url(#b14b543c-6321-495a-af1c-10106bd7b6dc)"
          />
          <g opacity="0.71">
            <path
              d="M1240.29,356.12a15.15,15.15,0,0,0-2.32,1c-.69.4-1.32,1-1.33,1.54a2.48,2.48,0,0,0,.89,1.72,11.91,11.91,0,0,0,1.83,1.52,37.37,37.37,0,0,0,4.27,2.47c1.49.76,3,1.47,4.55,2.11s3.09,1.28,4.66,1.86,3.16,1.11,4.75,1.63,3.22.95,4.86,1.27a13.29,13.29,0,0,0,5,.3,10.65,10.65,0,0,1-5.12.82,30.84,30.84,0,0,1-5.17-.65,51.79,51.79,0,0,1-9.88-3.12,36.76,36.76,0,0,1-9-5.28,11.8,11.8,0,0,1-1.89-2,5.71,5.71,0,0,1-.71-1.29,2.65,2.65,0,0,1-.12-1.61,2.37,2.37,0,0,1,.93-1.29,4.52,4.52,0,0,1,1.25-.61A10.37,10.37,0,0,1,1240.29,356.12Z"
              fill="#d66e9f"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1335.3,371.54c6.82-.31,13.65.44,20.43,1,3.38.31,6.76.62,10.13.7a53.44,53.44,0,0,0,10-.49,27.46,27.46,0,0,0,9.22-3.1,24.58,24.58,0,0,0,3.92-2.81,43.55,43.55,0,0,0,3.4-3.59,71.83,71.83,0,0,1,7.35-7.35,31.58,31.58,0,0,1,9.09-5.49c3.3-1.26,6.5-2.2,9.6-3.47.78-.3,1.54-.64,2.31-1a9.08,9.08,0,0,0,2-1,3.18,3.18,0,0,0,1.22-3.22,10.73,10.73,0,0,0-1.78-4.1,26.64,26.64,0,0,0-3.08-3.76,52.24,52.24,0,0,0-7.68-6.33,70.06,70.06,0,0,0-18.06-8.76,55.47,55.47,0,0,0-20-2.74,52.49,52.49,0,0,1,20.4,1.38,67,67,0,0,1,18.92,8.23,48.79,48.79,0,0,1,8.22,6.44,28.9,28.9,0,0,1,3.47,4.06,13,13,0,0,1,2.3,5.17,6.31,6.31,0,0,1-.25,3.2,5.79,5.79,0,0,1-2,2.63,11.12,11.12,0,0,1-2.53,1.39c-.8.34-1.59.7-2.39,1-3.2,1.33-6.53,2.34-9.59,3.54-6.15,2.23-10.94,7-15.48,12a43.51,43.51,0,0,1-3.71,3.74,25.87,25.87,0,0,1-4.42,3,26.27,26.27,0,0,1-4.94,2.05,33.09,33.09,0,0,1-5.18,1.07c-7,.85-13.86-.11-20.6-1-3.37-.5-6.73-1-10.1-1.47S1338.71,371.71,1335.3,371.54Z"
              fill="#31586d"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1232.15,316c-5.5,2.59-11.09,5-16.7,7.28-2.8,1.17-5.63,2.27-8.44,3.4s-5.71,2.18-8.43,3.29a28.07,28.07,0,0,0-7.49,4.45,13,13,0,0,0-4.56,6.92,11.07,11.07,0,0,0,1.58,8.15,25.81,25.81,0,0,0,6,6.59,22.44,22.44,0,0,1-7-6,13.61,13.61,0,0,1-2.12-4.26,11.21,11.21,0,0,1-.29-4.86,14.53,14.53,0,0,1,4.89-8.22,29.65,29.65,0,0,1,8-4.93c5.74-2.21,11.39-4.25,17.14-6.24S1226.31,317.74,1232.15,316Z"
              fill="#d66e9f"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1319,316c-7-.26-14-1.05-20.91-1.54s-13.92-.57-19.72,2.61a24.2,24.2,0,0,0-4.13,2.73l-1,.81a11.17,11.17,0,0,1-1.12.83,23.83,23.83,0,0,1-2.34,1.45,50.2,50.2,0,0,1-10,3.91c-3.39,1-6.83,1.72-10.2,2.55a34.74,34.74,0,0,0-4.93,1.49,4.24,4.24,0,0,0-2,1.38,1.49,1.49,0,0,0-.19,1.14,5.5,5.5,0,0,0,.23.59l.35.55-.44-.49a5.58,5.58,0,0,1-.35-.58,1.77,1.77,0,0,1,0-1.41,4.67,4.67,0,0,1,2-1.89,32,32,0,0,1,4.89-2.14c3.33-1.16,6.66-2.18,9.92-3.34a54.55,54.55,0,0,0,9.34-4.15c.71-.43,1.42-.86,2.08-1.34a10.55,10.55,0,0,0,1-.75l1-.8a27,27,0,0,1,4.57-3.1,26.32,26.32,0,0,1,10.61-2.83,57.42,57.42,0,0,1,10.68.55C1305.31,313.19,1312.15,314.59,1319,316Z"
              fill="#305891"
            />
          </g>
        </g>
        <g>
          <ellipse
            cx="1408.39"
            cy="417.08"
            rx="44.89"
            ry="7.92"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1384.83,410.25c-7.72,3.91-9.38,4.74-16.33,2s-20.85-18.9-5.28-29.74,31.41,3.61,31.41,10c0,0-27-28.08,0-35.31s18.07,21.13,16.12,25.3c0,0,9.73-19.18,20.85-13.34s4,41.92-16.5,32.63c0,0,27.62-13.18,36.23,1s-47,17-56.7,12.23S1384.83,410.25,1384.83,410.25Z"
            fill="#1f441f"
          />
          <path
            d="M1384.2,376.76c7,2.8,4.59-11,4.59-11s3.06-1.67,3.13-7.75C1381.54,361.92,1381.39,369.62,1384.2,376.76Z"
            fill="#659965"
          />
          <path
            d="M1408.25,386.92c-19.74-1.95-20-18.63-9.18-23.35S1408.25,386.92,1408.25,386.92Z"
            fill="#245624"
          />
          <path
            d="M1399.28,401.52c-32,5.21-38.17-17.46-22.57-28.23S1399.28,401.52,1399.28,401.52Z"
            fill="#245624"
          />
          <path
            d="M1412.68,400.84c24.06,14.18,38.23-4.55,29.83-18.93S1412.68,400.84,1412.68,400.84Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1410.75,382.47c10,6.67,12-5.28,12-5.28,4.28-.59,5.56-4.84,6-9.06C1418.81,366.57,1410.75,382.47,1410.75,382.47Z"
              fill="#659965"
            />
            <path d="M1410.75,382.47c.2-.43.47-1.12.77-2Z" fill="#659965" />
          </g>
          <path
            d="M1422.39,405c13.74,3.61,22.44-4.63,22.55-14.21-.51.45-1,.86-1.51,1.23-6.55,4.86-11.83,2.94-11.83,2.94s-.84,11.12-8.9,8.2Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1388.09,413.19s-24.46-8.62-18.62-22.52,14.18-6.39,18.62,11.12c0,0-5.83-37.25,15.57-32.25s5.28,31.41,0,32.25c0,0,15.57-21.13,25.58-5.84s-16.41,18.35-23.08,17.24S1388.09,413.19,1388.09,413.19Z"
              fill="#659965"
            />
            <path
              d="M1429.24,396a14.24,14.24,0,0,0-3.65-3.92c-3,11.17-14,9.9-14,9.9s.28,10.28-11.67,8.34l-1.18,2.42a48.79,48.79,0,0,1,7.43.5C1412.83,414.3,1439.24,411.24,1429.24,396Z"
              fill="#396039"
            />
            <path
              d="M1394.63,398.87s7.22,3.44,16-4.42c3.84-6.66,6.29-16.23,0-21.62-4.31,10.75-11.84,10.75-11.84,10.75S1406.86,396.92,1394.63,398.87Z"
              fill="#396039"
            />
            <path
              d="M1388.79,413.12a21.88,21.88,0,0,1-9.17-10.36c-6.74.87-9.74-6.92-10.73-10.36-3.24,12.88,19.2,20.79,19.2,20.79Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1370.16,407.21a29.66,29.66,0,0,1-9.51-1.45,21.47,21.47,0,0,0,7.85,6.45c6.46,2.59,8.36,2.05,14.78-1.18A31.5,31.5,0,0,1,1370.16,407.21Z"
            fill="#172d17"
          />
          <path
            d="M1451.19,402.54c-3.54,7.37-13,8.17-16.26,7.17,0,0-4.4,5.71-20.35,7.38,18.89-.34,42.6-4.71,36.75-14.33Z"
            fill="#172d17"
          />
          <path
            d="M1388.79,413.05c-8.06-3.34-5.28-11.4,0-10.29S1388.79,413.05,1388.79,413.05Z"
            fill="#245624"
          />
          <path
            d="M1388.3,412.66c12.79,12.41,25.65.66,19.28-8.34S1388.3,412.66,1388.3,412.66Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M1259.62,408c.23-.22.48-.44.73-.64a6.19,6.19,0,0,1,1.16-.81c.37-.21.77-.35,1.15-.52a3.89,3.89,0,0,0,1-.56c.31-.26.56-.58.86-.85a2.79,2.79,0,0,1,.79-.48,5,5,0,0,1,.64-.16,4.49,4.49,0,0,1,.64,0,.08.08,0,0,0,.09-.07,4.57,4.57,0,0,1,2.79.61,4.43,4.43,0,0,1,1.73,2,1.44,1.44,0,0,0-.08.46,3,3,0,0,0,.3,1,1.9,1.9,0,0,1,.19,1.14,9.21,9.21,0,0,1-.48,1.23,2.41,2.41,0,0,0-.12.66,2.15,2.15,0,0,0,.13.61,1.51,1.51,0,0,1,.06.7,5.31,5.31,0,0,1-.19.65,3.75,3.75,0,0,0-.11.67,4.36,4.36,0,0,1-.11.52,6.18,6.18,0,0,1-1.45,2,3.29,3.29,0,0,0-.72,1.22,6.49,6.49,0,0,0-.17,1.16,2.68,2.68,0,0,1-.21.93,2.88,2.88,0,0,1-.89,1c-.83.69-1.75,1.27-2.54,2a6.06,6.06,0,0,0-.55.58c-.16.19-.3.4-.47.59a1.7,1.7,0,0,1-.81.51,7,7,0,0,1-.92.13,2.46,2.46,0,0,0-1.28.44,2,2,0,0,1-.57.43,1.52,1.52,0,0,1-.6.06,6.11,6.11,0,0,0-1.21-.09l0,0a4.49,4.49,0,0,1-1.2-.5,4.29,4.29,0,0,1-1.34-1.31,6.59,6.59,0,0,0-.22-1.4c-.13-.52-.3-1-.38-1.57a4,4,0,0,1,0-.78c0-.26,0-.51,0-.77,0-.5-.1-1-.07-1.5a2.21,2.21,0,0,1,.21-.8c.12-.25.27-.47.41-.71a2.72,2.72,0,0,0,.29-.73,7.14,7.14,0,0,0,.11-.79c0-.35,0-.71.08-1.06.3-.65.64-1.31,1-2a3.81,3.81,0,0,1,.87-.21c.44-.07.88-.09,1.33-.15,0,0,.12-.07.09-.14a9.88,9.88,0,0,1-.45-1,1.25,1.25,0,0,1,.12-1.28Z"
                fill="#141c66"
              />
              <path d="M1269,405.2s-5.76,14.51-27.22,37.56" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1259.21,435.2c.38-.27.73-.57,1.09-.87a30.36,30.36,0,0,1,6.76-2.38c.31.05.63.1.94.12a11.81,11.81,0,0,0,1.19,0h1.36a9.53,9.53,0,0,0,2.61-.32c.41-.13.79-.34,1.19-.5a8.09,8.09,0,0,1,.83-.28c4.43,0,7.65,1.07,8,3a2,2,0,0,1,0,.78,3.55,3.55,0,0,1-.23.31,5.3,5.3,0,0,1-1.32,1.18,7.17,7.17,0,0,1-1.56.73,11.74,11.74,0,0,0-1.9.71,7.33,7.33,0,0,0-1.44,1.16,9.08,9.08,0,0,1-1.41,1.22,2.54,2.54,0,0,1-1.56.49,4.55,4.55,0,0,1-1.15-.37,4.93,4.93,0,0,0-1.42-.25,1.3,1.3,0,0,0-1,.3c-.28.27-.48.61-.75.89a3.18,3.18,0,0,1-2.51.88,12.7,12.7,0,0,1-2.78-.62c-.49-.14-1-.28-1.48-.38-.26-.05-.51-.09-.77-.12s-.59,0-.88-.05a11.67,11.67,0,0,1-3.47-1c-.56-.23-1.12-.44-1.69-.61-.17-1,.43-2,1.6-3A7.37,7.37,0,0,0,1259.21,435.2Z"
                fill="#141c66"
              />
              <path d="M1283.8,434.27s-25.23.52-42,9.68" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1257.21,436.91c.33-.17.65-.35,1-.55a24,24,0,0,1,5.6-1c.24.08.48.15.73.21a9.28,9.28,0,0,0,.92.15l1.08.16a7.63,7.63,0,0,0,2.08.09c.34-.05.66-.17,1-.24s.45-.09.68-.12c3.48.57,5.86,1.82,5.91,3.33a1.51,1.51,0,0,1-.11.62l-.22.21a4.58,4.58,0,0,1-1.18.76,6.63,6.63,0,0,1-1.32.37,8.49,8.49,0,0,0-1.58.31,5.37,5.37,0,0,0-1.27.73,7.22,7.22,0,0,1-1.27.78,2,2,0,0,1-1.28.18,4.07,4.07,0,0,1-.86-.43,3.65,3.65,0,0,0-1.08-.38,1,1,0,0,0-.83.1c-.25.18-.45.43-.69.61a2.52,2.52,0,0,1-2.08.37,10,10,0,0,1-2.1-.84c-.37-.17-.74-.34-1.12-.48a5.84,5.84,0,0,0-.59-.2c-.22-.06-.45-.1-.68-.15a9.28,9.28,0,0,1-2.59-1.21,12.73,12.73,0,0,0-1.25-.69c0-.78.59-1.52,1.64-2.16A5.83,5.83,0,0,0,1257.21,436.91Z"
                fill="#141c66"
              />
              <path d="M1276.6,439.3s-19.84-2.8-34.13,2.26" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1253.38,432.11a.51.51,0,0,0,.4,0,.57.57,0,0,0,.19-.41,4,4,0,0,0,0-.78v0a3.4,3.4,0,0,0,.53.08.65.65,0,0,0,.37-.07c.2-.14.14-.41.08-.61s-.08-.28-.12-.41c.29-.32.59-.65.91-1l.19.15a4.2,4.2,0,0,0,.5.36,1.07,1.07,0,0,0,.46.17.1.1,0,0,0,.11-.11c0-.21-.09-.42-.13-.63a1.36,1.36,0,0,1,0-.6c.06-.23.31-.27.48-.4a.6.6,0,0,0,.19-.44,2.09,2.09,0,0,0,0-.25c.4-.37.82-.74,1.25-1.12l.28.21a1.58,1.58,0,0,0,.77.37.62.62,0,0,0,.68-.36,1.47,1.47,0,0,0,0-1,3.75,3.75,0,0,0-.17-.47l.41-.43c.44-.35.89-.7,1.35-1h.08a.83.83,0,0,1,.34.13,1.75,1.75,0,0,0,.58.17.09.09,0,0,0,.11-.08c0-.3-.08-.9.31-1,.12,0,.23.11.33.15a.29.29,0,0,0,.37-.07c.16-.21,0-.51.13-.75s.39,0,.49.13a4.56,4.56,0,0,0,.51.65.1.1,0,0,0,.16-.09c0-.52,0-1-.07-1.56,1-.65,2-1.23,2.93-1.75a1.34,1.34,0,0,0,.07.18.1.1,0,0,0,.14.05,4.48,4.48,0,0,1,.15.89c0,.19,0,.37,0,.55s.19.16.2,0a5.61,5.61,0,0,0,0-.58,8.82,8.82,0,0,0-.13-1.36c.83-.44,1.63-.83,2.37-1.15a3.79,3.79,0,0,1,.18,1.11c0,.16,0,.32,0,.48a.1.1,0,0,0,.2,0,2.81,2.81,0,0,0,0-.5c0-.32.08-.64.1-1,0-.12,0-.25,0-.37a18.75,18.75,0,0,1,2.2-.76,13.74,13.74,0,0,0,.37,1.4c0,.06.11.09.15,0a2.12,2.12,0,0,0,.59-1.05,3.25,3.25,0,0,0,.13-.62c1-.1,1.65,0,2,.51.69.93-.2,2.88-2.18,5.27-.4-.08-.8-.14-1.2-.2a.1.1,0,0,0,0,.19,5.72,5.72,0,0,0,1,.32c-.53.62-1.13,1.27-1.8,1.93a15.32,15.32,0,0,0-2,.38.1.1,0,0,0-.09.11c.07.42.17.83.26,1.24-1,.88-2,1.77-3.19,2.66a7.67,7.67,0,0,0-2,.47,4.53,4.53,0,0,0-1.24.84c-.18.17-.37.35-.56.51a6.33,6.33,0,0,0-.56.47c-.33.33-.59.74-.91,1.08a1.14,1.14,0,0,1-1.09.43,2.54,2.54,0,0,1-.76-.49.38.38,0,0,0-.32-.07.53.53,0,0,0-.27.28,2,2,0,0,0-.07,1.14c0,.12,0,.24,0,.36-4,2.09-7.14,2.85-8,1.69-.53-.72-.12-2.06,1-3.73Z"
                fill="#141c66"
              />
              <path d="M1272.91,420.29s-28.45,21.81-30.93,23" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1263.5,419.45a1.31,1.31,0,0,1,.45.6c-.06.23-.12.45-.17.68s-.16.67-.22,1a6.61,6.61,0,0,1-.22,1,6.16,6.16,0,0,1-.65,1.43,6.45,6.45,0,0,0-.81,1.59c-.12.47-.11,1-.19,1.44v0l-.42.62a19.16,19.16,0,0,1-3.09,3.47l-.31.19a26.78,26.78,0,0,0-3,1.5,1.28,1.28,0,0,1-.76-.22c-1.35-.95-.35-4.71,2.23-8.39S1262.15,418.49,1263.5,419.45Z"
                fill="#141c66"
              />
              <path d="M1256.37,424.38s1.27,7.49-12.87,18.3" fill="#141c66" />
              <path
                d="M1262.85,421.26a3.87,3.87,0,0,1-.87,1.81,8.66,8.66,0,0,0-1.27,1.43,2.54,2.54,0,0,0-.31,1c0,.33,0,.66-.08,1a1.89,1.89,0,0,1-.4,1,1.65,1.65,0,0,1-.66.46,3.33,3.33,0,0,0-.74.4,2.74,2.74,0,0,0-.69.95,3.44,3.44,0,0,1-.73,1,3,3,0,0,1-.67.34,2.16,2.16,0,0,0-.67.44,2.11,2.11,0,0,0-.44.63,1.52,1.52,0,0,1-.37.56,2,2,0,0,1-.93.33l-.11,0a.67.67,0,0,1-.3-.13c-1.06-.75.17-4.34,2.75-8s5.56-6.06,6.63-5.31a.93.93,0,0,1,.3.43A7.88,7.88,0,0,0,1262.85,421.26Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1216.82,392.68q-.09-.69-.12-1.38a10.5,10.5,0,0,1,.06-2,17.26,17.26,0,0,1,.4-1.76,5.63,5.63,0,0,0,.17-1.58c0-.58-.19-1.14-.23-1.72a3.84,3.84,0,0,1,.12-1.31q.16-.45.36-.87a5.6,5.6,0,0,1,.51-.76.14.14,0,0,0,0-.17,6.51,6.51,0,0,1,3.07-2.68,6.3,6.3,0,0,1,3.78-.26,2.14,2.14,0,0,0,.47.48,4.21,4.21,0,0,0,1.41.52,2.68,2.68,0,0,1,1.47.76,12.85,12.85,0,0,1,1,1.59,2.88,2.88,0,0,0,.66.69,2.73,2.73,0,0,0,.81.38,2.22,2.22,0,0,1,.85.53,7.38,7.38,0,0,1,.58.77,6.41,6.41,0,0,0,.68.7,6.68,6.68,0,0,1,.49.57,8.54,8.54,0,0,1,1.06,3.36,4.71,4.71,0,0,0,.79,1.87,10.11,10.11,0,0,0,1.17,1.19,3.8,3.8,0,0,1,.9,1,4.37,4.37,0,0,1,.4,1.89c.08,1.54-.05,3.09.13,4.62a10.47,10.47,0,0,0,.19,1.12c.09.35.21.69.28,1a2.37,2.37,0,0,1-.1,1.37,12.93,12.93,0,0,1-.64,1.15,3.39,3.39,0,0,0-.58,1.84,3,3,0,0,1,0,1,2.12,2.12,0,0,1-.45.73,9.93,9.93,0,0,0-1.13,1.3.13.13,0,0,0,0,.08,5.84,5.84,0,0,1-1.59,1,6.11,6.11,0,0,1-2.65.42,8.74,8.74,0,0,0-1.79-.94,20.73,20.73,0,0,1-2.12-.9,7.09,7.09,0,0,1-.93-.61c-.29-.24-.54-.51-.84-.73-.57-.43-1.23-.74-1.77-1.2a3.16,3.16,0,0,1-.75-.92c-.18-.35-.31-.71-.46-1.07a3.41,3.41,0,0,0-.58-.95,10.42,10.42,0,0,0-.82-.81c-.37-.34-.76-.66-1.14-1a29.88,29.88,0,0,1-1.38-2.84,5.58,5.58,0,0,1,.5-1.18c.3-.56.65-1.09,1-1.65a.14.14,0,0,0-.08-.21c-.51-.11-1-.2-1.53-.35a2.17,2.17,0,0,1-1-.55,2,2,0,0,1-.38-.68C1216.94,393.27,1216.88,393,1216.82,392.68Z"
                fill="#396039"
              />
              <path
                d="M1221.61,379.58a106.72,106.72,0,0,1,7,15.07c2,5.17,3.73,10.44,5.33,15.75s2.91,10.7,4.19,16.09c.62,2.7,1.18,5.41,1.77,8.12l1.52,8.17-1.66-8.14c-.61-2.7-1.18-5.41-1.82-8.11-1.3-5.38-2.66-10.75-4.28-16s-3.26-10.58-5.23-15.76c-1-2.58-2-5.15-3.15-7.68A79.23,79.23,0,0,0,1221.61,379.58Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1247.64,416.35c0-.66,0-1.32-.08-2a43.88,43.88,0,0,1,3-9.77c.33-.32.65-.65.94-1s.68-.89,1-1.35.78-1.05,1.16-1.58a13.46,13.46,0,0,0,1.85-3.26c.21-.58.29-1.19.45-1.78.11-.4.24-.8.38-1.19,3.79-5.08,7.76-7.85,10.22-6.67a2.74,2.74,0,0,1,.88.68c.06.18.11.36.16.54a7.6,7.6,0,0,1,.23,2.51,10.9,10.9,0,0,1-.5,2.4,16.16,16.16,0,0,0-.81,2.79,9.75,9.75,0,0,0,.11,2.64,13.18,13.18,0,0,1,.19,2.66,3.63,3.63,0,0,1-.77,2.2,6.65,6.65,0,0,1-1.4,1,6.69,6.69,0,0,0-1.5,1.41,1.82,1.82,0,0,0-.52,1.41c.06.55.29,1.07.39,1.61a4.6,4.6,0,0,1-1.14,3.63,18.57,18.57,0,0,1-3.08,2.65c-.58.44-1.16.89-1.7,1.38-.27.25-.54.51-.8.78s-.54.64-.81,1a16.59,16.59,0,0,1-4.07,3.14,23.48,23.48,0,0,0-2.15,1.42c-1.24-.63-1.93-2.2-2.08-4.41A10.82,10.82,0,0,0,1247.64,416.35Z"
                fill="#2f4f2f"
              />
              <path
                d="M1267.53,387.39c-1.45,2.13-2.84,4.31-4.18,6.51s-2.68,4.42-3.95,6.67q-3.81,6.75-7.07,13.78a149.89,149.89,0,0,0-5.77,14.36,104.61,104.61,0,0,0-3.72,15,90.75,90.75,0,0,1,3.54-15.08,148.85,148.85,0,0,1,5.69-14.42q3.32-7,7.17-13.75C1261.81,396,1264.54,391.6,1267.53,387.39Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M1247.89,420.1c.08-.51.14-1,.19-1.56a34.84,34.84,0,0,1,3.62-7.28,9.23,9.23,0,0,0,.86-.65c.35-.29.65-.61,1-.93s.74-.72,1.1-1.09a10.47,10.47,0,0,0,1.87-2.32c.24-.43.38-.89.58-1.34s.29-.59.45-.88c3.61-3.5,7.07-5.17,8.85-3.93a2.23,2.23,0,0,1,.61.65c0,.14,0,.29,0,.44a6.07,6.07,0,0,1-.14,2,8.33,8.33,0,0,1-.69,1.82,13.65,13.65,0,0,0-1,2.08,7.69,7.69,0,0,0-.25,2.08,10.62,10.62,0,0,1-.19,2.11,2.82,2.82,0,0,1-.88,1.63,5,5,0,0,1-1.23.61,5.62,5.62,0,0,0-1.36.92,1.49,1.49,0,0,0-.58,1c0,.44.1.88.1,1.31a3.63,3.63,0,0,1-1.35,2.7,14.69,14.69,0,0,1-2.76,1.69c-.51.27-1,.55-1.5.87a7.11,7.11,0,0,0-.72.5c-.27.21-.51.44-.77.65a13.07,13.07,0,0,1-3.58,1.94c-.64.26-1.26.53-1.86.84-.9-.64-1.24-2-1.08-3.71A8.76,8.76,0,0,0,1247.89,420.1Z"
                fill="#396039"
              />
              <path
                d="M1267.16,399.93c-1.41,1.49-2.77,3-4.1,4.58s-2.65,3.13-3.93,4.73c-2.56,3.2-5,6.51-7.29,9.9a120.86,120.86,0,0,0-6.35,10.52,83.38,83.38,0,0,0-4.84,11.29,71.24,71.24,0,0,1,4.67-11.38,117.56,117.56,0,0,1,6.29-10.59q3.48-5.07,7.37-9.86A120.87,120.87,0,0,1,1267.16,399.93Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1239.12,420.4a.77.77,0,0,0,.3-.49.84.84,0,0,0-.31-.57,6,6,0,0,0-.88-.69v0a4.59,4.59,0,0,0,.54-.54,1,1,0,0,0,.23-.48c0-.35-.36-.51-.63-.62l-.58-.21c-.12-.6-.24-1.22-.35-1.87l.35-.09c.28-.08.56-.16.84-.27a1.5,1.5,0,0,0,.58-.38.15.15,0,0,0,0-.22,9.1,9.1,0,0,0-.84-.39,1.82,1.82,0,0,1-.72-.46c-.22-.27,0-.59,0-.89a.81.81,0,0,0-.34-.59c-.09-.09-.18-.16-.27-.24-.09-.77-.16-1.56-.22-2.38l.47-.14a2.58,2.58,0,0,0,1.09-.56.9.9,0,0,0,.16-1.09,2,2,0,0,0-1.09-.81,5.39,5.39,0,0,0-.68-.22c0-.28-.09-.55-.14-.83,0-.8,0-1.61,0-2.43l.06-.09a1.41,1.41,0,0,1,.45-.28,2.29,2.29,0,0,0,.68-.51.15.15,0,0,0,0-.21c-.32-.27-1.1-.67-.88-1.21.07-.15.32-.17.45-.24a.43.43,0,0,0,.23-.49c-.1-.36-.54-.5-.74-.79s.34-.43.56-.45a6.63,6.63,0,0,0,1.18,0,.15.15,0,0,0,0-.27c-.61-.43-1.21-.86-1.85-1.25.12-1.7.28-3.32.49-4.84l.27.08a.14.14,0,0,0,.17-.13,6.65,6.65,0,0,1,1.16.59c.21.16.42.31.62.48s.35-.08.21-.21a6.48,6.48,0,0,0-.67-.5,12.66,12.66,0,0,0-1.66-1c.2-1.32.44-2.56.7-3.7a5.42,5.42,0,0,1,1.43.75l.51.46c.14.12.33-.07.2-.2a3.05,3.05,0,0,0-.53-.49c-.34-.31-.67-.63-1-.93-.13-.11-.26-.22-.4-.32a23.8,23.8,0,0,1,1-3.17,18.58,18.58,0,0,0,1.91.77.15.15,0,0,0,.18-.14,3.11,3.11,0,0,0-.7-1.57,6.46,6.46,0,0,0-.61-.68c.7-1.19,1.48-1.84,2.29-1.84,1.65,0,3.13,2.69,4.18,7-.44.39-.85.8-1.26,1.2-.11.12,0,.32.18.23a10.55,10.55,0,0,0,1.21-.86c.26,1.13.48,2.37.68,3.7a21.73,21.73,0,0,0-1.28,2.61.16.16,0,0,0,0,.2c.54.28,1.1.51,1.65.76.17,1.87.28,3.86.31,5.92a11.19,11.19,0,0,0-1.15,2.69,6.16,6.16,0,0,0-.1,2.14c0,.36.08.72.1,1.07s0,.7.06,1.05c.1.67.35,1.3.46,2a1.61,1.61,0,0,1-.43,1.62,3.77,3.77,0,0,1-1.21.45.56.56,0,0,0-.36.31.74.74,0,0,0,.1.54,2.91,2.91,0,0,0,1.24,1.06l.46.25c-1,6.36-2.82,10.6-4.89,10.6-1.27,0-2.45-1.62-3.4-4.35Z"
                fill="#659965"
              />
              <path
                d="M1242.24,388c.25,9.18.31,18.36.42,27.54v13.77c-.05,4.58,0,9.18-.41,13.76.22-2.29.17-4.59.2-6.88l0-6.88-.08-13.77Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1233.25,398a1.8,1.8,0,0,1,1.08,0c.2.27.41.53.62.78s.64.76,1,1.12a9.57,9.57,0,0,1,.94,1.08,9.31,9.31,0,0,1,1.09,2,9.15,9.15,0,0,0,1.13,2.28c.44.54,1,.94,1.49,1.44l0,0c.12.33.24.66.35,1a26.85,26.85,0,0,1,1.35,6.5c0,.17,0,.34,0,.51a41.65,41.65,0,0,0-.83,4.7,1.88,1.88,0,0,1-.89.68c-2.25.74-5.7-3.61-7.71-9.71S1231,398.75,1233.25,398Z"
                fill="#3b6818"
              />
              <path
                d="M1232.82,410.39s9.66,4.92,10,30.34"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.29"
              />
              <path
                d="M1234.77,400.31a5.55,5.55,0,0,1,1.34,2.52,11.69,11.69,0,0,0,.54,2.68,3.81,3.81,0,0,0,.88,1.2c.35.32.72.6,1.06.94a2.8,2.8,0,0,1,.77,1.28,2.35,2.35,0,0,1,0,1.15,5.18,5.18,0,0,0-.18,1.19,4.14,4.14,0,0,0,.49,1.6,4.62,4.62,0,0,1,.49,1.65,4.13,4.13,0,0,1-.18,1.06,2.9,2.9,0,0,0-.07,1.14,3,3,0,0,0,.35,1,2.26,2.26,0,0,1,.32.9,2.85,2.85,0,0,1-.41,1.34.91.91,0,0,0-.07.14,1.1,1.1,0,0,1-.4.24c-1.77.58-4.84-3.89-6.85-10s-2.2-11.53-.43-12.11a1.14,1.14,0,0,1,.75,0A11.3,11.3,0,0,0,1234.77,400.31Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M1070.74,286.81c.13-.13.27-.25.41-.37a3.75,3.75,0,0,1,.65-.45,5.24,5.24,0,0,1,.64-.29,1.84,1.84,0,0,0,.54-.32c.18-.14.32-.32.49-.47a1.53,1.53,0,0,1,.44-.27l.36-.09a2.17,2.17,0,0,1,.36,0s0,0,0,0a2.43,2.43,0,0,1,2.53,1.47.57.57,0,0,0,0,.26,1.4,1.4,0,0,0,.17.56,1.17,1.17,0,0,1,.1.64,5.8,5.8,0,0,1-.27.69,1.15,1.15,0,0,0-.06.37,1,1,0,0,0,.07.34,1,1,0,0,1,0,.39,2.15,2.15,0,0,1-.11.36c0,.13,0,.26-.06.38a1.36,1.36,0,0,1-.06.29,3.32,3.32,0,0,1-.81,1.12,2.11,2.11,0,0,0-.41.69,4.62,4.62,0,0,0-.09.65,1.52,1.52,0,0,1-.12.52,1.79,1.79,0,0,1-.49.57c-.47.38-1,.7-1.43,1.12-.11.1-.21.21-.31.32l-.26.34a1.06,1.06,0,0,1-.46.29,4.18,4.18,0,0,1-.51.06,1.55,1.55,0,0,0-.72.25.93.93,0,0,1-.32.24.91.91,0,0,1-.33,0,3.91,3.91,0,0,0-.68-.06h0a2.05,2.05,0,0,1-.67-.27,2.52,2.52,0,0,1-.75-.74,4.21,4.21,0,0,0-.12-.78,8.7,8.7,0,0,1-.22-.88,2.13,2.13,0,0,1,0-.44c0-.14,0-.29,0-.43s-.06-.56,0-.84a1.16,1.16,0,0,1,.12-.45c.06-.14.15-.26.22-.4a1.18,1.18,0,0,0,.17-.4,3.47,3.47,0,0,0,.06-.45c0-.2,0-.39,0-.59.17-.37.36-.74.57-1.1a2.92,2.92,0,0,1,.49-.12c.25,0,.5-.05.75-.08a.07.07,0,0,0,0-.08,5.62,5.62,0,0,1-.25-.56.83.83,0,0,1-.06-.44,1,1,0,0,1,.12-.28Z"
                fill="#141c66"
              />
              <path d="M1076,285.24s-3.23,8.13-15.26,21" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1070.51,302.05c.21-.15.41-.32.61-.49a17.3,17.3,0,0,1,3.78-1.33l.54.06c.22,0,.44,0,.66,0h.77a5.22,5.22,0,0,0,1.46-.18c.23-.07.44-.19.66-.28l.47-.16c2.48,0,4.28.61,4.49,1.66a1.09,1.09,0,0,1,0,.44l-.13.17a3.1,3.1,0,0,1-.74.66,4.61,4.61,0,0,1-.87.41,6,6,0,0,0-1.07.4,3.56,3.56,0,0,0-.8.65,5.23,5.23,0,0,1-.8.68,1.36,1.36,0,0,1-.87.27,2.38,2.38,0,0,1-.64-.2,2.45,2.45,0,0,0-.8-.14.77.77,0,0,0-.57.16c-.15.15-.26.35-.41.51a1.82,1.82,0,0,1-1.41.49,7.65,7.65,0,0,1-1.56-.35,7.75,7.75,0,0,0-.83-.21l-.43-.07-.49,0a6.45,6.45,0,0,1-1.94-.55,9,9,0,0,0-.95-.34c-.1-.54.24-1.12.89-1.69A4.14,4.14,0,0,0,1070.51,302.05Z"
                fill="#141c66"
              />
              <path d="M1084.29,301.53s-14.14.29-23.52,5.42" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1069.39,303l.54-.31a13.4,13.4,0,0,1,3.13-.56l.41.12a4.67,4.67,0,0,0,.52.08l.6.09a4.18,4.18,0,0,0,1.17.05,5.73,5.73,0,0,0,.56-.14l.38-.06c2,.32,3.29,1,3.31,1.87a.82.82,0,0,1-.06.34l-.12.12a2.44,2.44,0,0,1-.67.42,3.06,3.06,0,0,1-.73.21,4.53,4.53,0,0,0-.89.18,2.79,2.79,0,0,0-.71.41,4.33,4.33,0,0,1-.71.43,1.07,1.07,0,0,1-.72.1,1.8,1.8,0,0,1-.48-.24,2.14,2.14,0,0,0-.6-.21.55.55,0,0,0-.47.06c-.14.1-.25.23-.39.34a1.46,1.46,0,0,1-1.17.21,6.26,6.26,0,0,1-1.17-.48c-.21-.09-.41-.19-.63-.27l-.33-.11-.38-.08a5.2,5.2,0,0,1-1.45-.68c-.23-.14-.46-.27-.7-.39,0-.43.33-.85.92-1.21A3.22,3.22,0,0,0,1069.39,303Z"
                fill="#141c66"
              />
              <path d="M1080.25,304.35s-11.11-1.57-19.12,1.26" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1067.24,300.32a.32.32,0,0,0,.22,0,.3.3,0,0,0,.11-.23,3.31,3.31,0,0,0,0-.44h0a1.54,1.54,0,0,0,.3,0,.33.33,0,0,0,.2,0c.12-.07.08-.23.05-.34a2,2,0,0,0-.07-.23l.51-.55.11.09a2.83,2.83,0,0,0,.28.2.58.58,0,0,0,.25.09.06.06,0,0,0,.07-.06,2.21,2.21,0,0,0-.08-.35.78.78,0,0,1,0-.34c0-.13.17-.15.27-.22a.33.33,0,0,0,.11-.25v-.14l.7-.63.16.12a1,1,0,0,0,.43.21.36.36,0,0,0,.38-.2.74.74,0,0,0,0-.53,1.43,1.43,0,0,0-.09-.27l.23-.24c.24-.2.49-.39.75-.58h0a.44.44,0,0,1,.19.07,1.19,1.19,0,0,0,.32.1.08.08,0,0,0,.07-.05c0-.17,0-.51.17-.56.06,0,.13.06.18.08a.17.17,0,0,0,.21,0c.09-.12,0-.29.07-.42s.22,0,.28.07a2.06,2.06,0,0,0,.29.37.06.06,0,0,0,.09,0c0-.29,0-.59,0-.88.56-.36,1.11-.69,1.64-1a.3.3,0,0,0,0,.1s0,0,.08,0a2.74,2.74,0,0,1,.08.5v.31c0,.07.1.09.11,0a1.82,1.82,0,0,0,0-.33,4.88,4.88,0,0,0-.07-.76c.46-.25.91-.46,1.33-.65a2.3,2.3,0,0,1,.1.63l0,.27a.06.06,0,1,0,.11,0,1.33,1.33,0,0,0,0-.28c0-.18,0-.36,0-.54a1.34,1.34,0,0,0,0-.2,9.64,9.64,0,0,1,1.23-.43,6.37,6.37,0,0,0,.21.78.06.06,0,0,0,.09,0,1.22,1.22,0,0,0,.32-.59,2,2,0,0,0,.08-.35c.54-.06.92,0,1.11.29.39.52-.11,1.61-1.22,2.95l-.67-.11a.06.06,0,0,0,0,.11c.18.07.37.13.55.18-.29.34-.63.7-1,1.08a6.92,6.92,0,0,0-1.12.21.05.05,0,0,0,0,.06c0,.23.09.46.14.69-.55.5-1.15,1-1.79,1.49a4.19,4.19,0,0,0-1.11.27,2.39,2.39,0,0,0-.7.47l-.31.28a4.15,4.15,0,0,0-.32.27c-.19.18-.33.41-.51.6a.63.63,0,0,1-.61.24,1.41,1.41,0,0,1-.43-.27.21.21,0,0,0-.17,0,.24.24,0,0,0-.15.16,1.16,1.16,0,0,0,0,.64l0,.2c-2.24,1.17-4,1.59-4.48.94-.3-.4-.07-1.15.57-2.09Z"
                fill="#141c66"
              />
              <path d="M1078.19,293.7s-15.94,12.22-17.34,12.9" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1072.91,293.22a.74.74,0,0,1,.26.34c0,.13-.07.25-.1.38a5.78,5.78,0,0,0-.12.57,4.88,4.88,0,0,1-.12.55,4,4,0,0,1-.37.81,3.33,3.33,0,0,0-.45.88,7.5,7.5,0,0,0-.11.81v0l-.24.34a10.23,10.23,0,0,1-1.73,1.95,1,1,0,0,1-.17.1,14.55,14.55,0,0,0-1.67.85.84.84,0,0,1-.43-.13c-.76-.53-.2-2.64,1.25-4.7S1072.15,292.69,1072.91,293.22Z"
                fill="#141c66"
              />
              <path d="M1068.92,296s.71,4.19-7.21,10.25" fill="#141c66" />
              <path
                d="M1072.55,294.24a2.22,2.22,0,0,1-.49,1,4.9,4.9,0,0,0-.71.8,1.45,1.45,0,0,0-.17.56c0,.18,0,.37,0,.55a.92.92,0,0,1-.59.81,1.68,1.68,0,0,0-.42.22,1.49,1.49,0,0,0-.39.53,1.65,1.65,0,0,1-.4.54,1.5,1.5,0,0,1-.38.19,1.15,1.15,0,0,0-.37.25,1.07,1.07,0,0,0-.25.35.85.85,0,0,1-.21.31,1,1,0,0,1-.52.19h-.06a.51.51,0,0,1-.17-.07c-.6-.42.09-2.44,1.54-4.5s3.11-3.39,3.71-3a.4.4,0,0,1,.17.24A4.25,4.25,0,0,0,1072.55,294.24Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1046.76,278.23a6.85,6.85,0,0,1-.07-.78,6.1,6.1,0,0,1,0-1.13c0-.33.15-.66.23-1a3.25,3.25,0,0,0,.09-.88c0-.33-.1-.64-.13-1a2.59,2.59,0,0,1,.07-.73c.06-.17.13-.33.2-.49a3.13,3.13,0,0,1,.29-.42.09.09,0,0,0,0-.1,3.46,3.46,0,0,1,3.83-1.65,1,1,0,0,0,.26.27,2.08,2.08,0,0,0,.8.29,1.56,1.56,0,0,1,.82.43,6.27,6.27,0,0,1,.55.89,2,2,0,0,0,.37.39,1.59,1.59,0,0,0,.46.21,1.22,1.22,0,0,1,.47.3,3.5,3.5,0,0,1,.33.43,2.79,2.79,0,0,0,.38.39l.28.32a5.1,5.1,0,0,1,.59,1.89,2.47,2.47,0,0,0,.44,1,4.64,4.64,0,0,0,.66.67,2.1,2.1,0,0,1,.5.57,2.59,2.59,0,0,1,.23,1.06c0,.86,0,1.73.07,2.59a4.62,4.62,0,0,0,.11.63c0,.19.11.38.15.58a1.35,1.35,0,0,1-.06.77,6.54,6.54,0,0,1-.35.64,2,2,0,0,0-.33,1,1.56,1.56,0,0,1,0,.57,1.22,1.22,0,0,1-.25.41,6.31,6.31,0,0,0-.64.73s0,0,0,.05a3.33,3.33,0,0,1-.89.53,3.39,3.39,0,0,1-1.48.23,5.27,5.27,0,0,0-1-.52,12.52,12.52,0,0,1-1.19-.51,3.58,3.58,0,0,1-.52-.34c-.17-.13-.31-.28-.48-.41s-.68-.41-1-.67a1.6,1.6,0,0,1-.41-.52,4.53,4.53,0,0,1-.26-.6,2.24,2.24,0,0,0-.33-.53,4.89,4.89,0,0,0-.46-.45l-.64-.56a14.63,14.63,0,0,1-.77-1.59,3.19,3.19,0,0,1,.28-.66c.17-.31.36-.61.54-.92a.08.08,0,0,0,0-.12,8.71,8.71,0,0,1-.85-.2,1.12,1.12,0,0,1-.55-.31,1,1,0,0,1-.21-.37C1046.83,278.56,1046.79,278.39,1046.76,278.23Z"
                fill="#396039"
              />
              <path
                d="M1049.44,270.89a59.3,59.3,0,0,1,3.92,8.44c1.12,2.9,2.09,5.85,3,8.82s1.64,6,2.35,9l1,4.55.86,4.58-.93-4.57-1-4.54c-.74-3-1.5-6-2.4-9s-1.83-5.93-2.93-8.83c-.56-1.45-1.14-2.89-1.77-4.31A42.39,42.39,0,0,0,1049.44,270.89Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1064,291.49c0-.37,0-.74,0-1.11a24.93,24.93,0,0,1,1.7-5.48,6.82,6.82,0,0,0,.53-.55c.21-.24.38-.5.57-.76l.65-.88a7.87,7.87,0,0,0,1-1.83c.11-.32.16-.66.25-1s.13-.44.21-.66c2.12-2.85,4.35-4.4,5.72-3.74a1.55,1.55,0,0,1,.5.38l.09.3a4.48,4.48,0,0,1,.13,1.41,6.89,6.89,0,0,1-.28,1.35,9.32,9.32,0,0,0-.46,1.56,5.65,5.65,0,0,0,.06,1.48,7.43,7.43,0,0,1,.11,1.49,2,2,0,0,1-.43,1.23,3.65,3.65,0,0,1-.79.56,4.19,4.19,0,0,0-.84.79,1.07,1.07,0,0,0-.29.8c0,.3.17.59.22.9a2.54,2.54,0,0,1-.64,2,9.79,9.79,0,0,1-1.72,1.49c-.33.25-.65.5-1,.77a4.67,4.67,0,0,0-.45.44c-.16.17-.3.36-.46.54a9.29,9.29,0,0,1-2.28,1.75,13.9,13.9,0,0,0-1.2.8,2.79,2.79,0,0,1-1.17-2.47A6.57,6.57,0,0,0,1064,291.49Z"
                fill="#2f4f2f"
              />
              <path
                d="M1075.17,275.26c-1.62,2.4-3.12,4.87-4.55,7.39s-2.75,5.09-4,7.72a83.32,83.32,0,0,0-3.24,8,57.84,57.84,0,0,0-2.08,8.42,51.08,51.08,0,0,1,2-8.45,82.66,82.66,0,0,1,3.19-8.08A101.49,101.49,0,0,1,1075.17,275.26Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M1064.16,293.59a8.46,8.46,0,0,0,.11-.88,19.74,19.74,0,0,1,2-4.07l.49-.37a6.5,6.5,0,0,0,.53-.52l.62-.61a5.71,5.71,0,0,0,1-1.3c.13-.24.21-.5.32-.75s.17-.33.26-.5c2-2,4-2.89,5-2.2a1.34,1.34,0,0,1,.34.37l0,.24a3.49,3.49,0,0,1-.08,1.12,5.24,5.24,0,0,1-.39,1,7.33,7.33,0,0,0-.55,1.17,4.56,4.56,0,0,0-.15,1.16,5.27,5.27,0,0,1-.1,1.19,1.62,1.62,0,0,1-.5.91,2.88,2.88,0,0,1-.68.34,3,3,0,0,0-.76.51.83.83,0,0,0-.33.59c0,.24.05.49.06.73a2,2,0,0,1-.76,1.51,7.88,7.88,0,0,1-1.54.95c-.29.15-.57.31-.85.48s-.27.19-.4.29-.29.24-.43.36a7.25,7.25,0,0,1-2,1.09c-.35.14-.71.3-1,.47a2.21,2.21,0,0,1-.6-2.08A5.21,5.21,0,0,0,1064.16,293.59Z"
                fill="#396039"
              />
              <path
                d="M1075,282.29c-1.57,1.67-3.06,3.43-4.5,5.21s-2.79,3.65-4.08,5.55a67.74,67.74,0,0,0-3.56,5.89,47.08,47.08,0,0,0-2.71,6.33,39.79,39.79,0,0,1,2.62-6.38,67,67,0,0,1,3.52-5.93A79.69,79.69,0,0,1,1075,282.29Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1059.25,293.76a.46.46,0,0,0,.17-.28.53.53,0,0,0-.17-.32,4.66,4.66,0,0,0-.49-.39h0a2.13,2.13,0,0,0,.3-.3.43.43,0,0,0,.13-.27c0-.2-.2-.29-.35-.35l-.32-.12c-.07-.33-.14-.68-.2-1.05l.2-.05a3.18,3.18,0,0,0,.47-.15.85.85,0,0,0,.32-.21.08.08,0,0,0,0-.12,3.88,3.88,0,0,0-.46-.22,1.1,1.1,0,0,1-.41-.26c-.12-.15,0-.33,0-.5a.45.45,0,0,0-.19-.33l-.15-.13c0-.43-.09-.88-.12-1.34l.26-.07a1.38,1.38,0,0,0,.61-.32.5.5,0,0,0,.1-.61,1.17,1.17,0,0,0-.62-.45l-.38-.13c0-.15-.05-.31-.08-.46,0-.45,0-.9,0-1.36l0-.06a.84.84,0,0,1,.26-.15,1.33,1.33,0,0,0,.38-.29.08.08,0,0,0,0-.11c-.18-.15-.62-.38-.49-.68,0-.09.17-.1.24-.14a.24.24,0,0,0,.14-.27c-.06-.2-.31-.28-.42-.44s.19-.25.32-.25a3.67,3.67,0,0,0,.66,0,.09.09,0,0,0,0-.15c-.34-.24-.68-.49-1-.7.07-1,.16-1.87.28-2.72l.15,0a.07.07,0,0,0,.09-.07,3.06,3.06,0,0,1,.65.33l.35.26c.08.07.19,0,.11-.11a2.57,2.57,0,0,0-.37-.28,7.22,7.22,0,0,0-.93-.57c.11-.74.25-1.43.39-2.07a3.21,3.21,0,0,1,.8.42l.29.26a.08.08,0,1,0,.11-.12,1.93,1.93,0,0,0-.3-.27c-.19-.17-.37-.35-.57-.52l-.23-.18a13.38,13.38,0,0,1,.57-1.78,8.24,8.24,0,0,0,1.07.43.07.07,0,0,0,.1-.07,1.68,1.68,0,0,0-.39-.88,3.07,3.07,0,0,0-.34-.38c.39-.67.83-1,1.28-1,.92,0,1.75,1.51,2.34,3.92-.24.22-.47.45-.7.68-.07.06,0,.17.1.12a5.42,5.42,0,0,0,.67-.48q.22,1,.39,2.07a11.76,11.76,0,0,0-.72,1.47.08.08,0,0,0,0,.11c.3.16.61.28.92.42.1,1.05.16,2.17.18,3.32a6.32,6.32,0,0,0-.65,1.51,3.46,3.46,0,0,0,0,1.2c0,.2,0,.4,0,.6a5.85,5.85,0,0,0,0,.59c.05.37.19.72.25,1.09a.9.9,0,0,1-.24.91,2.39,2.39,0,0,1-.67.26.29.29,0,0,0-.21.16.42.42,0,0,0,.06.31,1.59,1.59,0,0,0,.69.59l.26.14c-.57,3.57-1.58,5.94-2.74,5.94-.71,0-1.37-.9-1.91-2.43Z"
                fill="#659965"
              />
              <path
                d="M1061,275.58c.14,5.14.18,10.28.24,15.42v7.72c0,2.57,0,5.15-.23,7.71.12-1.28.1-2.57.11-3.85v-3.86l0-7.72Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1056,281.21a1.05,1.05,0,0,1,.61,0c.11.15.23.29.34.43a8.39,8.39,0,0,0,.56.63,6.18,6.18,0,0,1,.52.61,4.61,4.61,0,0,1,.61,1.11,5.37,5.37,0,0,0,.63,1.27c.25.3.57.53.84.81h0c.07.19.14.38.2.57a15,15,0,0,1,.75,3.64,2.83,2.83,0,0,1,0,.29,21.64,21.64,0,0,0-.47,2.63,1,1,0,0,1-.5.38c-1.26.42-3.19-2-4.32-5.44S1054.7,281.62,1056,281.21Z"
                fill="#3b6818"
              />
              <path
                d="M1055.72,288.15s5.41,2.76,5.6,17"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.16"
              />
              <path
                d="M1056.82,282.5a3.14,3.14,0,0,1,.74,1.41,6.35,6.35,0,0,0,.31,1.5,2.12,2.12,0,0,0,.49.68c.2.18.4.33.59.52a1.53,1.53,0,0,1,.44.72,1.42,1.42,0,0,1,0,.65,2.84,2.84,0,0,0-.1.66,2.1,2.1,0,0,0,.28.9,1.73,1.73,0,0,1,.17,1.51,1.57,1.57,0,0,0,0,.65,1.65,1.65,0,0,0,.19.58,1.16,1.16,0,0,1,.18.51,1.47,1.47,0,0,1-.23.75l0,.08a.61.61,0,0,1-.22.13c-1,.33-2.71-2.18-3.84-5.6s-1.23-6.46-.24-6.78a.61.61,0,0,1,.42,0A6.24,6.24,0,0,0,1056.82,282.5Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g transform="translate(-12 0)">
          <g>
            <polygon
              points="97.71 217.99 116.24 191.87 116.24 250.07 97.32 260.78 97.71 217.99"
              fill="#4d3768"
              stroke="#e5d433"
              strokeMiterlimit="10"
              strokeWidth="0.38"
            />
            <polygon
              points="92.78 215.13 116.24 191.87 97.71 217.99 97.32 260.78 92.78 257.93 92.78 215.13"
              fill="#cca032"
            />
            <line
              x1="106.78"
              y1="234.15"
              x2="116.24"
              y2="228.52"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.38"
            />
            <line
              x1="100.53"
              y1="241.03"
              x2="116.24"
              y2="231.65"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="0.69"
            />
            <line
              x1="105.94"
              y1="213.14"
              x2="116.24"
              y2="207.29"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="0.69"
            />
            <line
              x1="109.41"
              y1="208.39"
              x2="116.24"
              y2="205.05"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="0.69"
            />
          </g>
          <g>
            <polygon
              points="141.7 217.11 123.17 190.99 123.17 249.19 142.09 259.9 141.7 217.11"
              fill="#4d3768"
              stroke="#e5d433"
              strokeMiterlimit="10"
              strokeWidth="0.38"
            />
            <polygon
              points="146.64 214.25 123.17 190.99 141.7 217.11 142.09 259.9 146.64 257.05 146.64 214.25"
              fill="#af8c28"
            />
            <line
              x1="132.63"
              y1="233.27"
              x2="123.17"
              y2="227.64"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="0.69"
            />
            <line
              x1="138.89"
              y1="240.15"
              x2="123.17"
              y2="230.77"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="0.69"
            />
            <line
              x1="133.48"
              y1="212.26"
              x2="123.17"
              y2="206.41"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="0.69"
            />
            <line
              x1="130"
              y1="207.51"
              x2="123.17"
              y2="204.17"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="0.69"
            />
          </g>
          <polygon
            points="118.33 191.87 106.78 223.25 116.24 223.47 118.33 191.87"
            fill="#cca032"
          />
          <polygon
            points="120.29 191.87 123.19 223.47 132.05 223.25 120.29 191.87"
            fill="#cca032"
          />
          <polygon
            points="106.78 223.25 106.78 266.5 116.24 266.26 116.24 223.47 106.78 223.25"
            fill="#af8c28"
          />
          <polygon
            points="123.19 223.47 123.17 266.5 132.05 266.5 132.05 223.25 123.19 223.47"
            fill="#af8c28"
          />
          <polygon
            points="123.17 266.5 120.29 242.53 120.29 191.87 123.19 223.47 123.17 266.5"
            fill="#4d3768"
            stroke="#e5d433"
            strokeMiterlimit="10"
            strokeWidth="0.38"
          />
          <polygon
            points="116.24 266.26 118.33 243.66 118.33 191.87 116.24 223.47 116.24 266.26"
            fill="#4d3768"
            stroke="#e5d433"
            strokeMiterlimit="10"
            strokeWidth="0.38"
          />
        </g>
        <g transform="translate(-12 0)">
          <g>
            <polygon
              points="28.08 233.15 57.33 191.91 57.33 283.8 27.46 300.7 28.08 233.15"
              fill="#4d3768"
              stroke="#e5d433"
              strokeMiterlimit="10"
              strokeWidth="0.6"
            />
            <polygon
              points="20.29 228.65 57.33 191.91 28.08 233.15 27.46 300.7 20.29 296.2 20.29 228.65"
              fill="#cca032"
            />
            <line
              x1="42.4"
              y1="258.66"
              x2="57.33"
              y2="249.78"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.6"
            />
            <line
              x1="32.52"
              y1="269.53"
              x2="57.33"
              y2="254.71"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="1.09"
            />
            <line
              x1="41.07"
              y1="225.49"
              x2="57.33"
              y2="216.26"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="1.09"
            />
            <line
              x1="46.55"
              y1="218"
              x2="57.33"
              y2="212.73"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="1.09"
            />
          </g>
          <g>
            <polygon
              points="97.53 231.76 68.28 190.53 68.28 282.41 98.14 299.31 97.53 231.76"
              fill="#4d3768"
              stroke="#e5d433"
              strokeMiterlimit="10"
              strokeWidth="0.6"
            />
            <polygon
              points="105.32 227.26 68.28 190.53 97.53 231.76 98.14 299.31 105.32 294.81 105.32 227.26"
              fill="#af8c28"
            />
            <line
              x1="83.21"
              y1="257.27"
              x2="68.28"
              y2="248.39"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="1.09"
            />
            <line
              x1="93.08"
              y1="268.14"
              x2="68.28"
              y2="253.32"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="1.09"
            />
            <line
              x1="84.54"
              y1="224.1"
              x2="68.28"
              y2="214.87"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="1.09"
            />
            <line
              x1="79.05"
              y1="216.62"
              x2="68.28"
              y2="211.34"
              fill="none"
              stroke="#cca032"
              strokeMiterlimit="10"
              strokeWidth="1.09"
            />
          </g>
          <polygon
            points="60.62 191.91 42.4 241.45 57.33 241.81 60.62 191.91"
            fill="#cca032"
          />
          <polygon
            points="63.72 191.91 68.3 241.81 82.29 241.45 63.72 191.91"
            fill="#cca032"
          />
          <polygon
            points="42.4 241.45 42.4 309.74 57.33 309.36 57.33 241.81 42.4 241.45"
            fill="#af8c28"
          />
          <polygon
            points="68.3 241.81 68.28 309.74 82.29 309.74 82.29 241.45 68.3 241.81"
            fill="#af8c28"
          />
          <polygon
            points="68.28 309.74 63.72 271.9 63.72 191.91 68.3 241.81 68.28 309.74"
            fill="#4d3768"
            stroke="#e5d433"
            strokeMiterlimit="10"
            strokeWidth="0.6"
          />
          <polygon
            points="57.33 309.36 60.62 273.69 60.62 191.91 57.33 241.81 57.33 309.36"
            fill="#4d3768"
            stroke="#e5d433"
            strokeMiterlimit="10"
            strokeWidth="0.6"
          />
        </g>
        <g>
          <path
            d="M1047.33,0V97.73l63.09-.64V44.18Zm31.58,77.7A21.73,21.73,0,1,1,1100.65,56,21.73,21.73,0,0,1,1078.91,77.7Z"
            fill="#6d4c89"
          />
          <path
            d="M1078.91,33.81a21.12,21.12,0,0,1,16.5,5.67,22.46,22.46,0,0,1,5.28,7.47,22.63,22.63,0,0,1,0,18,22.63,22.63,0,0,1-5.29,7.48,21.11,21.11,0,0,1-16.5,5.66,23.53,23.53,0,0,0,14.84-7.32,21.86,21.86,0,0,0,0-29.69A23.57,23.57,0,0,0,1078.91,33.81Z"
            fill="#e59661"
          />
          <line
            x1="1047.14"
            y1="0.5"
            x2="1047.14"
            y2="97.5"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <path
            d="M986.48,88.93s-5.41,11,1.27,17.07l-10.44-.09s3.84-1.84,4.31-3,.6-9,3.93-13.59Z"
            fill="#6d4c89"
          />
          <path
            d="M985.14,89.46s-.5-6.38-4.14-7.23c0,0,1.5,1.3.74,2.35,0,0-1.36-3.14-5.59-2.4,0,0,4.86.64,5.58,3.59a3.4,3.4,0,0,0-3.74,1.1S985.17,87.05,985.14,89.46Z"
            fill="#6d4c89"
          />
          <path
            d="M986.48,89.47s.62-6.36,4.27-7.16c0,0-1.53,1.28-.78,2.34,0,0,1.41-3.12,5.63-2.3,0,0-4.87.55-5.64,3.49A3.41,3.41,0,0,1,993.68,87S986.5,87.06,986.48,89.47Z"
            fill="#6d4c89"
          />
          <path
            d="M984.69,90.58s7.12-9.11,14.95-5.51c0,0-4.44-.21-4.82.31,0,0,1.46-.21,1.37,1.22,0,0-3-1.47-3.87-.77,0,0,1.68.35,1.57,1.06,0,0-2.69-.67-3.39,0,0,0,1.74.43,1,1.25,0,0-2.37-1-3.53.48,0,0,1-.33,1.3,0C989.31,88.61,984.87,89.64,984.69,90.58Z"
            fill="#6d4c89"
          />
          <path
            d="M986,90.47s-6-8.73-14.12-4.39c0,0,4.41-.58,4.73-.08a1.39,1.39,0,0,0-1.51,1.36s3.15-1.76,3.92-1.11c0,0-1.7.5-1.68,1.21,0,0,2.74-.9,3.36-.33,0,0-1.77.58-1.18,1.37,0,0,2.47-1.28,3.43.19,0,0-.94-.25-1.29.15C981.65,88.84,985.92,89.52,986,90.47Z"
            fill="#6d4c89"
          />
          <path
            d="M984.53,90.08s6.73-5.26,12.1,2c0,0-3.32-2.37-3.68-2.06a1.62,1.62,0,0,1,.85,1.84s-2-2.88-2.8-2.62c0,0,1.21,1.15,1,1.78,0,0-1.92-2-2.54-1.7,0,0,1.24,1.25.59,1.7,0,0-1.63-2.17-2.73-1.26,0,0,.8.17,1,.67C988.31,90.45,984.81,89.27,984.53,90.08Z"
            fill="#6d4c89"
          />
          <path
            d="M986.48,90.28s-7.91-6.19-14.21,1.78c0,0,3.9-2.53,4.33-2.16a1.74,1.74,0,0,0-1,2s2.41-3.16,3.29-2.84c0,0-1.42,1.25-1.2,2,0,0,2.26-2.13,3-1.82,0,0-1.46,1.36-.7,1.9,0,0,1.92-2.38,3.21-1.31,0,0-.94.16-1.14.72C982,90.55,986.15,89.36,986.48,90.28Z"
            fill="#6d4c89"
          />
          <path
            d="M985.31,90.46c.32-3.68-3.53-8-6.33-7.76,0,0,5.53-1,6.4,2.29,0,0-1.08-4.39-2.71-4.4,0,0,3.6-1,4.23,2.09,0,0,2-3.78,0-4.31,0,0,4.44,1.22,2.52,4.15,0,0,2-1.68,4.44.58,0,0-4.74.05-5.56,1.91,0,0,2.09-1.32,3.31,0,0,0-4.18-.73-5.25,2.35Z"
            fill="#6d4c89"
          />
          <path
            d="M985.54,90.46c.25-2.84-2.73-6.17-4.88-6,0,0,4.26-.79,4.93,1.76,0,0-.83-3.38-2.09-3.39,0,0,2.78-.74,3.26,1.61,0,0,1.53-2.91,0-3.32,0,0,3.42.94,1.94,3.2a2.53,2.53,0,0,1,3.42.44s-3.65,0-4.28,1.48c0,0,1.61-1,2.55,0,0,0-3.22-.56-4,1.81Z"
            fill="#6d4c89"
          />
          <path
            d="M985.88,91.59s-.29-3.69-2.39-4.18c0,0,.87.75.43,1.35a2.8,2.8,0,0,0-3.23-1.38s2.81.37,3.22,2.07a2,2,0,0,0-2.16.64S985.9,90.19,985.88,91.59Z"
            fill="#6d4c89"
          />
          <path
            d="M985.26,91s.36-3.67,2.47-4.13c0,0-.89.74-.45,1.35a2.79,2.79,0,0,1,3.25-1.33s-2.82.32-3.26,2a2,2,0,0,1,2.15.67S985.27,89.65,985.26,91Z"
            fill="#6d4c89"
          />
          <path
            d="M981.62,102.87c.44-1.09.58-7.51,3-12.13-.34,1.27-2.58,10-1.49,12.52.44,1-1,1.92-3,2.67l-2.82,0S981.15,104.07,981.62,102.87Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M1094.75,72.79s-7.37,14.95,1.71,23.24l-14.2-.12s5.23-2.51,5.88-4.15.81-12.24,5.33-18.5Z"
            fill="#6d4c89"
          />
          <path
            d="M1092.92,73.51s-.69-8.68-5.63-9.85c0,0,2,1.78,1,3.2,0,0-1.85-4.27-7.6-3.26,0,0,6.61.87,7.59,4.88a4.62,4.62,0,0,0-5.09,1.5S1093,70.23,1092.92,73.51Z"
            fill="#6d4c89"
          />
          <path
            d="M1094.74,73.52s.84-8.66,5.81-9.74c0,0-2.08,1.74-1.06,3.18,0,0,1.92-4.24,7.65-3.13,0,0-6.62.75-7.66,4.75a4.62,4.62,0,0,1,5.06,1.58S1094.76,70.25,1094.74,73.52Z"
            fill="#6d4c89"
          />
          <path
            d="M1092.3,75s9.69-12.4,20.34-7.5c0,0-6-.28-6.56.43,0,0,2-.3,1.87,1.65,0,0-4.09-2-5.26-1,0,0,2.28.48,2.13,1.44,0,0-3.65-.91-4.6-.06,0,0,2.36.57,1.4,1.7,0,0-3.22-1.43-4.8.65,0,0,1.36-.44,1.77.06C1098.59,72.36,1092.56,73.76,1092.3,75Z"
            fill="#6d4c89"
          />
          <path
            d="M1094.08,74.88s-8.11-11.88-19.21-6c0,0,6-.8,6.43-.12a1.89,1.89,0,0,0-2,1.86s4.28-2.4,5.32-1.51c0,0-2.31.68-2.28,1.65,0,0,3.72-1.23,4.56-.45,0,0-2.4.78-1.59,1.86,0,0,3.36-1.74,4.66.27,0,0-1.29-.35-1.75.2C1088.18,72.67,1094,73.59,1094.08,74.88Z"
            fill="#6d4c89"
          />
          <path
            d="M1092.09,74.35s9.16-7.16,16.45,2.75c0,0-4.51-3.22-5-2.8a2.2,2.2,0,0,1,1.16,2.51s-2.79-3.93-3.81-3.58c0,0,1.64,1.57,1.39,2.43,0,0-2.62-2.66-3.46-2.32,0,0,1.69,1.71.8,2.32,0,0-2.21-3-3.71-1.71,0,0,1.09.23,1.33.91C1097.24,74.86,1092.47,73.25,1092.09,74.35Z"
            fill="#6d4c89"
          />
          <path
            d="M1094.74,74.62s-10.75-8.42-19.32,2.44c0,0,5.3-3.45,5.88-3a2.36,2.36,0,0,0-1.36,2.77s3.27-4.31,4.47-3.87c0,0-1.93,1.7-1.64,2.67,0,0,3.08-2.89,4.07-2.46,0,0-2,1.85-.95,2.57,0,0,2.61-3.23,4.37-1.78,0,0-1.28.22-1.56,1C1088.7,75,1094.29,73.37,1094.74,74.62Z"
            fill="#6d4c89"
          />
          <path
            d="M1093.15,74.87c.44-5-4.8-10.9-8.61-10.56,0,0,7.53-1.4,8.7,3.11,0,0-1.46-6-3.68-6,0,0,4.9-1.29,5.75,2.85,0,0,2.69-5.15,0-5.87,0,0,6,1.66,3.42,5.65,0,0,2.78-2.28,6,.79,0,0-6.45.06-7.56,2.61,0,0,2.84-1.8,4.5,0,0,0-5.68-1-7.15,3.19Z"
            fill="#6d4c89"
          />
          <path
            d="M1093.46,74.87c.34-3.86-3.7-8.4-6.64-8.14,0,0,5.8-1.08,6.71,2.4,0,0-1.13-4.61-2.84-4.62,0,0,3.78-1,4.43,2.19,0,0,2.08-4,0-4.52,0,0,4.66,1.28,2.64,4.36,0,0,2.15-1.76,4.66.6,0,0-5,0-5.83,2,0,0,2.19-1.39,3.47,0,0,0-4.38-.77-5.51,2.46Z"
            fill="#6d4c89"
          />
          <path
            d="M1093.93,76.4s-.4-5-3.26-5.69c0,0,1.19,1,.58,1.85,0,0-1.06-2.47-4.39-1.88,0,0,3.82.5,4.39,2.82a2.67,2.67,0,0,0-2.94.87S1094,74.51,1093.93,76.4Z"
            fill="#6d4c89"
          />
          <path
            d="M1093.08,75.67s.49-5,3.36-5.64c0,0-1.2,1-.61,1.84,0,0,1.1-2.45,4.42-1.8,0,0-3.83.43-4.43,2.74a2.67,2.67,0,0,1,2.92.92S1093.09,73.77,1093.08,75.67Z"
            fill="#6d4c89"
          />
          <path
            d="M1088.14,91.76c.59-1.47.78-10.22,4.11-16.51-.46,1.74-3.51,13.63-2,17,.6,1.36-1.38,2.61-4.12,3.64l-3.85,0S1087.49,93.4,1088.14,91.76Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M1118.75,82.79s-7.37,14.95,1.71,23.24l-14.2-.12s5.23-2.51,5.88-4.15.81-12.24,5.33-18.5Z"
            fill="#6d4c89"
          />
          <path
            d="M1116.92,83.51s-.69-8.68-5.63-9.85c0,0,2,1.78,1,3.2,0,0-1.85-4.27-7.6-3.26,0,0,6.61.87,7.59,4.88a4.62,4.62,0,0,0-5.09,1.5S1117,80.23,1116.92,83.51Z"
            fill="#6d4c89"
          />
          <path
            d="M1118.74,83.52s.84-8.66,5.81-9.74c0,0-2.08,1.74-1.06,3.18,0,0,1.92-4.24,7.65-3.13,0,0-6.62.75-7.66,4.75a4.62,4.62,0,0,1,5.06,1.58S1118.76,80.25,1118.74,83.52Z"
            fill="#6d4c89"
          />
          <path
            d="M1116.3,85s9.69-12.4,20.34-7.5c0,0-6-.28-6.56.43,0,0,2-.3,1.87,1.65,0,0-4.09-2-5.26-1,0,0,2.28.48,2.13,1.44,0,0-3.65-.91-4.6-.06,0,0,2.36.57,1.4,1.7,0,0-3.22-1.43-4.8.65,0,0,1.36-.44,1.77.06C1122.59,82.36,1116.56,83.76,1116.3,85Z"
            fill="#6d4c89"
          />
          <path
            d="M1118.08,84.88s-8.11-11.88-19.21-6c0,0,6-.8,6.43-.12a1.89,1.89,0,0,0-2,1.86s4.28-2.4,5.32-1.51c0,0-2.31.68-2.28,1.65,0,0,3.72-1.23,4.56-.45,0,0-2.4.78-1.59,1.86,0,0,3.36-1.74,4.66.27,0,0-1.29-.35-1.75.2C1112.18,82.67,1118,83.59,1118.08,84.88Z"
            fill="#6d4c89"
          />
          <path
            d="M1116.09,84.35s9.16-7.16,16.45,2.75c0,0-4.51-3.22-5-2.8a2.2,2.2,0,0,1,1.16,2.51s-2.79-3.93-3.81-3.58c0,0,1.64,1.57,1.39,2.43,0,0-2.62-2.66-3.46-2.32,0,0,1.69,1.71.8,2.32,0,0-2.21-3-3.71-1.71,0,0,1.09.23,1.33.91C1121.24,84.86,1116.47,83.25,1116.09,84.35Z"
            fill="#6d4c89"
          />
          <path
            d="M1118.74,84.62s-10.75-8.42-19.32,2.44c0,0,5.3-3.45,5.88-3a2.36,2.36,0,0,0-1.36,2.77s3.27-4.31,4.47-3.87c0,0-1.93,1.7-1.64,2.67,0,0,3.08-2.89,4.07-2.46,0,0-2,1.85-.95,2.57,0,0,2.61-3.23,4.37-1.78,0,0-1.28.22-1.56,1C1112.7,85,1118.29,83.37,1118.74,84.62Z"
            fill="#6d4c89"
          />
          <path
            d="M1117.15,84.87c.44-5-4.8-10.9-8.61-10.56,0,0,7.53-1.4,8.7,3.11,0,0-1.46-6-3.68-6,0,0,4.9-1.29,5.75,2.85,0,0,2.69-5.15,0-5.87,0,0,6,1.66,3.42,5.65,0,0,2.78-2.28,6,.79,0,0-6.45.06-7.56,2.61,0,0,2.84-1.8,4.5,0,0,0-5.68-1-7.15,3.19Z"
            fill="#6d4c89"
          />
          <path
            d="M1117.46,84.87c.34-3.86-3.7-8.4-6.64-8.14,0,0,5.8-1.08,6.71,2.4,0,0-1.13-4.61-2.84-4.62,0,0,3.78-1,4.43,2.19,0,0,2.08-4,0-4.52,0,0,4.66,1.28,2.64,4.36,0,0,2.15-1.76,4.66.6,0,0-5,0-5.83,2,0,0,2.19-1.39,3.47,0,0,0-4.38-.77-5.51,2.46Z"
            fill="#6d4c89"
          />
          <path
            d="M1117.93,86.4s-.4-5-3.26-5.69c0,0,1.19,1,.58,1.85,0,0-1.06-2.47-4.39-1.88,0,0,3.82.5,4.39,2.82a2.67,2.67,0,0,0-2.94.87S1118,84.51,1117.93,86.4Z"
            fill="#6d4c89"
          />
          <path
            d="M1117.08,85.67s.49-5,3.36-5.64c0,0-1.2,1-.61,1.84,0,0,1.1-2.45,4.42-1.8,0,0-3.83.43-4.43,2.74a2.67,2.67,0,0,1,2.92.92S1117.09,83.77,1117.08,85.67Z"
            fill="#6d4c89"
          />
          <path
            d="M1112.14,101.76c.59-1.47.78-10.22,4.11-16.51-.46,1.74-3.51,13.63-2,17,.6,1.36-1.38,2.61-4.12,3.64l-3.85,0S1111.49,103.4,1112.14,101.76Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g transform="translate(10 -30)">
          <rect x="962.64" y="174" width="95" height="4" fill="#422b47" />
          <ellipse
            cx="1010.14"
            cy="178.07"
            rx="47.68"
            ry="10.93"
            fill="#422b47"
          />
          <ellipse
            cx="1010.15"
            cy="174.11"
            rx="47.68"
            ry="10.93"
            fill="#6d4c89"
          />
          <circle cx="1005.18" cy="110.54" r="67.54" fill="#663f6d" />
          <path
            d="M957.51,118.49a67.51,67.51,0,0,1,82.39-65.88,67.54,67.54,0,1,0-49.58,123.81A67.49,67.49,0,0,1,957.51,118.49Z"
            fill="#d0827d"
          />
          <path
            d="M1041.26,53.45a67.54,67.54,0,0,0-54.18,122.16,67.79,67.79,0,0,0,12.07,2.19A67.53,67.53,0,0,1,1043.05,59c2,0,4,.11,6,.29A68.53,68.53,0,0,0,1041.26,53.45Z"
            fill="#422f5b"
          />
          <path
            d="M980.64,153c1.74.36,12,24,20,25,43,0,72.08-30.21,72.08-67.46a67.21,67.21,0,0,0-14.08-41.25h0S1060.1,143.07,980.64,153Z"
            fill="#422b47"
          />
          <path
            d="M990.32,176.42s-52.31-49.83,0-102.62C1001,62.2,1030.64,53,1047.64,58l1,1s-29-3-60,28-1,86.83,6,90.42Z"
            fill="#291f3a"
          />
          <path
            d="M962.47,174.11c0,5.59,18.36,10.2,42,10.84-36.76-4-37-15.71-37-15.71h0C964.28,170.71,962.47,172.36,962.47,174.11Z"
            fill="#d0827d"
          />
          <polygon
            points="951.64 86 978.64 113 980.64 102 988.64 87 1000.64 75 1015.64 65 1000.64 45 951.64 86"
            fill="#667784"
          />
          <path
            d="M980.64,102l7.72-14.47.28-1.53c-14,7-14.7,0-14.7,0-11.7,9-22.3,0-22.3,0l27,27Z"
            fill="#4e6472"
          />
          <polygon
            points="951.64 86 955.64 91 1004.64 50 1000.64 45 951.64 86"
            fill="#95aab7"
          />
          <ellipse
            cx="980.14"
            cy="70.5"
            rx="32"
            ry="9"
            transform="translate(179.58 640.37) rotate(-39.56)"
            fill="#95aab7"
          />
          <ellipse
            cx="976.14"
            cy="65.5"
            rx="32"
            ry="9"
            transform="translate(181.85 636.68) rotate(-39.56)"
            fill="#3f2b2b"
          />
          <ellipse
            cx="976.14"
            cy="65.5"
            rx="22.83"
            ry="6.42"
            transform="translate(181.85 636.68) rotate(-39.56)"
            fill="#775252"
          />
          <ellipse
            cx="976.14"
            cy="65.5"
            rx="16.29"
            ry="4.58"
            transform="translate(181.85 636.68) rotate(-39.56)"
            fill="#542d2d"
          />
          <path
            d="M999.14,177.5A68.16,68.16,0,0,1,984.66,162,62,62,0,0,1,976,142.45a67.14,67.14,0,0,1,3.64-42.31,68,68,0,0,1,5.08-9.53A63.37,63.37,0,0,1,991.24,82a67.3,67.3,0,0,1,16.66-13.55,65.2,65.2,0,0,1,9.71-4.59,62.85,62.85,0,0,1,10.29-2.94,65.42,65.42,0,0,1,10.6-1.2c.88-.06,1.77,0,2.66,0s1.77,0,2.65,0c1.77.1,3.53.28,5.28.51a69.78,69.78,0,0,0-40,10.21,75.23,75.23,0,0,0-8.39,6.11,67.55,67.55,0,0,0-7.34,7.31c-1.14,1.3-2.2,2.67-3.25,4s-2,2.8-2.91,4.28a63.84,63.84,0,0,0-4.81,9.15A71.38,71.38,0,0,0,979,111.1a73,73,0,0,0-1.79,10.18l-.22,2.59c-.06.86-.07,1.72-.11,2.58-.08,1.73,0,3.46.06,5.19a67.27,67.27,0,0,0,1.34,10.28C981.17,155.5,988.77,167.94,999.14,177.5Z"
            fill="#d0827d"
          />
          <path
            d="M1057.82,174.11c0-1.75-1.8-3.4-5-4.87,0,0-3.41,11.24-22.64,14.78C1046.51,182.29,1057.82,178.5,1057.82,174.11Z"
            fill="#422b47"
          />
        </g>
        <g>
          <path
            d="M979.21,188.71c1.79-3,2.4-3.64,1.64-5.64s-1.5-.29-.73-4a3.91,3.91,0,0,0-3.47-5c-1.32-.14-7.57,3.53-6.51,5.52s1.5,7.66.37,8.13S977.09,192.2,979.21,188.71Z"
            fill="#396039"
          />
          <path
            d="M978,181.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S978,181.81,978,181.81Z"
            fill="#447244"
          />
          <path
            d="M982.55,179c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S982.55,179,982.55,179Z"
            fill="#6b996b"
          />
          <path
            d="M975.59,191.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.45-1-3.7,1.11-3.79,1.84a4.74,4.74,0,0,0,2.58,3.91C970.75,191.73,973.75,190,975.59,191.38Z"
            fill="#447244"
          />
          <path
            d="M982,193c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C986.83,193.38,983.83,191.62,982,193Z"
            fill="#447244"
          />
          <path
            d="M985.84,190.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0a3.92,3.92,0,0,1-1.83,1.63,3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,985.84,190.21Z"
            fill="#396039"
          />
          <path
            d="M979.47,191.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,979.47,191.7Z"
            fill="#704d3c"
          />
          <path
            d="M982.68,191.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
            fill="#634b42"
          />
          <path
            d="M977.28,190.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,977.28,190.34Z"
            fill="#44322c"
          />
          <path
            d="M982,190.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1.05-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,982,190.79Z"
            fill="#6b996b"
          />
          <g>
            <path d="M977.63,188.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
            <path
              d="M977.59,188.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C977.88,187.05,977.64,187.84,977.59,188.43Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M974.41,188.32c-.56-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,974.41,188.32Z"
            fill="#6b996b"
          />
          <path
            d="M975.53,180.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S975.53,180.08,975.53,180.08Z"
            fill="#6b996b"
          />
          <path
            d="M969.75,190.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C968.94,190.7,969.59,190,969.75,190.23Z"
            fill="#447244"
          />
          <path
            d="M981.67,193.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.27,1.27,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C981.44,194.14,981.18,193.9,981.67,193.9Z"
            fill="#396039"
          />
          <path
            d="M979.26,186.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1,.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.75.34-1.63-.31-2.19-1.34l-.25-.51h0S978.85,187.39,979.26,186.48Z"
            fill="#447244"
          />
          <path
            d="M986.72,185.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.27-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S987.42,188.12,986.72,185.92Z"
            fill="#447244"
          />
          <path
            d="M975.68,207.05s.24-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C975.68,207.32,975.68,207.05,975.68,207.05Z"
            fill="#44322c"
          />
          <path
            d="M978.61,206.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-1.95,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.14.57a3.16,3.16,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,978.61,206.93Z"
            fill="#44322c"
          />
          <path
            d="M978,199.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92,2.62,2.62,0,0,0-.72,1.72,3.89,3.89,0,0,0,.25,1.87,7.5,7.5,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C978.07,200.77,977.82,200,978,199.41Z"
            fill="#44322c"
          />
          <path
            d="M978,186.93c0,.38.18.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C978.11,187.68,978,187.31,978,186.93Z"
            fill="#44322c"
          />
        </g>
        <g opacity="0.22">
          <ellipse
            cx="593.88"
            cy="172.65"
            rx="10.52"
            ry="12.99"
            transform="translate(256.21 690.8) rotate(-73.12)"
            opacity="0.79"
          />
          <line
            x1="591.31"
            y1="182.8"
            x2="491.57"
            y2="157.89"
            fill="#141c66"
            stroke="#000"
            strokeMiterlimit="10"
            opacity="0.79"
          />
          <line
            x1="596.94"
            y1="162.58"
            x2="526.53"
            y2="132.92"
            fill="#141c66"
            stroke="#000"
            strokeMiterlimit="10"
            opacity="0.79"
          />
          <line
            x1="593.88"
            y1="172.65"
            x2="531.52"
            y2="152.9"
            fill="#141c66"
            stroke="#000"
            strokeMiterlimit="10"
            opacity="0.79"
          />
        </g>
        <g>
          <circle cx="530.63" cy="82.07" r="15.07" fill="#aaa8c6" />
          <line
            x1="515.65"
            y1="81.51"
            x2="496.89"
            y2="152.59"
            fill="none"
            stroke="#aaa8c6"
            strokeMiterlimit="10"
            strokeWidth="0.85"
          />
          <line
            x1="545.7"
            y1="82.07"
            x2="565.61"
            y2="153.16"
            fill="none"
            stroke="#aaa8c6"
            strokeMiterlimit="10"
            strokeWidth="0.85"
          />
          <path
            d="M540.94,71.08c0,.16-1.36,26-24.35,16.47a15.07,15.07,0,1,0,24.35-16.47Z"
            fill="#6565a5"
          />
          <line
            x1="530.63"
            y1="82.07"
            x2="532.91"
            y2="169.37"
            fill="none"
            stroke="#aaa8c6"
            strokeMiterlimit="10"
            strokeWidth="0.85"
          />
          <path
            d="M520,78.8c-3.54-1.38,6-11.09,11.09-9.67C537.11,70.81,531.63,83.35,520,78.8Z"
            fill="#ded3ef"
          />
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M1191.65,364.09a10.64,10.64,0,0,1,.94-.84,9.32,9.32,0,0,1,1.51-1.06c.49-.27,1-.45,1.51-.67a5.42,5.42,0,0,0,1.25-.74c.41-.33.73-.75,1.13-1.1a3.75,3.75,0,0,1,1-.63c.28-.08.55-.15.83-.21a7.56,7.56,0,0,1,.83,0,.11.11,0,0,0,.12-.09,5.62,5.62,0,0,1,5.89,3.4,1.81,1.81,0,0,0-.1.61,4,4,0,0,0,.4,1.32,2.52,2.52,0,0,1,.24,1.48,11.55,11.55,0,0,1-.63,1.6,2.23,2.23,0,0,0,0,1.66,2.11,2.11,0,0,1,.08.9,8.29,8.29,0,0,1-.25.85,6.47,6.47,0,0,0-.15.88c0,.23-.08.46-.14.68a8,8,0,0,1-1.89,2.6,4.35,4.35,0,0,0-.94,1.59,8.59,8.59,0,0,0-.22,1.51,3.61,3.61,0,0,1-.27,1.22,4.07,4.07,0,0,1-1.16,1.32c-1.08.89-2.29,1.64-3.32,2.61a10,10,0,0,0-.71.75c-.21.26-.39.53-.62.78a2.14,2.14,0,0,1-1,.67,9.71,9.71,0,0,1-1.19.16,3.17,3.17,0,0,0-1.67.58,2.78,2.78,0,0,1-.75.56,2.05,2.05,0,0,1-.78.07,9.23,9.23,0,0,0-1.57-.12.09.09,0,0,0-.07,0,5.61,5.61,0,0,1-1.56-.65,5.49,5.49,0,0,1-1.75-1.71,8,8,0,0,0-.29-1.82,20.85,20.85,0,0,1-.49-2,5.82,5.82,0,0,1-.06-1c0-.34.07-.67.07-1,0-.65-.13-1.3-.09-1.95a3.19,3.19,0,0,1,.27-1.05c.16-.32.36-.61.53-.92a3,3,0,0,0,.38-.95,9,9,0,0,0,.15-1c0-.45.06-.91.1-1.37a28.43,28.43,0,0,1,1.33-2.56,4.9,4.9,0,0,1,1.13-.27c.57-.09,1.16-.12,1.73-.2.08,0,.16-.09.12-.17-.2-.44-.42-.86-.58-1.32a1.85,1.85,0,0,1-.13-1,1.73,1.73,0,0,1,.29-.65C1191.28,364.5,1191.46,364.29,1191.65,364.09Z"
                fill="#141c66"
              />
              <path
                d="M1203.85,360.45s-7.52,18.91-35.48,48.94"
                fill="#141c66"
              />
            </g>
            <g>
              <path
                d="M1191.11,399.55c.49-.36,1-.74,1.41-1.14a40,40,0,0,1,8.81-3.1c.42.07.83.12,1.24.15s1,0,1.54,0l1.78,0a12.19,12.19,0,0,0,3.4-.42c.54-.16,1-.44,1.55-.64.35-.14.71-.26,1.08-.37,5.78,0,10,1.4,10.45,3.84a2.75,2.75,0,0,1,0,1c-.1.13-.2.27-.31.4a7,7,0,0,1-1.71,1.54,10.11,10.11,0,0,1-2,.94,15.05,15.05,0,0,0-2.48.93,9.44,9.44,0,0,0-1.88,1.51,11.61,11.61,0,0,1-1.84,1.59,3.25,3.25,0,0,1-2,.64,6.1,6.1,0,0,1-1.5-.48,6.16,6.16,0,0,0-1.85-.33,1.74,1.74,0,0,0-1.32.39c-.36.35-.62.8-1,1.17a4.15,4.15,0,0,1-3.27,1.14,16.64,16.64,0,0,1-3.62-.81c-.64-.18-1.29-.36-1.94-.49-.33-.07-.67-.12-1-.16s-.77,0-1.15-.07a14.83,14.83,0,0,1-4.51-1.28c-.73-.29-1.46-.57-2.21-.79-.22-1.25.55-2.61,2.09-3.93A10.2,10.2,0,0,0,1191.11,399.55Z"
                fill="#141c66"
              />
              <path d="M1223.16,398.33s-32.88.68-54.7,12.62" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1188.5,401.77c.43-.21.84-.46,1.25-.71a31.7,31.7,0,0,1,7.3-1.31c.32.1.63.2,1,.28s.8.13,1.21.19l1.4.22a9.47,9.47,0,0,0,2.71.1c.44-.06.86-.21,1.3-.31s.59-.11.89-.15c4.53.74,7.64,2.37,7.7,4.34a2,2,0,0,1-.14.8l-.29.28a5.71,5.71,0,0,1-1.54,1,8.53,8.53,0,0,1-1.71.48,11.32,11.32,0,0,0-2.07.41,7.42,7.42,0,0,0-1.66.95,9.51,9.51,0,0,1-1.64,1,2.59,2.59,0,0,1-1.68.24,4.63,4.63,0,0,1-1.11-.56,5,5,0,0,0-1.41-.5,1.36,1.36,0,0,0-1.08.14c-.33.23-.59.55-.91.79a3.33,3.33,0,0,1-2.71.48,13.73,13.73,0,0,1-2.74-1.09,15.49,15.49,0,0,0-1.45-.63c-.25-.1-.51-.18-.77-.26s-.59-.13-.89-.2a12,12,0,0,1-3.37-1.57c-.54-.32-1.08-.63-1.63-.9,0-1,.76-2,2.13-2.82A7.62,7.62,0,0,0,1188.5,401.77Z"
                fill="#141c66"
              />
              <path d="M1213.77,404.89s-25.85-3.65-44.47,2.94" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1183.51,395.52a.69.69,0,0,0,.51,0,.73.73,0,0,0,.26-.53,5.91,5.91,0,0,0,0-1v0a3.28,3.28,0,0,0,.69.1.8.8,0,0,0,.48-.09c.27-.18.18-.54.11-.79s-.1-.36-.16-.54c.37-.42.76-.85,1.18-1.28l.25.21a7.75,7.75,0,0,0,.66.46,1.29,1.29,0,0,0,.59.22.13.13,0,0,0,.15-.14c0-.28-.12-.55-.17-.82a1.64,1.64,0,0,1-.06-.79c.08-.3.4-.35.62-.52a.71.71,0,0,0,.25-.57,1.83,1.83,0,0,0,0-.33c.52-.48,1.07-1,1.63-1.45l.36.27a2.38,2.38,0,0,0,1,.49.83.83,0,0,0,.88-.48,1.88,1.88,0,0,0,0-1.24,4.39,4.39,0,0,0-.21-.61c.18-.19.35-.38.53-.56.57-.46,1.15-.91,1.75-1.35h.11a1.25,1.25,0,0,1,.45.18,2.43,2.43,0,0,0,.74.22.13.13,0,0,0,.15-.11c0-.39-.1-1.18.41-1.31.15,0,.3.14.42.19a.4.4,0,0,0,.49-.09c.21-.27.07-.67.17-1s.51,0,.63.17a6.27,6.27,0,0,0,.67.85.14.14,0,0,0,.22-.12c0-.68,0-1.36-.09-2,1.3-.85,2.58-1.61,3.81-2.28l.09.23a.12.12,0,0,0,.18.07,5.13,5.13,0,0,1,.2,1.16c0,.24,0,.48,0,.72s.25.21.26,0a6.45,6.45,0,0,0,0-.76,11.66,11.66,0,0,0-.17-1.77c1.08-.58,2.12-1.08,3.09-1.51a4.84,4.84,0,0,1,.23,1.46l-.06.62a.14.14,0,0,0,.27,0,3.68,3.68,0,0,0,.06-.66c0-.41.09-.83.12-1.25,0-.16,0-.32,0-.48a21.28,21.28,0,0,1,2.87-1,14.79,14.79,0,0,0,.48,1.82.13.13,0,0,0,.2.05,2.83,2.83,0,0,0,.76-1.36,5.68,5.68,0,0,0,.17-.82c1.25-.13,2.15.07,2.6.67.89,1.2-.27,3.76-2.85,6.87-.52-.11-1-.19-1.56-.26a.13.13,0,0,0-.07.25,9.67,9.67,0,0,0,1.29.41q-1,1.21-2.34,2.52a19.35,19.35,0,0,0-2.61.49.13.13,0,0,0-.12.14c.09.55.23,1.08.35,1.62-1.28,1.15-2.68,2.31-4.17,3.46a10.16,10.16,0,0,0-2.6.62,5.73,5.73,0,0,0-1.62,1.1l-.73.66c-.24.2-.5.38-.73.61-.43.44-.76,1-1.18,1.4a1.49,1.49,0,0,1-1.43.57,3.79,3.79,0,0,1-1-.63.44.44,0,0,0-.41-.1.67.67,0,0,0-.35.37,2.75,2.75,0,0,0-.1,1.48c0,.15,0,.31.07.47-5.21,2.73-9.3,3.71-10.43,2.2-.69-.93-.15-2.68,1.33-4.86Z"
                fill="#141c66"
              />
              <path d="M1209,380.12s-37.07,28.42-40.31,30" fill="#141c66" />
            </g>
            <g>
              <path
                d="M1196.7,379a1.74,1.74,0,0,1,.59.8c-.08.29-.16.58-.23.87s-.21.88-.28,1.33a9.47,9.47,0,0,1-.29,1.28,7.9,7.9,0,0,1-.85,1.87,8.24,8.24,0,0,0-1.05,2.07c-.16.62-.15,1.25-.25,1.88v0l-.55.81a24.65,24.65,0,0,1-4,4.53l-.41.24a37.25,37.25,0,0,0-3.89,2,1.74,1.74,0,0,1-1-.29c-1.77-1.24-.46-6.14,2.91-10.94S1194.93,377.77,1196.7,379Z"
                fill="#141c66"
              />
              <path d="M1187.4,385.45s1.66,9.75-16.76,23.85" fill="#141c66" />
              <path
                d="M1195.85,381.38a5.08,5.08,0,0,1-1.13,2.36,11.32,11.32,0,0,0-1.66,1.86,3.4,3.4,0,0,0-.4,1.29c-.05.43-.05.86-.11,1.29a2.69,2.69,0,0,1-.51,1.27,2.24,2.24,0,0,1-.87.6,4.27,4.27,0,0,0-1,.52,3.59,3.59,0,0,0-.91,1.23,4.15,4.15,0,0,1-.94,1.25,3.43,3.43,0,0,1-.87.45,2.71,2.71,0,0,0-.88.57,2.51,2.51,0,0,0-.57.83,2,2,0,0,1-.49.72,2.53,2.53,0,0,1-1.2.43l-.15,0a.84.84,0,0,1-.38-.15c-1.4-1,.21-5.67,3.58-10.47s7.23-7.89,8.63-6.91a1.1,1.1,0,0,1,.39.56A9.77,9.77,0,0,0,1195.85,381.38Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1135.87,344.13a18,18,0,0,1-.16-1.8,13.61,13.61,0,0,1,.08-2.63c.1-.78.34-1.53.51-2.3a7.53,7.53,0,0,0,.23-2.06c0-.75-.25-1.48-.3-2.24a5.12,5.12,0,0,1,.15-1.7c.15-.39.3-.77.47-1.13a9.6,9.6,0,0,1,.66-1,.15.15,0,0,0,0-.21,8.44,8.44,0,0,1,4-3.5,8.3,8.3,0,0,1,4.92-.34,2.57,2.57,0,0,0,.61.62,5.29,5.29,0,0,0,1.85.68,3.57,3.57,0,0,1,1.91,1,18.36,18.36,0,0,1,1.29,2.07A3.22,3.22,0,0,0,1154,331a2.85,2.85,0,0,1,1.11.69,9,9,0,0,1,.75,1,9.67,9.67,0,0,0,.89.92,9.05,9.05,0,0,1,.65.74c.94,1.25,1,2.91,1.37,4.39a6.23,6.23,0,0,0,1,2.43,12.37,12.37,0,0,0,1.53,1.54,5,5,0,0,1,1.17,1.34,5.59,5.59,0,0,1,.52,2.45c.1,2-.07,4,.17,6a11.9,11.9,0,0,0,.26,1.45c.1.46.26.9.35,1.37a3.09,3.09,0,0,1-.13,1.78,14.63,14.63,0,0,1-.83,1.5,4.54,4.54,0,0,0-.76,2.41,3.5,3.5,0,0,1,0,1.33,2.78,2.78,0,0,1-.58,1A12.61,12.61,0,0,0,1160,365a.16.16,0,0,0,0,.09,7.59,7.59,0,0,1-2.06,1.24,7.83,7.83,0,0,1-3.46.55,12.33,12.33,0,0,0-2.33-1.23,25.65,25.65,0,0,1-2.76-1.17,7.45,7.45,0,0,1-1.21-.8c-.38-.3-.71-.66-1.1-.95-.75-.55-1.6-.95-2.31-1.55a4.21,4.21,0,0,1-1-1.21c-.24-.45-.4-.93-.6-1.39a5,5,0,0,0-.76-1.25,13.25,13.25,0,0,0-1.07-1.05c-.49-.44-1-.85-1.48-1.29a39.69,39.69,0,0,1-1.81-3.7,7.44,7.44,0,0,1,.66-1.53c.39-.73.85-1.43,1.25-2.15,0-.1,0-.26-.1-.29a19.29,19.29,0,0,1-2-.45,2.69,2.69,0,0,1-1.27-.72,2.28,2.28,0,0,1-.49-.87C1136,344.91,1135.94,344.52,1135.87,344.13Z"
                fill="#396039"
              />
              <path
                d="M1142.11,327.06a139.88,139.88,0,0,1,9.1,19.64c2.61,6.74,4.87,13.61,7,20.52l1.5,5.21,1.38,5.24c1,3.48,1.72,7,2.58,10.52s1.54,7.06,2.31,10.59l2,10.64-2.16-10.61c-.8-3.52-1.54-7.05-2.37-10.56s-1.66-7-2.65-10.5l-1.41-5.23-1.52-5.19c-2-6.92-4.26-13.79-6.82-20.54l-2-5c-.71-1.66-1.37-3.34-2.12-5A100.42,100.42,0,0,0,1142.11,327.06Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1176,375c0-.87,0-1.73-.1-2.59a57.14,57.14,0,0,1,4-12.74c.43-.42.84-.84,1.23-1.28s.88-1.17,1.31-1.76,1-1.37,1.5-2.06a17.4,17.4,0,0,0,2.43-4.25c.27-.76.37-1.55.58-2.32.14-.53.31-1,.49-1.55,4.94-6.62,10.11-10.23,13.32-8.69a3.53,3.53,0,0,1,1.15.89q.12.35.21.69a10.32,10.32,0,0,1,.3,3.27,15.24,15.24,0,0,1-.65,3.14,21.21,21.21,0,0,0-1.06,3.63,13.22,13.22,0,0,0,.14,3.44,16.79,16.79,0,0,1,.24,3.47,4.63,4.63,0,0,1-1,2.87,8.77,8.77,0,0,1-1.82,1.31,8.74,8.74,0,0,0-2,1.83,2.41,2.41,0,0,0-.67,1.85c.08.71.38,1.39.5,2.1a5.93,5.93,0,0,1-1.47,4.72,24.22,24.22,0,0,1-4,3.46c-.75.58-1.5,1.16-2.21,1.8-.35.32-.7.66-1,1s-.7.84-1.06,1.26a21.31,21.31,0,0,1-5.3,4.08c-1,.59-1.9,1.19-2.8,1.85-1.62-.81-2.51-2.86-2.71-5.74A14.35,14.35,0,0,0,1176,375Z"
                fill="#2f4f2f"
              />
              <path
                d="M1202,337.23q-2.85,4.17-5.46,8.5t-5.14,8.69c-3.31,5.85-6.38,11.85-9.21,17.95a196.41,196.41,0,0,0-7.53,18.71c-1,3.22-2,6.41-2.78,9.7-.93,3.24-1.43,6.57-2.07,9.88a119.35,119.35,0,0,1,4.62-19.65,192.09,192.09,0,0,1,7.42-18.8q4.31-9.15,9.33-17.92C1194.49,348.45,1198.06,342.73,1202,337.23Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M1176.35,379.87c.11-.67.19-1.36.25-2a45.33,45.33,0,0,1,4.72-9.48c.39-.27.77-.55,1.13-.85s.84-.8,1.25-1.21l1.44-1.42a14.18,14.18,0,0,0,2.44-3c.3-.56.49-1.17.75-1.75a12.55,12.55,0,0,1,.58-1.16c4.71-4.55,9.23-6.73,11.54-5.11a2.92,2.92,0,0,1,.8.84c0,.19,0,.38.07.57a8.12,8.12,0,0,1-.18,2.6,11.81,11.81,0,0,1-.91,2.38,16.39,16.39,0,0,0-1.29,2.71,10.32,10.32,0,0,0-.33,2.71,13.34,13.34,0,0,1-.25,2.75,3.62,3.62,0,0,1-1.15,2.12,6.59,6.59,0,0,1-1.59.8,7,7,0,0,0-1.77,1.19,1.91,1.91,0,0,0-.76,1.36c0,.57.12,1.14.13,1.71a4.74,4.74,0,0,1-1.76,3.51,18.63,18.63,0,0,1-3.59,2.21c-.67.35-1.33.72-2,1.12-.33.21-.64.43-1,.66s-.65.57-1,.86a17.06,17.06,0,0,1-4.68,2.52c-.82.34-1.64.69-2.42,1.1-1.17-.85-1.61-2.57-1.4-4.85A11.49,11.49,0,0,0,1176.35,379.87Z"
                fill="#396039"
              />
              <path
                d="M1201.47,353.58c-1.84,1.94-3.62,3.94-5.35,6s-3.45,4.08-5.12,6.16q-5,6.27-9.49,12.91a154.87,154.87,0,0,0-8.29,13.7c-1.17,2.4-2.42,4.76-3.41,7.24-1.15,2.42-2,5-2.9,7.47a94.21,94.21,0,0,1,6.09-14.82,153.27,153.27,0,0,1,8.2-13.8q4.54-6.62,9.6-12.85A159.52,159.52,0,0,1,1201.47,353.58Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1164.93,380.25a1,1,0,0,0,.38-.63,1.09,1.09,0,0,0-.39-.74,8.36,8.36,0,0,0-1.15-.91v0a5.21,5.21,0,0,0,.7-.71,1.17,1.17,0,0,0,.31-.63c0-.45-.47-.66-.82-.8s-.5-.18-.76-.27c-.16-.78-.31-1.6-.46-2.44l.46-.12a9.89,9.89,0,0,0,1.09-.35,2.11,2.11,0,0,0,.76-.49.19.19,0,0,0,0-.29,10.81,10.81,0,0,0-1.09-.51,2.36,2.36,0,0,1-.94-.61c-.28-.34-.07-.76-.07-1.15a1,1,0,0,0-.44-.77,3.65,3.65,0,0,0-.36-.31c-.11-1-.2-2-.28-3.1l.62-.18a3.34,3.34,0,0,0,1.42-.74,1.2,1.2,0,0,0,.21-1.42,2.69,2.69,0,0,0-1.42-1.05,7.11,7.11,0,0,0-.89-.29c-.06-.36-.13-.72-.19-1.08,0-1,0-2.09,0-3.16a.57.57,0,0,1,.08-.13,1.71,1.71,0,0,1,.59-.36,3.07,3.07,0,0,0,.89-.67.19.19,0,0,0,0-.26c-.42-.36-1.43-.88-1.15-1.58.09-.2.41-.23.58-.32a.56.56,0,0,0,.31-.63c-.13-.48-.71-.66-1-1s.46-.57.74-.59a8.76,8.76,0,0,0,1.54,0,.2.2,0,0,0,.05-.35c-.79-.56-1.58-1.12-2.41-1.63.15-2.22.37-4.33.64-6.31l.35.1a.19.19,0,0,0,.23-.16,7.87,7.87,0,0,1,1.5.77c.28.2.55.4.81.62s.45-.11.27-.27a8.82,8.82,0,0,0-.86-.65,17.2,17.2,0,0,0-2.17-1.32c.26-1.73.56-3.34.91-4.82a7.48,7.48,0,0,1,1.86,1c.22.2.44.41.67.6a.18.18,0,0,0,.26-.26,4.16,4.16,0,0,0-.7-.63c-.44-.41-.87-.82-1.33-1.21-.17-.15-.35-.29-.53-.43a32.58,32.58,0,0,1,1.32-4.13,20.54,20.54,0,0,0,2.49,1,.19.19,0,0,0,.24-.18,4,4,0,0,0-.92-2,7.49,7.49,0,0,0-.79-.9c.91-1.54,1.92-2.4,3-2.4,2.15,0,4.08,3.51,5.44,9.12-.56.5-1.1,1-1.63,1.56a.19.19,0,0,0,.23.3,13.71,13.71,0,0,0,1.58-1.13c.33,1.48.63,3.1.88,4.82a31.62,31.62,0,0,0-1.67,3.41.2.2,0,0,0,.07.26c.7.37,1.43.66,2.15,1,.22,2.44.36,5,.41,7.72a14.06,14.06,0,0,0-1.5,3.5,8,8,0,0,0-.13,2.79c0,.47.1.93.13,1.4s0,.91.08,1.37c.13.86.45,1.69.6,2.55a2.13,2.13,0,0,1-.57,2.11,4.89,4.89,0,0,1-1.57.59.68.68,0,0,0-.47.4,1,1,0,0,0,.13.71,3.79,3.79,0,0,0,1.62,1.37l.59.33c-1.31,8.29-3.67,13.81-6.37,13.81-1.66,0-3.19-2.1-4.44-5.66C1164.68,380.46,1164.81,380.36,1164.93,380.25Z"
                fill="#659965"
              />
              <path
                d="M1169,338q.24,9,.34,17.94l.21,17.94V391.8l-.09,9c-.1,3-.1,6-.45,9,.29-3,.22-6,.26-9l0-9-.11-17.94Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M1157.27,351.07a2.42,2.42,0,0,1,1.41,0c.27.34.53.68.81,1,.41.5.83,1,1.28,1.45A13.8,13.8,0,0,1,1162,355a12.2,12.2,0,0,1,1.41,2.58,11.86,11.86,0,0,0,1.47,3,26.79,26.79,0,0,0,1.95,1.89l0,0c.16.43.31.87.46,1.32a35.64,35.64,0,0,1,1.75,8.47c0,.22,0,.44-.07.67-.28,2-1,4.06-1.07,6.12a2.47,2.47,0,0,1-1.17.88c-2.93,1-7.42-4.7-10-12.65S1154.35,352,1157.27,351.07Z"
                fill="#3b6818"
              />
              <path
                d="M1156.71,367.21s12.59,6.41,13,39.54"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.38"
              />
              <path
                d="M1159.26,354.07a7.18,7.18,0,0,1,1.74,3.29,14.82,14.82,0,0,0,.71,3.49,5,5,0,0,0,1.14,1.56c.45.43.94.79,1.38,1.23a3.57,3.57,0,0,1,1,1.67,3,3,0,0,1,0,1.5,7.15,7.15,0,0,0-.22,1.55,5.08,5.08,0,0,0,.64,2.09,5.8,5.8,0,0,1,.63,2.15A4.8,4.8,0,0,1,1166,374a4.15,4.15,0,0,0-.09,1.5,3.85,3.85,0,0,0,.46,1.36,2.75,2.75,0,0,1,.42,1.17,3.68,3.68,0,0,1-.54,1.75l-.09.18a1.33,1.33,0,0,1-.52.31c-2.31.76-6.3-5.07-8.92-13s-2.87-15-.56-15.78a1.54,1.54,0,0,1,1,0A14.28,14.28,0,0,0,1159.26,354.07Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  );
};

export default Decor1;
